export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AssignmentStatus: { input: AssignmentStatus; output: AssignmentStatus; }
  AttemptStatus: { input: AttemptStatus; output: AttemptStatus; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  DateTimeNaive: { input: DateTimeNaive; output: DateTimeNaive; }
  DateTimeUtc: { input: DateTimeUtc; output: DateTimeUtc; }
  InvoiceStatus: { input: InvoiceStatus; output: InvoiceStatus; }
  JSON: { input: { [key: string]: any }; output: { [key: string]: any }; }
  Language: { input: Language; output: Language; }
  RRule: { input: RRule; output: RRule; }
  RRuleNaive: { input: RRuleNaive; output: RRuleNaive; }
  Time: { input: string; output: string; }
  USState: { input: USState; output: USState; }
  UUID: { input: string; output: string; }
  Upload: { input: File; output: File; }
};

export type AbxBreakdown = {
  __typename?: 'ABXBreakdown';
  awarenessPoints: Scalars['Int']['output'];
  engagedPoints: Scalars['Int']['output'];
  intentPoints: Scalars['Int']['output'];
  linkedinPoints: Scalars['Int']['output'];
};

export type AbxCompanies = PaginatedList & {
  __typename?: 'ABXCompanies';
  objects: Array<CrmCompany>;
  totalCount: Scalars['Int']['output'];
};

export type AbxCompaniesInput = {
  hasLinkedinEngagements?: InputMaybe<Scalars['Boolean']['input']>;
  hasLinkedinImpressions?: InputMaybe<Scalars['Boolean']['input']>;
  highIntentPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  possiblyOutdated?: InputMaybe<Scalars['Boolean']['input']>;
  reviewAiReferrers?: InputMaybe<Array<Scalars['String']['input']>>;
  rubricGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  rubricWindowDays?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<SortInput>;
  tiers?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AbxCompanyTimeline = {
  __typename?: 'ABXCompanyTimeline';
  crossedIntoAbx3At?: Maybe<Scalars['DateTime']['output']>;
  markers: Array<AbxTimelineMarker>;
  scoreSeries: Array<AbxScorePoint>;
};

export type AbxIntentContext = {
  __typename?: 'ABXIntentContext';
  contextText?: Maybe<Scalars['String']['output']>;
  sourceDealAttioId?: Maybe<Scalars['String']['output']>;
  sourceDealName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AbxIntentEvent = {
  __typename?: 'ABXIntentEvent';
  action?: Maybe<Scalars['String']['output']>;
  attioCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  attioId: Scalars['String']['output'];
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  person?: Maybe<CrmContact>;
  points: Scalars['Int']['output'];
  referrer?: Maybe<Scalars['String']['output']>;
  scoreGroup?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceDetails?: Maybe<Scalars['String']['output']>;
};

export enum AbxIntentEventFilter {
  All = 'ALL',
  ScoredOnly = 'SCORED_ONLY',
  SkippedOnly = 'SKIPPED_ONLY'
}

export type AbxIntentEvents = PaginatedList & {
  __typename?: 'ABXIntentEvents';
  objects: Array<AbxIntentEvent>;
  totalCount: Scalars['Int']['output'];
};

export type AbxIntentEventsInput = {
  filter?: InputMaybe<AbxIntentEventFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type AbxScorePoint = {
  __typename?: 'ABXScorePoint';
  realtimeScore: Scalars['Int']['output'];
  tier: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type AbxSummary = {
  __typename?: 'ABXSummary';
  abx0Count: Scalars['Int']['output'];
  abx1Count: Scalars['Int']['output'];
  abx2Count: Scalars['Int']['output'];
  abx3Count: Scalars['Int']['output'];
  abxDealsAllTime: Scalars['Int']['output'];
  abxPipelineValueAllTime: Scalars['Float']['output'];
};

export enum AbxTimelineKind {
  Add = 'ADD',
  Expire = 'EXPIRE'
}

export type AbxTimelineMarker = {
  __typename?: 'ABXTimelineMarker';
  eventId?: Maybe<Scalars['UUID']['output']>;
  kind: AbxTimelineKind;
  points: Scalars['Int']['output'];
  scoreGroup: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type AiCourseInput = {
  brandDetailsId?: InputMaybe<Scalars['UUID']['input']>;
  interactivity: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  textList?: InputMaybe<Array<Scalars['String']['input']>>;
  toneFormality: Scalars['Int']['input'];
  toneSeriousness: Scalars['Int']['input'];
};

export type AiCourseRequest = {
  __typename?: 'AICourseRequest';
  course: Course;
  id: Scalars['UUID']['output'];
};

export type AiCourseRequestMedia = {
  __typename?: 'AICourseRequestMedia';
  aiCourseRequest: AiCourseRequest;
  id: Scalars['UUID']['output'];
  media: Media;
};

export type AiEditPromptRequest = {
  __typename?: 'AIEditPromptRequest';
  aiResponseOptions?: Maybe<Array<AiResponseOption>>;
  generationCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  generationErroredAt?: Maybe<Scalars['DateTime']['output']>;
  generationStartedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  mediaSuggestions?: Maybe<Array<MediaSuggestion>>;
  prompt: Prompt;
  requestType: EditPromptWithAiType;
  response?: Maybe<Scalars['String']['output']>;
};

export type AiGenerateCourseFromOutlineRequest = {
  __typename?: 'AIGenerateCourseFromOutlineRequest';
  aiRequest: AiRequest;
  course?: Maybe<Course>;
  courseOutline: CourseOutline;
  generationCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  generationErroredAt?: Maybe<Scalars['DateTime']['output']>;
  generationStartedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  response?: Maybe<Scalars['String']['output']>;
};

export type AiGenerateModuleRequest = {
  __typename?: 'AIGenerateModuleRequest';
  generationCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  generationErroredAt?: Maybe<Scalars['DateTime']['output']>;
  generationStartedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
};

export type AiGenerationFeedback = {
  __typename?: 'AIGenerationFeedback';
  id?: Maybe<Scalars['UUID']['output']>;
  libraryItemId?: Maybe<Scalars['UUID']['output']>;
  selection?: Maybe<FeedbackSelection>;
  text?: Maybe<Scalars['String']['output']>;
};

export type AiImageRequest = {
  __typename?: 'AIImageRequest';
  attemptNumber: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  prompt: Prompt;
};

export type AiLessonGeneration = {
  __typename?: 'AILessonGeneration';
  id: Scalars['UUID']['output'];
  messagePromptsAttempted: Scalars['Boolean']['output'];
  messagePromptsSuccess: Scalars['Boolean']['output'];
  questionPromptsAttempted: Scalars['Boolean']['output'];
  questionPromptsSuccess: Scalars['Boolean']['output'];
  titleAttempted: Scalars['Boolean']['output'];
};

export type AiNewPromptRequest = {
  __typename?: 'AINewPromptRequest';
  aiCourseRequest?: Maybe<AiCourseRequest>;
  attemptNumber: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  index: Scalars['Float']['output'];
  lesson?: Maybe<Lesson>;
  prompt: Prompt;
  text: Scalars['String']['output'];
};

export type AiOrgContext = {
  __typename?: 'AIOrgContext';
  businessType: Scalars['String']['output'];
  foundingStory: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isApproved: Scalars['Boolean']['output'];
  missionStatement: Scalars['String']['output'];
  rulesForAi?: Maybe<Scalars['String']['output']>;
  sells: Scalars['String']['output'];
};

export type AiOrgContextMutationResult = MutationResult & {
  __typename?: 'AIOrgContextMutationResult';
  aiOrgContext?: Maybe<AiOrgContext>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type AiPrompt = {
  __typename?: 'AIPrompt';
  correctFreeResponseAnswer?: Maybe<AiTranslationSet>;
  correctTfAnswer?: Maybe<Scalars['Boolean']['output']>;
  index: Scalars['Int']['output'];
  responseOptions: Array<AiQuestionResponseOption>;
  selectAllThatApply: Scalars['Boolean']['output'];
  text: AiTranslationSet;
  type: PromptType;
};

export type AiQuestionResponseOption = {
  __typename?: 'AIQuestionResponseOption';
  answer: AiTranslationSet;
  index: Scalars['Int']['output'];
  isCorrect: Scalars['Boolean']['output'];
};

export type AiRequest = {
  __typename?: 'AIRequest';
  accepted: Scalars['Boolean']['output'];
  aiCourseRequest?: Maybe<AiCourseRequest>;
  aiEditPromptRequest?: Maybe<AiEditPromptRequest>;
  aiGenerateCourseFromOutlineRequest?: Maybe<AiGenerateCourseFromOutlineRequest>;
  aiGenerateModuleRequest?: Maybe<AiGenerateModuleRequest>;
  aiImageRequest?: Maybe<AiImageRequest>;
  aiNewPromptRequest?: Maybe<AiNewPromptRequest>;
  aiScormUploadRequest?: Maybe<AiscormUploadRequest>;
  id: Scalars['UUID']['output'];
  rejected: Scalars['Boolean']['output'];
  requestText?: Maybe<Scalars['String']['output']>;
  requestedBy: Employee;
};

export type AiRequestMutationResult = MutationResult & {
  __typename?: 'AIRequestMutationResult';
  aiRequest?: Maybe<AiRequest>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type AiResponseOption = {
  __typename?: 'AIResponseOption';
  aiEditPromptRequest: AiEditPromptRequest;
  answer: TranslationSet;
  id: Scalars['UUID']['output'];
  index: Scalars['Float']['output'];
  isCorrect: Scalars['Boolean']['output'];
};

export type AiscormUploadRequest = {
  __typename?: 'AISCORMUploadRequest';
  id: Scalars['UUID']['output'];
  module: Module;
  scormUpload: ScormUpload;
};

export type AiTranslationSet = {
  __typename?: 'AITranslationSet';
  en: Scalars['String']['output'];
};

export type AiUpdateLibraryItemInput = {
  instructions: Scalars['String']['input'];
  libraryItemId: Scalars['UUID']['input'];
};

export type AbortOpusAgentTurnResult = MutationResult & {
  __typename?: 'AbortOpusAgentTurnResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  turn?: Maybe<OpusAgentChatTurn>;
};

export type AccessContentMutationResult = MutationResult & {
  __typename?: 'AccessContentMutationResult';
  courseInstance?: Maybe<CourseInstance>;
  error?: Maybe<Error>;
  libraryItem?: Maybe<LibraryItem>;
  moduleInstance?: Maybe<ModuleInstance>;
  success: Scalars['Boolean']['output'];
  trainingResourceInstance?: Maybe<TrainingResourceInstance>;
};

export type AccessContentViaQrCodeInput = {
  libraryItemId: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type AccessSource = {
  __typename?: 'AccessSource';
  accessGivenAt: Scalars['DateTime']['output'];
  accessType: AccessType;
  assignedByStr: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isReassignment: Scalars['Boolean']['output'];
  parentId?: Maybe<Scalars['UUID']['output']>;
  sourceType: AccessSourceType;
};

export enum AccessSourceType {
  Automation = 'AUTOMATION',
  AutoReassignAllertrainModuleWhenExamPart_2Failed = 'AUTO_REASSIGN_ALLERTRAIN_MODULE_WHEN_EXAM_PART_2_FAILED',
  AutoReassignModuleOnCourseFailure = 'AUTO_REASSIGN_MODULE_ON_COURSE_FAILURE',
  AutoReassignOnFailure = 'AUTO_REASSIGN_ON_FAILURE',
  Backfill = 'BACKFILL',
  CoursePromptMedia = 'COURSE_PROMPT_MEDIA',
  Manual = 'MANUAL',
  MessageBlast = 'MESSAGE_BLAST',
  ModuleContentMembershipInstance = 'MODULE_CONTENT_MEMBERSHIP_INSTANCE',
  OnCompletionAssignmentRule = 'ON_COMPLETION_ASSIGNMENT_RULE',
  QrCode = 'QR_CODE',
  WorkflowNodeInstance = 'WORKFLOW_NODE_INSTANCE'
}

export enum AccessType {
  Assignment = 'ASSIGNMENT',
  LibraryAccess = 'LIBRARY_ACCESS'
}

export type AccessTypeListInput = {
  value: Array<AccessType>;
};

export enum ActionItemPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type ActionPermissionSet = {
  __typename?: 'ActionPermissionSet';
  assignContent?: Maybe<Scalars['Boolean']['output']>;
  changeOrgSettings?: Maybe<Scalars['Boolean']['output']>;
  createChat?: Maybe<Scalars['Boolean']['output']>;
  createContent?: Maybe<Scalars['Boolean']['output']>;
  deactivateTrainees?: Maybe<Scalars['Boolean']['output']>;
  editTrainees?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  inviteOthers?: Maybe<Scalars['Boolean']['output']>;
  manageBilling?: Maybe<Scalars['Boolean']['output']>;
  manageGuestFeedbackRecommendations?: Maybe<Scalars['Boolean']['output']>;
  manageLibrary?: Maybe<Scalars['Boolean']['output']>;
  manageOrgIntegrations?: Maybe<Scalars['Boolean']['output']>;
  managePremiumContent?: Maybe<Scalars['Boolean']['output']>;
  markAsComplete?: Maybe<Scalars['Boolean']['output']>;
  promoteTrainees?: Maybe<Scalars['Boolean']['output']>;
  sendMessages?: Maybe<Scalars['Boolean']['output']>;
  sendPosts?: Maybe<Scalars['Boolean']['output']>;
  unassignContent?: Maybe<Scalars['Boolean']['output']>;
  updateAutomations?: Maybe<Scalars['Boolean']['output']>;
  verifySkills?: Maybe<Scalars['Boolean']['output']>;
  viewAllSubmittedTaskLists?: Maybe<Scalars['Boolean']['output']>;
  viewReporting?: Maybe<Scalars['Boolean']['output']>;
};

export type ActionPermissionSetInput = {
  assignContent?: InputMaybe<OptionalBooleanValue>;
  changeOrgSettings?: InputMaybe<OptionalBooleanValue>;
  createChat?: InputMaybe<OptionalBooleanValue>;
  createContent?: InputMaybe<OptionalBooleanValue>;
  deactivateTrainees?: InputMaybe<OptionalBooleanValue>;
  editTrainees?: InputMaybe<OptionalBooleanValue>;
  inviteOthers?: InputMaybe<OptionalBooleanValue>;
  manageBilling?: InputMaybe<OptionalBooleanValue>;
  manageGuestFeedbackRecommendations?: InputMaybe<OptionalBooleanValue>;
  manageLibrary?: InputMaybe<OptionalBooleanValue>;
  manageOrgIntegrations?: InputMaybe<OptionalBooleanValue>;
  managePremiumContent?: InputMaybe<OptionalBooleanValue>;
  markAsComplete?: InputMaybe<OptionalBooleanValue>;
  promoteTrainees?: InputMaybe<OptionalBooleanValue>;
  sendMessages?: InputMaybe<OptionalBooleanValue>;
  sendPosts?: InputMaybe<OptionalBooleanValue>;
  unassignContent?: InputMaybe<OptionalBooleanValue>;
  updateAutomations?: InputMaybe<OptionalBooleanValue>;
  verifySkills?: InputMaybe<OptionalBooleanValue>;
  viewAllSubmittedTaskLists?: InputMaybe<OptionalBooleanValue>;
  viewReporting?: InputMaybe<OptionalBooleanValue>;
};

export type ActiveClient = {
  __typename?: 'ActiveClient';
  activeWorkflowNodeId?: Maybe<Scalars['UUID']['output']>;
  clientId: Scalars['UUID']['output'];
  courseVersionId?: Maybe<Scalars['Int']['output']>;
  moduleContentMembershipId?: Maybe<Scalars['UUID']['output']>;
  moduleVersionId?: Maybe<Scalars['UUID']['output']>;
  promptUuid?: Maybe<Scalars['UUID']['output']>;
  richTextDocumentId?: Maybe<Scalars['UUID']['output']>;
  skillVersionId?: Maybe<Scalars['UUID']['output']>;
  user: Employee;
  verificationStepId?: Maybe<Scalars['UUID']['output']>;
  workflowVersionId?: Maybe<Scalars['UUID']['output']>;
};

export type ActiveClientMutationResult = MutationResult & {
  __typename?: 'ActiveClientMutationResult';
  activeClient?: Maybe<ActiveClient>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type ActiveClientsInput = {
  courseVersionId?: InputMaybe<Scalars['Int']['input']>;
  moduleVersionId?: InputMaybe<Scalars['UUID']['input']>;
  richTextDocumentId?: InputMaybe<Scalars['UUID']['input']>;
  skillVersionId?: InputMaybe<Scalars['UUID']['input']>;
  workflowVersionId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum ActorType {
  Hris = 'HRIS',
  User = 'USER'
}

export type AddConditionalStepGroupActionInput = {
  conditionalStepGroup: ConditionalStepGroupInput;
  parentVerificationStepId: Scalars['UUID']['input'];
};

export type AddContentToLibraryInput = {
  catalogCourseIds: Array<Scalars['Int']['input']>;
  catalogModuleIds: Array<Scalars['UUID']['input']>;
};

export enum AddCoursePosition {
  Last = 'LAST',
  Next = 'NEXT',
  Now = 'NOW'
}

export type AddLessonActionInput = {
  /** @deprecated Field no longer supported */
  firstPromptUuid?: InputMaybe<Scalars['UUID']['input']>;
  lesson?: InputMaybe<LessonObjectInput>;
  /** @deprecated Field no longer supported */
  lessonUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** @deprecated Field no longer supported */
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
};

export type AddMcOptionActionInput = {
  promptUuid: Scalars['UUID']['input'];
};

export type AddMediaActionInput = {
  mediaId: Scalars['Int']['input'];
};

export type AddModuleContentMembershipActionInput = {
  aiRequestUuid?: InputMaybe<Scalars['UUID']['input']>;
  courseId?: InputMaybe<Scalars['Int']['input']>;
  fractionPosition: Scalars['Float']['input'];
  moduleContentMembershipUuid: Scalars['UUID']['input'];
  sectionBreak?: InputMaybe<SectionBreakInput>;
  skillId?: InputMaybe<Scalars['Int']['input']>;
  trainingResourceId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AddPromptActionInput = {
  lessonUuid: Scalars['UUID']['input'];
  position: Scalars['Int']['input'];
  prompt: PromptObjectInput;
  /** @deprecated Field no longer supported */
  promptUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** @deprecated Field no longer supported */
  type?: InputMaybe<PromptType>;
};

export type AddResponseOptionActionInput = {
  position?: InputMaybe<Scalars['Int']['input']>;
  promptUuid: Scalars['UUID']['input'];
  responseOption?: InputMaybe<ResponseOptionObjectInput>;
  /** @deprecated Field no longer supported */
  responseOptionId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AddStepActionInput = {
  position: Scalars['Int']['input'];
  step: VerificationStepObjectInput;
};

export type AddStepResponseOptionActionInput = {
  position: Scalars['Int']['input'];
  stepId: Scalars['UUID']['input'];
  stepResponseOption: StepResponseOptionObjectInput;
};

export type AddStepResponseOptionInstanceActionInput = {
  stepResponseOptionId: Scalars['UUID']['input'];
};

export type AddUsersToLocationsInput = {
  courses?: InputMaybe<Array<AssignCourseInput>>;
  locationIds: Array<Scalars['Int']['input']>;
  userIds: Array<Scalars['Int']['input']>;
};

export type AddUsersToRolesInput = {
  courses?: InputMaybe<Array<AssignCourseInput>>;
  roleIds: Array<Scalars['Int']['input']>;
  userIds: Array<Scalars['Int']['input']>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lineOne: Scalars['String']['output'];
  lineTwo?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  postalCode: Scalars['String']['output'];
  timezoneStr?: Maybe<Scalars['String']['output']>;
  usState?: Maybe<Scalars['USState']['output']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lineOne: Scalars['String']['input'];
  lineTwo?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type AdminEmployeesInput = {
  locationIds?: InputMaybe<IntArrayInput>;
  search?: InputMaybe<StringValue>;
};

export type AdminLibraryFiltersInput = {
  /** @deprecated Use publishStates instead */
  excludeDrafts?: InputMaybe<OptionalBooleanValue>;
  folderId?: InputMaybe<OptionalUuidValue>;
  hasCompletedKnowledgeCheck?: InputMaybe<OptionalBooleanValue>;
  hasEnglishSearchDocument?: InputMaybe<OptionalBooleanValue>;
  ids?: InputMaybe<UuidArrayInput>;
  isArchived?: InputMaybe<OptionalBooleanValue>;
  /** @deprecated Use publishStates instead */
  isPublished?: InputMaybe<OptionalBooleanValue>;
  itemType?: InputMaybe<LibraryItemTypeInput>;
  itemTypes?: InputMaybe<LibraryItemTypeListInput>;
  lastEditedByUserIds?: InputMaybe<IntArrayInput>;
  publishStates?: InputMaybe<PublishStateArrayInput>;
  resourceTypes?: InputMaybe<TrainingResourceTypeListInput>;
  searchDocumentIds?: InputMaybe<UuidArrayInput>;
  tagIds?: InputMaybe<UuidArrayInput>;
};

export type AdminLibraryInput = {
  filters?: InputMaybe<AdminLibraryFiltersInput>;
  search?: InputMaybe<StringValue>;
  searchMode?: InputMaybe<LibrarySearchMode>;
  sort?: InputMaybe<SortInput>;
};

export type AdoptionDay = {
  __typename?: 'AdoptionDay';
  count: Scalars['Int']['output'];
  day: Scalars['Date']['output'];
  expectedUsers?: Maybe<Scalars['Int']['output']>;
};

export type AgentArtifactGql = {
  __typename?: 'AgentArtifactGQL';
  externalLink?: Maybe<Scalars['String']['output']>;
  githubPrNumber?: Maybe<Scalars['Int']['output']>;
  githubRepo?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  slackChannelId?: Maybe<Scalars['String']['output']>;
  slackThreadTs?: Maybe<Scalars['String']['output']>;
  type: AgentArtifactType;
};

export enum AgentArtifactType {
  GithubComment = 'GITHUB_COMMENT',
  GithubPr = 'GITHUB_PR',
  LinearComment = 'LINEAR_COMMENT',
  SlackMessage = 'SLACK_MESSAGE'
}

export type AgentCiFailureGql = {
  __typename?: 'AgentCIFailureGQL';
  createdAt: Scalars['DateTime']['output'];
  headSha: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  prNumber: Scalars['Int']['output'];
  repo: Scalars['String']['output'];
  status: GitHubCiFailureStatus;
};

export enum AgentChatMessagePartType {
  Error = 'ERROR',
  Text = 'TEXT',
  Work = 'WORK'
}

export enum AgentChatMessageRole {
  Assistant = 'ASSISTANT',
  User = 'USER'
}

export enum AgentChatMessageStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Streaming = 'STREAMING'
}

export type AgentCommandGql = {
  __typename?: 'AgentCommandGQL';
  asyncCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  asyncLogs?: Maybe<Scalars['String']['output']>;
  asyncLogsLineCount?: Maybe<Scalars['Int']['output']>;
  asyncStartedAt?: Maybe<Scalars['DateTime']['output']>;
  asyncStatus?: Maybe<CommandStatus>;
  commandSource?: Maybe<CommandSource>;
  commandType?: Maybe<CommandType>;
  createdAt: Scalars['DateTime']['output'];
  eng?: Maybe<EngSlug>;
  id: Scalars['UUID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  triggerLink?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AgentGitHubPrCommentGql = {
  __typename?: 'AgentGitHubPRCommentGQL';
  commentBody: Scalars['String']['output'];
  commentUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  prNumber: Scalars['Int']['output'];
  repo: Scalars['String']['output'];
  status: GitHubPrCommentStatus;
};

export type AgentPrCiCheckGql = {
  __typename?: 'AgentPRCiCheckGQL';
  conclusion: Scalars['String']['output'];
  detailsUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AgentSessionCustomerProblemGql = {
  __typename?: 'AgentSessionCustomerProblemGQL';
  customerProblem?: Maybe<CustomerProblem>;
  id: Scalars['UUID']['output'];
};

export type AgentSessionGql = {
  __typename?: 'AgentSessionGQL';
  artifacts: Array<AgentArtifactGql>;
  ciFailures: Array<AgentCiFailureGql>;
  claudeSessionId?: Maybe<Scalars['UUID']['output']>;
  commands: Array<AgentCommandGql>;
  createdAt: Scalars['DateTime']['output'];
  customerProblem?: Maybe<AgentSessionCustomerProblemGql>;
  eng?: Maybe<EngSlug>;
  githubPrComments: Array<AgentGitHubPrCommentGql>;
  id: Scalars['UUID']['output'];
  latestCommand?: Maybe<AgentCommandGql>;
  linearIssueAssignee?: Maybe<Scalars['String']['output']>;
  linearIssueDescription?: Maybe<Scalars['String']['output']>;
  linearIssueId?: Maybe<Scalars['String']['output']>;
  linearIssueIdentifier?: Maybe<Scalars['String']['output']>;
  linearIssueState?: Maybe<Scalars['String']['output']>;
  linearIssueTitle?: Maybe<Scalars['String']['output']>;
  linearIssueUrl?: Maybe<Scalars['String']['output']>;
  prs: Array<AgentSessionPrgql>;
  slackChannelId?: Maybe<Scalars['String']['output']>;
  slackChannelName?: Maybe<Scalars['String']['output']>;
  slackThreadTs?: Maybe<Scalars['String']['output']>;
  slackUserId?: Maybe<Scalars['String']['output']>;
  slackUserName?: Maybe<Scalars['String']['output']>;
  sourceGithubCommentUrl?: Maybe<Scalars['String']['output']>;
  sourceGithubPrNumber?: Maybe<Scalars['Int']['output']>;
  sourceGithubRepo?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalCostUsd?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AgentSessionPrgql = {
  __typename?: 'AgentSessionPRGQL';
  checks?: Maybe<Array<AgentPrCiCheckGql>>;
  ciStatus?: Maybe<Scalars['String']['output']>;
  headRef?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  isAssignedCiFixes: Scalars['Boolean']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isMerged?: Maybe<Scalars['Boolean']['output']>;
  prNumber: Scalars['Int']['output'];
  repo: Scalars['String']['output'];
  reviewers?: Maybe<Array<Scalars['String']['output']>>;
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum AgentSessionPrFilter {
  HasOpenPrs = 'HAS_OPEN_PRS',
  HasPrs = 'HAS_PRS'
}

export type AgentSessionsGql = {
  __typename?: 'AgentSessionsGQL';
  objects: Array<AgentSessionGql>;
  totalCount: Scalars['Int']['output'];
};

export type AgentSessionsInput = {
  commandSource?: InputMaybe<CommandSource>;
  eng?: InputMaybe<EngSlug>;
  prFilter?: InputMaybe<AgentSessionPrFilter>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
  status?: InputMaybe<CommandStatus>;
};

export type AiChat = {
  __typename?: 'AiChat';
  createdAt: Scalars['DateTime']['output'];
  exchanges: Array<AiChatExchange>;
  id: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
  type: AiChatType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AiChatExchange = {
  __typename?: 'AiChatExchange';
  aiGenerationFeedback: Array<Maybe<AiGenerationFeedback>>;
  attachments: Array<AiExchangeAttachment>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  vercelChatMessages: Array<VercelAiChatMessage>;
};

export type AiChatExchangeStep = {
  __typename?: 'AiChatExchangeStep';
  createdAt: Scalars['DateTime']['output'];
  exchange: AiChatExchange;
  id: Scalars['UUID']['output'];
  index: Scalars['Int']['output'];
};

export enum AiChatType {
  AuditOutline = 'AUDIT_OUTLINE',
  CheckInOutline = 'CHECK_IN_OUTLINE',
  CourseContent = 'COURSE_CONTENT',
  CourseOutline = 'COURSE_OUTLINE',
  FreeResponseGrader = 'FREE_RESPONSE_GRADER',
  GuestFeedbackAnalysis = 'GUEST_FEEDBACK_ANALYSIS',
  KnowledgeBase = 'KNOWLEDGE_BASE',
  ModuleContent = 'MODULE_CONTENT',
  ModuleOutline = 'MODULE_OUTLINE',
  QuestionGeneration = 'QUESTION_GENERATION',
  TaskListOutline = 'TASK_LIST_OUTLINE'
}

export type AiChats = PaginatedList & {
  __typename?: 'AiChats';
  objects: Array<AiChat>;
  totalCount: Scalars['Int']['output'];
};

export type AiExchangeAttachment = {
  __typename?: 'AiExchangeAttachment';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  libraryItem: LibraryItem;
  media: Media;
};

export type ApplyBuilderActionsMutationResult = MutationResult & {
  __typename?: 'ApplyBuilderActionsMutationResult';
  appliedBuilderActions?: Maybe<Array<BuilderAction>>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type AskOpusAnnotation = {
  __typename?: 'AskOpusAnnotation';
  id: Scalars['UUID']['output'];
  pgvectorSearchResult?: Maybe<VectorSearchResult>;
  questionAnswer: AskOpusQuestionAnswer;
  vectorStoreSearchResponse?: Maybe<OpenAi_VectorStoreSearchResponse>;
};

export enum AskOpusAnsweredClassification {
  Answered = 'ANSWERED',
  NotAnswered = 'NOT_ANSWERED',
  Partial = 'PARTIAL'
}

export type AskOpusQuestionAnswer = {
  __typename?: 'AskOpusQuestionAnswer';
  annotations: Array<AskOpusAnnotation>;
  answer: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Employee;
  exchangeStep: AiChatExchangeStep;
  id: Scalars['UUID']['output'];
  question: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AskOpusQuestionAnswers = PaginatedList & {
  __typename?: 'AskOpusQuestionAnswers';
  objects: Array<AskOpusQuestionAnswer>;
  totalCount: Scalars['Int']['output'];
};

export type AskOpusQuestionAnswersFiltersInput = {
  createdAtEndDate?: InputMaybe<DateTimeValue>;
  createdAtStartDate?: InputMaybe<DateTimeValue>;
};

export type AskOpusQuestionAnswersInput = {
  filters?: InputMaybe<AskOpusQuestionAnswersFiltersInput>;
};

export type AskOpusTheme = {
  __typename?: 'AskOpusTheme';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  examples: Array<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AskOpusThemeAnalysis = {
  __typename?: 'AskOpusThemeAnalysis';
  analysisEndDate: Scalars['DateTime']['output'];
  analysisStartDate: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  questionCount: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
  themes: Array<AskOpusTheme>;
  uniqueUserCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum AskOpusTopicClassification {
  KnowledgeBase = 'KNOWLEDGE_BASE',
  Other = 'OTHER',
  ProductQuestion = 'PRODUCT_QUESTION',
  Reporting = 'REPORTING'
}

export type AssignCourseInput = {
  courseId: Scalars['Int']['input'];
  dueDate?: InputMaybe<Scalars['Date']['input']>;
};

export type AssignLibraryItemsInput = {
  libraryItemIds: Array<Scalars['UUID']['input']>;
  reassign?: InputMaybe<Scalars['Boolean']['input']>;
  reassignLibraryItemIdsInModule?: InputMaybe<Array<Scalars['UUID']['input']>>;
  userSelection?: InputMaybe<UserSelectionInput>;
  userSelectionSet?: InputMaybe<UserSelectionSetInput>;
};

export enum AssignedUserType {
  All = 'ALL',
  NonSupervisors = 'NON_SUPERVISORS',
  Supervisors = 'SUPERVISORS'
}

export type Assignment = {
  __typename?: 'Assignment';
  accessSources: Array<AccessSource>;
  assignedByList?: Maybe<Array<Scalars['String']['output']>>;
  attemptsCount: Scalars['Int']['output'];
  certificateUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  course?: Maybe<Course>;
  /** @deprecated Field no longer supported */
  courseId?: Maybe<Scalars['Int']['output']>;
  courseInstances: Array<CourseInstance>;
  createdAt: Scalars['DateTime']['output'];
  currentCourseInstance?: Maybe<CourseInstance>;
  currentInstanceAccuracy?: Maybe<Scalars['Float']['output']>;
  currentInstanceCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  currentInstanceFirstAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  currentInstanceLastAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  currentInstanceLastAssignedByStr?: Maybe<Scalars['String']['output']>;
  currentInstancePercentComplete: Scalars['Float']['output'];
  currentInstanceStartedAt?: Maybe<Scalars['DateTime']['output']>;
  currentModuleInstance?: Maybe<ModuleInstance>;
  currentResourceInstance?: Maybe<TrainingResourceInstance>;
  currentSCORMCourseInstance?: Maybe<ScormCourseInstance>;
  currentSkillInstance?: Maybe<SkillInstance>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  firstAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  firstAssignedByStr?: Maybe<Scalars['String']['output']>;
  foodHandlerExamCompliance?: Maybe<FoodHandlerExamComplianceType>;
  id: Scalars['UUID']['output'];
  isCurrentInstanceAssignedThroughModule: Scalars['Boolean']['output'];
  isOrHasBeenAssigned: Scalars['Boolean']['output'];
  libraryItem: LibraryItem;
  moduleInstances: Array<ModuleInstance>;
  /** @deprecated Field no longer supported */
  resource?: Maybe<TrainingResource>;
  /** @deprecated Field no longer supported */
  resourceId?: Maybe<Scalars['Int']['output']>;
  scormCourseInstances: Array<ScormCourseInstance>;
  searchHeadline?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  skill?: Maybe<Skill>;
  /** @deprecated Field no longer supported */
  skillId?: Maybe<Scalars['Int']['output']>;
  skillInstances: Array<SkillInstance>;
  status: Scalars['AssignmentStatus']['output'];
  user: Employee;
  userId: Scalars['Int']['output'];
};

export type AssignmentCompletionDay = {
  __typename?: 'AssignmentCompletionDay';
  axisLabel: Scalars['String']['output'];
  completedAssignments: Scalars['Int']['output'];
  day: Scalars['Date']['output'];
  libraryItemId?: Maybe<Scalars['UUID']['output']>;
  pastDueAssignments: Scalars['Int']['output'];
  tooltipLabel: Scalars['String']['output'];
  totalAssignments: Scalars['Int']['output'];
};

export type AssignmentCompletionInput = {
  libraryItemId?: InputMaybe<Scalars['UUID']['input']>;
  since?: InputMaybe<DateTimeValue>;
};

export enum AssignmentContentType {
  Audit = 'AUDIT',
  Course = 'COURSE',
  Folder = 'FOLDER',
  Module = 'MODULE',
  Resource = 'RESOURCE',
  ScormCourse = 'SCORM_COURSE',
  Skill = 'SKILL',
  Task = 'TASK'
}

export type AssignmentContentTypeListInput = {
  value: Array<AssignmentContentType>;
};

export type AssignmentDiff = {
  __typename?: 'AssignmentDiff';
  added: Array<Employee>;
  removed: Array<Employee>;
};

export enum AssignmentHistoryEventType {
  Assigned = 'ASSIGNED',
  CheckinAssigned = 'CHECKIN_ASSIGNED',
  CheckinCompleted = 'CHECKIN_COMPLETED',
  CheckinFailed = 'CHECKIN_FAILED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  MissedDueDate = 'MISSED_DUE_DATE',
  Passed = 'PASSED',
  Reassigned = 'REASSIGNED',
  Started = 'STARTED',
  Unassigned = 'UNASSIGNED'
}

export type AssignmentHistoryItem = {
  __typename?: 'AssignmentHistoryItem';
  accessType?: Maybe<AccessType>;
  accuracy?: Maybe<Scalars['Float']['output']>;
  actor?: Maybe<Employee>;
  assignedBy?: Maybe<Scalars['String']['output']>;
  assignment: Assignment;
  automation?: Maybe<Automation>;
  changeReason?: Maybe<Scalars['String']['output']>;
  courseInstanceId?: Maybe<Scalars['Int']['output']>;
  date: Scalars['DateTime']['output'];
  eventType: AssignmentHistoryEventType;
  facilitatedBy?: Maybe<Employee>;
  failed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isReassignment: Scalars['Boolean']['output'];
  manuallyAssignedBy?: Maybe<Employee>;
  markedCompletedBy?: Maybe<Employee>;
  markedCompletedReason?: Maybe<Scalars['String']['output']>;
  moduleInstanceId?: Maybe<Scalars['UUID']['output']>;
  passingRequirement?: Maybe<Scalars['Float']['output']>;
  skillInstanceId?: Maybe<Scalars['UUID']['output']>;
  sourceEventId?: Maybe<Scalars['UUID']['output']>;
  sourceType?: Maybe<AccessSourceType>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AssignmentInput = {
  userSelectionSet?: InputMaybe<UserSelectionSetInput>;
};

export type AssignmentStatusArrayInput = {
  value: Array<Scalars['AssignmentStatus']['input']>;
};

export type AssignmentStatusCount = {
  __typename?: 'AssignmentStatusCount';
  count: Scalars['Int']['output'];
  status: Scalars['AssignmentStatus']['output'];
};

export type Assignments = PaginatedList & {
  __typename?: 'Assignments';
  objects: Array<Assignment>;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentsFiltersInput = {
  accessTypes?: InputMaybe<AccessTypeListInput>;
  archivedOnly?: InputMaybe<BooleanValue>;
  complianceTypes?: InputMaybe<Array<ComplianceType>>;
  contentTypes?: InputMaybe<AssignmentContentTypeListInput>;
  courseId?: InputMaybe<IntValue>;
  courseIds?: InputMaybe<IntArrayInput>;
  currentCourseInstanceFilters?: InputMaybe<CurrentCourseInstanceFiltersInput>;
  currentInstanceCompletedEndDate?: InputMaybe<DateTimeInput>;
  currentInstanceCompletedStartDate?: InputMaybe<DateTimeInput>;
  currentInstanceStarted?: InputMaybe<BooleanValue>;
  currentModuleInstanceFilters?: InputMaybe<CurrentModuleInstanceFiltersInput>;
  currentSkillInstanceFilters?: InputMaybe<CurrentSkillInstanceFiltersInput>;
  excludeAccessTypes?: InputMaybe<AccessTypeListInput>;
  excludeDrafts?: InputMaybe<BooleanValue>;
  excludeUserIds?: InputMaybe<IntArrayInput>;
  foodHandlerExamComplianceTypes?: InputMaybe<Array<FoodHandlerExamComplianceType>>;
  hasCertificate?: InputMaybe<BooleanValue>;
  ids?: InputMaybe<UuidArrayInput>;
  includeArchived?: InputMaybe<BooleanValue>;
  includeCompletedAssignmentsWithoutAccessSource?: InputMaybe<BooleanValue>;
  isTopLevel?: InputMaybe<BooleanValue>;
  libraryItemIds?: InputMaybe<UuidArrayInput>;
  locationGroupIds?: InputMaybe<UuidArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
  /** @deprecated Field no longer supported */
  moduleId?: InputMaybe<IntValue>;
  /** @deprecated Field no longer supported */
  moduleIds?: InputMaybe<IntArrayInput>;
  peopleFilters?: InputMaybe<GetPeopleInput>;
  readyForTraining?: InputMaybe<BooleanValue>;
  /** @deprecated Field no longer supported */
  resourceIds?: InputMaybe<StringArrayInput>;
  roleGroupIds?: InputMaybe<UuidArrayInput>;
  roleIds?: InputMaybe<IntArrayInput>;
  searchDocumentIds?: InputMaybe<UuidArrayInput>;
  shpAssignedUserTypes?: InputMaybe<Array<AssignedUserType>>;
  shpUsStates?: InputMaybe<Array<InputMaybe<Scalars['USState']['input']>>>;
  /** @deprecated Field no longer supported */
  skillIds?: InputMaybe<IntArrayInput>;
  statuses?: InputMaybe<AssignmentStatusArrayInput>;
  tagIds?: InputMaybe<UuidArrayInput>;
  useDirectReports?: InputMaybe<BooleanValue>;
  userId?: InputMaybe<IntValue>;
  userIds?: InputMaybe<IntArrayInput>;
  userTypes?: InputMaybe<UserTypeListInput>;
};

export type AssignmentsInput = {
  filters: AssignmentsFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type AssignmentsMutationResult = MutationResult & {
  __typename?: 'AssignmentsMutationResult';
  assignments?: Maybe<Array<Assignment>>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type AttemptStatusArrayInput = {
  value: Array<Scalars['AttemptStatus']['input']>;
};

export type AuditFollowUpTaskSetup = {
  __typename?: 'AuditFollowUpTaskSetup';
  hasAudits: Scalars['Boolean']['output'];
  hasFollowUpTaskTriggers: Scalars['Boolean']['output'];
};

export enum AuditLocationProgressStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type AuditLocationStatus = {
  __typename?: 'AuditLocationStatus';
  completedSkillInstance?: Maybe<SkillInstance>;
  currentWindowEnd?: Maybe<Scalars['DateTimeUtc']['output']>;
  currentWindowStart?: Maybe<Scalars['DateTimeUtc']['output']>;
  draftSkillInstance?: Maybe<SkillInstance>;
  isOnSchedule: Scalars['Boolean']['output'];
  location: Location;
  status: AuditLocationProgressStatus;
};

export type AutoReassignInterval = {
  __typename?: 'AutoReassignInterval';
  count: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  sourceDateType: AutoReassignIntervalSourceDateType;
  unit: AutoReassignIntervalUnit;
};

export type AutoReassignIntervalInput = {
  count: Scalars['Int']['input'];
  sourceDateType: AutoReassignIntervalSourceDateType;
  unit: AutoReassignIntervalUnit;
};

export enum AutoReassignIntervalSourceDateType {
  Assignment = 'ASSIGNMENT',
  Completion = 'COMPLETION'
}

export type AutoReassignIntervalSourceDateTypeValue = {
  value: AutoReassignIntervalSourceDateType;
};

export enum AutoReassignIntervalUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type AutoReassignIntervalUnitValue = {
  value: AutoReassignIntervalUnit;
};

export type Automation = {
  __typename?: 'Automation';
  autoReassign: Scalars['Boolean']['output'];
  autoReassignInterval?: Maybe<AutoReassignInterval>;
  enabled: Scalars['Boolean']['output'];
  endDatetime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  lastEditedBy?: Maybe<Employee>;
  libraryItem: LibraryItem;
  newUsersOnly: Scalars['Boolean']['output'];
  startDatetime?: Maybe<Scalars['DateTime']['output']>;
  type: AutomationType;
  updatedAt: Scalars['DateTime']['output'];
  userSelectionSet?: Maybe<UserSelectionSet>;
};

export type AutomationDiff = {
  __typename?: 'AutomationDiff';
  added: Array<Employee>;
  removed?: Maybe<Array<Employee>>;
};

export type AutomationInput = {
  autoReassign?: InputMaybe<BooleanValue>;
  autoReassignInterval?: InputMaybe<AutoReassignIntervalInput>;
  enabled?: InputMaybe<BooleanValue>;
  endDatetime?: InputMaybe<OptionalDateTimeValue>;
  newUsersOnly?: InputMaybe<BooleanValue>;
  startDatetime?: InputMaybe<DateTimeValue>;
  userSelectionSet?: InputMaybe<UserSelectionSetInput>;
};

export type AutomationMutationResult = MutationResult & {
  __typename?: 'AutomationMutationResult';
  automation?: Maybe<Automation>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type AutomationOverride = {
  __typename?: 'AutomationOverride';
  automation: Automation;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Employee>;
  id: Scalars['UUID']['output'];
  reason: AutomationOverrideReason;
  user: Employee;
};

export enum AutomationOverrideReason {
  ManuallyUnassigned = 'MANUALLY_UNASSIGNED',
  NewUsersOnly = 'NEW_USERS_ONLY'
}

export enum AutomationType {
  Assignment = 'ASSIGNMENT',
  LibraryAccess = 'LIBRARY_ACCESS'
}

export type AutomationTypeInput = {
  value: AutomationType;
};

export type Automations = PaginatedList & {
  __typename?: 'Automations';
  objects: Array<Automation>;
  totalCount: Scalars['Int']['output'];
};

export type AutomationsInput = {
  filters: AutomationsV2FiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type AutomationsV2FiltersInput = {
  contentTypes?: InputMaybe<LibraryItemTypeListInput>;
  type?: InputMaybe<AutomationTypeInput>;
  userSelection?: InputMaybe<UserSelectionFiltersInput>;
};

export type AvailableOrgsInput = {
  search?: InputMaybe<StringValue>;
};

export type AverageTimeToComplete = {
  __typename?: 'AverageTimeToComplete';
  courseId: Scalars['Int']['output'];
  days?: Maybe<Scalars['Float']['output']>;
  seconds?: Maybe<Scalars['Float']['output']>;
};

export type AverageTimetoCompleteInput = {
  courseIds: Array<Scalars['Int']['input']>;
};

export type AvgTrainingFeedbackInput = {
  since?: InputMaybe<DateTimeValue>;
};

export type AvgTrainingFeedbackWeek = {
  __typename?: 'AvgTrainingFeedbackWeek';
  average: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  week?: Maybe<Scalars['Date']['output']>;
};

export type BackfilledAssignment = {
  __typename?: 'BackfilledAssignment';
  assignedByUser: Employee;
  completionDate: Scalars['DateTime']['output'];
  createdAssignment?: Maybe<Assignment>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  hrisEmployee?: Maybe<HrisEmployee>;
  id: Scalars['UUID']['output'];
  label: Scalars['String']['output'];
  libraryItem: LibraryItem;
  matchingStrategy: BackfilledAssignmentUserMatchingStrategy;
  org?: Maybe<Org>;
  phoneNumber: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  status: BackfilledAssignmentStatus;
  traineeName: Scalars['String']['output'];
};

export type BackfilledAssignmentImportPreview = {
  __typename?: 'BackfilledAssignmentImportPreview';
  alreadyBackfilled: Array<BackfilledAssignmentPreviewRow>;
  alreadyCompleted: Array<BackfilledAssignmentPreviewRow>;
  cleanMatches: Array<BackfilledAssignmentPreviewRow>;
  csvErrors: Array<CsvSchemaError>;
  hrisEmployeeNotFound: Array<BackfilledAssignmentPreviewRow>;
  libraryItemNotFound: Array<BackfilledAssignmentPreviewRow>;
  userNotFound: Array<BackfilledAssignmentPreviewRow>;
};

export type BackfilledAssignmentPreviewRow = {
  __typename?: 'BackfilledAssignmentPreviewRow';
  contentName: Scalars['String']['output'];
  matchedHrisEmployee?: Maybe<HrisEmployee>;
  matchedLibraryItem?: Maybe<LibraryItem>;
  matchedUser?: Maybe<Employee>;
  traineeName: Scalars['String']['output'];
};

export enum BackfilledAssignmentStatus {
  Pending = 'PENDING',
  Processed = 'PROCESSED'
}

export enum BackfilledAssignmentUserMatchingStrategy {
  EmailMatching = 'EMAIL_MATCHING',
  HrisMatching = 'HRIS_MATCHING',
  NameMatching = 'NAME_MATCHING',
  PhoneNumberMatching = 'PHONE_NUMBER_MATCHING'
}

export type BackfilledAssignments = PaginatedList & {
  __typename?: 'BackfilledAssignments';
  objects: Array<BackfilledAssignment>;
  totalCount: Scalars['Int']['output'];
};

export type BackfilledAssignmentsFiltersInput = {
  statuses?: InputMaybe<Array<BackfilledAssignmentStatus>>;
};

export type BackfilledAssignmentsInput = {
  filters?: InputMaybe<BackfilledAssignmentsFiltersInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type BackfilledCertificate = {
  __typename?: 'BackfilledCertificate';
  assignedByUser: Employee;
  assignedUserType?: Maybe<AssignedUserType>;
  becameCompliantAt: Scalars['DateTime']['output'];
  complianceType: ComplianceType;
  createdAt: Scalars['DateTime']['output'];
  createdComplianceAttempt?: Maybe<ComplianceAttempt>;
  email: Scalars['String']['output'];
  hrisEmployee?: Maybe<HrisEmployee>;
  id: Scalars['UUID']['output'];
  label: Scalars['String']['output'];
  matchedUser?: Maybe<Employee>;
  matchingStrategy: BackfilledAssignmentUserMatchingStrategy;
  org?: Maybe<Org>;
  phoneNumber: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  status: BackfilledCertificateStatus;
  traineeName: Scalars['String']['output'];
  usState?: Maybe<Scalars['String']['output']>;
};

export type BackfilledCertificateImportPreview = {
  __typename?: 'BackfilledCertificateImportPreview';
  alreadyBackfilled: Array<BackfilledCertificatePreviewRow>;
  alreadyCompliant: Array<BackfilledCertificatePreviewRow>;
  cleanMatches: Array<BackfilledCertificatePreviewRow>;
  csvErrors: Array<CsvSchemaError>;
  hrisEmployeeNotFound: Array<BackfilledCertificatePreviewRow>;
  userNotFound: Array<BackfilledCertificatePreviewRow>;
};

export type BackfilledCertificatePreviewRow = {
  __typename?: 'BackfilledCertificatePreviewRow';
  matchedHrisEmployee?: Maybe<HrisEmployee>;
  matchedUser?: Maybe<Employee>;
  traineeName: Scalars['String']['output'];
};

export enum BackfilledCertificateStatus {
  Pending = 'PENDING',
  Processed = 'PROCESSED'
}

export type BackfilledCertificates = PaginatedList & {
  __typename?: 'BackfilledCertificates';
  objects: Array<BackfilledCertificate>;
  totalCount: Scalars['Int']['output'];
};

export type BackfilledCertificatesFiltersInput = {
  complianceTypes?: InputMaybe<Array<ComplianceType>>;
  statuses?: InputMaybe<Array<BackfilledCertificateStatus>>;
};

export type BackfilledCertificatesInput = {
  filters?: InputMaybe<BackfilledCertificatesFiltersInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export enum BackgroundGradient {
  Blue = 'BLUE',
  Gradient_1 = 'GRADIENT_1',
  Gradient_2 = 'GRADIENT_2',
  Gradient_3 = 'GRADIENT_3',
  Gradient_4 = 'GRADIENT_4',
  Gradient_5 = 'GRADIENT_5',
  Gradient_6 = 'GRADIENT_6',
  Gradient_7 = 'GRADIENT_7',
  Gradient_8 = 'GRADIENT_8',
  Gradient_9 = 'GRADIENT_9',
  Gradient_10 = 'GRADIENT_10',
  Gray = 'GRAY',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Purple = 'PURPLE',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type BaseMutationResult = MutationResult & {
  __typename?: 'BaseMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type BillingAccount = {
  __typename?: 'BillingAccount';
  additionalBillingEmails?: Maybe<Array<Scalars['String']['output']>>;
  assignedCreditsBalance: Scalars['Int']['output'];
  autoCollectInvoices: Scalars['Boolean']['output'];
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingPortalUrl?: Maybe<Scalars['String']['output']>;
  creditBalance: Scalars['Int']['output'];
  creditSpendByLocation: CreditSpendByLocation;
  id: Scalars['UUID']['output'];
  invoices: Array<Invoice>;
  locationGroup?: Maybe<LocationGroup>;
  paymentMethod?: Maybe<PaymentMethod>;
  subscriptions: Array<BillingSubscription>;
};


export type BillingAccountCreditSpendByLocationArgs = {
  input?: InputMaybe<GetCreditSpendByLocationInput>;
};

export type BillingAccountInput = {
  address?: InputMaybe<AddressInput>;
  billingContact?: InputMaybe<UserInput>;
  email: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  locationLicenses?: InputMaybe<Scalars['Int']['input']>;
  subscription?: InputMaybe<SubscriptionInput>;
  userLicenses?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingSubscription = {
  __typename?: 'BillingSubscription';
  id: Scalars['UUID']['output'];
  plan: Plan;
};

export type BlastNotificationSchedule = {
  __typename?: 'BlastNotificationSchedule';
  reminderTime?: Maybe<Scalars['Time']['output']>;
  sendUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type BlastNotificationScheduleInput = {
  sendUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BlastNotifications = {
  __typename?: 'BlastNotifications';
  sentAt: Scalars['DateTime']['output'];
};

export type BlastRecipient = {
  __typename?: 'BlastRecipient';
  /** @deprecated Field no longer supported */
  employee: Employee;
  id: Scalars['Int']['output'];
  sentToPhone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  trainee: Employee;
  user: Employee;
};

export type BlastRecipientGroup = {
  __typename?: 'BlastRecipientGroup';
  id: Scalars['Int']['output'];
  location?: Maybe<Location>;
  role?: Maybe<Role>;
};

export type BlastSentRecord = {
  __typename?: 'BlastSentRecord';
  blastNotifications: Array<BlastNotifications>;
  createdAt: Scalars['DateTime']['output'];
  firstReadAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  latestNotification?: Maybe<Scalars['DateTime']['output']>;
  messageBlast: MessageBlast;
  messageReaction?: Maybe<MessageReaction>;
  recipient: Employee;
};

export type BlastSentRecordInput = {
  id: Scalars['Int']['input'];
  messageReaction: MessageReaction;
};

export type BlastSentRecords = PaginatedList & {
  __typename?: 'BlastSentRecords';
  objects: Array<BlastSentRecord>;
  totalCount: Scalars['Int']['output'];
};

export type BooleanValue = {
  value: Scalars['Boolean']['input'];
};

export type BrandDetails = {
  __typename?: 'BrandDetails';
  aiBrandContext?: Maybe<AiOrgContext>;
  brandColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  logoUrls?: Maybe<ImageUrls>;
};

export type BrandDetailsInput = {
  brandColor?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type BuilderAction = {
  __typename?: 'BuilderAction';
  addedModuleContentMembership?: Maybe<ModuleContentMembership>;
  clientId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  payload?: Maybe<Scalars['JSON']['output']>;
  user: Employee;
  uuid: Scalars['UUID']['output'];
};

export type BuilderActionInput = {
  clientId: Scalars['UUID']['input'];
  courseBuilderAction?: InputMaybe<CourseBuilderActionInput>;
  moduleBuilderAction?: InputMaybe<ModuleBuilderActionInput>;
  remediationInstanceBuilderAction?: InputMaybe<RemediationInstanceBuilderActionInput>;
  skillBuilderAction?: InputMaybe<SkillBuilderActionInput>;
  skillInstanceBuilderAction?: InputMaybe<SkillInstanceBuilderActionInput>;
  trainingResourceBuilderAction?: InputMaybe<TrainingResourceBuilderActionInput>;
  uuid: Scalars['UUID']['input'];
  workflowBuilderAction?: InputMaybe<WorkflowBuilderActionInput>;
};

export type BulkCreateTrainingResourceInput = {
  description?: InputMaybe<TranslationSetInput>;
  mediaUrls: TranslationSetInput;
  name: TranslationSetInput;
};

export type BulkPublishResourcesMutationResult = MutationResult & {
  __typename?: 'BulkPublishResourcesMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  trainingResources?: Maybe<Array<TrainingResource>>;
};

export type BulkUpdateLibraryItemAutomationsInput = {
  automationInput: AutomationInput;
  automationType: AutomationType;
  libraryItemIds: Array<Scalars['UUID']['input']>;
};

export type CrmabxAssignment = {
  __typename?: 'CRMABXAssignment';
  ae: CrmUser;
  assignedAt: Scalars['DateTime']['output'];
  company: CrmCompany;
  dealAttioId: Scalars['String']['output'];
  dealName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
};

export type CrmabxAssignments = PaginatedList & {
  __typename?: 'CRMABXAssignments';
  objects: Array<CrmabxAssignment>;
  totalCount: Scalars['Int']['output'];
};

export type CrmabxAssignmentsInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type CrmAccountStatusUpdate = {
  __typename?: 'CRMAccountStatusUpdate';
  attioCreatedAt: Scalars['DateTime']['output'];
  attioId: Scalars['String']['output'];
  blockers?: Maybe<Scalars['String']['output']>;
  company: CrmCompany;
  context?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<CrmUser>;
  id: Scalars['UUID']['output'];
  nextSteps?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CrmAccountStatusUpdates = PaginatedList & {
  __typename?: 'CRMAccountStatusUpdates';
  objects: Array<CrmAccountStatusUpdate>;
  totalCount: Scalars['Int']['output'];
};

export type CrmAccountStatusUpdatesInput = {
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type CrmCompanies = PaginatedList & {
  __typename?: 'CRMCompanies';
  objects: Array<CrmCompany>;
  totalCount: Scalars['Int']['output'];
};

export type CrmCompaniesInput = {
  csmAttioId?: InputMaybe<Scalars['String']['input']>;
  csmId?: InputMaybe<Scalars['UUID']['input']>;
  health?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type CrmCompany = {
  __typename?: 'CRMCompany';
  abxCurrentTier?: Maybe<Scalars['Int']['output']>;
  abxIntentScoreRealtime?: Maybe<Scalars['Int']['output']>;
  abxIntentScoreTotal?: Maybe<Scalars['Int']['output']>;
  abxLast30DayIntentScore?: Maybe<Scalars['Int']['output']>;
  abxLast60DayIntentScore?: Maybe<Scalars['Int']['output']>;
  abxLast90DayIntentScore?: Maybe<Scalars['Int']['output']>;
  abxScoresLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  accountStatusUpdates: Array<CrmAccountStatusUpdate>;
  acv?: Maybe<Scalars['Float']['output']>;
  attioId: Scalars['String']['output'];
  contacts: Array<CrmContact>;
  createdAt: Scalars['DateTime']['output'];
  csm?: Maybe<CrmUser>;
  customerSince?: Maybe<Scalars['Date']['output']>;
  customerStage?: Maybe<CustomerStage>;
  documents: Array<CrmCompanyDocument>;
  domains: Array<Scalars['String']['output']>;
  health?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  lastContactAt?: Maybe<Scalars['DateTime']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  linkedinEngagements?: Maybe<Scalars['Int']['output']>;
  linkedinImpressions?: Maybe<Scalars['Int']['output']>;
  locationCount?: Maybe<Scalars['Int']['output']>;
  meetings: Array<CrmMeeting>;
  name?: Maybe<Scalars['String']['output']>;
  nextRenewalDate?: Maybe<Scalars['Date']['output']>;
  notes: Array<CrmNote>;
  orgId?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<CrmUser>;
  segment?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CrmCompanyDocument = {
  __typename?: 'CRMCompanyDocument';
  company: CrmCompany;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  docType: Scalars['String']['output'];
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  sources: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CrmContact = {
  __typename?: 'CRMContact';
  attioId: Scalars['String']['output'];
  company?: Maybe<CrmCompany>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isChampion: Scalars['Boolean']['output'];
  isDecisionMaker: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastContactAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumbers: Array<Scalars['String']['output']>;
  role?: Maybe<StakeholderRole>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CrmContacts = PaginatedList & {
  __typename?: 'CRMContacts';
  objects: Array<CrmContact>;
  totalCount: Scalars['Int']['output'];
};

export type CrmContactsInput = {
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  isChampion?: InputMaybe<Scalars['Boolean']['input']>;
  isDecisionMaker?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<StakeholderRole>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type CrmDeal = {
  __typename?: 'CRMDeal';
  aiAuthorityScore?: Maybe<Scalars['Int']['output']>;
  aiBandwidth?: Maybe<Scalars['String']['output']>;
  aiBudgetScore?: Maybe<Scalars['Int']['output']>;
  aiCurrentInfrastructure?: Maybe<Scalars['String']['output']>;
  aiCustomerStories?: Maybe<Scalars['String']['output']>;
  aiCustomization?: Maybe<Scalars['String']['output']>;
  aiDemoBookedCompleted?: Maybe<Scalars['String']['output']>;
  aiExecutionSummary?: Maybe<Scalars['String']['output']>;
  aiFollowUpSpeed?: Maybe<Scalars['String']['output']>;
  aiLossReasonOption?: Maybe<Scalars['String']['output']>;
  aiLossSummary?: Maybe<Scalars['String']['output']>;
  aiMultithreading?: Maybe<Scalars['String']['output']>;
  aiNeedScore?: Maybe<Scalars['Int']['output']>;
  aiNextStepDiscipline?: Maybe<Scalars['String']['output']>;
  aiQualificationSummary?: Maybe<Scalars['String']['output']>;
  aiReadinessOption?: Maybe<Scalars['String']['output']>;
  aiReadinessSummary?: Maybe<Scalars['String']['output']>;
  aiTimelineScore?: Maybe<Scalars['Int']['output']>;
  aiTrainingOwnership?: Maybe<Scalars['String']['output']>;
  attioCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  attioId: Scalars['String']['output'];
  closeDate?: Maybe<Scalars['Date']['output']>;
  company?: Maybe<CrmCompany>;
  contractStartDate?: Maybe<Scalars['Date']['output']>;
  contractYears?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  cycleTime?: Maybe<Scalars['Int']['output']>;
  dealContactsCount?: Maybe<Scalars['Int']['output']>;
  enteredDiscoveryAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  leadType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<CrmUser>;
  plan?: Maybe<Scalars['String']['output']>;
  products: Array<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type CrmDealsFiltersInput = {
  aiAuthorityScores?: InputMaybe<Array<Scalars['Int']['input']>>;
  aiBandwidths?: InputMaybe<Array<Scalars['String']['input']>>;
  aiBudgetScores?: InputMaybe<Array<Scalars['Int']['input']>>;
  aiCurrentInfrastructures?: InputMaybe<Array<Scalars['String']['input']>>;
  aiCustomerStories?: InputMaybe<Array<Scalars['String']['input']>>;
  aiCustomizations?: InputMaybe<Array<Scalars['String']['input']>>;
  aiDemoBookedCompleteds?: InputMaybe<Array<Scalars['String']['input']>>;
  aiFollowUpSpeeds?: InputMaybe<Array<Scalars['String']['input']>>;
  aiLossReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  aiMultithreadings?: InputMaybe<Array<Scalars['String']['input']>>;
  aiNeedScores?: InputMaybe<Array<Scalars['Int']['input']>>;
  aiNextStepDisciplines?: InputMaybe<Array<Scalars['String']['input']>>;
  aiReadinessScores?: InputMaybe<Array<Scalars['String']['input']>>;
  aiTimelineScores?: InputMaybe<Array<Scalars['Int']['input']>>;
  aiTrainingOwnerships?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  dealTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  leadTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  segments?: InputMaybe<Array<Scalars['String']['input']>>;
  stages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CrmDealsInput = {
  filters: CrmDealsFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type CrmDealsResult = PaginatedList & {
  __typename?: 'CRMDealsResult';
  objects: Array<CrmDeal>;
  totalCount: Scalars['Int']['output'];
};

export type CrmDealsSummary = {
  __typename?: 'CRMDealsSummary';
  avgAuthorityScoreLost?: Maybe<Scalars['Float']['output']>;
  avgBudgetScoreLost?: Maybe<Scalars['Float']['output']>;
  avgCycleTimeLost?: Maybe<Scalars['Float']['output']>;
  avgCycleTimeWon?: Maybe<Scalars['Float']['output']>;
  avgDealValueLost?: Maybe<Scalars['Float']['output']>;
  avgDealValueWon?: Maybe<Scalars['Float']['output']>;
  avgNeedScoreLost?: Maybe<Scalars['Float']['output']>;
  avgTimelineScoreLost?: Maybe<Scalars['Float']['output']>;
  lossReasonBudgetPrice: Scalars['Int']['output'];
  lossReasonChampionLost: Scalars['Int']['output'];
  lossReasonCompetitor: Scalars['Int']['output'];
  lossReasonNoReadiness: Scalars['Int']['output'];
  lossReasonNotQualified: Scalars['Int']['output'];
  lossReasonOther: Scalars['Int']['output'];
  lossReasonProductGap: Scalars['Int']['output'];
  notReadyCount: Scalars['Int']['output'];
  partiallyReadyCount: Scalars['Int']['output'];
  readyCount: Scalars['Int']['output'];
  totalLost: Scalars['Int']['output'];
  totalWon: Scalars['Int']['output'];
};

export type CrmEmail = {
  __typename?: 'CRMEmail';
  body?: Maybe<Scalars['String']['output']>;
  cc?: Maybe<Array<Scalars['String']['output']>>;
  company?: Maybe<CrmCompany>;
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Array<Scalars['String']['output']>>;
};

export type CrmEmails = PaginatedList & {
  __typename?: 'CRMEmails';
  objects: Array<CrmEmail>;
  totalCount: Scalars['Int']['output'];
};

export type CrmEmailsInput = {
  companyId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CrmGmailConnection = {
  __typename?: 'CRMGmailConnection';
  createdAt: Scalars['DateTime']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  errorCount: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CrmMeeting = {
  __typename?: 'CRMMeeting';
  aiSummary?: Maybe<Scalars['String']['output']>;
  attioCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  attioMeetingId: Scalars['String']['output'];
  company?: Maybe<CrmCompany>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  participants: Array<CrmMeetingParticipant>;
  rawTranscript?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CrmMeetingParticipant = {
  __typename?: 'CRMMeetingParticipant';
  emailAddress?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CrmMeetings = PaginatedList & {
  __typename?: 'CRMMeetings';
  objects: Array<CrmMeeting>;
  totalCount: Scalars['Int']['output'];
};

export type CrmMeetingsInput = {
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
  startTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CrmNote = {
  __typename?: 'CRMNote';
  attioCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  attioNoteId: Scalars['String']['output'];
  company?: Maybe<CrmCompany>;
  contact?: Maybe<CrmContact>;
  contentPlaintext?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<CrmUser>;
  id: Scalars['UUID']['output'];
  parentObject: Scalars['String']['output'];
  parentRecordAttioId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CrmNotes = PaginatedList & {
  __typename?: 'CRMNotes';
  objects: Array<CrmNote>;
  totalCount: Scalars['Int']['output'];
};

export type CrmNotesInput = {
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
};

export enum CrmTeam {
  Cs = 'CS',
  Leadership = 'LEADERSHIP',
  Marketing = 'MARKETING',
  Product = 'PRODUCT',
  Sales = 'SALES'
}

export type CrmUser = {
  __typename?: 'CRMUser';
  attioId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  gmailConnection?: Maybe<CrmGmailConnection>;
  id: Scalars['UUID']['output'];
  person: Person;
  team?: Maybe<CrmTeam>;
  updatedAt: Scalars['DateTime']['output'];
  zoomInfoConnection?: Maybe<CrmZoomInfoConnection>;
};

export type CrmUsers = PaginatedList & {
  __typename?: 'CRMUsers';
  objects: Array<CrmUser>;
  totalCount: Scalars['Int']['output'];
};

export type CrmZoomInfoConnection = {
  __typename?: 'CRMZoomInfoConnection';
  createdAt: Scalars['DateTime']['output'];
  errorCount: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CsRep = {
  __typename?: 'CSRep';
  intercomAdminId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CsTicket = {
  __typename?: 'CSTicket';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  csmRep?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  priority?: Maybe<Scalars['String']['output']>;
  rawStatus: Scalars['String']['output'];
  source: Scalars['String']['output'];
  statusBucket: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum CsTicketSource {
  CustomerProblem = 'CUSTOMER_PROBLEM',
  Intercom = 'INTERCOM',
  Request = 'REQUEST'
}

export type CsTicketSourceCount = {
  __typename?: 'CSTicketSourceCount';
  count: Scalars['Int']['output'];
  source: Scalars['String']['output'];
};

export type CsTicketStats = {
  __typename?: 'CSTicketStats';
  medianResolutionHours?: Maybe<Scalars['Float']['output']>;
  newThisWeek: Scalars['Int']['output'];
  openBySource: Array<CsTicketSourceCount>;
  openCount: Scalars['Int']['output'];
  resolvedSparkline: Array<Scalars['Int']['output']>;
  resolvedThisWeek: Scalars['Int']['output'];
};

export enum CsTicketStatusBucket {
  AwaitingReply = 'AWAITING_REPLY',
  Closed = 'CLOSED',
  Open = 'OPEN',
  Pending = 'PENDING',
  Snoozed = 'SNOOZED',
  Unknown = 'UNKNOWN'
}

export type CsTicketsFeedInput = {
  adminIds?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  customers?: InputMaybe<Array<Scalars['String']['input']>>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  newThisWeek?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedThisWeek?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<StringValue>;
  sources?: InputMaybe<Array<CsTicketSource>>;
  statusBuckets?: InputMaybe<Array<CsTicketStatusBucket>>;
};

export type CsTicketsList = PaginatedList & {
  __typename?: 'CSTicketsList';
  objects: Array<CsTicket>;
  totalCount: Scalars['Int']['output'];
};

export type CandidateMergeChoiceInput = {
  candidateId: Scalars['ID']['input'];
  chosenAttioId?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CatalogCategory = {
  __typename?: 'CatalogCategory';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isOnCategoryNav: Scalars['Boolean']['output'];
  memberships: Array<CatalogCourseMembership>;
  name: Scalars['String']['output'];
  onHomepage: Scalars['Boolean']['output'];
};

export type CatalogCourse = {
  __typename?: 'CatalogCourse';
  course: Course;
  description: Scalars['String']['output'];
  developedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  minutesToAuthor?: Maybe<Scalars['Int']['output']>;
  type: CatalogCourseType;
};

export type CatalogCourseMembership = {
  __typename?: 'CatalogCourseMembership';
  catalogCourse?: Maybe<CatalogCourse>;
  catalogModule?: Maybe<CatalogModule>;
  catalogSharp?: Maybe<SharpCatalogExperience>;
  id: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
};

export enum CatalogCourseType {
  Premium = 'PREMIUM',
  Ready = 'READY',
  Template = 'TEMPLATE'
}

export type CatalogModule = {
  __typename?: 'CatalogModule';
  description: Scalars['String']['output'];
  developedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  module: Module;
  premiumConfig?: Maybe<PremiumContentConfig>;
  type: CatalogCourseType;
};

export type CatalogMutationResult = MutationResult & {
  __typename?: 'CatalogMutationResult';
  course?: Maybe<Course>;
  courses?: Maybe<Array<Course>>;
  error?: Maybe<Error>;
  modules?: Maybe<Array<Module>>;
  orgPremiumConfigs?: Maybe<Array<OrgPremiumContentConfig>>;
  success: Scalars['Boolean']['output'];
};

export type CertificateEndorser = {
  __typename?: 'CertificateEndorser';
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Chat = {
  __typename?: 'Chat';
  chatType: ChatType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Employee;
  id: Scalars['UUID']['output'];
  latestMessageCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  latestMessageHasAttachments: Scalars['Boolean']['output'];
  latestMessageText?: Maybe<Scalars['String']['output']>;
  members: Array<Employee>;
  membersCanEditMembers: Scalars['Boolean']['output'];
  membersCanEditTitle: Scalars['Boolean']['output'];
  owners: Array<Employee>;
  title?: Maybe<TranslationSet>;
  unreadCount: Scalars['Int']['output'];
  userSelectionSet: UserSelectionSet;
  viewerArchivedAt?: Maybe<Scalars['DateTime']['output']>;
  viewerIsOwner: Scalars['Boolean']['output'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  attachment?: Maybe<ChatMessageAttachment>;
  author: Employee;
  authorSearchHeadline?: Maybe<Scalars['String']['output']>;
  chat: Chat;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  hasUnresolvedReport: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  mentions: Array<ChatMessageMention>;
  reactions: Array<ChatMessageReaction>;
  reportedChatMessageAttachments: Array<ChatMessageAttachment>;
  reportedText?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  textSearchHeadline?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  viewerCanStartChatWithAuthor: Scalars['Boolean']['output'];
};

export type ChatMessageAttachment = {
  __typename?: 'ChatMessageAttachment';
  chatMessage: ChatMessage;
  id: Scalars['UUID']['output'];
  libraryItem?: Maybe<LibraryItem>;
  media?: Maybe<Media>;
  reportedMedia?: Maybe<Media>;
};

export type ChatMessageAttachmentInput = {
  libraryItemId?: InputMaybe<Scalars['UUID']['input']>;
  mediaId?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatMessageMention = {
  __typename?: 'ChatMessageMention';
  id: Scalars['UUID']['output'];
  mentionedUser: Employee;
};

export type ChatMessageMutationResult = MutationResult & {
  __typename?: 'ChatMessageMutationResult';
  chatMessage?: Maybe<ChatMessage>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type ChatMessageReaction = {
  __typename?: 'ChatMessageReaction';
  createdAt: Scalars['DateTime']['output'];
  emoji: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  user: Employee;
};

export type ChatMessages = PaginatedList & {
  __typename?: 'ChatMessages';
  objects: Array<ChatMessage>;
  totalCount: Scalars['Int']['output'];
};

export type ChatMessagesInput = {
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type ChatMessagesMutationResult = MutationResult & {
  __typename?: 'ChatMessagesMutationResult';
  chatMessages: Array<ChatMessage>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type ChatMutationResult = MutationResult & {
  __typename?: 'ChatMutationResult';
  chat?: Maybe<Chat>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type ChatSearchResult = {
  __typename?: 'ChatSearchResult';
  chat: Chat;
  message?: Maybe<ChatMessage>;
};

export type ChatSearchResults = PaginatedList & {
  __typename?: 'ChatSearchResults';
  objects: Array<ChatSearchResult>;
  totalCount: Scalars['Int']['output'];
};

export enum ChatType {
  Group = 'GROUP',
  OneOnOne = 'ONE_ON_ONE'
}

export type Chats = PaginatedList & {
  __typename?: 'Chats';
  objects: Array<Chat>;
  totalCount: Scalars['Int']['output'];
};

export type ChatsInput = {
  archived?: InputMaybe<BooleanValue>;
};

export enum ChunkSourceType {
  IntercomArticle = 'INTERCOM_ARTICLE',
  LibraryItemMeta = 'LIBRARY_ITEM_META',
  Prompt = 'PROMPT',
  PromptMedia = 'PROMPT_MEDIA',
  ResourceSegment = 'RESOURCE_SEGMENT',
  UserQuery = 'USER_QUERY'
}

export type ClearFormActionInput = {
  clearForm: Scalars['Boolean']['input'];
};

export type ClientFacingWorkflow = {
  __typename?: 'ClientFacingWorkflow';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Employee;
  id: Scalars['UUID']['output'];
  result?: Maybe<ClientFacingWorkflowResult>;
  status: ClientFacingWorkflowStatus;
  type: ClientFacingWorkflowType;
};

export type ClientFacingWorkflowMutationResult = MutationResult & {
  __typename?: 'ClientFacingWorkflowMutationResult';
  clientFacingWorkflow?: Maybe<ClientFacingWorkflow>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type ClientFacingWorkflowResult = {
  __typename?: 'ClientFacingWorkflowResult';
  extraction?: Maybe<Scalars['JSON']['output']>;
  failedContactIds?: Maybe<Array<Scalars['UUID']['output']>>;
  failureMessages?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['UUID']['output'];
  libraryItem?: Maybe<LibraryItem>;
  succeededContactIds?: Maybe<Array<Scalars['UUID']['output']>>;
};

export enum ClientFacingWorkflowStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum ClientFacingWorkflowType {
  AiUpdateLibraryItem = 'AI_UPDATE_LIBRARY_ITEM',
  ContactEnrichmentEnrich = 'CONTACT_ENRICHMENT_ENRICH',
  ContactEnrichmentSearch = 'CONTACT_ENRICHMENT_SEARCH',
  ContactEnrichmentSync = 'CONTACT_ENRICHMENT_SYNC',
  ContractPdfExtraction = 'CONTRACT_PDF_EXTRACTION',
  CreateAuditFromOutline = 'CREATE_AUDIT_FROM_OUTLINE',
  CreateCheckInFromOutline = 'CREATE_CHECK_IN_FROM_OUTLINE',
  CreateCourseFromOutline = 'CREATE_COURSE_FROM_OUTLINE',
  CreateModuleFromOutline = 'CREATE_MODULE_FROM_OUTLINE',
  CreateTaskListFromOutline = 'CREATE_TASK_LIST_FROM_OUTLINE'
}

export enum ClockInConfirmationAction {
  Files = 'FILES',
  Lessons = 'LESSONS',
  Messages = 'MESSAGES'
}

export type ClockInConfirmationSettings = {
  __typename?: 'ClockInConfirmationSettings';
  files: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  lessons: Scalars['Boolean']['output'];
  messages: Scalars['Boolean']['output'];
};

export type CoachingCriterion = {
  __typename?: 'CoachingCriterion';
  agentGuidance: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  maxValue?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  order: Scalars['Int']['output'];
  valueType: CoachingCriterionValueType;
};

export type CoachingCriterionInput = {
  agentGuidance: Scalars['String']['input'];
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  maxValue?: InputMaybe<Scalars['Int']['input']>;
  minValue?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  valueType: CoachingCriterionValueType;
};

export type CoachingCriterionResult = {
  __typename?: 'CoachingCriterionResult';
  commentary: Scalars['String']['output'];
  evidenceQuotes?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  maxValue?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
  valueType: CoachingCriterionValueType;
};

export type CoachingCriterionResultInput = {
  commentary?: InputMaybe<Scalars['String']['input']>;
  criterionKey: Scalars['String']['input'];
  evidenceQuotes?: InputMaybe<Array<Scalars['String']['input']>>;
  value: Scalars['String']['input'];
};

export enum CoachingCriterionValueType {
  Number = 'NUMBER',
  Select = 'SELECT',
  Text = 'TEXT'
}

export type CoachingPinnedRubric = {
  __typename?: 'CoachingPinnedRubric';
  criteria: Array<CoachingCriterion>;
  promptBody: Scalars['String']['output'];
  templateId: Scalars['UUID']['output'];
  templateName: Scalars['String']['output'];
};

export type CoachingPromptTemplate = {
  __typename?: 'CoachingPromptTemplate';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  identificationGuidance: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isSeeded: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  publishedVersion?: Maybe<CoachingPromptTemplateVersion>;
  team: CrmTeam;
  versions: Array<CoachingPromptTemplateVersion>;
};

export type CoachingPromptTemplateVersion = {
  __typename?: 'CoachingPromptTemplateVersion';
  criteria: Array<CoachingCriterion>;
  id: Scalars['UUID']['output'];
  promptBody: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedByName?: Maybe<Scalars['String']['output']>;
  versionNumber: Scalars['Int']['output'];
};

export type CoachingRun = {
  __typename?: 'CoachingRun';
  callAt?: Maybe<Scalars['DateTime']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  criterionResults: Array<CoachingCriterionResult>;
  errorMessage: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isTest: Scalars['Boolean']['output'];
  meetingTitle?: Maybe<Scalars['String']['output']>;
  overallSummary: Scalars['String']['output'];
  reRunOf?: Maybe<CoachingRun>;
  repNames: Array<Scalars['String']['output']>;
  routingReasoning: Scalars['String']['output'];
  routingState: CoachingRunRoutingState;
  status: CoachingRunStatus;
  team: CrmTeam;
  templateId?: Maybe<Scalars['UUID']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  templateVersionId?: Maybe<Scalars['UUID']['output']>;
  triggerSource: CoachingTriggerSource;
  triggeredByName?: Maybe<Scalars['String']['output']>;
};

export type CoachingRunList = PaginatedList & {
  __typename?: 'CoachingRunList';
  objects: Array<CoachingRun>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CoachingRunMutationResult = MutationResult & {
  __typename?: 'CoachingRunMutationResult';
  error?: Maybe<Error>;
  run?: Maybe<CoachingRun>;
  success: Scalars['Boolean']['output'];
};

export enum CoachingRunRoutingState {
  NotRequired = 'NOT_REQUIRED',
  NoTemplate = 'NO_TEMPLATE',
  Pending = 'PENDING',
  Selected = 'SELECTED'
}

export enum CoachingRunStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type CoachingRunsFiltersInput = {
  includeTests?: InputMaybe<Scalars['Boolean']['input']>;
  meetingId?: InputMaybe<Scalars['UUID']['input']>;
  notCoachedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  repIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  team: CrmTeam;
  templateIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type CoachingRunsInput = {
  filters: CoachingRunsFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type CoachingTemplateCandidate = {
  __typename?: 'CoachingTemplateCandidate';
  criteria: Array<CoachingCriterion>;
  id: Scalars['UUID']['output'];
  identificationGuidance: Scalars['String']['output'];
  name: Scalars['String']['output'];
  promptBody: Scalars['String']['output'];
};

export type CoachingTemplateMutationResult = MutationResult & {
  __typename?: 'CoachingTemplateMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  template?: Maybe<CoachingPromptTemplate>;
};

export enum CoachingTemplateRoutingKind {
  CsAgentClassified = 'CS_AGENT_CLASSIFIED',
  CsLaunchStage = 'CS_LAUNCH_STAGE',
  SalesDealStage = 'SALES_DEAL_STAGE'
}

export type CoachingTemplatesInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  team: CrmTeam;
};

export type CoachingTestMeeting = {
  __typename?: 'CoachingTestMeeting';
  companyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  startTime?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum CoachingTriggerSource {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
  Test = 'TEST'
}

export enum CommandSource {
  AttioClosedDealAnalysis = 'ATTIO_CLOSED_DEAL_ANALYSIS',
  AttioCoachingAgent = 'ATTIO_COACHING_AGENT',
  AttioScopeAgent = 'ATTIO_SCOPE_AGENT',
  ContentBuilderAgent = 'CONTENT_BUILDER_AGENT',
  CourseGeneratorAgent = 'COURSE_GENERATOR_AGENT',
  CourseUpdaterAgent = 'COURSE_UPDATER_AGENT',
  CustomerCallImpact = 'CUSTOMER_CALL_IMPACT',
  CustomerProblem = 'CUSTOMER_PROBLEM',
  DbqTaskIssue = 'DBQ_TASK_ISSUE',
  DocConverterAgent = 'DOC_CONVERTER_AGENT',
  GithubCiFailure = 'GITHUB_CI_FAILURE',
  GithubPrComment = 'GITHUB_PR_COMMENT',
  GithubPrReviewRafiki = 'GITHUB_PR_REVIEW_RAFIKI',
  LinearIssueDebug = 'LINEAR_ISSUE_DEBUG',
  LinearTriageRafiki = 'LINEAR_TRIAGE_RAFIKI',
  Maintenance = 'MAINTENANCE',
  Manual = 'MANUAL',
  ScheduledChangelogPublisher = 'SCHEDULED_CHANGELOG_PUBLISHER',
  ScheduledGuestFeedbackRecommendations = 'SCHEDULED_GUEST_FEEDBACK_RECOMMENDATIONS',
  ScheduledMemoryLibrarian = 'SCHEDULED_MEMORY_LIBRARIAN',
  ScheduledRafikiDriftSweep = 'SCHEDULED_RAFIKI_DRIFT_SWEEP',
  ScheduledRafikiFreeTime = 'SCHEDULED_RAFIKI_FREE_TIME',
  ScheduledRafikiHeartbeat = 'SCHEDULED_RAFIKI_HEARTBEAT',
  ScheduledRafikiSpendReport = 'SCHEDULED_RAFIKI_SPEND_REPORT',
  ScheduledRumTriage = 'SCHEDULED_RUM_TRIAGE',
  SkillGeneratorAgent = 'SKILL_GENERATOR_AGENT',
  SlackDmRafiki = 'SLACK_DM_RAFIKI',
  SlackMentionBestie = 'SLACK_MENTION_BESTIE',
  SlackMentionScar = 'SLACK_MENTION_SCAR',
  SlackThreadRafiki = 'SLACK_THREAD_RAFIKI'
}

export enum CommandStatus {
  Aborted = 'ABORTED',
  Failed = 'FAILED',
  Killed = 'KILLED',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

export enum CommandType {
  GoldenVolumeRebuild = 'GOLDEN_VOLUME_REBUILD',
  GoldenVolumeUpdate = 'GOLDEN_VOLUME_UPDATE',
  Manual = 'MANUAL',
  WorkerAgent = 'WORKER_AGENT',
  WorkerInit = 'WORKER_INIT'
}

export type Comment = {
  __typename?: 'Comment';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Employee;
  id: Scalars['UUID']['output'];
  inProductNotifications: Array<InProductNotification>;
  mentions: Array<CommentMention>;
  text: Scalars['String']['output'];
  thread: CommentThread;
};

export type CommentInput = {
  mentionedUserIds: Array<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};

export type CommentMention = {
  __typename?: 'CommentMention';
  id: Scalars['UUID']['output'];
  mentionedUser: Employee;
};

export type CommentThread = {
  __typename?: 'CommentThread';
  comments: Array<Comment>;
  id: Scalars['UUID']['output'];
  prompt?: Maybe<Prompt>;
  quotedText: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<Employee>;
  richTextDocument?: Maybe<RichTextDocument>;
};

export type CommentThreadMutationResult = MutationResult & {
  __typename?: 'CommentThreadMutationResult';
  commentThread?: Maybe<CommentThread>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type CompanyContactCandidate = {
  __typename?: 'CompanyContactCandidate';
  emails: Array<SourcedValue>;
  enrichedBy: Array<ProviderEnrichment>;
  firstName?: Maybe<Scalars['String']['output']>;
  foundIn: Array<ProviderSource>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isManuallyMerged: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  phones: Array<SourcedValue>;
  syncedToAttioAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompleteKnowledgeCheckInput = {
  attempt: CourseProgressPromptAttemptInput;
  confidence?: InputMaybe<KnowledgeCheckConfidence>;
  knowledgeCheckId: Scalars['UUID']['input'];
};

export type CompleteKnowledgeCheckMutationResult = MutationResult & {
  __typename?: 'CompleteKnowledgeCheckMutationResult';
  error?: Maybe<Error>;
  knowledgeCheck?: Maybe<KnowledgeCheck>;
  success: Scalars['Boolean']['output'];
};

export enum CompleteModuleInOrder {
  AnyOrder = 'ANY_ORDER',
  SectionOrder = 'SECTION_ORDER',
  SectionOrderSkipVerifications = 'SECTION_ORDER_SKIP_VERIFICATIONS',
  StrictOrder = 'STRICT_ORDER',
  StrictOrderSkipVerifications = 'STRICT_ORDER_SKIP_VERIFICATIONS'
}

export type CompleteReAuditInput = {
  assigneeDueDate: Scalars['Date']['input'];
  assigneeId: Scalars['Int']['input'];
  auditorMediaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  auditorNotes?: InputMaybe<Scalars['String']['input']>;
  remediationInstanceId: Scalars['UUID']['input'];
};

export type CompleteReAuditMutationResult = MutationResult & {
  __typename?: 'CompleteReAuditMutationResult';
  currentRemediationInstance?: Maybe<RemediationInstance>;
  error?: Maybe<Error>;
  newRemediationInstance?: Maybe<RemediationInstance>;
  success: Scalars['Boolean']['output'];
};

export type CompletedTaskCount = {
  __typename?: 'CompletedTaskCount';
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  libraryItemId: Scalars['UUID']['output'];
  locationId: Scalars['Int']['output'];
};

export type CompletedTaskCounts = PaginatedList & {
  __typename?: 'CompletedTaskCounts';
  objects: Array<CompletedTaskCount>;
  totalCount: Scalars['Int']['output'];
};

export type CompletedTaskCountsInput = {
  endDate?: InputMaybe<DateTimeValue>;
  libraryItemIds?: InputMaybe<UuidArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
  startDate?: InputMaybe<DateTimeValue>;
};

export type CompletedTaskSkillInstancesInput = {
  filters: CompletedTaskSkillInstancesSearchSortPaginateFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type CompletedTaskSkillInstancesSearchSortPaginateFiltersInput = {
  itemTypes?: InputMaybe<LibraryItemTypeListInput>;
  libraryItemIds?: InputMaybe<UuidArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
  skillInstanceIds?: InputMaybe<UuidArrayInput>;
  skillInstanceLocationIds?: InputMaybe<IntArrayInput>;
  verifiedAtEndDate?: InputMaybe<DateTimeValue>;
  verifiedAtStartDate?: InputMaybe<DateTimeValue>;
};

export type CompletionReportsInput = {
  allLocations?: InputMaybe<BooleanValue>;
  currentInstanceCompletedEndDate?: InputMaybe<DateTimeInput>;
  currentInstanceCompletedStartDate?: InputMaybe<DateTimeInput>;
  libraryItemIds?: InputMaybe<UuidArrayInput>;
  locationGroupIds?: InputMaybe<UuidArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
  roleIds?: InputMaybe<IntArrayInput>;
  userTypes?: InputMaybe<UserTypeListInput>;
};

export type CompletionSchedule = {
  __typename?: 'CompletionSchedule';
  createdAt: Scalars['DateTime']['output'];
  currentVersion?: Maybe<CompletionScheduleVersion>;
  id: Scalars['UUID']['output'];
  libraryItem: LibraryItem;
  name?: Maybe<TranslationSet>;
};

export type CompletionScheduleInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  libraryItemId: Scalars['UUID']['input'];
  name?: InputMaybe<TranslationSetObjectInput>;
  version: CompletionScheduleVersionInput;
};

export type CompletionScheduleInstance = {
  __typename?: 'CompletionScheduleInstance';
  completedBySkillInstance?: Maybe<SkillInstance>;
  end: Scalars['DateTimeUtc']['output'];
  id: Scalars['UUID']['output'];
  isMissed: Scalars['Boolean']['output'];
  isOpen: Scalars['Boolean']['output'];
  location: Location;
  start: Scalars['DateTimeUtc']['output'];
  window: CompletionScheduleWindow;
};

export type CompletionScheduleInstances = PaginatedList & {
  __typename?: 'CompletionScheduleInstances';
  objects: Array<CompletionScheduleInstance>;
  totalCount: Scalars['Int']['output'];
};

export type CompletionScheduleInstancesFiltersInput = {
  completed?: InputMaybe<BooleanValue>;
  endAfter?: InputMaybe<DateTimeUtcValue>;
  endBefore?: InputMaybe<DateTimeUtcValue>;
  endDate?: InputMaybe<DateValue>;
  libraryItemIds?: InputMaybe<UuidArrayInput>;
  libraryItemTypes?: InputMaybe<LibraryItemTypeListInput>;
  startAfter?: InputMaybe<DateTimeUtcValue>;
  startBefore?: InputMaybe<DateTimeUtcValue>;
  startDate?: InputMaybe<DateValue>;
};

export type CompletionScheduleInstancesInput = {
  filters: CompletionScheduleInstancesFiltersInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type CompletionScheduleMutationResult = MutationResult & {
  __typename?: 'CompletionScheduleMutationResult';
  completionSchedule?: Maybe<CompletionSchedule>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type CompletionScheduleVersion = {
  __typename?: 'CompletionScheduleVersion';
  completionSchedule: CompletionSchedule;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Employee;
  flattenedLocations: Array<Location>;
  id: Scalars['UUID']['output'];
  locationGroups: Array<LocationGroup>;
  locations: Array<Location>;
  scheduleSet: ScheduleSet;
};

export type CompletionScheduleVersionInput = {
  locationGroupIds?: InputMaybe<UuidArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
  scheduleSet: ScheduleSetInput;
};

export type CompletionScheduleWindow = {
  __typename?: 'CompletionScheduleWindow';
  completionSchedule: CompletionSchedule;
  completionScheduleVersion: CompletionScheduleVersion;
  end: Scalars['DateTimeNaive']['output'];
  id: Scalars['UUID']['output'];
  instances: Array<CompletionScheduleInstance>;
  start: Scalars['DateTimeNaive']['output'];
};

export type CompletionScheduleWindows = PaginatedList & {
  __typename?: 'CompletionScheduleWindows';
  objects: Array<CompletionScheduleWindow>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CompletionScheduleWindowsFiltersInput = {
  completionScheduleIds?: InputMaybe<UuidArrayInput>;
  endDateTime?: InputMaybe<DateTimeNaiveValue>;
  libraryItemId?: InputMaybe<UuidValue>;
  locationIds?: InputMaybe<IntArrayInput>;
  startBefore?: InputMaybe<DateTimeNaiveValue>;
  startDateTime?: InputMaybe<DateTimeNaiveValue>;
};

export type CompletionScheduleWindowsInput = {
  filters: CompletionScheduleWindowsFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type ComplianceAttempt = {
  __typename?: 'ComplianceAttempt';
  assignedUserType?: Maybe<AssignedUserType>;
  becameCompliantAt?: Maybe<Scalars['DateTime']['output']>;
  compliantUntil?: Maybe<Scalars['DateTime']['output']>;
  courseInstance?: Maybe<CourseInstance>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  importedFromExternalSource: Scalars['Boolean']['output'];
  isCompliant: Scalars['Boolean']['output'];
  moduleInstance?: Maybe<ModuleInstance>;
  usState?: Maybe<Scalars['USState']['output']>;
};

export type ComplianceAttemptImportInput = {
  assignedUserType?: InputMaybe<AssignedUserType>;
  becameCompliantAt: Scalars['DateTime']['input'];
  complianceType: ComplianceType;
  usState?: InputMaybe<Scalars['USState']['input']>;
  userId: Scalars['Int']['input'];
};

export type ComplianceAttemptImportsInput = {
  complianceAttemptImports: Array<ComplianceAttemptImportInput>;
};

export type ComplianceRecord = {
  __typename?: 'ComplianceRecord';
  attempts: Array<ComplianceAttempt>;
  complianceType: ComplianceType;
  compliantAt?: Maybe<Scalars['DateTime']['output']>;
  compliantUntil?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isCompliant: Scalars['Boolean']['output'];
  isPastDue: Scalars['Boolean']['output'];
  user: Employee;
};

export type ComplianceRecords = PaginatedList & {
  __typename?: 'ComplianceRecords';
  objects: Array<ComplianceRecord>;
  totalCount: Scalars['Int']['output'];
};

export type ComplianceRecordsInput = {
  assignedUserTypes?: InputMaybe<Array<AssignedUserType>>;
  complianceType?: InputMaybe<ComplianceTypeInput>;
  isCompliant?: InputMaybe<BooleanValue>;
  isOrHasBeenCompliant?: InputMaybe<BooleanValue>;
  locationGroupIds?: InputMaybe<UuidArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
  peopleFilters?: InputMaybe<GetPeopleInput>;
  roleIds?: InputMaybe<IntArrayInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
  usStates?: InputMaybe<Array<InputMaybe<Scalars['USState']['input']>>>;
  userIds?: InputMaybe<IntArrayInput>;
};

export type ComplianceReport = {
  __typename?: 'ComplianceReport';
  allLocations: Scalars['Boolean']['output'];
  completed: Scalars['Int']['output'];
  complianceType: ComplianceType;
  id: Scalars['UUID']['output'];
  locationGroupId?: Maybe<Scalars['UUID']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ComplianceReportsInput = {
  complianceType?: InputMaybe<ComplianceTypeInput>;
};

export enum ComplianceType {
  Allertrain = 'ALLERTRAIN',
  AllertrainManager = 'ALLERTRAIN_MANAGER',
  CaIndoorHeatIllnessPreventionNonsupervisor = 'CA_INDOOR_HEAT_ILLNESS_PREVENTION_NONSUPERVISOR',
  CaIndoorHeatIllnessPreventionSupervisor = 'CA_INDOOR_HEAT_ILLNESS_PREVENTION_SUPERVISOR',
  CaWorkplaceViolencePreventionNonsupervisor = 'CA_WORKPLACE_VIOLENCE_PREVENTION_NONSUPERVISOR',
  CaWorkplaceViolencePreventionSupervisor = 'CA_WORKPLACE_VIOLENCE_PREVENTION_SUPERVISOR',
  FoodHandler = 'FOOD_HANDLER',
  FoodManager = 'FOOD_MANAGER',
  HumanTraffickingAwarenessCa = 'HUMAN_TRAFFICKING_AWARENESS_CA',
  SexualHarassmentPrevention = 'SEXUAL_HARASSMENT_PREVENTION'
}

export type ComplianceTypeInput = {
  value: ComplianceType;
};

export type ConditionalStepGroup = {
  __typename?: 'ConditionalStepGroup';
  checkedCondition?: Maybe<TriggerCheckedCondition>;
  childVerificationSteps: Array<VerificationStep>;
  id: Scalars['UUID']['output'];
  numberCondition?: Maybe<TriggerNumberCondition>;
  parentVerificationStep: VerificationStep;
  verificationStepMultipleChoiceCondition?: Maybe<TriggerVerificationStepMultipleChoiceCondition>;
  verificationSteps: Array<VerificationStep>;
  yesNoCondition?: Maybe<TriggerYesNoCondition>;
};

export type ConditionalStepGroupInput = {
  checkedCondition?: InputMaybe<BooleanValue>;
  id: Scalars['UUID']['input'];
  numberCondition?: InputMaybe<TriggerNumberConditionInput>;
  verificationStepMultipleChoiceAnyCondition?: InputMaybe<VerificationStepTriggerMultipleChoiceAnyConditionInput>;
  verificationStepMultipleChoiceCondition?: InputMaybe<VerificationStepTriggerMultipleChoiceConditionInput>;
  yesNoCondition?: InputMaybe<BooleanValue>;
};

export type ConnectWorkflowNodesActionInput = {
  childNodeId: Scalars['UUID']['input'];
  parentNodeId: Scalars['UUID']['input'];
};

export type ContentInput = {
  courseId?: InputMaybe<Scalars['Int']['input']>;
  moduleId?: InputMaybe<Scalars['Int']['input']>;
  orgPremiumContentConfigId?: InputMaybe<Scalars['Int']['input']>;
  scormCourseId?: InputMaybe<Scalars['UUID']['input']>;
  skillId?: InputMaybe<Scalars['Int']['input']>;
  trainingResourceId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ContentPermissions = {
  __typename?: 'ContentPermissions';
  hasCommentPermission: Scalars['Boolean']['output'];
  hasEditAdminAndManagerSharingPermission: Scalars['Boolean']['output'];
  hasEditContentPermission: Scalars['Boolean']['output'];
  hasPublishPermission: Scalars['Boolean']['output'];
  hasShareWithIndividualsPermission: Scalars['Boolean']['output'];
};

export type ContentQrCode = {
  __typename?: 'ContentQRCode';
  destinationUrl: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  imageUrl: Scalars['String']['output'];
  includeLogo: Scalars['Boolean']['output'];
  includeTitle: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type ContentSharingPermission = {
  __typename?: 'ContentSharingPermission';
  allAdmins: SharingPermission;
  allManagers: SharingPermission;
  id: Scalars['UUID']['output'];
  individuals: Array<UserSharingPermission>;
};

export type ContentSharingPermissionMutationResult = MutationResult & {
  __typename?: 'ContentSharingPermissionMutationResult';
  contentSharingPermission?: Maybe<ContentSharingPermission>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type ContentTagMembership = {
  __typename?: 'ContentTagMembership';
  /** @deprecated Field no longer supported */
  course?: Maybe<Course>;
  /** @deprecated Field no longer supported */
  courseId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  libraryItem: LibraryItem;
  libraryItemId: Scalars['UUID']['output'];
  /** @deprecated Field no longer supported */
  skill?: Maybe<Skill>;
  /** @deprecated Field no longer supported */
  skillId?: Maybe<Scalars['Int']['output']>;
  tag: Tag;
  tagId: Scalars['UUID']['output'];
  /** @deprecated Field no longer supported */
  trainingResource?: Maybe<TrainingResource>;
  /** @deprecated Field no longer supported */
  trainingResourceId?: Maybe<Scalars['UUID']['output']>;
};

export type ContentTagMembershipInput = {
  /** @deprecated Field no longer supported */
  content?: InputMaybe<ContentInput>;
  libraryItemId?: InputMaybe<Scalars['UUID']['input']>;
  tagId: Scalars['UUID']['input'];
};

export type ContentTagMembershipMutationResult = MutationResult & {
  __typename?: 'ContentTagMembershipMutationResult';
  contentTagMemberships?: Maybe<Array<ContentTagMembership>>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type Contract = {
  __typename?: 'Contract';
  addenda: Array<Contract>;
  annualIncreaseAppliesTo?: Maybe<ContractDiscountBasis>;
  annualIncreasePercent?: Maybe<Scalars['Float']['output']>;
  billingCadence?: Maybe<ContractBillingCadence>;
  contractId: Scalars['String']['output'];
  contractTotal: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Employee>;
  customer: Scalars['String']['output'];
  deal?: Maybe<CrmDeal>;
  discounts: Array<ContractDiscount>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  exitRunRate: Scalars['Float']['output'];
  extractionNotes: Scalars['String']['output'];
  freeMonths: Scalars['Int']['output'];
  freePosition?: Maybe<ContractFreePosition>;
  hasOptInPilotTerm: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isAddendum: Scalars['Boolean']['output'];
  lineItems: Array<ContractLineItem>;
  marketingTerms: Array<ContractMarketingTerm>;
  payments: Array<ContractPayment>;
  phases: Array<ContractPhase>;
  planTier?: Maybe<ContractPlanTier>;
  primaryContract?: Maybe<Contract>;
  renewalIncreaseCapPercent?: Maybe<Scalars['Float']['output']>;
  renewalNoticeDays?: Maybe<Scalars['Int']['output']>;
  renewalTermsNote: Scalars['String']['output'];
  salesRep: Scalars['String']['output'];
  satisfactionGuaranteeDays?: Maybe<Scalars['Int']['output']>;
  satisfactionGuaranteeNote: Scalars['String']['output'];
  statedTotal?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<ContractStatus>;
  termMonths?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Employee>;
  yearOneAcv: Scalars['Float']['output'];
  yearOneTotal: Scalars['Float']['output'];
};

export enum ContractBillingCadence {
  Annual = 'ANNUAL',
  Custom = 'CUSTOM',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Upfront = 'UPFRONT'
}

export type ContractDiscount = {
  __typename?: 'ContractDiscount';
  appliesTo: ContractDiscountBasis;
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  kind: ContractDiscountKind;
  phase?: Maybe<ContractPhase>;
  value: Scalars['Float']['output'];
};

export enum ContractDiscountBasis {
  All = 'ALL',
  Recurring = 'RECURRING'
}

export enum ContractDiscountKind {
  Amount = 'AMOUNT',
  Percent = 'PERCENT'
}

export enum ContractDurationUnit {
  Annual = 'ANNUAL',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnual = 'SEMI_ANNUAL'
}

export enum ContractFeeTreatment {
  Additive = 'ADDITIVE',
  Credited = 'CREDITED',
  NotApplicable = 'NOT_APPLICABLE'
}

export enum ContractFreePosition {
  NotApplicable = 'NOT_APPLICABLE',
  TermEnd = 'TERM_END',
  TermStart = 'TERM_START'
}

export enum ContractLineCategory {
  OneTime = 'ONE_TIME',
  Recurring = 'RECURRING'
}

export type ContractLineItem = {
  __typename?: 'ContractLineItem';
  category: ContractLineCategory;
  datesOverridden: Scalars['Boolean']['output'];
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  feeTreatment: ContractFeeTreatment;
  id: Scalars['UUID']['output'];
  listRate?: Maybe<Scalars['Float']['output']>;
  monthlyAmount: Scalars['Float']['output'];
  netRate: Scalars['Float']['output'];
  notes: Scalars['String']['output'];
  origin: ContractLineOrigin;
  phase?: Maybe<ContractPhase>;
  product: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  serviceEnd?: Maybe<Scalars['Date']['output']>;
  serviceStart?: Maybe<Scalars['Date']['output']>;
  totalAmount: Scalars['Float']['output'];
  unitType: ContractUnitType;
};

export enum ContractLineOrigin {
  AddedLater = 'ADDED_LATER',
  OriginalCommitment = 'ORIGINAL_COMMITMENT'
}

export type ContractMarketingTerm = {
  __typename?: 'ContractMarketingTerm';
  conditionsDiscount: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['UUID']['output'];
  kind: ContractMarketingTermKind;
  order: Scalars['Int']['output'];
};

export enum ContractMarketingTermKind {
  CaseStudy = 'CASE_STUDY',
  LogoRights = 'LOGO_RIGHTS',
  Other = 'OTHER',
  SocialPost = 'SOCIAL_POST',
  Testimonial = 'TESTIMONIAL'
}

export type ContractMutationResult = MutationResult & {
  __typename?: 'ContractMutationResult';
  contract?: Maybe<Contract>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type ContractPayment = {
  __typename?: 'ContractPayment';
  amount?: Maybe<Scalars['Float']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type ContractPhase = {
  __typename?: 'ContractPhase';
  description: Scalars['String']['output'];
  discountNote: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  durationUnit?: Maybe<ContractDurationUnit>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['UUID']['output'];
  increasePercent?: Maybe<Scalars['Float']['output']>;
  kind: ContractPhaseKind;
  openEnded: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  total: Scalars['Float']['output'];
};

export enum ContractPhaseKind {
  Free = 'FREE',
  Pilot = 'PILOT',
  Y1 = 'Y1',
  Y2 = 'Y2',
  Y3 = 'Y3'
}

export enum ContractPlanTier {
  Core = 'CORE',
  Enterprise = 'ENTERPRISE',
  EnterpriseLms = 'ENTERPRISE_LMS',
  Growth = 'GROWTH'
}

export enum ContractStatus {
  Active = 'ACTIVE',
  Pilot = 'PILOT',
  Terminated = 'TERMINATED'
}

export enum ContractUnitType {
  Credit = 'CREDIT',
  Flat = 'FLAT',
  Location = 'LOCATION',
  User = 'USER'
}

export type ContractsFiltersInput = {
  customer?: InputMaybe<StringValue>;
  planTier?: InputMaybe<ContractPlanTier>;
  status?: InputMaybe<ContractStatus>;
};

export type ContractsInput = {
  filters: ContractsFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type ContractsResult = PaginatedList & {
  __typename?: 'ContractsResult';
  objects: Array<Contract>;
  totalCount: Scalars['Int']['output'];
};

export type ConvertMediaToRichTextDocumentWorkflow = {
  __typename?: 'ConvertMediaToRichTextDocumentWorkflow';
  conversionStatus?: Maybe<MediaConversionStatus>;
  id: Scalars['UUID']['output'];
  richTextDocuments?: Maybe<Array<RichTextDocument>>;
  sourceMedia: Media;
};

export type CopyModuleInput = {
  duplicateChildContent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Course = {
  __typename?: 'Course';
  aiGenerateCourseFromOutlineRequest?: Maybe<AiGenerateCourseFromOutlineRequest>;
  aiGenerationFailed: Scalars['Boolean']['output'];
  aiGenerationInProgress: Scalars['Boolean']['output'];
  aiGenerationRequested: Scalars['Boolean']['output'];
  assignableByManagers: Scalars['Boolean']['output'];
  assignedCount: Scalars['Int']['output'];
  autoReassignOnFailure: Scalars['Boolean']['output'];
  averageAccuracy?: Maybe<Scalars['Float']['output']>;
  averageFeedbackRating?: Maybe<Scalars['Float']['output']>;
  averageTimeToCompleteDays?: Maybe<Scalars['Float']['output']>;
  averageTimeToCompleteSeconds?: Maybe<Scalars['Float']['output']>;
  courseVersions: Array<CourseVersion>;
  createdFrom?: Maybe<CatalogCourse>;
  draftVersion: CourseVersion;
  enableCertificate: Scalars['Boolean']['output'];
  enablePromptRetries: Scalars['Boolean']['output'];
  excludeFromKnowledgeCheck?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isAIGenerated?: Maybe<Scalars['Boolean']['output']>;
  lastBuilderActionId?: Maybe<Scalars['Int']['output']>;
  lastPublishedBy?: Maybe<Employee>;
  lessonCount: Scalars['Int']['output'];
  libraryItem: LibraryItem;
  moduleContentMemberships: Array<ModuleContentMembership>;
  passingAccuracyThreshold?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedVersion?: Maybe<CourseVersion>;
  scormUpload?: Maybe<ScormUpload>;
  topic?: Maybe<Topic>;
};

export type CourseBuilderActionInput = {
  addLessonAction?: InputMaybe<AddLessonActionInput>;
  addMcOptionAction?: InputMaybe<AddMcOptionActionInput>;
  addPromptAction?: InputMaybe<AddPromptActionInput>;
  addResponseOptionAction?: InputMaybe<AddResponseOptionActionInput>;
  courseId: Scalars['Int']['input'];
  moveLessonAction?: InputMaybe<MoveLessonActionInput>;
  movePromptAction?: InputMaybe<MovePromptActionInput>;
  moveResponseOptionAction?: InputMaybe<MoveResponseOptionActionInput>;
  removeLessonAction?: InputMaybe<RemoveLessonActionInput>;
  removeMcOptionAction?: InputMaybe<RemoveMcOptionActionInput>;
  removePromptAction?: InputMaybe<RemovePromptActionInput>;
  removeResponseOptionAction?: InputMaybe<RemoveResponseOptionActionInput>;
  removeTranslationSetOverrides?: InputMaybe<RemoveTranslationSetOverridesActionInput>;
  removeTranslationSetOverridesAction?: InputMaybe<RemoveTranslationSetOverridesActionInput>;
  /** @deprecated Field no longer supported */
  setAllowGradedFreeResponseTyposAction?: InputMaybe<SetAllowGradedFreeResponseTyposActionInput>;
  setCourseCoverImageAction?: InputMaybe<SetCourseCoverImageActionInput>;
  setCourseDescriptionAction?: InputMaybe<SetCourseDescriptionActionInput>;
  setCourseNameAction?: InputMaybe<SetCourseNameActionInput>;
  setCourseSettingsAction?: InputMaybe<SetCourseSettingsActionInput>;
  setGradedFreeResponseCorrectAnswerAction?: InputMaybe<SetGradedFreeResponseCorrectAnswerActionInput>;
  setLessonNameAction?: InputMaybe<SetLessonNameActionInput>;
  setMcCorrectOptionAction?: InputMaybe<SetMcCorrectOptionActionInput>;
  setMcOptionAction?: InputMaybe<SetMcOptionActionInput>;
  setPromptAssignMediaAction?: InputMaybe<SetPromptAssignMediaActionInput>;
  setPromptImageOnlyMatchItemsAction?: InputMaybe<SetPromptImageOnlyMatchItemsActionInput>;
  setPromptMediaAction?: InputMaybe<SetPromptMediaActionInput>;
  setPromptRandomizeOptionOrderAction?: InputMaybe<SetPromptRandomizeOptionOrderActionInput>;
  setPromptRequireFullVideoPlaybackAction?: InputMaybe<SetPromptRequireFullVideoPlaybackActionInput>;
  setPromptSelectAllThatApplyAction?: InputMaybe<SetPromptSelectAllThatApplyActionInput>;
  setPromptTextAction?: InputMaybe<SetPromptTextActionInput>;
  setPromptTypeAction?: InputMaybe<SetPromptTypeActionInput>;
  setResponseOptionAnswerAction?: InputMaybe<SetResponseOptionAnswerActionInput>;
  setResponseOptionIsCorrectAction?: InputMaybe<SetResponseOptionIsCorrectActionInput>;
  setResponseOptionMatchItemAction?: InputMaybe<SetResponseOptionMatchItemActionInput>;
  setResponseOptionMediaAction?: InputMaybe<SetResponseOptionMediaActionInput>;
  setTrueFalseCorrectOptionAction?: InputMaybe<SetTrueFalseCorrectOptionActionInput>;
};

export type CourseFeedback = {
  __typename?: 'CourseFeedback';
  comment?: Maybe<Scalars['String']['output']>;
  commentLanguage?: Maybe<Scalars['Language']['output']>;
  commentTranslation?: Maybe<Scalars['String']['output']>;
  courseInstance: CourseInstance;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  rating: Scalars['Int']['output'];
};

export type CourseFeedbackInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
};

export type CourseFeedbackRatingCount = {
  __typename?: 'CourseFeedbackRatingCount';
  count: Scalars['Int']['output'];
  rating: Scalars['Int']['output'];
};

export type CourseFeedbackRatingDistribution = {
  __typename?: 'CourseFeedbackRatingDistribution';
  averageRating?: Maybe<Scalars['Float']['output']>;
  countsByRating: Array<CourseFeedbackRatingCount>;
  totalCount: Scalars['Int']['output'];
};

export type CourseFeedbacks = PaginatedList & {
  __typename?: 'CourseFeedbacks';
  objects: Array<CourseFeedback>;
  totalCount: Scalars['Int']['output'];
};

export type CourseFeedbacksFiltersInput = {
  /** @deprecated Field no longer supported */
  courseIds?: InputMaybe<IntArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
  ratings?: InputMaybe<IntArrayInput>;
};

export type CourseFeedbacksInput = {
  /** @deprecated Field no longer supported */
  courseId?: InputMaybe<Scalars['Int']['input']>;
  courseIds?: InputMaybe<IntArrayInput>;
  /** @deprecated Field no longer supported */
  filters?: InputMaybe<CourseFeedbacksFiltersInput>;
  locationGroupIds?: InputMaybe<UuidArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
  moduleIds?: InputMaybe<IntArrayInput>;
  ratings?: InputMaybe<IntArrayInput>;
  roleGroupIds?: InputMaybe<UuidArrayInput>;
  roleIds?: InputMaybe<IntArrayInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type CourseInstance = {
  __typename?: 'CourseInstance';
  accuracy?: Maybe<Scalars['Float']['output']>;
  assignedByAccessSources: Array<AccessSource>;
  assignedByList: Array<Scalars['String']['output']>;
  assignment: Assignment;
  certificateUrl?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  course: Course;
  courseVersion?: Maybe<CourseVersion>;
  createdAt: Scalars['DateTime']['output'];
  drillStatuses: Array<DrillStatus>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  failed?: Maybe<Scalars['Boolean']['output']>;
  feedback?: Maybe<CourseFeedback>;
  firstAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  firstAssignedByStr?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  isAssignedThroughModule: Scalars['Boolean']['output'];
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  lastAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  lastAssignedByStr?: Maybe<Scalars['String']['output']>;
  lessonInstances: Array<LessonInstance>;
  markedCompletedBy?: Maybe<Employee>;
  markedCompletedReason?: Maybe<Scalars['String']['output']>;
  moduleContentMembershipInstances: Array<ModuleContentMembershipInstance>;
  percentComplete: Scalars['Float']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['AttemptStatus']['output'];
  track?: Maybe<Scalars['Int']['output']>;
  user: Employee;
};

export type CourseInstanceMutationResult = MutationResult & {
  __typename?: 'CourseInstanceMutationResult';
  courseInstance?: Maybe<CourseInstance>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type CourseInstancesMutationResult = MutationResult & {
  __typename?: 'CourseInstancesMutationResult';
  courseInstances?: Maybe<Array<CourseInstance>>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type CourseMutationResult = MutationResult & {
  __typename?: 'CourseMutationResult';
  course?: Maybe<Course>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type CourseOutline = {
  __typename?: 'CourseOutline';
  aiGenerateCourseFromOutlineRequests: Array<AiGenerateCourseFromOutlineRequest>;
  aiGenerateModuleRequest?: Maybe<AiGenerateModuleRequest>;
  body: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  interactivity: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  toneFormality: Scalars['Int']['output'];
  toneSeriousness: Scalars['Int']['output'];
};

export type CourseProgressCourseInstanceInput = {
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  percentComplete: Scalars['Float']['input'];
  startedAt: Scalars['DateTime']['input'];
};

export type CourseProgressLessonInstanceInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  courseInstance: CourseProgressCourseInstanceInput;
  lessonInstanceId: Scalars['UUID']['input'];
  percentComplete: Scalars['Float']['input'];
  startedAt: Scalars['DateTime']['input'];
};

export type CourseProgressPromptAttemptInput = {
  promptInstance: CourseProgressPromptInstanceInput;
  response: Scalars['String']['input'];
  responseOptionInstances?: InputMaybe<Array<CourseProgressResponseOptionInstanceInput>>;
  submittedAt: Scalars['DateTime']['input'];
  trueFalseResponse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CourseProgressPromptInstanceInput = {
  answeredCorrectly?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lessonInstance?: InputMaybe<CourseProgressLessonInstanceInput>;
  numFailures: Scalars['Int']['input'];
  promptId: Scalars['Int']['input'];
  startedAt: Scalars['DateTime']['input'];
};

export type CourseProgressResponseOptionInstanceInput = {
  id: Scalars['UUID']['input'];
  matchItemId?: InputMaybe<Scalars['UUID']['input']>;
  responseOptionId: Scalars['UUID']['input'];
};

export type CourseVersion = {
  __typename?: 'CourseVersion';
  archivedPublishState?: Maybe<PublishState>;
  authors: Array<Employee>;
  course: Course;
  createdAt: Scalars['DateTime']['output'];
  grade?: Maybe<CourseVersionGrade>;
  id: Scalars['Int']['output'];
  lessons: Array<Lesson>;
  publishState?: Maybe<PublishState>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CourseVersionGrade = {
  __typename?: 'CourseVersionGrade';
  courseVersion: CourseVersion;
  feedbackMd: Scalars['String']['output'];
  grade: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  moduleVersion: ModuleVersion;
  sections: Array<SectionGrade>;
  totalScore: Scalars['Int']['output'];
};

export type CourseVersionMutationResult = MutationResult & {
  __typename?: 'CourseVersionMutationResult';
  courseVersion?: Maybe<CourseVersion>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type CoverImage = {
  __typename?: 'CoverImage';
  background?: Maybe<BackgroundGradient>;
  emojiIcon?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  imageUrls?: Maybe<ImageUrls>;
  /** @deprecated Field no longer supported */
  mediaUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type CoverImageInput = {
  background?: InputMaybe<BackgroundGradient>;
  emojiIcon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAiFeedbackInput = {
  chatMessageId?: InputMaybe<Scalars['UUID']['input']>;
  courseVersionGradeId?: InputMaybe<Scalars['UUID']['input']>;
  libraryItemId?: InputMaybe<Scalars['UUID']['input']>;
  selection: FeedbackSelection;
  text?: InputMaybe<Scalars['String']['input']>;
  vercelChatMessageId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBackfilledAssignmentsInput = {
  csvContent: Scalars['String']['input'];
  matchingStrategy: BackfilledAssignmentUserMatchingStrategy;
};

export type CreateBackfilledAssignmentsMutationResult = MutationResult & {
  __typename?: 'CreateBackfilledAssignmentsMutationResult';
  error?: Maybe<Error>;
  importedCount?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateBackfilledCertificatesInput = {
  complianceType: ComplianceType;
  csvContent: Scalars['String']['input'];
  matchingStrategy: BackfilledAssignmentUserMatchingStrategy;
};

export type CreateBackfilledCertificatesMutationResult = MutationResult & {
  __typename?: 'CreateBackfilledCertificatesMutationResult';
  error?: Maybe<Error>;
  importedCount?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateChatInput = {
  chatType: ChatType;
  membersCanEditMembers?: InputMaybe<Scalars['Boolean']['input']>;
  membersCanEditTitle?: InputMaybe<Scalars['Boolean']['input']>;
  ownerUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<TranslationSetInput>;
  userSelectionSet: UserSelectionSetInput;
};

export type CreateChatMessageReactionInput = {
  chatMessageId: Scalars['UUID']['input'];
  emoji: Scalars['String']['input'];
};

export type CreateCoachingTemplateInput = {
  identificationGuidance: Scalars['String']['input'];
  name: Scalars['String']['input'];
  team: CrmTeam;
};

export type CreateGroupInput = {
  address?: InputMaybe<AddressInput>;
  name: Scalars['String']['input'];
  type: GroupType;
};

export type CreateLocationInput = {
  addressInput?: InputMaybe<AddressInput>;
  locationGroupIds?: InputMaybe<UuidArrayInput>;
  name: Scalars['String']['input'];
};

export type CreateOrgGuestFeedbackCsvUploadInput = {
  feedbackDateColumn: Scalars['String']['input'];
  feedbackSource?: InputMaybe<Scalars['String']['input']>;
  feedbackTextColumn: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  locationColumn: Scalars['String']['input'];
  locationMappings: Array<CsvLocationMappingInput>;
  ratingColumn: Scalars['String']['input'];
  ratingColumnMax: Scalars['Float']['input'];
  ratingColumnMin: Scalars['Float']['input'];
};

export type CreatePostCommentInput = {
  messageBlastId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export type CreateRemediationInstanceInput = {
  assigneeDueDate: Scalars['Date']['input'];
  assigneeId: Scalars['Int']['input'];
  auditorMediaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  auditorNotes?: InputMaybe<Scalars['String']['input']>;
  flaggedVerificationStepInstanceIds: Array<Scalars['UUID']['input']>;
  skillInstanceId: Scalars['UUID']['input'];
};

export type CreateReportedContentInput = {
  chatMessageId?: InputMaybe<Scalars['UUID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  postCommentId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateRichTextDocumentInput = {
  content: TranslationSetInput;
};

export type CreateRoleInput = {
  directReportRoleIds?: InputMaybe<IntArrayInput>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<ActionPermissionSetInput>;
  requireClockInConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  roleGroupIds?: InputMaybe<UuidArrayInput>;
  roleLevelV2?: InputMaybe<Scalars['Int']['input']>;
  roleUserType?: InputMaybe<UserType>;
};

export type CreateScheduledUserInvitesInput = {
  csvContent: Scalars['String']['input'];
  inviteUserAt: Scalars['DateTime']['input'];
  userType: UserType;
};

export type CreateScheduledUserInvitesMutationResult = MutationResult & {
  __typename?: 'CreateScheduledUserInvitesMutationResult';
  error?: Maybe<Error>;
  scheduledCount?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateSearchDocumentInput = {
  mediaId: Scalars['Int']['input'];
};

export type CreateSevenShiftsIntegrationInput = {
  accessToken: Scalars['String']['input'];
};

export type CreateSevenShiftsIntegrationMutationResult = MutationResult & {
  __typename?: 'CreateSevenShiftsIntegrationMutationResult';
  error?: Maybe<Error>;
  hrisIntegration?: Maybe<HrisIntegration>;
  success: Scalars['Boolean']['output'];
};

export type CreateTaskInput = {
  approvalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  assigneeId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  locationId: Scalars['Int']['input'];
  observerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  proofOfCompletionRequirement?: InputMaybe<TaskProofOfCompletionRequirement>;
  reviewerId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Set to raise the task as a follow-up on a submitted audit or checklist, so it
   * appears on that submission and carries its context. The submission must be
   * published and at the task's location.
   */
  sourceSkillInstanceId?: InputMaybe<Scalars['UUID']['input']>;
  /** Optional step within sourceSkillInstanceId that the follow-up is about. */
  sourceVerificationStepInstanceId?: InputMaybe<Scalars['UUID']['input']>;
  title: Scalars['String']['input'];
};

export type CreateTrainingResourceInput = {
  description?: InputMaybe<TranslationSetInput>;
  mediaInput?: InputMaybe<MediaInput>;
  name?: InputMaybe<TranslationSetInput>;
  richTextDocumentInput?: InputMaybe<CreateRichTextDocumentInput>;
  type?: InputMaybe<TrainingResourceVersionType>;
};

export type CreateUserSharingPermissionsInput = {
  courseId?: InputMaybe<Scalars['Int']['input']>;
  moduleId?: InputMaybe<Scalars['Int']['input']>;
  permission: SharingPermission;
  skillId?: InputMaybe<Scalars['Int']['input']>;
  trainingResourceId?: InputMaybe<Scalars['UUID']['input']>;
  userIds: Array<Scalars['Int']['input']>;
};

export type CreateWorkflowNodeActionInput = {
  libraryItemId?: InputMaybe<Scalars['UUID']['input']>;
  nodeId: Scalars['UUID']['input'];
  positionX: Scalars['Float']['input'];
  positionY: Scalars['Float']['input'];
  timeDelayDays?: InputMaybe<Scalars['Int']['input']>;
  type: WorkflowNodeType;
  userSelectionSet?: InputMaybe<UserSelectionSetInput>;
};

export type CreditCard = {
  __typename?: 'CreditCard';
  brand: Scalars['String']['output'];
  expMonth: Scalars['String']['output'];
  expYear: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

export type CreditPurchaseOption = {
  __typename?: 'CreditPurchaseOption';
  baseCredits: Scalars['Int']['output'];
  bonusCredits: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  perUnitCostBasis: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  savings: Scalars['Float']['output'];
  totalCredits: Scalars['Int']['output'];
};

export type CreditSpendByLocation = {
  __typename?: 'CreditSpendByLocation';
  locationCreditSpend: Array<LocationCreditSpend>;
  timeframeEnd: Scalars['DateTime']['output'];
  timeframeStart: Scalars['DateTime']['output'];
};

export type CsvColumn = {
  __typename?: 'CsvColumn';
  exampleValues: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type CsvColumnNumberRange = {
  __typename?: 'CsvColumnNumberRange';
  maxValue: Scalars['Float']['output'];
  minValue: Scalars['Float']['output'];
};

export type CsvLocationMapping = {
  __typename?: 'CsvLocationMapping';
  locationId?: Maybe<Scalars['Int']['output']>;
  locationName: Scalars['String']['output'];
};

export type CsvLocationMappingInput = {
  locationId: Scalars['Int']['input'];
  locationName: Scalars['String']['input'];
};

export type CsvSchemaError = {
  __typename?: 'CsvSchemaError';
  columnIndex?: Maybe<Scalars['Int']['output']>;
  error: Scalars['String']['output'];
  rawRow: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
};

export type CurrentCourseInstanceFiltersInput = {
  versionOlderThan?: InputMaybe<DateTimeValue>;
};

export type CurrentModuleInstanceFiltersInput = {
  versionOlderThan?: InputMaybe<DateTimeValue>;
};

export type CurrentSkillInstanceFiltersInput = {
  delegationFilters?: InputMaybe<DelegationFiltersInput>;
  verifiable?: InputMaybe<BooleanValue>;
  verifiedByUsers?: InputMaybe<IntArrayInput>;
};

export type CustomReport = {
  __typename?: 'CustomReport';
  createdBy?: Maybe<Employee>;
  emailSchedule?: Maybe<ScheduledReport>;
  fields: Array<CustomReportFieldMemberships>;
  filters?: Maybe<Array<ReportFilter>>;
  id: Scalars['UUID']['output'];
  lastEditedBy?: Maybe<Employee>;
  limit?: Maybe<Scalars['Int']['output']>;
  org: Org;
  sortAscending?: Maybe<Scalars['Boolean']['output']>;
  sortBy?: Maybe<ReportField>;
  title: Scalars['String']['output'];
  topic: ReportTopic;
};

export type CustomReportFieldMemberships = {
  __typename?: 'CustomReportFieldMemberships';
  field: ReportField;
  index: Scalars['Int']['output'];
};

export type CustomerFacingAccountPlan = {
  __typename?: 'CustomerFacingAccountPlan';
  embedUrl: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type CustomerProblem = {
  __typename?: 'CustomerProblem';
  accounts: Array<Scalars['String']['output']>;
  createdAtNotion?: Maybe<Scalars['DateTime']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  notionPageId: Scalars['String']['output'];
  pageContent: Scalars['String']['output'];
  priority?: Maybe<Scalars['String']['output']>;
  products: Array<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  syncedAt: Scalars['DateTime']['output'];
};

export type CustomerProblemAccountCount = {
  __typename?: 'CustomerProblemAccountCount';
  account: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export enum CustomerProblemNotionSyncStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export type CustomerProblemPriorityCount = {
  __typename?: 'CustomerProblemPriorityCount';
  count: Scalars['Int']['output'];
  priority: Scalars['String']['output'];
};

export type CustomerProblemProductCount = {
  __typename?: 'CustomerProblemProductCount';
  count: Scalars['Int']['output'];
  product: Scalars['String']['output'];
};

export type CustomerProblemStatusCount = {
  __typename?: 'CustomerProblemStatusCount';
  count: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type CustomerProblemTimePoint = {
  __typename?: 'CustomerProblemTimePoint';
  count: Scalars['Int']['output'];
  week: Scalars['String']['output'];
};

export type CustomerProblemsFiltersInput = {
  accounts?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  newThisWeek?: InputMaybe<Scalars['Boolean']['input']>;
  priorities?: InputMaybe<Array<Scalars['String']['input']>>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  resolvedThisWeek?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  submitters?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAfter?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomerProblemsHeatmap = {
  __typename?: 'CustomerProblemsHeatmap';
  accounts: Array<Scalars['String']['output']>;
  cells: Array<CustomerProblemsHeatmapCell>;
  products: Array<Scalars['String']['output']>;
};

export type CustomerProblemsHeatmapCell = {
  __typename?: 'CustomerProblemsHeatmapCell';
  account: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  product: Scalars['String']['output'];
};

export type CustomerProblemsInput = {
  filters: CustomerProblemsFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type CustomerProblemsList = PaginatedList & {
  __typename?: 'CustomerProblemsList';
  objects: Array<CustomerProblem>;
  totalCount: Scalars['Int']['output'];
};

export type CustomerProblemsSummary = {
  __typename?: 'CustomerProblemsSummary';
  highPriorityCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  uniqueAccountCount: Scalars['Int']['output'];
};

export type CustomerProblemsTrends = {
  __typename?: 'CustomerProblemsTrends';
  byPriority: Array<CustomerProblemPriorityCount>;
  byStatus: Array<CustomerProblemStatusCount>;
  overTime: Array<CustomerProblemTimePoint>;
  topAccounts: Array<CustomerProblemAccountCount>;
  topProducts: Array<CustomerProblemProductCount>;
};

export enum CustomerStage {
  Growth = 'GROWTH',
  Maintain = 'MAINTAIN',
  Onboarding = 'ONBOARDING',
  Sunset = 'SUNSET',
  Turnaround = 'TURNAROUND'
}

export type DashboardFeedbackInput = {
  comment: Scalars['String']['input'];
};

export type DataTransform = {
  __typename?: 'DataTransform';
  id: Scalars['UUID']['output'];
  output: TranslationSet;
  type?: Maybe<DataTransformType>;
};

export type DataTransformInput = {
  libraryItemId?: InputMaybe<Scalars['UUID']['input']>;
  mediaId?: InputMaybe<Scalars['Int']['input']>;
  type: DataTransformType;
};

export type DataTransformMutationResult = MutationResult & {
  __typename?: 'DataTransformMutationResult';
  dataTransform?: Maybe<DataTransform>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type DataTransformSet = {
  __typename?: 'DataTransformSet';
  id: Scalars['UUID']['output'];
  transforms: Array<DataTransform>;
};

export enum DataTransformType {
  AiChatAttachmentMarkdown = 'AI_CHAT_ATTACHMENT_MARKDOWN'
}

export type DateTimeInput = {
  value: Scalars['DateTime']['input'];
};

export type DateTimeNaiveValue = {
  value: Scalars['DateTimeNaive']['input'];
};

export type DateTimeUtcValue = {
  value: Scalars['DateTimeUtc']['input'];
};

export type DateTimeValue = {
  value: Scalars['DateTime']['input'];
};

export type DateValue = {
  value: Scalars['Date']['input'];
};

export enum DayOfTheWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum DeactivationReason {
  CrossOrgMapping = 'CROSS_ORG_MAPPING',
  DeactivatedOrg = 'DEACTIVATED_ORG',
  Hris = 'HRIS',
  Manual = 'MANUAL',
  SwitchedOrgs = 'SWITCHED_ORGS'
}

export enum DealScopeActorFilter {
  Ai = 'AI',
  Human = 'HUMAN'
}

export type DealScopeAgentRun = {
  __typename?: 'DealScopeAgentRun';
  answersWritten: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  sourceMeeting?: Maybe<DealScopeMeeting>;
  status: DealScopeAgentRunStatus;
};

export enum DealScopeAgentRunStatus {
  Failed = 'FAILED',
  Succeeded = 'SUCCEEDED'
}

export type DealScopeAnswer = {
  __typename?: 'DealScopeAnswer';
  agentRun?: Maybe<DealScopeAgentRun>;
  answeredBy?: Maybe<ScopeActor>;
  confident: Scalars['Boolean']['output'];
  currentValue: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DealScopeAnswerEvent = {
  __typename?: 'DealScopeAnswerEvent';
  agentRun?: Maybe<DealScopeAgentRun>;
  answeredBy?: Maybe<ScopeActor>;
  confident?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  previousValue?: Maybe<Scalars['String']['output']>;
  questionKey: Scalars['String']['output'];
  questionLabel: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DealScopeAnswerInput = {
  confident: Scalars['Boolean']['input'];
  questionKey: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum DealScopeAnswerStatus {
  Answered = 'ANSWERED',
  Missing = 'MISSING',
  NeedsConfirming = 'NEEDS_CONFIRMING'
}

export enum DealScopeAnswerType {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  Select = 'SELECT',
  Text = 'TEXT'
}

export type DealScopeCard = {
  __typename?: 'DealScopeCard';
  agentRuns: Array<DealScopeAgentRun>;
  arr?: Maybe<Scalars['Int']['output']>;
  categories: Array<DealScopeChecklistCategory>;
  companyName: Scalars['String']['output'];
  dealId: Scalars['UUID']['output'];
  events: Array<DealScopeAnswerEvent>;
  missingQuestions: Array<DealScopeQuestion>;
  ownerName?: Maybe<Scalars['String']['output']>;
  readiness: DealScopeReadinessResult;
  readyMarkedAt?: Maybe<Scalars['DateTime']['output']>;
  readyMarkedBy?: Maybe<ScopeActor>;
  stage?: Maybe<Scalars['String']['output']>;
};

export enum DealScopeCategory {
  BusinessProfile = 'BUSINESS_PROFILE',
  CommercialEnterpriseReadiness = 'COMMERCIAL_ENTERPRISE_READINESS',
  ContentReadiness = 'CONTENT_READINESS',
  GoalsAndUrgency = 'GOALS_AND_URGENCY',
  StakeholderMap = 'STAKEHOLDER_MAP',
  TechnologyStack = 'TECHNOLOGY_STACK',
  TrainingSituation = 'TRAINING_SITUATION'
}

export type DealScopeCategoryScore = {
  __typename?: 'DealScopeCategoryScore';
  category: DealScopeCategory;
  confident: Scalars['Int']['output'];
  isSupplemental: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  pct: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type DealScopeChecklistCategory = {
  __typename?: 'DealScopeChecklistCategory';
  category: DealScopeCategory;
  isSupplemental: Scalars['Boolean']['output'];
  items: Array<DealScopeChecklistItem>;
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type DealScopeChecklistItem = {
  __typename?: 'DealScopeChecklistItem';
  answer?: Maybe<DealScopeAnswer>;
  question: DealScopeQuestion;
  status: DealScopeAnswerStatus;
};

export type DealScopeList = PaginatedList & {
  __typename?: 'DealScopeList';
  objects: Array<DealScopeListRow>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DealScopeListRow = {
  __typename?: 'DealScopeListRow';
  arr?: Maybe<Scalars['Int']['output']>;
  companyName: Scalars['String']['output'];
  dealId: Scalars['UUID']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  readinessBand: DealScopeReadiness;
  readinessScore: Scalars['Int']['output'];
  stage?: Maybe<Scalars['String']['output']>;
};

export type DealScopeMeeting = {
  __typename?: 'DealScopeMeeting';
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DealScopeQuestion = {
  __typename?: 'DealScopeQuestion';
  agentGuidance: Scalars['String']['output'];
  answerType: DealScopeAnswerType;
  category: DealScopeCategory;
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
};

export enum DealScopeReadiness {
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Ready = 'READY'
}

export type DealScopeReadinessResult = {
  __typename?: 'DealScopeReadinessResult';
  band: DealScopeReadiness;
  categories: Array<DealScopeCategoryScore>;
  score: Scalars['Int']['output'];
};

export type DealScopeSummary = {
  __typename?: 'DealScopeSummary';
  inProgressCount: Scalars['Int']['output'];
  notStartedCount: Scalars['Int']['output'];
  readyCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type DealScopesFiltersInput = {
  ownerIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  readinessBands?: InputMaybe<Array<DealScopeReadiness>>;
  stages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DealScopesInput = {
  filters: DealScopesFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type DelegationFiltersInput = {
  delegatedByUsers?: InputMaybe<IntArrayInput>;
  delegatedToUsers?: InputMaybe<IntArrayInput>;
  includeNotDelegated?: InputMaybe<BooleanValue>;
};

export type DeleteChatInput = {
  chatId: Scalars['UUID']['input'];
};

export type DeleteChatMessageInput = {
  chatMessageId: Scalars['UUID']['input'];
};

export type DeleteChatMessageReactionInput = {
  chatMessageId: Scalars['UUID']['input'];
};

export type DeleteComplianceAttemptsInput = {
  complianceRecordIds: Array<Scalars['UUID']['input']>;
};

export type DeleteHrisIntegrationInput = {
  hrisIntegrationId: Scalars['UUID']['input'];
};

export type DeleteHrisIntegrationMutationResult = MutationResult & {
  __typename?: 'DeleteHrisIntegrationMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type DeleteOrgPremiumContentConfigsInput = {
  ids: Array<Scalars['Int']['input']>;
};

export type DeletePostCommentInput = {
  postCommentId: Scalars['UUID']['input'];
};

export type DeleteWorkflowNodeActionInput = {
  nodeId: Scalars['UUID']['input'];
};

export type DiffAssignmentRulesChangeInput = {
  assignmentId: Scalars['Int']['input'];
  assignmentInput: AssignmentInput;
};

export type DiffAssignmentRulesMutationResult = MutationResult & {
  __typename?: 'DiffAssignmentRulesMutationResult';
  /** @deprecated Field no longer supported */
  diff?: Maybe<AssignmentDiff>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type DiffAutomationRulesChangeInput = {
  automationId: Scalars['Int']['input'];
  automationInput: AutomationInput;
  countIsForReviewScreen?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DiffAutomationRulesMutationResult = MutationResult & {
  __typename?: 'DiffAutomationRulesMutationResult';
  diff?: Maybe<AutomationDiff>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type DiscardFormActionInput = {
  discard: Scalars['Boolean']['input'];
};

export type DisconnectWorkflowNodesActionInput = {
  childNodeId: Scalars['UUID']['input'];
  parentNodeId: Scalars['UUID']['input'];
};

export type DraftTaskConfig = {
  __typename?: 'DraftTaskConfig';
  approvalRequired: Scalars['Boolean']['output'];
  assignee?: Maybe<Employee>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['UUID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  proofOfCompletionRequirement?: Maybe<TaskProofOfCompletionRequirement>;
  title: Scalars['String']['output'];
  titleIsAutoGenerated: Scalars['Boolean']['output'];
};

export type DrillStatus = {
  __typename?: 'DrillStatus';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  courseInstance: CourseInstance;
  id: Scalars['UUID']['output'];
  lesson: Lesson;
  placeInSequence: Scalars['Float']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  track?: Maybe<Scalars['Int']['output']>;
};

export type DrillStatusMutationResult = MutationResult & {
  __typename?: 'DrillStatusMutationResult';
  drillStatus?: Maybe<DrillStatus>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type DueDateInput = {
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDateDays?: InputMaybe<Scalars['Int']['input']>;
};

export type DueDateInputValue = {
  value: DueDateInput;
};

export type EslTheme = {
  __typename?: 'ESLTheme';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EditChatMessageInput = {
  chatMessageId: Scalars['UUID']['input'];
  text: Scalars['String']['input'];
};

export type EditOpusAgentMessageResult = MutationResult & {
  __typename?: 'EditOpusAgentMessageResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  turn?: Maybe<OpusAgentChatTurn>;
};

export type EditPostCommentInput = {
  postCommentId: Scalars['UUID']['input'];
  text: Scalars['String']['input'];
};

export type EditPromptWithAiInput = {
  /** @deprecated Field no longer supported */
  autoAcceptChanges?: InputMaybe<Scalars['Boolean']['input']>;
  customRequestText?: InputMaybe<Scalars['String']['input']>;
  promptUuid: Scalars['UUID']['input'];
  type: EditPromptWithAiType;
};

export enum EditPromptWithAiType {
  AddEmojis = 'ADD_EMOJIS',
  AddMedia = 'ADD_MEDIA',
  ExtendText = 'EXTEND_TEXT',
  NewPrompt = 'NEW_PROMPT',
  ReadingLevel = 'READING_LEVEL',
  ShortenText = 'SHORTEN_TEXT',
  SpellingAndGrammar = 'SPELLING_AND_GRAMMAR',
  WriteQuestion = 'WRITE_QUESTION'
}

export type EmailPreferences = {
  __typename?: 'EmailPreferences';
  dcOhrReminderEnabled: Scalars['Boolean']['output'];
  emailsEnabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  weeklyReachEngagementEmailEnabled: Scalars['Boolean']['output'];
};

export type Employee = {
  __typename?: 'Employee';
  blastSentRecords: Array<BlastSentRecord>;
  brands: Array<LocationGroup>;
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy?: Maybe<Employee>;
  deactivatedReason?: Maybe<DeactivationReason>;
  email?: Maybe<Scalars['String']['output']>;
  englishName?: Maybe<Scalars['String']['output']>;
  enteredFirstName: Scalars['String']['output'];
  enteredLastName: Scalars['String']['output'];
  enteredName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  foodHandlerExams: Array<FoodHandlerExam>;
  hasConfirmedClockIn: Scalars['Boolean']['output'];
  hasUnreadMessages: Scalars['Boolean']['output'];
  hasUsedApp: Scalars['Boolean']['output'];
  hrisEmployee?: Maybe<HrisEmployee>;
  id: Scalars['Int']['output'];
  incompleteAssignmentsCount: Scalars['Int']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  jointEmploymentStatus?: Maybe<JointEmploymentStatus>;
  knowledgeCheckStreakWeeks: Scalars['Int']['output'];
  language: Scalars['Language']['output'];
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  locationGroups: Array<LocationGroup>;
  locations: Array<Location>;
  locationsFromDirectMemberships: Array<Location>;
  name: Scalars['String']['output'];
  notificationPreferences?: Maybe<NotificationPreferences>;
  oneOffCheckInsToFacilitate: Array<OneOffCheckInDelegation>;
  oneOffDelegatedCheckIns: Array<OneOffCheckInDelegation>;
  ongoingCheckInsToFacilitate: Array<OngoingCheckInDelegation>;
  ongoingDelegatedCheckIns: Array<OngoingCheckInDelegation>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  org?: Maybe<Org>;
  pastDueAssignmentsCount: Scalars['Int']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Media>;
  qualifiesForKnowledgeCheck: Scalars['Boolean']['output'];
  requiresClockInConfirmation: Scalars['Boolean']['output'];
  roles: Array<Role>;
  totalCompletedKnowledgeChecks: Scalars['Int']['output'];
  unreadMessageCount: Scalars['Int']['output'];
  userActionPermissionOverrides?: Maybe<UserActionPermissionOverrides>;
  userGlobalPushNotificationSettings?: Maybe<UserGlobalPushNotificationSettings>;
  userType: UserType;
};

export type EmployeeActionPermission = {
  __typename?: 'EmployeeActionPermission';
  hasOverride: Scalars['Boolean']['output'];
  hasPermission: Scalars['Boolean']['output'];
  reasonEnum: PermissionReason;
  user: Employee;
};

export type EmployeeActionPermissions = PaginatedList & {
  __typename?: 'EmployeeActionPermissions';
  enabledCount: Scalars['Int']['output'];
  objects: Array<EmployeeActionPermission>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeBlastSentRecordsInput = {
  excludePostsCopiedToChats?: InputMaybe<BooleanValue>;
};

export type EmployeeEngagement = {
  __typename?: 'EmployeeEngagement';
  activeEmployees: Scalars['Int']['output'];
  totalEmployees: Scalars['Int']['output'];
};

export type EmployeeMutationResult = MutationResult & {
  __typename?: 'EmployeeMutationResult';
  /** @deprecated Field no longer supported */
  employee?: Maybe<Employee>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<Employee>;
};

export type Employees = PaginatedList & {
  __typename?: 'Employees';
  objects: Array<Employee>;
  totalCount: Scalars['Int']['output'];
};

export type EmployeesMutationResult = MutationResult & {
  __typename?: 'EmployeesMutationResult';
  employees?: Maybe<Array<Employee>>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export enum EngSlug {
  Anne = 'ANNE',
  Ben = 'BEN',
  Brinza = 'BRINZA',
  Callie = 'CALLIE',
  Claudio = 'CLAUDIO',
  Dom = 'DOM',
  Doug = 'DOUG',
  Jeff = 'JEFF',
  Jerry = 'JERRY',
  Perandre = 'PERANDRE',
  Pushkar = 'PUSHKAR',
  Taylor = 'TAYLOR'
}

export enum EngagementStatus {
  Below = 'BELOW',
  Higher = 'HIGHER',
  OnTrack = 'ON_TRACK'
}

export type EnrichCrmContactResult = MutationResult & {
  __typename?: 'EnrichCRMContactResult';
  clientFacingWorkflow?: Maybe<ClientFacingWorkflow>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type EnrichCandidatesViaProviderResult = MutationResult & {
  __typename?: 'EnrichCandidatesViaProviderResult';
  clientFacingWorkflow?: Maybe<ClientFacingWorkflow>;
  error?: Maybe<Error>;
  queued: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type EnrichCustomContactResult = MutationResult & {
  __typename?: 'EnrichCustomContactResult';
  clientFacingWorkflow?: Maybe<ClientFacingWorkflow>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type ExpectedUsersConfig = {
  __typename?: 'ExpectedUsersConfig';
  adminOverrideUserCount?: Maybe<Scalars['Int']['output']>;
  adminOverrideUserCountUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  adminOverrideUserCountUpdatedBy?: Maybe<Employee>;
  hrisUserCount: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  managerReportedUserCount?: Maybe<Scalars['Int']['output']>;
  managerReportedUserCountUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  managerReportedUserCountUpdatedBy?: Maybe<Employee>;
  strategy: ExpectedUsersStrategy;
};

export type ExpectedUsersConfigInput = {
  adminOverrideUserCount?: InputMaybe<Scalars['Int']['input']>;
  managerReportedUserCount?: InputMaybe<Scalars['Int']['input']>;
  strategy?: InputMaybe<ExpectedUsersStrategy>;
};

export enum ExpectedUsersStrategy {
  AdminOverride = 'ADMIN_OVERRIDE',
  Hris = 'HRIS',
  Manager = 'MANAGER',
  OrgDefault = 'ORG_DEFAULT'
}

export type ExternalScormCloudCourse = {
  __typename?: 'ExternalSCORMCloudCourse';
  createdAt: Scalars['DateTime']['output'];
  externalSCORMCloudCourseId: Scalars['String']['output'];
  externalSCORMCloudCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  externalSCORMCloudImportJobId?: Maybe<Scalars['String']['output']>;
  externalSCORMCloudImportMessage?: Maybe<Scalars['String']['output']>;
  externalSCORMCloudImportStatus?: Maybe<ExternalScormCloudImportStatus>;
  id: Scalars['UUID']['output'];
  packageName: Scalars['String']['output'];
  scormCourseVersion: ScormCourseVersion;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ExternalScormCloudImportStatus {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  Running = 'RUNNING'
}

export type ExtractContractFromPdfResult = MutationResult & {
  __typename?: 'ExtractContractFromPdfResult';
  clientFacingWorkflow?: Maybe<ClientFacingWorkflow>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  adminSelfServable?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  staffSelfServableForOrg?: Maybe<Scalars['Boolean']['output']>;
  userFacingName?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagInput = {
  enabled: BooleanValue;
  name: Scalars['String']['input'];
};

export type FeedbackInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
};

export enum FeedbackSelection {
  Ignored = 'IGNORED',
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export enum Ff {
  AiFeedbackOnGradedFreeResponseAttempt = 'AIFeedbackOnGradedFreeResponseAttempt',
  AiChat = 'AiChat',
  AiImageGen = 'AiImageGen',
  ApplyBuilderActionsViaUserActor = 'ApplyBuilderActionsViaUserActor',
  AskOpusKillSwitch = 'AskOpusKillSwitch',
  AskOpusManagerTools = 'AskOpusManagerTools',
  AskOpusPgVectorStoreSearch = 'AskOpusPGVectorStoreSearch',
  AskOpusSuggestedQuestions = 'AskOpusSuggestedQuestions',
  Audits = 'Audits',
  AutomationUserSelections = 'AutomationUserSelections',
  BlastLibraryItemAttachments = 'BlastLibraryItemAttachments',
  BuildCompletionReportsWithDjango = 'BuildCompletionReportsWithDjango',
  ChangelogPublisherAgent = 'ChangelogPublisherAgent',
  ChatAuditOutlines = 'ChatAuditOutlines',
  ChatCheckInOutlines = 'ChatCheckInOutlines',
  ChatKnowledgeBase = 'ChatKnowledgeBase',
  ChatModuleOutlines = 'ChatModuleOutlines',
  ChatTaskListOutlines = 'ChatTaskListOutlines',
  Chats = 'Chats',
  CollaborativeTaskLists = 'CollaborativeTaskLists',
  ConditionalSteps = 'ConditionalSteps',
  ContentBuilderAgent = 'ContentBuilderAgent',
  ContentBuilderDirectApi = 'ContentBuilderDirectApi',
  CrossOrgDeactivation = 'CrossOrgDeactivation',
  CsCoachingAgent = 'CsCoachingAgent',
  CsCoachingTemplateEditor = 'CsCoachingTemplateEditor',
  DealClosedAnalysisAgent = 'DealClosedAnalysisAgent',
  DealScopeAgent = 'DealScopeAgent',
  DisableHrisDataLinking = 'DisableHRISDataLinking',
  DownloadDcOhrReport = 'DownloadDcOhrReport',
  GuestFeedbackCorrectiveAction = 'GuestFeedbackCorrectiveAction',
  GuestFeedbackRecommendations = 'GuestFeedbackRecommendations',
  GuestFeedbackRecommendationsAgent = 'GuestFeedbackRecommendationsAgent',
  Impersonation = 'Impersonation',
  JointEmployer = 'JointEmployer',
  KnowledgeCheck = 'KnowledgeCheck',
  LibraryFolders = 'LibraryFolders',
  LibraryItemOldSlowSearch = 'LibraryItemOldSlowSearch',
  LibraryItemOverviewTab = 'LibraryItemOverviewTab',
  LibraryItemSearchWithDescription = 'LibraryItemSearchWithDescription',
  LlmTranslations = 'LlmTranslations',
  ManagersSeeOtherManagerSentMessages = 'ManagersSeeOtherManagerSentMessages',
  MatchingQuestion = 'MatchingQuestion',
  McpConnector = 'McpConnector',
  McpSqlTools = 'McpSqlTools',
  MemoryLibrarianAgent = 'MemoryLibrarianAgent',
  Messaging = 'Messaging',
  MessagingActivityItem = 'MessagingActivityItem',
  MobileDesign2026 = 'MobileDesign2026',
  ModuleCertificates = 'ModuleCertificates',
  MostRecentAuditCompletionReports = 'MostRecentAuditCompletionReports',
  MultipleUserSelections = 'MultipleUserSelections',
  NewMessaging = 'NewMessaging',
  NightlyRumErrorTriageAgent = 'NightlyRumErrorTriageAgent',
  OfflineMode = 'OfflineMode',
  OpusAgent = 'OpusAgent',
  OpusAgentWrites = 'OpusAgentWrites',
  OpusImpactTrackerAgent = 'OpusImpactTrackerAgent',
  PathsAsWorkflows = 'PathsAsWorkflows',
  PhoneSignupFromHrisEmployee = 'PhoneSignupFromHrisEmployee',
  PostAuditRemediation = 'PostAuditRemediation',
  PreventScreenshot = 'PreventScreenshot',
  ProductContainerCourseGeneration = 'ProductContainerCourseGeneration',
  ProductContainerDocConversion = 'ProductContainerDocConversion',
  ProfileImage = 'ProfileImage',
  RafikiAgent = 'RafikiAgent',
  RafikiFreeTimeAgent = 'RafikiFreeTimeAgent',
  ReportingOverview = 'ReportingOverview',
  ResyncHrisIntegration = 'ResyncHrisIntegration',
  RichTextDocComments = 'RichTextDocComments',
  RichTextDocListenMode = 'RichTextDocListenMode',
  RichTextDocument = 'RichTextDocument',
  RunGuestFeedbackRecommendations = 'RunGuestFeedbackRecommendations',
  ScormResources = 'SCORMResources',
  SalesCoachingAgent = 'SalesCoachingAgent',
  SalesCoachingTemplateEditor = 'SalesCoachingTemplateEditor',
  SelfDirectedCheckins = 'SelfDirectedCheckins',
  SignupCodeSelfServeRotation = 'SignupCodeSelfServeRotation',
  SkillInstanceBuilderActions = 'SkillInstanceBuilderActions',
  SwitchToUser = 'SwitchToUser',
  TaskLibraryItemType = 'TaskLibraryItemType',
  TaskSchedule = 'TaskSchedule',
  TestingFfEnum = 'TestingFfEnum',
  Triggers = 'Triggers',
  UseGeminiOcr = 'UseGeminiOcr',
  UseNewTraineeLibraryResolverInGlobalSearch = 'UseNewTraineeLibraryResolverInGlobalSearch',
  UseNewTraineeLibraryResolverInLibrary = 'UseNewTraineeLibraryResolverInLibrary',
  UserLocationGroups = 'UserLocationGroups',
  WeeklyReachEngagementEmail = 'WeeklyReachEngagementEmail',
  WipeDemoOrgWithNewCascadeDeleteFast = 'WipeDemoOrgWithNewCascadeDeleteFast',
  Workflows = 'Workflows'
}

export enum FieldType {
  Date = 'DATE',
  Datetime = 'DATETIME',
  Locations = 'LOCATIONS',
  Number = 'NUMBER',
  Regions = 'REGIONS',
  Roles = 'ROLES',
  String = 'STRING',
  StringList = 'STRING_LIST'
}

export type FileInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FileListUploadMutationResult = MutationResult & {
  __typename?: 'FileListUploadMutationResult';
  error?: Maybe<Error>;
  fileUrls?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type FileUploadMutationResult = MutationResult & {
  __typename?: 'FileUploadMutationResult';
  error?: Maybe<Error>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FloatValue = {
  value: Scalars['Float']['input'];
};

export type Folder = {
  __typename?: 'Folder';
  id: Scalars['UUID']['output'];
  libraryItem: LibraryItem;
  position: Scalars['String']['output'];
};

export type FolderInput = {
  coverImage?: InputMaybe<CoverImageInput>;
  description: TranslationSetObjectInput;
  name: TranslationSetObjectInput;
  /** Folder.id of the parent, or that FOLDER library item's id. Omit only for a top-level folder. Related folders nest under one parent with short names. Do not flatten into 'Parent - Child' siblings at the library root. */
  parentFolderId?: InputMaybe<Scalars['UUID']['input']>;
};

export type FolderMutationResult = MutationResult & {
  __typename?: 'FolderMutationResult';
  error?: Maybe<Error>;
  folder?: Maybe<Folder>;
  success: Scalars['Boolean']['output'];
};

export type FoodHandlerExam = {
  __typename?: 'FoodHandlerExam';
  id: Scalars['UUID']['output'];
  link: Scalars['String']['output'];
  moduleInstance: ModuleInstance;
  passed: Scalars['Boolean']['output'];
  score?: Maybe<Scalars['Float']['output']>;
};

export enum FoodHandlerExamComplianceType {
  Compliant = 'COMPLIANT',
  ExamNotPassed = 'EXAM_NOT_PASSED',
  Incomplete = 'INCOMPLETE'
}

export type FullEnrichCompanyContact = {
  __typename?: 'FullEnrichCompanyContact';
  createdAt: Scalars['DateTime']['output'];
  enrichedAt?: Maybe<Scalars['DateTime']['output']>;
  enrichmentJobId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  fullenrichPersonId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  jobTitle: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  linkedinUrl: Scalars['String']['output'];
  locationCity: Scalars['String']['output'];
  locationCountry: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  seniority: Scalars['String']['output'];
  syncedToAttioAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workEmail: Scalars['String']['output'];
};

export type GenAuditFromOutlineChatInput = {
  aiChatId: Scalars['UUID']['input'];
  auditOutlineText: Scalars['String']['input'];
  brandDetailsId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GenCheckInFromOutlineChatInput = {
  aiChatId: Scalars['UUID']['input'];
  brandDetailsId?: InputMaybe<Scalars['UUID']['input']>;
  checkInOutlineText: Scalars['String']['input'];
};

export type GenCourseFromOutlineChatInput = {
  aiChatId: Scalars['UUID']['input'];
  brandDetailsId?: InputMaybe<Scalars['UUID']['input']>;
  courseOutlineText: Scalars['String']['input'];
};

export type GenModuleFromOutlineChatInput = {
  aiChatId: Scalars['UUID']['input'];
  brandDetailsId?: InputMaybe<Scalars['UUID']['input']>;
  moduleOutlineText: Scalars['String']['input'];
};

export type GenTaskListFromOutlineChatInput = {
  aiChatId: Scalars['UUID']['input'];
  brandDetailsId?: InputMaybe<Scalars['UUID']['input']>;
  taskListOutlineText: Scalars['String']['input'];
};

export type GenerateBuilderActionsFromSuggestionMutationResult = MutationResult & {
  __typename?: 'GenerateBuilderActionsFromSuggestionMutationResult';
  builderActionInputs: Array<Scalars['JSON']['output']>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type GenerateImageInput = {
  prompt: Scalars['String']['input'];
};

export type GenerateLinkTokenMutationResult = MutationResult & {
  __typename?: 'GenerateLinkTokenMutationResult';
  error?: Maybe<Error>;
  hrisIntegrationId?: Maybe<Scalars['UUID']['output']>;
  success: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type GenericMutationResult = MutationResult & {
  __typename?: 'GenericMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type GetAiRequestsInput = {
  courseVersionId?: InputMaybe<Scalars['Int']['input']>;
  includeAcceptedAndRejected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetBillingAccountsInput = {
  ids?: InputMaybe<UuidArrayInput>;
};

export type GetBuilderActionsInput = {
  afterBuilderActionId?: InputMaybe<Scalars['Int']['input']>;
  clientId: Scalars['UUID']['input'];
  courseId?: InputMaybe<Scalars['Int']['input']>;
  moduleId?: InputMaybe<Scalars['Int']['input']>;
  skillId?: InputMaybe<Scalars['Int']['input']>;
  skillInstanceId?: InputMaybe<Scalars['UUID']['input']>;
  trainingResourceId?: InputMaybe<Scalars['UUID']['input']>;
  workflowId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetCreditSpendByLocationInput = {
  timeframeEnd?: InputMaybe<DateTimeInput>;
  timeframeStart?: InputMaybe<DateTimeInput>;
};

export type GetCsvColumnNumberRangeMutationResult = MutationResult & {
  __typename?: 'GetCsvColumnNumberRangeMutationResult';
  error?: Maybe<Error>;
  numberRange?: Maybe<CsvColumnNumberRange>;
  success: Scalars['Boolean']['output'];
};

export type GetCsvColumnsMutationResult = MutationResult & {
  __typename?: 'GetCsvColumnsMutationResult';
  columns?: Maybe<Array<CsvColumn>>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type GetOrCreateAssignmentMutationResult = MutationResult & {
  __typename?: 'GetOrCreateAssignmentMutationResult';
  assignment?: Maybe<Assignment>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type GetOrCreateAuditInstanceDraftInput = {
  locationId: Scalars['Int']['input'];
  skillId: Scalars['Int']['input'];
};

export type GetOrCreateCheckinInstanceDraftInput = {
  skillId: Scalars['Int']['input'];
  traineeUserId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetOrCreateTaskListInstanceDraftInput = {
  locationId: Scalars['Int']['input'];
  skillId: Scalars['Int']['input'];
};

export type GetPeopleInput = {
  activeSince?: InputMaybe<DateTimeValue>;
  chatId?: InputMaybe<UuidValue>;
  deactivatedOnly?: InputMaybe<BooleanValue>;
  doingEsl?: InputMaybe<BooleanValue>;
  excludeConfirmedStillEmployedAfter?: InputMaybe<DateTimeValue>;
  hasRole?: InputMaybe<BooleanValue>;
  hasUsedApp?: InputMaybe<BooleanValue>;
  inactiveSince?: InputMaybe<DateTimeValue>;
  includeDeactivated?: InputMaybe<BooleanValue>;
  includeStaffForStaff?: InputMaybe<BooleanValue>;
  languages?: InputMaybe<LanguageArrayInput>;
  locationGroupIds?: InputMaybe<UuidArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
  roleGroupIds?: InputMaybe<UuidArrayInput>;
  roleIds?: InputMaybe<IntArrayInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
  totalCompletedKnowledgeChecksGte?: InputMaybe<IntValue>;
  userIds?: InputMaybe<IntArrayInput>;
  userTypes?: InputMaybe<UserTypeListInput>;
};

export type GetReportViewsInput = {
  reportViewType: ReportViewTypeValueInput;
};

export enum GitHubCiFailureStatus {
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Stale = 'STALE'
}

export enum GitHubCommentType {
  IssueComment = 'ISSUE_COMMENT',
  ReviewComment = 'REVIEW_COMMENT'
}

export enum GitHubPrCommentStatus {
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Resolved = 'RESOLVED',
  Stale = 'STALE'
}

export type GiveAccessToLibraryItemsInput = {
  libraryItemIds: Array<Scalars['UUID']['input']>;
  userSelection: UserSelectionInput;
};

export type Glossary = {
  __typename?: 'Glossary';
  glossaryEntries: Array<GlossaryEntry>;
  id: Scalars['UUID']['output'];
};

export type GlossaryEntry = {
  __typename?: 'GlossaryEntry';
  entry: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type GlossarySet = {
  __typename?: 'GlossarySet';
  glossary: Glossary;
  id: Scalars['UUID']['output'];
};

export type GlossarySetInput = {
  entries: Array<Scalars['String']['input']>;
};

export type GoogleBusinessAccount = {
  __typename?: 'GoogleBusinessAccount';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GradeActionItem = {
  __typename?: 'GradeActionItem';
  action: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  priority: ActionItemPriority;
  section: SectionGrade;
  suggestion: Scalars['String']['output'];
};

export type GradeCourseVersionInput = {
  courseVersionId: Scalars['Int']['input'];
  moduleVersionId: Scalars['UUID']['input'];
};

export type GradeCourseVersionMutationResult = MutationResult & {
  __typename?: 'GradeCourseVersionMutationResult';
  courseVersionGrade: CourseVersionGrade;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type GradedFreeResponseInput = {
  correctAnswer: Scalars['String']['input'];
  question: Scalars['String']['input'];
  response: Scalars['String']['input'];
};

export enum GroupType {
  Location = 'LOCATION',
  Role = 'ROLE'
}

export type GroupedCount = {
  __typename?: 'GroupedCount';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type GuestFeedback = {
  __typename?: 'GuestFeedback';
  analyzedAt?: Maybe<Scalars['DateTime']['output']>;
  csvUploadLocation?: Maybe<GuestFeedbackCsvUploadLocation>;
  date: Scalars['DateTime']['output'];
  feedbackSource?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  integrationLocation?: Maybe<GuestFeedbackIntegrationLocation>;
  rating?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  themeMemberships: Array<GuestFeedbackThemeMembership>;
};

export type GuestFeedbackAnalysisRun = {
  __typename?: 'GuestFeedbackAnalysisRun';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  locationGroup?: Maybe<LocationGroup>;
  recommendationCount: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type GuestFeedbackAnalysisRunsInput = {
  locationGroupId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GuestFeedbackCorrectiveAction = {
  __typename?: 'GuestFeedbackCorrectiveAction';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  actionType?: Maybe<GuestFeedbackRecommendationActionType>;
  affectedLocations: Array<Scalars['String']['output']>;
  analysisRun?: Maybe<GuestFeedbackAnalysisRun>;
  audience: GuestFeedbackCorrectiveActionAudience;
  commentThread: CommentThread;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  contentType?: Maybe<LibraryItemContentType>;
  correctiveActionGroupId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  issueDescription: Scalars['String']['output'];
  libraryItem?: Maybe<LibraryItem>;
  locationGroup?: Maybe<LocationGroup>;
  locations: Array<Location>;
  measuringImpactStartedOn?: Maybe<Scalars['Date']['output']>;
  priority: ActionItemPriority;
  remediation: Scalars['String']['output'];
  sampleReviews: Array<GuestFeedbackSampleReview>;
  status: GuestFeedbackCorrectiveActionStatus;
  targetRoles: Array<Location>;
  theme?: Maybe<GuestFeedbackTheme>;
  title: Scalars['String']['output'];
};

export enum GuestFeedbackCorrectiveActionAudience {
  Both = 'BOTH',
  CurrentStaff = 'CURRENT_STAFF',
  NewHire = 'NEW_HIRE'
}

export type GuestFeedbackCorrectiveActionInput = {
  issueDescription: Scalars['String']['input'];
  remediation: Scalars['String']['input'];
};

export type GuestFeedbackCorrectiveActionMutationResult = MutationResult & {
  __typename?: 'GuestFeedbackCorrectiveActionMutationResult';
  correctiveAction?: Maybe<GuestFeedbackCorrectiveAction>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export enum GuestFeedbackCorrectiveActionStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  MeasuringImpact = 'MEASURING_IMPACT',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type GuestFeedbackCorrectiveActionsInput = {
  ids?: InputMaybe<UuidArrayInput>;
};

export type GuestFeedbackCsvUploadLocation = {
  __typename?: 'GuestFeedbackCsvUploadLocation';
  id: Scalars['UUID']['output'];
  location?: Maybe<Location>;
  locationName: Scalars['String']['output'];
};

export type GuestFeedbackIntegrationLocation = {
  __typename?: 'GuestFeedbackIntegrationLocation';
  id: Scalars['UUID']['output'];
  location?: Maybe<Location>;
  sourceLocationId: Scalars['String']['output'];
  sourceName?: Maybe<Scalars['String']['output']>;
};

export type GuestFeedbackRatingTrendInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  themeId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GuestFeedbackRatingTrendPoint = {
  __typename?: 'GuestFeedbackRatingTrendPoint';
  avgRating: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  weekStart: Scalars['Date']['output'];
};

export enum GuestFeedbackRecommendationActionType {
  Create = 'CREATE',
  Reassign = 'REASSIGN',
  Update = 'UPDATE'
}

export type GuestFeedbackRecommendationsInput = {
  actionType?: InputMaybe<GuestFeedbackRecommendationActionType>;
  analysisRunId?: InputMaybe<Scalars['UUID']['input']>;
  locationGroupId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<GuestFeedbackCorrectiveActionStatus>;
};

export type GuestFeedbackSampleReview = {
  __typename?: 'GuestFeedbackSampleReview';
  id: Scalars['UUID']['output'];
  review: Scalars['String']['output'];
};

export type GuestFeedbackTheme = {
  __typename?: 'GuestFeedbackTheme';
  description: Scalars['String']['output'];
  feedbackCount: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  mentionCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type GuestFeedbackThemeMembership = {
  __typename?: 'GuestFeedbackThemeMembership';
  feedback: GuestFeedback;
  id: Scalars['UUID']['output'];
  relevanceScore: Scalars['Float']['output'];
  theme: GuestFeedbackTheme;
};

export type GuestFeedbackThemeSummaryInput = {
  analyzedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxRating?: InputMaybe<Scalars['Float']['input']>;
  minRating?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<StringValue>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GuestFeedbackThemesInput = {
  locationGroupId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GuestFeedbacks = PaginatedList & {
  __typename?: 'GuestFeedbacks';
  objects: Array<GuestFeedback>;
  totalCount: Scalars['Int']['output'];
};

export type GuestFeedbacksInput = {
  analyzedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxRating?: InputMaybe<Scalars['Float']['input']>;
  minRating?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  themeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type HrisActivationData = {
  __typename?: 'HrisActivationData';
  createdLocations: Array<HrisLocation>;
  createdTeams: Array<HrisTeam>;
  deactivatedEmployees: Array<HrisEmployee>;
  linkedEmployees: Array<HrisEmployee>;
  linkedLocations: Array<HrisLocation>;
  linkedTeams: Array<HrisTeam>;
};

export type HrisConfig = {
  __typename?: 'HrisConfig';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  dataVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  finishedConnectingAt?: Maybe<Scalars['DateTime']['output']>;
  finishedLoadingAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
};

export type HrisConfigMutationResult = MutationResult & {
  __typename?: 'HrisConfigMutationResult';
  error?: Maybe<Error>;
  hrisConfig?: Maybe<HrisConfig>;
  success: Scalars['Boolean']['output'];
};

export type HrisCsvUpload = {
  __typename?: 'HrisCsvUpload';
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  csvObjects: Array<Scalars['JSON']['output']>;
  csvRawText: Scalars['String']['output'];
  csvUrl: Scalars['String']['output'];
  dataVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  finishedCreatingObjectsAt?: Maybe<Scalars['DateTime']['output']>;
  firstNameFallbackField?: Maybe<Scalars['String']['output']>;
  firstNameField?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  idField?: Maybe<Scalars['String']['output']>;
  lastNameFallbackField?: Maybe<Scalars['String']['output']>;
  lastNameField?: Maybe<Scalars['String']['output']>;
  locationField?: Maybe<Scalars['String']['output']>;
  locationGroup?: Maybe<LocationGroup>;
  modifiedEmployeesCount: Scalars['Int']['output'];
  nameField?: Maybe<Scalars['String']['output']>;
  org: Org;
  phoneFallbackField?: Maybe<Scalars['String']['output']>;
  phoneField?: Maybe<Scalars['String']['output']>;
  selectedColumnsAt?: Maybe<Scalars['DateTime']['output']>;
  startDateField?: Maybe<Scalars['String']['output']>;
  startedCreatingObjectsAt?: Maybe<Scalars['DateTime']['output']>;
  teamField?: Maybe<Scalars['String']['output']>;
  terminationDateField?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<Employee>;
};

export type HrisCsvUploadMutationResult = MutationResult & {
  __typename?: 'HrisCsvUploadMutationResult';
  error?: Maybe<Error>;
  hrisCsvUpload: HrisCsvUpload;
  success: Scalars['Boolean']['output'];
};

export type HrisCsvUploads = PaginatedList & {
  __typename?: 'HrisCsvUploads';
  objects: Array<HrisCsvUpload>;
  totalCount: Scalars['Int']['output'];
};

export type HrisCsvUploadsFiltersInput = {
  appliedAt?: InputMaybe<DateTimeValue>;
  locationGroupId?: InputMaybe<UuidValue>;
  orgId?: InputMaybe<UuidValue>;
  uploadedById?: InputMaybe<IntValue>;
};

export type HrisCsvUploadsInput = {
  filters?: InputMaybe<HrisCsvUploadsFiltersInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type HrisEmployee = {
  __typename?: 'HrisEmployee';
  createdAt: Scalars['DateTime']['output'];
  csvUpload?: Maybe<HrisCsvUpload>;
  employmentStatus?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  hrisIntegration?: Maybe<HrisIntegration>;
  id: Scalars['Int']['output'];
  lastModifiedByHrisCsvUploadId?: Maybe<Scalars['UUID']['output']>;
  lastModifiedByMergeBackfillRunId?: Maybe<Scalars['Int']['output']>;
  lastName: Scalars['String']['output'];
  locationMemberships: Array<HrisEmployeeLocationMembership>;
  manuallyLinked: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  rawHrisData?: Maybe<Scalars['JSON']['output']>;
  remoteHrisDataPassthrough?: Maybe<Scalars['JSON']['output']>;
  remoteHrisId: Scalars['UUID']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  teamMemberships: Array<HrisEmployeeTeamMembership>;
  terminationDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<Employee>;
};

export type HrisEmployeeEvent = {
  __typename?: 'HrisEmployeeEvent';
  createdAt: Scalars['DateTime']['output'];
  employmentStatus?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  hrisIntegration?: Maybe<HrisIntegration>;
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  manuallyLinked: Scalars['Boolean']['output'];
  pghContext?: Maybe<PghistoryContext>;
  pghCreatedAt: Scalars['DateTime']['output'];
  pghId: Scalars['Int']['output'];
  pghLabel: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  rawHrisData?: Maybe<Scalars['JSON']['output']>;
  remoteHrisId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  terminationDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type HrisEmployeeEvents = PaginatedList & {
  __typename?: 'HrisEmployeeEvents';
  objects: Array<HrisEmployeeEvent>;
  totalCount: Scalars['Int']['output'];
};

export type HrisEmployeeEventsFiltersInput = {
  hrisEmployeeId?: InputMaybe<IntValue>;
  pghIdLte?: InputMaybe<IntValue>;
};

export type HrisEmployeeEventsInput = {
  filters: HrisEmployeeEventsFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type HrisEmployeeLocationMembership = {
  __typename?: 'HrisEmployeeLocationMembership';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  location: HrisLocation;
  updatedAt: Scalars['DateTime']['output'];
};

export type HrisEmployeeMutationResult = MutationResult & {
  __typename?: 'HrisEmployeeMutationResult';
  error?: Maybe<Error>;
  hrisEmployee?: Maybe<HrisEmployee>;
  success: Scalars['Boolean']['output'];
};

export type HrisEmployeeTeamMembership = {
  __typename?: 'HrisEmployeeTeamMembership';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  team: HrisTeam;
  updatedAt: Scalars['DateTime']['output'];
};

export type HrisEmployees = PaginatedList & {
  __typename?: 'HrisEmployees';
  objects: Array<HrisEmployee>;
  totalCount: Scalars['Int']['output'];
};

export type HrisEmployeesFiltersInput = {
  hrisCsvUploadId?: InputMaybe<UuidValue>;
  hrisIntegrationId?: InputMaybe<UuidValue>;
  hrisLocationIds?: InputMaybe<IntArrayInput>;
  hrisStatus?: InputMaybe<StringValue>;
  inviteStatus?: InputMaybe<BooleanValue>;
  mergeBackfillRunId?: InputMaybe<IntValue>;
  opusLocationIds?: InputMaybe<IntArrayInput>;
  roleIds?: InputMaybe<IntArrayInput>;
};

export type HrisEmployeesInput = {
  filters?: InputMaybe<HrisEmployeesFiltersInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type HrisIntegration = {
  __typename?: 'HrisIntegration';
  activeHrisEmployeeCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  hrisProvider?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  initialSyncCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  lastReceivedDataAt?: Maybe<Scalars['DateTime']['output']>;
  locationCount: Scalars['Int']['output'];
  status?: Maybe<MergeLinkedAccountStatus>;
  statusDetail?: Maybe<Scalars['String']['output']>;
  teamCount: Scalars['Int']['output'];
  type: HrisIntegrationType;
};

export enum HrisIntegrationType {
  Crunchtime = 'Crunchtime',
  Deputy = 'Deputy',
  HotSchedules = 'HotSchedules',
  Merge = 'Merge',
  QuBeyond = 'QUBeyond',
  SevenShifts = 'SevenShifts'
}

export type HrisLocation = {
  __typename?: 'HrisLocation';
  activeHrisEmployeeCount: Scalars['Int']['output'];
  address?: Maybe<Address>;
  createdAt: Scalars['DateTime']['output'];
  group?: Maybe<Location>;
  hrisIntegration?: Maybe<HrisIntegration>;
  id: Scalars['Int']['output'];
  manuallyLinked: Scalars['Boolean']['output'];
  mostRecentEmployeeUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type HrisLocations = PaginatedList & {
  __typename?: 'HrisLocations';
  objects: Array<HrisLocation>;
  totalCount: Scalars['Int']['output'];
};

export type HrisLocationsFiltersInput = {
  hrisIntegrationId?: InputMaybe<UuidValue>;
};

export type HrisLocationsInput = {
  filters?: InputMaybe<HrisLocationsFiltersInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type HrisTeam = {
  __typename?: 'HrisTeam';
  activeHrisEmployeeCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  group?: Maybe<Role>;
  hrisIntegration?: Maybe<HrisIntegration>;
  id: Scalars['Int']['output'];
  manuallyLinked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type HrisTeams = PaginatedList & {
  __typename?: 'HrisTeams';
  objects: Array<HrisTeam>;
  totalCount: Scalars['Int']['output'];
};

export type HrisTeamsFiltersInput = {
  hrisIntegrationId?: InputMaybe<UuidValue>;
};

export type HrisTeamsInput = {
  filters?: InputMaybe<HrisTeamsFiltersInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type ImageGenerationMutationResult = MutationResult & {
  __typename?: 'ImageGenerationMutationResult';
  error?: Maybe<Error>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImageUrls = {
  __typename?: 'ImageUrls';
  id: Scalars['UUID']['output'];
  medium?: Maybe<Scalars['String']['output']>;
  original: Scalars['String']['output'];
  thumb?: Maybe<Scalars['String']['output']>;
  wide?: Maybe<Scalars['String']['output']>;
};

export enum ImpactReportGoalType {
  ConsistentOperationsAcrossLocations = 'CONSISTENT_OPERATIONS_ACROSS_LOCATIONS',
  EnsuringRegulatoryCompliance = 'ENSURING_REGULATORY_COMPLIANCE',
  HealthyNewStoreOpenings = 'HEALTHY_NEW_STORE_OPENINGS',
  LoweringEmployeeTurnover = 'LOWERING_EMPLOYEE_TURNOVER',
  TrainingNewHiresFaster = 'TRAINING_NEW_HIRES_FASTER'
}

export enum ImpactReportSupportingGoalType {
  EmployeeTrainingSatisfaction = 'EMPLOYEE_TRAINING_SATISFACTION',
  GrowingBrandProductKnowledge = 'GROWING_BRAND_PRODUCT_KNOWLEDGE',
  ImprovingEngagementForSegment = 'IMPROVING_ENGAGEMENT_FOR_SEGMENT',
  ImprovingExecutionOfLtos = 'IMPROVING_EXECUTION_OF_LTOS',
  ImprovingFranchiseEngagement = 'IMPROVING_FRANCHISE_ENGAGEMENT',
  ImprovingKnowledgeForTopic = 'IMPROVING_KNOWLEDGE_FOR_TOPIC',
  ImprovingTrainingCompletionRates = 'IMPROVING_TRAINING_COMPLETION_RATES',
  SavingTrainingTeamTime = 'SAVING_TRAINING_TEAM_TIME'
}

export enum ImpactReportWidgetType {
  ActiveUsers_30Days = 'ACTIVE_USERS_30_DAYS',
  Adoption = 'ADOPTION',
  AssignmentCompletion = 'ASSIGNMENT_COMPLETION',
  BrandProductKnowledge = 'BRAND_PRODUCT_KNOWLEDGE',
  Compliance = 'COMPLIANCE',
  ConsistentOperations = 'CONSISTENT_OPERATIONS',
  ContentCreationSavings = 'CONTENT_CREATION_SAVINGS',
  CourseFeedback = 'COURSE_FEEDBACK',
  EmployeeRetention = 'EMPLOYEE_RETENTION',
  FranchiseActiveUsers = 'FRANCHISE_ACTIVE_USERS',
  FranchiseAdoption = 'FRANCHISE_ADOPTION',
  LtoCompletion = 'LTO_COMPLETION',
  NewHireOnboarding = 'NEW_HIRE_ONBOARDING',
  NewStoreOpenings = 'NEW_STORE_OPENINGS',
  NsoTrainingTime = 'NSO_TRAINING_TIME',
  ReEngagement = 'RE_ENGAGEMENT',
  SegmentEngagement = 'SEGMENT_ENGAGEMENT',
  TopicKnowledge = 'TOPIC_KNOWLEDGE',
  TranslationsAccessibility = 'TRANSLATIONS_ACCESSIBILITY'
}

export type ImpactReportingAdoption = {
  __typename?: 'ImpactReportingAdoption';
  activeEmployees: Scalars['Int']['output'];
  activeEmployees30DaysAgo: Scalars['Int']['output'];
  totalEmployees: Scalars['Int']['output'];
  totalEmployees30DaysAgo: Scalars['Int']['output'];
  totalEmployeesType: TotalEmployeesType;
};

export type ImpactReportingAssignmentCompletion = {
  __typename?: 'ImpactReportingAssignmentCompletion';
  completedAssignments: Scalars['Int']['output'];
  completedAssignments30DaysAgo: Scalars['Int']['output'];
  pastDueAssignments: Scalars['Int']['output'];
  totalAssignments: Scalars['Int']['output'];
  totalAssignments30DaysAgo: Scalars['Int']['output'];
};

export type ImpactReportingBrandAndProductKnowledgeCompletion = {
  __typename?: 'ImpactReportingBrandAndProductKnowledgeCompletion';
  averageCourseAccuracy?: Maybe<Scalars['Float']['output']>;
  averageCourseAccuracy30DaysAgo?: Maybe<Scalars['Float']['output']>;
  completedAssignments: Scalars['Int']['output'];
  completedAssignments30DaysAgo: Scalars['Int']['output'];
  totalAssignments: Scalars['Int']['output'];
  totalAssignments30DaysAgo: Scalars['Int']['output'];
};

export type ImpactReportingCompliance = {
  __typename?: 'ImpactReportingCompliance';
  complianceTypes: Array<ImpactReportingComplianceType>;
};

export type ImpactReportingComplianceType = {
  __typename?: 'ImpactReportingComplianceType';
  complianceType: ComplianceType;
  compliantUsers: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type ImpactReportingConsistentOperations = {
  __typename?: 'ImpactReportingConsistentOperations';
  onTimeCompletionScheduleWindows: Scalars['Int']['output'];
  onTimeCompletionScheduleWindows30DayChange?: Maybe<Scalars['Float']['output']>;
  totalCompletionScheduleWindows: Scalars['Int']['output'];
  totalSubmittedCheckinLocations: Scalars['Int']['output'];
  totalSubmittedCheckins: Scalars['Int']['output'];
  totalSubmittedCheckins30DayChange?: Maybe<Scalars['Float']['output']>;
  totalSubmittedTaskListLocations: Scalars['Int']['output'];
  totalSubmittedTaskLists: Scalars['Int']['output'];
  totalSubmittedTaskLists30DayChange?: Maybe<Scalars['Float']['output']>;
};

export type ImpactReportingCourseFeedback = {
  __typename?: 'ImpactReportingCourseFeedback';
  averageRating?: Maybe<Scalars['Float']['output']>;
  averageRating30DaysAgo?: Maybe<Scalars['Float']['output']>;
  totalCourseFeedback: Scalars['Int']['output'];
};

export type ImpactReportingCustomSegmentEngagement = {
  __typename?: 'ImpactReportingCustomSegmentEngagement';
  activeUsers: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type ImpactReportingEmployeeRetention = {
  __typename?: 'ImpactReportingEmployeeRetention';
  averageTenure?: Maybe<Scalars['Int']['output']>;
  averageTenureMonthChange?: Maybe<Scalars['Float']['output']>;
  cohorts: ImpactReportingEmployeeRetentionCohorts;
  employeeType: TotalEmployeesType;
  months: Array<ImpactReportingEmployeeRetentionCohortMonth>;
};

export type ImpactReportingEmployeeRetentionCohortMonth = {
  __typename?: 'ImpactReportingEmployeeRetentionCohortMonth';
  cohorts: ImpactReportingEmployeeRetentionCohorts;
  month: Scalars['Date']['output'];
};

export type ImpactReportingEmployeeRetentionCohorts = {
  __typename?: 'ImpactReportingEmployeeRetentionCohorts';
  day30Retained?: Maybe<Scalars['Int']['output']>;
  day30Total?: Maybe<Scalars['Int']['output']>;
  day60Retained?: Maybe<Scalars['Int']['output']>;
  day60Total?: Maybe<Scalars['Int']['output']>;
  day90Retained?: Maybe<Scalars['Int']['output']>;
  day90Total?: Maybe<Scalars['Int']['output']>;
};

export type ImpactReportingEngagement = {
  __typename?: 'ImpactReportingEngagement';
  activeManagers: Scalars['Int']['output'];
  activeTrainees: Scalars['Int']['output'];
  activeUsers: Scalars['Int']['output'];
  engagementStatus: EngagementStatus;
  totalManagers: Scalars['Int']['output'];
  totalTrainees: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type ImpactReportingOnboarding = {
  __typename?: 'ImpactReportingOnboarding';
  averageDaysToCompleteNewHireTraining30DayChange?: Maybe<Scalars['Float']['output']>;
  months: Array<ImpactReportingOnboardingMonth>;
};

export type ImpactReportingOnboardingMonth = {
  __typename?: 'ImpactReportingOnboardingMonth';
  averageDaysToCompleteNewHireTraining: Scalars['Float']['output'];
  month: Scalars['Date']['output'];
};

export type ImpactReportingReengagement = {
  __typename?: 'ImpactReportingReengagement';
  askOpusQuestionCount: Scalars['Int']['output'];
  askOpusQuestionCount30DaysAgo: Scalars['Int']['output'];
  askOpusQuestionCountStatus: EngagementStatus;
  knowledgeCheckAccuracy?: Maybe<Scalars['Float']['output']>;
  knowledgeCheckAccuracy30DaysAgo?: Maybe<Scalars['Float']['output']>;
  knowledgeCheckAnswerCount: Scalars['Int']['output'];
  knowledgeCheckAnswerCount30DaysAgo: Scalars['Int']['output'];
  libraryContentViews: Scalars['Int']['output'];
  libraryContentViews30DaysAgo: Scalars['Int']['output'];
};

export type ImpactReportingStoreOpening = {
  __typename?: 'ImpactReportingStoreOpening';
  assignmentCompletion30dPercent?: Maybe<Scalars['Float']['output']>;
  cohort30dRetentionPercent?: Maybe<Scalars['Float']['output']>;
  evaluationNotes?: Maybe<Scalars['String']['output']>;
  evaluationStatus?: Maybe<StoreOpeningEvaluationStatus>;
  firstMemberAddedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEditedByName?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  openingDate?: Maybe<Scalars['DateTime']['output']>;
};

export type InProductNotification = {
  __typename?: 'InProductNotification';
  comment?: Maybe<Comment>;
  course?: Maybe<Course>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  module?: Maybe<Module>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  task?: Maybe<Task>;
  type: NotificationType;
};

export type InProductNotifications = PaginatedList & {
  __typename?: 'InProductNotifications';
  objects: Array<InProductNotification>;
  totalCount: Scalars['Int']['output'];
};

export type InProductNotificationsInput = {
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type InProductNotificationsMutationResult = MutationResult & {
  __typename?: 'InProductNotificationsMutationResult';
  error?: Maybe<Error>;
  inProductNotifications: Array<InProductNotification>;
  success: Scalars['Boolean']['output'];
};

export type InitializeBillingInput = {
  address?: InputMaybe<AddressInput>;
  billingContact?: InputMaybe<UserInput>;
  email: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  locationLicenses?: InputMaybe<Scalars['Int']['input']>;
  subscription?: InputMaybe<SubscriptionInput>;
  userLicenses?: InputMaybe<Scalars['Int']['input']>;
};

export type IntArrayInput = {
  value: Array<Scalars['Int']['input']>;
};

export type IntValue = {
  value: Scalars['Int']['input'];
};

export type IntentEvent = {
  __typename?: 'IntentEvent';
  action?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CrmCompany>;
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  referrer?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceDetails?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};

export type IntercomConversation = {
  __typename?: 'IntercomConversation';
  adminAssigneeId?: Maybe<Scalars['String']['output']>;
  assigneeName?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  companyNameOverride?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  intercomCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  intercomId: Scalars['String']['output'];
  intercomUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  medianCustomerReplySeconds?: Maybe<Scalars['Float']['output']>;
  medianRepReplySeconds?: Maybe<Scalars['Float']['output']>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  open?: Maybe<Scalars['Boolean']['output']>;
  orgName?: Maybe<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
  sourceDeliveredAs?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  teamAssigneeId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  waitingSince?: Maybe<Scalars['DateTime']['output']>;
};

export type IntercomConversationMutationResult = MutationResult & {
  __typename?: 'IntercomConversationMutationResult';
  conversation?: Maybe<IntercomConversation>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type IntercomConversationsFiltersInput = {
  adminIds?: InputMaybe<Array<Scalars['String']['input']>>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  companies?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  newThisWeek?: InputMaybe<Scalars['Boolean']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedThisWeek?: InputMaybe<Scalars['Boolean']['input']>;
  sourceDeliveredAs?: InputMaybe<Array<Scalars['String']['input']>>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<CsTicketStatusBucket>>;
  updatedAfter?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IntercomConversationsInput = {
  filters: IntercomConversationsFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type IntercomConversationsList = PaginatedList & {
  __typename?: 'IntercomConversationsList';
  objects: Array<IntercomConversation>;
  totalCount: Scalars['Int']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  amountDue: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber: Scalars['String']['output'];
  invoicePdf?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['InvoiceStatus']['output'];
  targetDate?: Maybe<Scalars['DateTime']['output']>;
};

export enum IssueType {
  FailedDbqTask = 'FAILED_DBQ_TASK',
  TriggeredDatadogMonitor = 'TRIGGERED_DATADOG_MONITOR'
}

export enum JointEmploymentStatus {
  CorporateEmployee = 'CORPORATE_EMPLOYEE',
  Exempt = 'EXEMPT',
  FranchiseEmployee = 'FRANCHISE_EMPLOYEE'
}

export type KillAgentCommandResult = {
  __typename?: 'KillAgentCommandResult';
  asyncStatus?: Maybe<CommandStatus>;
  commandId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type KnowledgeCheck = {
  __typename?: 'KnowledgeCheck';
  assignment?: Maybe<Assignment>;
  date: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
  knowledgeCheckInstance?: Maybe<KnowledgeCheckInstance>;
  prompt: Prompt;
  promptInstance?: Maybe<PromptInstance>;
  user: Employee;
};

export enum KnowledgeCheckConfidence {
  Not = 'NOT',
  Somewhat = 'SOMEWHAT',
  Very = 'VERY'
}

export type KnowledgeCheckInstance = {
  __typename?: 'KnowledgeCheckInstance';
  completedAt: Scalars['DateTime']['output'];
  confidence?: Maybe<KnowledgeCheckConfidence>;
  id: Scalars['UUID']['output'];
  knowledgeCheck: KnowledgeCheck;
};

export type KnowledgeCheckInstances = PaginatedList & {
  __typename?: 'KnowledgeCheckInstances';
  objects: Array<KnowledgeCheckInstance>;
  totalCount: Scalars['Int']['output'];
};

export type KnowledgeCheckInstancesFiltersInput = {
  completedGte?: InputMaybe<DateTimeValue>;
  completedLte?: InputMaybe<DateTimeValue>;
  libraryItemId?: InputMaybe<UuidValue>;
};

export type KnowledgeCheckInstancesInput = {
  filters: KnowledgeCheckInstancesFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type KnowledgeCheckLocationLeaderboard = {
  __typename?: 'KnowledgeCheckLocationLeaderboard';
  id: Scalars['Int']['output'];
  location: Location;
  users: Array<KnowledgeCheckLocationLeaderboardUser>;
};

export type KnowledgeCheckLocationLeaderboardUser = {
  __typename?: 'KnowledgeCheckLocationLeaderboardUser';
  rank: Scalars['Int']['output'];
  user: Employee;
};

export type KnowledgeCheckLocationLeaderboards = PaginatedList & {
  __typename?: 'KnowledgeCheckLocationLeaderboards';
  objects: Array<KnowledgeCheckLocationLeaderboard>;
  totalCount: Scalars['Int']['output'];
};

export type KnowledgeCheckStreak = {
  __typename?: 'KnowledgeCheckStreak';
  answeredThisWeek: Scalars['Int']['output'];
  completedToday: Scalars['Boolean']['output'];
  daysToKeepStreak: Scalars['Int']['output'];
  weeks: Scalars['Int']['output'];
};

export type LanguageArrayInput = {
  value: Array<Scalars['Language']['input']>;
};

export type LanguageInput = {
  value: Scalars['Language']['input'];
};

export type LanguageValue = {
  value: Scalars['Language']['input'];
};

export enum LeaderboardWindow {
  AllTime = 'ALL_TIME',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK'
}

export type Lesson = {
  __typename?: 'Lesson';
  aiLessonGeneration?: Maybe<AiLessonGeneration>;
  courseVersion: CourseVersion;
  id: Scalars['Int']['output'];
  index: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  prompts: Array<Prompt>;
  uuid: Scalars['UUID']['output'];
};

export type LessonInstance = {
  __typename?: 'LessonInstance';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  courseInstance: CourseInstance;
  id: Scalars['UUID']['output'];
  lesson: Lesson;
  percentComplete: Scalars['Float']['output'];
  promptInstances: Array<PromptInstance>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  user: Employee;
};

export type LessonObjectInput = {
  name: Scalars['String']['input'];
  prompts: Array<PromptObjectInput>;
  uuid: Scalars['UUID']['input'];
};

export type LibraryItem = {
  __typename?: 'LibraryItem';
  accessAutomation?: Maybe<Automation>;
  accessCount: Scalars['Int']['output'];
  aiGenerationFeedback?: Maybe<AiGenerationFeedback>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<Employee>;
  assignedCompletedCount: Scalars['Int']['output'];
  assignedCount: Scalars['Int']['output'];
  assignedPastDueCount: Scalars['Int']['output'];
  assignmentAutomation?: Maybe<Automation>;
  completedCount: Scalars['Int']['output'];
  completedKnowledgeCheckInstancesCount: Scalars['Int']['output'];
  completionSchedules: Array<CompletionSchedule>;
  contentTagMemberships: Array<ContentTagMembership>;
  course?: Maybe<Course>;
  coverImage?: Maybe<CoverImage>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Employee>;
  dataTransformSet?: Maybe<DataTransformSet>;
  description: TranslationSet;
  dueDate?: Maybe<Scalars['Date']['output']>;
  dueDateDays?: Maybe<Scalars['Int']['output']>;
  folder?: Maybe<Folder>;
  id: Scalars['UUID']['output'];
  knowledgeCheckAccuracy?: Maybe<Scalars['Float']['output']>;
  knowledgeCheckAverageConfidence?: Maybe<KnowledgeCheckConfidence>;
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEditedBy?: Maybe<Employee>;
  module?: Maybe<Module>;
  myAssignment?: Maybe<Assignment>;
  name: TranslationSet;
  onCompletionAssignmentRules: Array<OnCompletionAssignmentRule>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  org?: Maybe<Org>;
  orgPremiumContentConfig?: Maybe<OrgPremiumContentConfig>;
  orgSharpConfig?: Maybe<OrgSharpConfig>;
  parentFolderMemberships: Array<LibraryItemFolderMembership>;
  publishState?: Maybe<PublishState>;
  qrCode?: Maybe<ContentQrCode>;
  resourceType?: Maybe<TrainingResourceType>;
  scormCourse?: Maybe<ScormCourse>;
  searchDocuments: Array<SearchDocument>;
  searchHeadline?: Maybe<Scalars['String']['output']>;
  sharingPermissions: ContentSharingPermission;
  skill?: Maybe<Skill>;
  submittedTasksCount: Scalars['Int']['output'];
  trainingResource?: Maybe<TrainingResource>;
  type: LibraryItemType;
};

export enum LibraryItemContentType {
  Course = 'COURSE',
  Module = 'MODULE',
  Skill = 'SKILL',
  TrainingResource = 'TRAINING_RESOURCE'
}

export type LibraryItemFolderMembership = {
  __typename?: 'LibraryItemFolderMembership';
  folder?: Maybe<Folder>;
  id: Scalars['UUID']['output'];
  libraryItem: LibraryItem;
};

export type LibraryItemFolderMembershipInput = {
  folderId: Scalars['UUID']['input'];
  libraryItemId: Scalars['UUID']['input'];
};

export type LibraryItemFolderMembershipsMutationResult = MutationResult & {
  __typename?: 'LibraryItemFolderMembershipsMutationResult';
  error?: Maybe<Error>;
  memberships: Array<LibraryItemFolderMembership>;
  success: Scalars['Boolean']['output'];
};

export type LibraryItemMutationResult = MutationResult & {
  __typename?: 'LibraryItemMutationResult';
  error?: Maybe<Error>;
  libraryItem?: Maybe<LibraryItem>;
  success: Scalars['Boolean']['output'];
};

export enum LibraryItemPublishedStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  NeedsSetup = 'NEEDS_SETUP',
  Published = 'PUBLISHED',
  UnpublishedChanges = 'UNPUBLISHED_CHANGES'
}

export enum LibraryItemType {
  Audit = 'AUDIT',
  Course = 'COURSE',
  Folder = 'FOLDER',
  Module = 'MODULE',
  PremiumContent = 'PREMIUM_CONTENT',
  ScormCourse = 'SCORM_COURSE',
  Sharp = 'SHARP',
  Skill = 'SKILL',
  Task = 'TASK',
  TrainingResource = 'TRAINING_RESOURCE'
}

export type LibraryItemTypeInput = {
  value: LibraryItemType;
};

export type LibraryItemTypeListInput = {
  value: Array<LibraryItemType>;
};

export type LibraryItems = PaginatedList & {
  __typename?: 'LibraryItems';
  objects: Array<LibraryItem>;
  totalCount: Scalars['Int']['output'];
};

export type LibraryItemsMutationResult = MutationResult & {
  __typename?: 'LibraryItemsMutationResult';
  error?: Maybe<Error>;
  objects?: Maybe<LibraryItems>;
  success: Scalars['Boolean']['output'];
};

export enum LibrarySearchMode {
  Name = 'NAME',
  NameDescriptionAndContent = 'NAME_DESCRIPTION_AND_CONTENT'
}

export enum LicenseType {
  PerLocation = 'PER_LOCATION',
  PerUser = 'PER_USER'
}

export enum LinearIssueProblemArea {
  Ask = 'ASK',
  EngineerError = 'ENGINEER_ERROR',
  Infrastructure = 'INFRASTRUCTURE',
  Other = 'OTHER',
  Unknown = 'UNKNOWN',
  UserError = 'USER_ERROR'
}

export enum LinearIssueProductArea {
  Access = 'ACCESS',
  Ai = 'AI',
  AskOpus = 'ASK_OPUS',
  ContentBuilder = 'CONTENT_BUILDER',
  Docs = 'DOCS',
  Hris = 'HRIS',
  Messages = 'MESSAGES',
  Organization = 'ORGANIZATION',
  PathBuilder = 'PATH_BUILDER',
  Reporting = 'REPORTING',
  Resources = 'RESOURCES',
  TaskLists = 'TASK_LISTS',
  Training = 'TRAINING',
  Unknown = 'UNKNOWN'
}

export type LinkUserToHrisEmployeeByDateOfBirthInput = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Address>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  assignmentCompletionPercentage: Scalars['Float']['output'];
  assignmentPastDuePercentage: Scalars['Float']['output'];
  createdBy?: Maybe<Employee>;
  currentLocationReportDay?: Maybe<LocationReportDay>;
  employees: Array<Employee>;
  expectedUsersConfig: ExpectedUsersConfig;
  firstMemberAddedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  lastUpdatedBy?: Maybe<Employee>;
  locationGroupMemberships: Array<LocationGroupMembership>;
  metricRankings?: Maybe<LocationMetricRankings>;
  name: Scalars['String']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  org: Org;
  pastDueUsersCount: Scalars['Int']['output'];
  previousLocationReportDay?: Maybe<LocationReportDay>;
  signupCode?: Maybe<SignupCode>;
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  userCount: Scalars['Int']['output'];
};


export type LocationUserCountArgs = {
  roleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LocationCreditSpend = {
  __typename?: 'LocationCreditSpend';
  creditsSpent: Scalars['Int']['output'];
  locationId?: Maybe<Scalars['Int']['output']>;
  locationName: Scalars['String']['output'];
};

export type LocationDataPoint = {
  __typename?: 'LocationDataPoint';
  data: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
};

export type LocationEmployeeCountOverrideInput = {
  employeeCount: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
};

export type LocationFilters = {
  __typename?: 'LocationFilters';
  locationGroups?: Maybe<Array<LocationGroup>>;
  locations?: Maybe<Array<Location>>;
};

export type LocationGroup = {
  __typename?: 'LocationGroup';
  brandDetails?: Maybe<BrandDetails>;
  childLocationGroups: Array<LocationGroup>;
  id: Scalars['UUID']['output'];
  locationCount: Scalars['Int']['output'];
  locationMemberships: Array<LocationGroupMembership>;
  name: Scalars['String']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  parentLocationGroup?: Maybe<LocationGroup>;
  type: LocationGroupType;
  userCount: Scalars['Int']['output'];
  userLocationGroupMemberships: Array<UserLocationGroupMembership>;
};


export type LocationGroupUserCountArgs = {
  roleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LocationGroupInput = {
  brandDetails?: InputMaybe<BrandDetailsInput>;
  childLocationGroupIds?: Array<Scalars['UUID']['input']>;
  locationIds: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  parentLocationGroupId?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<LocationGroupType>;
};

export type LocationGroupMembership = {
  __typename?: 'LocationGroupMembership';
  id: Scalars['UUID']['output'];
  location: Location;
  locationGroup: LocationGroup;
};

export type LocationGroupMutationResult = MutationResult & {
  __typename?: 'LocationGroupMutationResult';
  error?: Maybe<Error>;
  locationGroup?: Maybe<LocationGroup>;
  success: Scalars['Boolean']['output'];
};

export enum LocationGroupType {
  Brand = 'BRAND',
  Franchise = 'FRANCHISE',
  Region = 'REGION'
}

export type LocationGroups = PaginatedList & {
  __typename?: 'LocationGroups';
  objects: Array<LocationGroup>;
  totalCount: Scalars['Int']['output'];
};

export type LocationGroupsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  locationGroupsChildOf?: InputMaybe<Array<Scalars['UUID']['input']>>;
  locationGroupsDirectChildOf?: InputMaybe<Array<Scalars['UUID']['input']>>;
  openedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
  types?: InputMaybe<Array<LocationGroupType>>;
};

export type LocationLeaderboard = PaginatedList & {
  __typename?: 'LocationLeaderboard';
  objects: Array<LocationLeaderboardItem>;
  totalCount: Scalars['Int']['output'];
};

export type LocationLeaderboardInput = {
  sort?: InputMaybe<SortInput>;
  window?: InputMaybe<LeaderboardWindow>;
};

export type LocationLeaderboardItem = {
  __typename?: 'LocationLeaderboardItem';
  assignmentCompletionPercentage?: Maybe<Scalars['Float']['output']>;
  assignmentPastDuePercentage?: Maybe<Scalars['Float']['output']>;
  assignmentsCompleted: Scalars['Int']['output'];
  averageAccuracy?: Maybe<Scalars['Float']['output']>;
  id: Scalars['UUID']['output'];
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  pastDueAssignments: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
};

export type LocationMetricRanking = {
  __typename?: 'LocationMetricRanking';
  rank: Scalars['Int']['output'];
  rankUp?: Maybe<Scalars['Boolean']['output']>;
  totalLocations: Scalars['Int']['output'];
};

export type LocationMetricRankings = {
  __typename?: 'LocationMetricRankings';
  adoption?: Maybe<LocationMetricRanking>;
  assignmentCompletion?: Maybe<LocationMetricRanking>;
  onTimeTaskLists?: Maybe<LocationMetricRanking>;
  traineeEngagement?: Maybe<LocationMetricRanking>;
};

export type LocationMutationResult = MutationResult & {
  __typename?: 'LocationMutationResult';
  error?: Maybe<Error>;
  location?: Maybe<Location>;
  success: Scalars['Boolean']['output'];
};

export type LocationReportDay = {
  __typename?: 'LocationReportDay';
  completedAssignments: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
  engagedManagers: Scalars['Int']['output'];
  engagedTrainees: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  onTimeTaskListsSubmitted: Scalars['Int']['output'];
  onboardedUserCount: Scalars['Int']['output'];
  pastDueAssignments?: Maybe<Scalars['Int']['output']>;
  targetUserCount: Scalars['Int']['output'];
  totalAssignments: Scalars['Int']['output'];
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  totalExpectedTaskListsSubmitted: Scalars['Int']['output'];
  totalManagers: Scalars['Int']['output'];
};

export type Locations = PaginatedList & {
  __typename?: 'Locations';
  objects: Array<Location>;
  totalCount: Scalars['Int']['output'];
};

export type LocationsInput = {
  hasHrisLink?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  locationGroupsChildOf?: InputMaybe<Array<Scalars['UUID']['input']>>;
  locationGroupsDirectChildOf?: InputMaybe<Array<Scalars['UUID']['input']>>;
  openedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type LocationsMutationResult = MutationResult & {
  __typename?: 'LocationsMutationResult';
  error?: Maybe<Error>;
  locations?: Maybe<Array<Location>>;
  success: Scalars['Boolean']['output'];
};

export enum McOption {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E'
}

export type MimeType = {
  __typename?: 'MIMEType';
  ext: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type ManagerLeaderboard = PaginatedList & {
  __typename?: 'ManagerLeaderboard';
  objects: Array<ManagerLeaderboardItem>;
  totalCount: Scalars['Int']['output'];
};

export type ManagerLeaderboardInput = {
  sort?: InputMaybe<SortInput>;
  /** @deprecated Field no longer supported */
  window?: InputMaybe<ManagerLeaderboardWindow>;
};

export type ManagerLeaderboardItem = {
  __typename?: 'ManagerLeaderboardItem';
  assignmentsCreated: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  managerFirstName: Scalars['String']['output'];
  managerId: Scalars['Int']['output'];
  managerLastName: Scalars['String']['output'];
  managerLocations?: Maybe<Array<Scalars['String']['output']>>;
  managerName: Scalars['String']['output'];
  managerRoles?: Maybe<Array<Scalars['String']['output']>>;
  rank: Scalars['Int']['output'];
  skillsVerified: Scalars['Int']['output'];
  teamAssignmentCompletionPercentage?: Maybe<Scalars['Float']['output']>;
  teamAssignmentPastDuePercentage?: Maybe<Scalars['Float']['output']>;
  teamAssignmentsCompleted: Scalars['Int']['output'];
  teamAverageAccuracy?: Maybe<Scalars['Float']['output']>;
};

export enum ManagerLeaderboardWindow {
  AllTime = 'ALL_TIME',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK'
}

export type MarkChatReadInput = {
  chatId: Scalars['UUID']['input'];
};

export type MarkChatReadResult = MutationResult & {
  __typename?: 'MarkChatReadResult';
  chat?: Maybe<Chat>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type MarkMessagingActivityItemsReadInput = {
  chatIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  postIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  types: Array<MessagingActivityItemType>;
};

export type MatchItem = {
  __typename?: 'MatchItem';
  id: Scalars['UUID']['output'];
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['Int']['output']>;
  text: TranslationSet;
};

export type MatchItemObjectInput = {
  id: Scalars['UUID']['input'];
  mediaId?: InputMaybe<Scalars['Int']['input']>;
  text: TranslationSetObjectInput;
};

export type MatchOrgGuestFeedbackCsvUploadLocationsInput = {
  columnName: Scalars['String']['input'];
  csvUrl: Scalars['String']['input'];
};

export type MatchOrgGuestFeedbackCsvUploadLocationsResult = MutationResult & {
  __typename?: 'MatchOrgGuestFeedbackCsvUploadLocationsResult';
  error?: Maybe<Error>;
  locationMappings: Array<CsvLocationMapping>;
  success: Scalars['Boolean']['output'];
};

export type Me = {
  __typename?: 'Me';
  availableOrgs: Orgs;
  canEditCoachingTemplates: Scalars['Boolean']['output'];
  crmUser?: Maybe<CrmUser>;
  emailPreferences: EmailPreferences;
  featureFlags: Array<FeatureFlag>;
  isStaff: Scalars['Boolean']['output'];
  user: Employee;
};


export type MeAvailableOrgsArgs = {
  input?: InputMaybe<AvailableOrgsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type MeCanEditCoachingTemplatesArgs = {
  team: CrmTeam;
};

export type Media = {
  __typename?: 'Media';
  createdAt: Scalars['DateTime']['output'];
  dataTransformSet?: Maybe<DataTransformSet>;
  hideVideoControls: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  imageUrls?: Maybe<ImageUrls>;
  loopVideo: Scalars['Boolean']['output'];
  mediaUrls: TranslationSet;
  mostRecentConvertMediaToRichTextDocumentWorkflow?: Maybe<ConvertMediaToRichTextDocumentWorkflow>;
  org: Org;
  subtitleTracks: Array<SubtitleTrack>;
  thumbnailImageUrl?: Maybe<Scalars['String']['output']>;
  trainingResourceVersions?: Maybe<Array<TrainingResourceVersion>>;
  unoptimizedUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MediaConversionStatus = {
  __typename?: 'MediaConversionStatus';
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  succeededAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MediaInput = {
  mediaUrls: TranslationSetInput;
};

export type MediaMutationResult = MutationResult & {
  __typename?: 'MediaMutationResult';
  error?: Maybe<Error>;
  media?: Maybe<Media>;
  success: Scalars['Boolean']['output'];
};

export type MediaSuggestion = {
  __typename?: 'MediaSuggestion';
  id: Scalars['UUID']['output'];
  media: Media;
  prompt: Prompt;
};

export type MergeBackfillRun = {
  __typename?: 'MergeBackfillRun';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  hrisIntegration: HrisIntegration;
  id: Scalars['Int']['output'];
  isNightlyResync?: Maybe<Scalars['Boolean']['output']>;
  modifiedActiveEmployeesCount: Scalars['Int']['output'];
  modifiedEmployeesCount: Scalars['Int']['output'];
  queuedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MergeBackfillRuns = PaginatedList & {
  __typename?: 'MergeBackfillRuns';
  objects: Array<MergeBackfillRun>;
  totalCount: Scalars['Int']['output'];
};

export type MergeBackfillRunsFiltersInput = {
  completedAt?: InputMaybe<DateTimeValue>;
  hrisEmployeeId?: InputMaybe<IntValue>;
  hrisIntegrationId?: InputMaybe<UuidValue>;
};

export type MergeBackfillRunsInput = {
  filters?: InputMaybe<MergeBackfillRunsFiltersInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type MergeCompanyContactCandidatesResult = MutationResult & {
  __typename?: 'MergeCompanyContactCandidatesResult';
  candidate?: Maybe<CompanyContactCandidate>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export enum MergeLinkedAccountStatus {
  Complete = 'COMPLETE',
  Idle = 'IDLE',
  Incomplete = 'INCOMPLETE',
  RelinkNeeded = 'RELINK_NEEDED'
}

export type MergeUsersInput = {
  fromUserId: Scalars['Int']['input'];
  intoUserId: Scalars['Int']['input'];
};

export type MessageBlast = {
  __typename?: 'MessageBlast';
  allowComments: Scalars['Boolean']['output'];
  commentCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  draft: Scalars['Boolean']['output'];
  fromOpus: Scalars['Boolean']['output'];
  fromOrg: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  mediaUrls?: Maybe<TranslationSet>;
  mentions: Array<PostMention>;
  messageBlastMedias?: Maybe<Array<MessageBlastMedia>>;
  messageText: TranslationSet;
  messageTextSearchHeadline?: Maybe<Scalars['String']['output']>;
  notificationSchedule?: Maybe<BlastNotificationSchedule>;
  reactionCount: Scalars['Int']['output'];
  readCount?: Maybe<Scalars['Int']['output']>;
  recipientCount: Scalars['Int']['output'];
  recipientGroups: Array<BlastRecipientGroup>;
  recipients: Array<BlastRecipient>;
  sendAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentBy: Employee;
  sentBySearchHeadline?: Maybe<Scalars['String']['output']>;
  sentRecords: Array<BlastSentRecord>;
  subject?: Maybe<TranslationSet>;
  subjectSearchHeadline?: Maybe<Scalars['String']['output']>;
  triggerMessageActionSkillInstance?: Maybe<SkillInstance>;
  userCanReceiveCommentPushNotifications: Scalars['Boolean']['output'];
  userSelectionSet?: Maybe<UserSelectionSet>;
  viewerHasReacted: Scalars['Boolean']['output'];
};

export type MessageBlastInput = {
  allowComments?: InputMaybe<Scalars['Boolean']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  fromOrg?: InputMaybe<Scalars['Boolean']['input']>;
  messageBlastMedias?: InputMaybe<Array<MessageBlastMediaInput>>;
  messageText: TranslationSetInput;
  sendAt?: InputMaybe<Scalars['DateTime']['input']>;
  sendUntil?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<TranslationSetInput>;
  userSelectionSet?: InputMaybe<UserSelectionSetInput>;
};

export type MessageBlastMedia = {
  __typename?: 'MessageBlastMedia';
  id: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  libraryItem?: Maybe<LibraryItem>;
  media?: Maybe<Media>;
  pinned: Scalars['Boolean']['output'];
};

export type MessageBlastMediaInput = {
  index: Scalars['Int']['input'];
  libraryItemId?: InputMaybe<Scalars['UUID']['input']>;
  mediaId?: InputMaybe<Scalars['Int']['input']>;
  pinned: Scalars['Boolean']['input'];
};

export type MessageBlastMutationResult = MutationResult & {
  __typename?: 'MessageBlastMutationResult';
  error?: Maybe<Error>;
  messageBlast?: Maybe<MessageBlast>;
  success: Scalars['Boolean']['output'];
};

export type MessageBlasts = PaginatedList & {
  __typename?: 'MessageBlasts';
  objects: Array<MessageBlast>;
  totalCount: Scalars['Int']['output'];
};

export type MessageBlastsInput = {
  draft?: InputMaybe<BooleanValue>;
  excludePostsCopiedToChats?: InputMaybe<BooleanValue>;
  ids?: InputMaybe<IntArrayInput>;
  received?: InputMaybe<BooleanValue>;
  scheduled?: InputMaybe<BooleanValue>;
  search?: InputMaybe<StringValue>;
  sentAfter?: InputMaybe<DateTimeValue>;
  sentByViewer?: InputMaybe<BooleanValue>;
  sort?: InputMaybe<SortInput>;
};

export enum MessageReaction {
  Heart = 'HEART',
  Question = 'QUESTION',
  Smile = 'SMILE',
  ThumbsDown = 'THUMBS_DOWN',
  ThumbsUp = 'THUMBS_UP'
}

export type MessageReadsGridInput = {
  locationIds: IntArrayInput;
  messageBlastIds: IntArrayInput;
};

export type MessagingActivityItem = {
  __typename?: 'MessagingActivityItem';
  actor?: Maybe<Employee>;
  chat?: Maybe<Chat>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  post?: Maybe<MessageBlast>;
  read: Scalars['Boolean']['output'];
  text: TranslationSet;
  type: MessagingActivityItemType;
  user: Employee;
};

export type MessagingActivityItemFiltersInput = {
  excludePostsCopiedToChats?: InputMaybe<BooleanValue>;
  postSentByMe?: InputMaybe<Scalars['Boolean']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<MessagingActivityItemType>>;
};

export enum MessagingActivityItemType {
  ChatMessageMention = 'CHAT_MESSAGE_MENTION',
  ChatOwnerAdded = 'CHAT_OWNER_ADDED',
  ChatOwnerRemoved = 'CHAT_OWNER_REMOVED',
  NewAutomatedPost = 'NEW_AUTOMATED_POST',
  NewChatMessage = 'NEW_CHAT_MESSAGE',
  NewPost = 'NEW_POST',
  NewPostComment = 'NEW_POST_COMMENT',
  NewPostReaction = 'NEW_POST_REACTION',
  PostCommentMention = 'POST_COMMENT_MENTION',
  PostMention = 'POST_MENTION'
}

export type MessagingActivityItems = PaginatedList & {
  __typename?: 'MessagingActivityItems';
  objects: Array<MessagingActivityItem>;
  totalCount: Scalars['Int']['output'];
};

export type MessagingActivityItemsMutationResult = MutationResult & {
  __typename?: 'MessagingActivityItemsMutationResult';
  error?: Maybe<Error>;
  messagingActivityItems: Array<MessagingActivityItem>;
  success: Scalars['Boolean']['output'];
};

export enum MobilePlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type ModifyImageInput = {
  imageUrl: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};

export type Module = {
  __typename?: 'Module';
  aiGenerateModuleRequests: Array<AiGenerateModuleRequest>;
  aiGenerationInProgress: Scalars['Boolean']['output'];
  aiScormUploadRequests: Array<AiscormUploadRequest>;
  assignedCount: Scalars['Int']['output'];
  averageCourseAccuracy?: Maybe<Scalars['Float']['output']>;
  averageCourseFeedbackRating?: Maybe<Scalars['Float']['output']>;
  averageTimeToCompleteDays?: Maybe<Scalars['Float']['output']>;
  averageTimeToCompleteSeconds?: Maybe<Scalars['Float']['output']>;
  catalogModules: Array<CatalogModule>;
  completeInOrder?: Maybe<Scalars['Boolean']['output']>;
  draftVersion: ModuleVersion;
  enableCertificate?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  lastBuilderActionId?: Maybe<Scalars['Int']['output']>;
  libraryItem: LibraryItem;
  publishedVersion?: Maybe<ModuleVersion>;
  versions: Array<ModuleVersion>;
};

export type ModuleBuilderActionInput = {
  addModuleContentMembershipAction?: InputMaybe<AddModuleContentMembershipActionInput>;
  moduleId: Scalars['Int']['input'];
  moveModuleContentMembershipAction?: InputMaybe<MoveModuleContentMembershipActionInput>;
  removeModuleContentMembershipAction?: InputMaybe<RemoveModuleContentMembershipActionInput>;
  setCourseOutlineBodyTextAction?: InputMaybe<SetCourseOutlineBodyTextActionInput>;
  setCourseOutlineTitleTextAction?: InputMaybe<SetCourseOutlineTitleTextActionInput>;
  setModuleContentMembershipRequireFullVideoPlaybackAction?: InputMaybe<SetModuleContentMembershipRequireFullVideoPlaybackActionInput>;
  setModuleCoverImageAction?: InputMaybe<SetModuleCoverImageActionInput>;
  setModuleDescriptionAction?: InputMaybe<SetModuleDescriptionActionInput>;
  setModuleNameAction?: InputMaybe<SetModuleNameActionInput>;
  setModuleSettingsAction?: InputMaybe<SetModuleSettingsActionInput>;
  setModuleVersionSettingsAction?: InputMaybe<SetModuleVersionSettingsActionInput>;
  setSectionBreakLockBetweenSectionDaysAction?: InputMaybe<SetSectionBreakLockBetweenSectionDaysActionInput>;
  setSectionBreakTitleAction?: InputMaybe<SetSectionBreakTitleActionInput>;
  startCourseOutlineGenerationAction?: InputMaybe<StartCourseOutlineGenerationActionInput>;
};

export type ModuleCompleteInOrderValue = {
  value: CompleteModuleInOrder;
};

export type ModuleContentMembership = {
  __typename?: 'ModuleContentMembership';
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']['output']>;
  courseOutline?: Maybe<CourseOutline>;
  fractionPosition: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  index: Scalars['Float']['output'];
  moduleVersion?: Maybe<ModuleVersion>;
  requireFullVideoPlayback: Scalars['Boolean']['output'];
  sectionBreak?: Maybe<SectionBreak>;
  skill?: Maybe<Skill>;
  skillId?: Maybe<Scalars['Int']['output']>;
  trainingResource?: Maybe<TrainingResource>;
  trainingResourceId?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type ModuleContentMembershipInput = {
  courseId?: InputMaybe<Scalars['Int']['input']>;
  sectionBreak?: InputMaybe<SectionBreakInput>;
  skillId?: InputMaybe<Scalars['Int']['input']>;
  trainingResourceId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ModuleContentMembershipInstance = {
  __typename?: 'ModuleContentMembershipInstance';
  courseInstance?: Maybe<CourseInstance>;
  id: Scalars['UUID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  moduleInstance: ModuleInstance;
  readyForTrainingAt?: Maybe<Scalars['DateTime']['output']>;
  requireFullVideoPlayback: Scalars['Boolean']['output'];
  sectionBreakInstance?: Maybe<SectionBreakInstance>;
  skillInstance?: Maybe<SkillInstance>;
  trainingResourceInstance?: Maybe<TrainingResourceInstance>;
};

export type ModuleInput = {
  /** @deprecated Field no longer supported */
  courseMemberships?: InputMaybe<Array<ModuleMembershipCourseInput>>;
  name: Scalars['String']['input'];
  /** @deprecated Field no longer supported */
  skillMemberships?: InputMaybe<Array<ModuleMembershipSkillInput>>;
};

export type ModuleInstance = {
  __typename?: 'ModuleInstance';
  assignedByAccessSources: Array<AccessSource>;
  assignedByList: Array<Scalars['String']['output']>;
  assignment: Assignment;
  certificateUrl?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  complianceAttempts: Array<ComplianceAttempt>;
  createdAt: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['Date']['output']>;
  failed?: Maybe<Scalars['Boolean']['output']>;
  firstAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  firstAssignedByStr?: Maybe<Scalars['String']['output']>;
  foodHandlerExam?: Maybe<FoodHandlerExam>;
  id: Scalars['UUID']['output'];
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  lastAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  lastAssignedByStr?: Maybe<Scalars['String']['output']>;
  markedCompletedBy?: Maybe<Employee>;
  markedCompletedReason?: Maybe<Scalars['String']['output']>;
  module: Module;
  moduleContentMembershipInstances: Array<ModuleContentMembershipInstance>;
  moduleVersion?: Maybe<ModuleVersion>;
  percentComplete: Scalars['Float']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['AttemptStatus']['output'];
  user: Employee;
};

export type ModuleMembershipCourseInput = {
  courseId: Scalars['Int']['input'];
  index: Scalars['Int']['input'];
};

export type ModuleMembershipSkillInput = {
  index: Scalars['Int']['input'];
  skillId: Scalars['Int']['input'];
};

export type ModuleMutationResult = MutationResult & {
  __typename?: 'ModuleMutationResult';
  error?: Maybe<Error>;
  module?: Maybe<Module>;
  success: Scalars['Boolean']['output'];
};

export type ModuleSettingsInput = {
  allAdmins?: InputMaybe<SharingPermission>;
  allManagers?: InputMaybe<SharingPermission>;
  completeInOrder?: InputMaybe<BooleanValue>;
  description?: InputMaybe<TranslationSetInputValue>;
  dueDate?: InputMaybe<DueDateInputValue>;
  qrCodeSettings?: InputMaybe<QrCodeSettingsInput>;
};

export type ModuleVersion = {
  __typename?: 'ModuleVersion';
  completeInOrder: CompleteModuleInOrder;
  id: Scalars['UUID']['output'];
  metadata: VersionMetadata;
  module: Module;
  moduleContentMemberships: Array<ModuleContentMembership>;
};

export type MostRecentAuditCompletionReportsInput = {
  libraryItemIds?: InputMaybe<UuidArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
};

export type MoveLessonActionInput = {
  lessonUuid: Scalars['UUID']['input'];
  position: Scalars['Int']['input'];
};

export type MoveModuleContentMembershipActionInput = {
  fractionPosition: Scalars['Float']['input'];
  moduleContentMembershipUuid: Scalars['UUID']['input'];
};

export type MovePromptActionInput = {
  lessonUuid: Scalars['UUID']['input'];
  position: Scalars['Int']['input'];
  promptUuid: Scalars['UUID']['input'];
};

export type MoveResponseOptionActionInput = {
  position: Scalars['Int']['input'];
  promptUuid: Scalars['UUID']['input'];
  responseOptionId: Scalars['UUID']['input'];
};

export type MoveStepActionInput = {
  id: Scalars['UUID']['input'];
  parentConditionalStepGroupId?: InputMaybe<Scalars['UUID']['input']>;
  position: Scalars['Int']['input'];
};

export type MoveStepResponseOptionActionInput = {
  position: Scalars['Int']['input'];
  stepResponseOptionId: Scalars['UUID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  AIAddEmojisToText: StringMutationResult;
  AISuggestReadingLevelChangesToText: StringMutationResult;
  AISuggestSpellingAndGrammarChangesToText: StringMutationResult;
  DeleteContract: ContractMutationResult;
  EnrichCRMContact: EnrichCrmContactResult;
  EnrichCandidatesViaProvider: EnrichCandidatesViaProviderResult;
  EnrichCustomContact: EnrichCustomContactResult;
  /**
   * Queue extraction of structured contract data from a base64-encoded contract
   * PDF via Claude. Returns a CONTRACT_PDF_EXTRACTION ClientFacingWorkflow to
   * poll; on completion its result.extraction mirrors magnum's contract form.
   */
  ExtractContractFromPdf: ExtractContractFromPdfResult;
  KillAgentCommand: KillAgentCommandResult;
  MergeCompanyContactCandidates: MergeCompanyContactCandidatesResult;
  PollAgentSessionCommandLogs: PollAgentSessionCommandLogsResult;
  PollAgentSessionCommands: PollAgentSessionCommandsResult;
  RecalculateABXBatch: GenericMutationResult;
  RecalculateABXForCompany: GenericMutationResult;
  SaveContract: ContractMutationResult;
  SearchCompanyContacts: SearchCompanyContactsResult;
  SendAgentMessage: SendAgentMessageResult;
  SeparateCompanyContactCandidate: SeparateCompanyContactCandidateResult;
  SetIntercomConversationCompany: IntercomConversationMutationResult;
  SyncCandidatesToAttio: SyncCandidatesToAttioResult;
  abortOpusAgentTurn: AbortOpusAgentTurnResult;
  acceptGuestFeedbackRecommendation: GuestFeedbackCorrectiveActionMutationResult;
  accessContentViaQRCode: AccessContentMutationResult;
  addContentToLibrary: CatalogMutationResult;
  addCourseToLibrary: CatalogMutationResult;
  addCoursesToLibrary: CatalogMutationResult;
  addPostReaction: PostReactionMutationResult;
  addTaskComment: TaskMutationResult;
  addTaskProofMedia: TaskMutationResult;
  addUsersToLocations: LocationsMutationResult;
  addUsersToRoles: RolesMutationResult;
  applyBuilderActions: ApplyBuilderActionsMutationResult;
  applyCourseProgress: GenericMutationResult;
  approveRemediationStep: RemediationStepInstanceMutationResult;
  archiveContent: BaseMutationResult;
  archiveLibraryItems: LibraryItemsMutationResult;
  archiveModule: ModuleMutationResult;
  archiveSkill: SkillMutationResult;
  archiveTrainingResource: TrainingResourceMutationResult;
  archiveWorkflow: WorkflowMutationResult;
  assignLibraryItems: BaseMutationResult;
  attributeUnsplashImageSelection: GenericMutationResult;
  bulkCreateTrainingResources: TrainingResourcesMutationResult;
  bulkPublishResources: BulkPublishResourcesMutationResult;
  bulkUpdateLibraryItemAutomations: AutomationMutationResult;
  cancelWorkflowInstance: WorkflowInstanceMutationResult;
  completeKnowledgeCheck: CompleteKnowledgeCheckMutationResult;
  completeMyTrainingResourceAssignment: TrainingResourceInstanceMutationResult;
  completeReAudit: CompleteReAuditMutationResult;
  completeTraineeSignup: BaseMutationResult;
  convertSCORMPackage: ScormPackageConversionMutationResult;
  copyCourse: CourseMutationResult;
  copyModule: ModuleMutationResult;
  copyResource: TrainingResourceMutationResult;
  copySkill: SkillMutationResult;
  createAICourse: CourseMutationResult;
  createAIFeedback: BaseMutationResult;
  createBackfilledAssignments: CreateBackfilledAssignmentsMutationResult;
  createBackfilledCertificates: CreateBackfilledCertificatesMutationResult;
  createBlastReadRecord: MessageBlastMutationResult;
  createChat: ChatMutationResult;
  createChatMessageReaction: ChatMessageMutationResult;
  createCheckoutSession: StringMutationResult;
  createClockInConfirmation: EmployeeMutationResult;
  createCoachingTemplate: CoachingTemplateMutationResult;
  createComment: CommentThreadMutationResult;
  createComplianceAttemptImports: BaseMutationResult;
  createContentTagMembership: ContentTagMembershipMutationResult;
  createContentTagMemberships: ContentTagMembershipMutationResult;
  createCourse: CourseMutationResult;
  createCourseFeedback: CourseInstanceMutationResult;
  createDashboardFeedback: GenericMutationResult;
  createExpoPushToken: GenericMutationResult;
  createFeedback: GenericMutationResult;
  createFolder: FolderMutationResult;
  createGoogleBusinessGuestFeedbackIntegration: OrgGuestFeedbackGoogleBusinessMutationResult;
  createHrisCsvUpload: HrisCsvUploadMutationResult;
  createHrisEmployeeLink: EmployeeMutationResult;
  createHrisLocationLink: GenericMutationResult;
  createHrisTeamLink: GenericMutationResult;
  createLibraryItemFolderMemberships: LibraryItemFolderMembershipsMutationResult;
  createLocation: LocationMutationResult;
  createLocationGroup: LocationGroupMutationResult;
  createMedia: MediaMutationResult;
  createMessageBlast: MessageBlastMutationResult;
  createModule: ModuleMutationResult;
  createOneOffCheckInDelegations: BaseMutationResult;
  createOngoingCheckInDelegations: BaseMutationResult;
  createOrUpdateCompletionSchedule: CompletionScheduleMutationResult;
  createOrUpdateDataTransform: DataTransformMutationResult;
  createOrg: OrgMutationResult;
  createOrgGuestFeedbackCsvUpload: OrgGuestFeedbackCsvUploadMutationResult;
  createOrgSharpConfig: OrgSharpConfigMutationResult;
  createPostComment: PostCommentMutationResult;
  createPromptCommentThread: CommentThreadMutationResult;
  createRemediationInstance: RemediationInstanceMutationResult;
  createReportView: ReportViewMutationResult;
  createReportedContent: ReportedContentMutationResult;
  createResourceFromSCORMPackage: ScormPackageConversionMutationResult;
  createRichTextDocumentCommentThread: CommentThreadMutationResult;
  createRole: RoleMutationResult;
  createRoleGroup: RoleGroupMutationResult;
  createSCORMCourseLibraryItem: ScormCourseMutationResult;
  createSCORMCoursePreviewLaunchLink: ScormCourseLaunchLinkMutationResult;
  createScheduledReportEmail: BaseMutationResult;
  createScheduledUserInvites: CreateScheduledUserInvitesMutationResult;
  createSearchDocument: SearchDocumentMutationResult;
  createSevenShiftsIntegration: CreateSevenShiftsIntegrationMutationResult;
  createSkill: SkillMutationResult;
  createStillEmployedConfirmation: BaseMutationResult;
  createTag: TagMutationResult;
  createTask: TaskMutationResult;
  createTrainingResource: TrainingResourceMutationResult;
  createTrainingResourceV2: TrainingResourceMutationResult;
  createTrainingSession: EmployeeMutationResult;
  createTrainingSessionEvent: GenericMutationResult;
  createUser: UserMutationResult;
  createUserSharingPermissions: UserSharingPermissionMutationResult;
  createWorkflow: WorkflowMutationResult;
  deleteBackfilledAssignments: MutationResult;
  deleteBackfilledCertificates: MutationResult;
  deleteChat: ChatMutationResult;
  deleteChatMessage: ChatMessageMutationResult;
  deleteChatMessageReaction: ChatMessageMutationResult;
  deleteComment: CommentThreadMutationResult;
  deleteCommentThread: CommentThreadMutationResult;
  deleteComplianceAttempts: BaseMutationResult;
  deleteContentTagMembership: ContentTagMembershipMutationResult;
  deleteContentTagMemberships: ContentTagMembershipMutationResult;
  deleteExpoPushTokens: GenerateLinkTokenMutationResult;
  deleteFolder: BaseMutationResult;
  deleteHrisEmployees: GenericMutationResult;
  deleteHrisIntegration: DeleteHrisIntegrationMutationResult;
  deleteHrisLocations: GenericMutationResult;
  deleteHrisTeams: GenericMutationResult;
  deleteLibraryItemFolderMemberships: BaseMutationResult;
  deleteLocation: LocationMutationResult;
  deleteLocationGroups: BaseMutationResult;
  deleteLocations: BaseMutationResult;
  deleteMessageBlast: MessageBlastMutationResult;
  deleteMessageBlastNotificationSchedule: MessageBlastMutationResult;
  deleteModule: ModuleMutationResult;
  deleteOnCompletionAssignmentRules: BaseMutationResult;
  deleteOneOffCheckInDelegations: BaseMutationResult;
  deleteOngoingCheckInDelegations: BaseMutationResult;
  deleteOrgGuestFeedbackCsvUpload: BaseMutationResult;
  deleteOrgGuestFeedbackIntegration: BaseMutationResult;
  deleteOrgPremiumContentConfigs: BaseMutationResult;
  deletePostComment: PostCommentMutationResult;
  deleteReport: BaseMutationResult;
  deleteReportView: BaseMutationResult;
  deleteRole: RoleMutationResult;
  deleteRoleGroups: BaseMutationResult;
  deleteRoles: BaseMutationResult;
  deleteScheduledReportEmail: BaseMutationResult;
  deleteScheduledUserInvites: MutationResult;
  deleteTag: TagMutationResult;
  deleteTags: TagMutationResult;
  deleteTask: BaseMutationResult;
  deleteTaskComment: TaskMutationResult;
  deleteUserPushNotificationSettingChatOverride: GenericMutationResult;
  deleteUserPushNotificationSettingPostActivityOverride: GenericMutationResult;
  /** @deprecated Field no longer supported */
  diffAssignmentRulesChange: DiffAssignmentRulesMutationResult;
  diffAutomationRulesChange: DiffAutomationRulesMutationResult;
  discardTaskFormDraft: BaseMutationResult;
  editChatMessage: ChatMessageMutationResult;
  editComment: CommentThreadMutationResult;
  editOpusAgentMessage: EditOpusAgentMessageResult;
  editPostComment: PostCommentMutationResult;
  editPromptWithAI: AiRequestMutationResult;
  employeeUpdateEmployee: UpdateEmployeeResult;
  genCourseFromOutlineChat: CourseMutationResult;
  generateBackfilledAssignmentCreationPreviewSummary: BackfilledAssignmentImportPreview;
  generateBackfilledCertificateCreationPreviewSummary: BackfilledCertificateImportPreview;
  generateBuilderActionsFromSuggestion: GenerateBuilderActionsFromSuggestionMutationResult;
  generateCoursePromptsResponsesCSV: StringMutationResult;
  generateDcOhrReportCsv: StringMutationResult;
  generateFollowUpTaskTitle: StringMutationResult;
  generateImage: ImageGenerationMutationResult;
  generateMergeAccountToken: BaseMutationResult;
  generateMergeLinkToken: GenerateLinkTokenMutationResult;
  generatePresignedS3PostData: PresignedS3PostDataMutationResult;
  generateScheduledUserInviteCreationPreviewSummary: ScheduledUserInviteImportPreview;
  getAIFeedbackOnGradedFreeResponseAttempt: Scalars['Boolean']['output'];
  getCsvColumnNumberRange: GetCsvColumnNumberRangeMutationResult;
  getCsvColumns: GetCsvColumnsMutationResult;
  getOrCreateAssignment: GetOrCreateAssignmentMutationResult;
  getOrCreateAuditInstanceDraft: SkillInstanceMutationResult;
  getOrCreateCheckInInstanceDraft: SkillInstanceMutationResult;
  getOrCreateTaskListInstanceDraft: SkillInstanceMutationResult;
  getReportFieldFrequencies: ReportMutationResult;
  getSCORMPackageUploadData: ScormPackageUploadDataMutationResult;
  giveAccessToLibraryItems: BaseMutationResult;
  gradeCourseVersion: GradeCourseVersionMutationResult;
  initializeBilling: OrgMutationResult;
  initializeCourseInstance: CourseInstanceMutationResult;
  linkUserToHrisEmployeeByDateOfBirth: HrisEmployeeMutationResult;
  logout: BaseMutationResult;
  markAssignmentsComplete: AssignmentsMutationResult;
  markChatRead: MarkChatReadResult;
  markInProductNotificationsAsRead: InProductNotificationsMutationResult;
  markMessagingActivityItemsRead: MessagingActivityItemsMutationResult;
  markPushNotificationClicked: GenericMutationResult;
  matchOrgGuestFeedbackCsvUploadLocations: MatchOrgGuestFeedbackCsvUploadLocationsResult;
  mergeUsers: EmployeeMutationResult;
  modifyImage: ImageGenerationMutationResult;
  openedCourse: GenericMutationResult;
  openedLocation: GenericMutationResult;
  openedLocationGroup: GenericMutationResult;
  openedModule: GenericMutationResult;
  openedRole: GenericMutationResult;
  openedRoleGroup: GenericMutationResult;
  openedSCORMCourse: GenericMutationResult;
  openedSkill: GenericMutationResult;
  openedTrainingResource: TrainingResourceMutationResult;
  openedUser: GenericMutationResult;
  pauseTraining: PauseTrainingResult;
  persistCoachingAnalysis: PersistCoachingAnalysisResult;
  persistDealScopeAnalysis: PersistDealScopeAnalysisResult;
  persistGuestFeedbackAnalysisRun: PersistGuestFeedbackAnalysisRunMutationResult;
  publishCoachingTemplateVersion: CoachingTemplateMutationResult;
  publishCourse: CourseMutationResult;
  publishModule: ModuleMutationResult;
  publishSCORMCourse: ScormCourseMutationResult;
  publishSkill: SkillMutationResult;
  publishTrainingResource: TrainingResourceMutationResult;
  publishWorkflow: PublishWorkflowMutationResult;
  purchaseCredits: OrgMutationResult;
  reactivateEmployee: EmployeeMutationResult;
  reactivateEmployees: EmployeesMutationResult;
  recoachRunWithTemplate: CoachingRunMutationResult;
  rejectGuestFeedbackRecommendation: GuestFeedbackCorrectiveActionMutationResult;
  rejectRemediationStep: RemediationStepInstanceMutationResult;
  removeActiveClient: BaseMutationResult;
  removeAssignments: BaseMutationResult;
  removeEmployee: RemoveEmployeeResult;
  removeEmployees: BaseMutationResult;
  removeExternalComplianceAttempts: BaseMutationResult;
  removeLibraryAccess: BaseMutationResult;
  removePostReaction: PostReactionMutationResult;
  removeReportDestinationChannel: OrgCustomReportDestinationMutationResult;
  removeTaskProofMedia: TaskMutationResult;
  removeUserSharingPermission: UserSharingPermissionMutationResult;
  removeUsersFromLocations: LocationsMutationResult;
  removeUsersFromRoles: RolesMutationResult;
  renameOpusAgentChat: RenameOpusAgentChatResult;
  replaceOnCompletionAssignmentRuleSets: ReplaceOnCompletionAssignmentRuleSetsMutationResult;
  resendBlastNotification: MessageBlastMutationResult;
  resetDemoOrg: BaseMutationResult;
  resolveAIRequest: AiRequestMutationResult;
  restoreReportedContent: ReportedContentMutationResult;
  resyncHrisIntegration: ResyncHrisIntegrationMutationResult;
  revertCourseToPriorVersion: CourseMutationResult;
  revertSCORMCourseToPublishedVersion: ScormCourseMutationResult;
  revertSkillToPriorVersion: SkillMutationResult;
  reviewTask: TaskMutationResult;
  rotateLegacySignupCodes: GenericMutationResult;
  runReport: ReportMutationResult;
  saveReport: SavedReportMutationResult;
  scrapeAIBrandContextFoundingStory: StringMutationResult;
  scrapeAIBrandContextMissionStatement: StringMutationResult;
  scrapeAIBrandContextSells: StringMutationResult;
  /** @deprecated Field no longer supported */
  searchUnsplashImages: SearchUnsplashMutationResult;
  sendChatMessages: ChatMessagesMutationResult;
  sendCoursePreviewToPhone: GenericMutationResult;
  sendOpusAgentMessage: SendOpusAgentMessageResult;
  sendSeparateChatMessages: BaseMutationResult;
  setActiveClient: ActiveClientMutationResult;
  setCoachingTemplateArchived: CoachingTemplateMutationResult;
  setCommentThreadResolved: CommentThreadMutationResult;
  setDealScopeReady: SetDealScopeReadyResult;
  /** @deprecated Field no longer supported */
  setEmployeeGroups: EmployeeMutationResult;
  setEmployeeLocationGroups: EmployeeMutationResult;
  setEmployeeLocations: EmployeeMutationResult;
  setEmployeeRoles: EmployeeMutationResult;
  setGoogleDriveReportDestination: OrgCustomReportDestinationMutationResult;
  setLocationManagerReportedUserCount: BaseMutationResult;
  setPostCommentsEnabled: MessageBlastMutationResult;
  setS3ReportDestination: OrgCustomReportDestinationMutationResult;
  setSftpReportDestination: OrgCustomReportDestinationMutationResult;
  setTaskProofText: TaskMutationResult;
  startAIUpdateLibraryItem: ClientFacingWorkflowMutationResult;
  startGenAuditFromOutlineChatWorkflow: ClientFacingWorkflowMutationResult;
  startGenCheckInFromOutlineChatWorkflow: ClientFacingWorkflowMutationResult;
  startGenCourseFromOutlineChatWorkflow: ClientFacingWorkflowMutationResult;
  startGenModuleFromOutlineChatWorkflow: ClientFacingWorkflowMutationResult;
  startGenTaskListFromOutlineChatWorkflow: ClientFacingWorkflowMutationResult;
  startRemediation: RemediationInstanceMutationResult;
  startSCORMCourseInstance: ScormCourseInstanceMutationResult;
  startTask: TaskMutationResult;
  startTrainingResourceMediaToRichTextDocumentConversion: TrainingResourceMutationResult;
  startUpdateLibraryItemFromRecommendation: ClientFacingWorkflowMutationResult;
  submitAuditForm: SkillInstanceMutationResult;
  submitCheckinForm: SkillInstanceMutationResult;
  submitRemediation: RemediationInstanceMutationResult;
  submitTaskForReview: TaskMutationResult;
  submitTaskForm: TaskFormMutationResult;
  submitTaskFormV2: SkillInstanceMutationResult;
  suggestAIBlocks: SuggestAiBlocksMutationResult;
  switchCoachingRunTeam: CoachingRunMutationResult;
  switchToUser: SwitchToUserMutationResult;
  textToSpeech: StringMutationResult;
  trackEvent?: Maybe<Scalars['Boolean']['output']>;
  translateText: TranslatedTextMutationResult;
  triggerCoachingTestRun: CoachingRunMutationResult;
  triggerGuestFeedbackRecommendations: BaseMutationResult;
  unarchiveLibraryItems: LibraryItemsMutationResult;
  unpauseTraining: EmployeesMutationResult;
  updateAIOrgContext: AiOrgContextMutationResult;
  updateAdminEmailPreferences: UserMutationResult;
  updateAssignmentDueDates: AssignmentsMutationResult;
  updateAutomation: AutomationMutationResult;
  /** @deprecated Field no longer supported */
  updateBillingEmail: OrgMutationResult;
  updateBlastNotificationSchedule: MessageBlastMutationResult;
  /** @deprecated Use addPostReaction / removePostReaction */
  updateBlastSentRecord: BaseMutationResult;
  updateCertificateEndorser: OrgMutationResult;
  updateChatMemberPermissions: ChatMutationResult;
  updateChatMemberState: ChatMutationResult;
  updateChatMembers: ChatMutationResult;
  updateChatOwners: ChatMutationResult;
  updateChatSettings: ChatMutationResult;
  updateChatTitle: ChatMutationResult;
  updateClockInConfirmationSettings: OrgMutationResult;
  updateCoachingTemplateDraft: CoachingTemplateMutationResult;
  updateCoachingTemplateMetadata: CoachingTemplateMutationResult;
  updateContentSharingPermission?: Maybe<ContentSharingPermissionMutationResult>;
  updateCourse: CourseMutationResult;
  updateCustomerFacingAccountPlan: OrgMutationResult;
  updateDcOhrReminderPreference: UserMutationResult;
  updateDealScopeAnswer: UpdateDealScopeAnswerResult;
  updateEmployeeCountSettings: BaseMutationResult;
  updateEmployeeFeatureFlags: BaseMutationResult;
  updateExpectedUsersConfigs: BaseMutationResult;
  updateFolder: FolderMutationResult;
  updateFolderPosition: FolderMutationResult;
  updateGlossarySet: OrgMutationResult;
  updateGuestFeedbackCorrectiveAction: GuestFeedbackCorrectiveActionMutationResult;
  /** @deprecated Field no longer supported */
  updateGuestFeedbackCorrectiveActions: BaseMutationResult;
  updateHrisCsvUpload: HrisCsvUploadMutationResult;
  updateLocation: LocationMutationResult;
  updateLocationGroup: LocationGroupMutationResult;
  updateMessageBlast: MessageBlastMutationResult;
  updateModuleSettings: ModuleMutationResult;
  updateMyOrg: BaseMutationResult;
  updateOrCreateUserGlobalPushNotificationSettings: UserGlobalPushNotificationSettingsMutationResult;
  updateOrCreateUserPushNotificationSetting: UserPushNotificationSettingMutationResult;
  updateOrCreateUserPushNotificationSettingChatOverride: UserPushNotificationSettingChatOverrideMutationResult;
  updateOrCreateUserPushNotificationSettingPostActivityOverride: UserPushNotificationSettingPostActivityOverrideMutationResult;
  updateOrbCustomer: OrgMutationResult;
  updateOrg: OrgMutationResult;
  updateOrgBrandColor: OrgMutationResult;
  updateOrgFeatureFlags: BaseMutationResult;
  updateOrgGuestFeedbackIntegration: OrgGuestFeedbackIntegrationMutationResult;
  updateOrgGuestFeedbackIntegrationLocation: OrgGuestFeedbackIntegrationLocationMutationResult;
  updateOrgHrisConfig: HrisConfigMutationResult;
  updateOrgLogo: OrgMutationResult;
  updateOrgPremiumContentConfig: BaseMutationResult;
  updateOrgSharpConfig: OrgSharpConfigMutationResult;
  updateRemediationStepResponse: RemediationStepInstanceMutationResult;
  updateReportView: ReportViewMutationResult;
  updateReportingTargets: ReportingTargetSetMutationResult;
  updateRole: RoleMutationResult;
  updateRoleGroup: RoleGroupMutationResult;
  updateRoleLevels: RolesMutationResult;
  updateSCORMCourse: ScormCourseMutationResult;
  updateSCORMCourseDraftVersion: ScormCourseMutationResult;
  updateSkill: SkillMutationResult;
  updateStoreOpening: ImpactReportingStoreOpening;
  updateSubtitles: MediaMutationResult;
  updateTag: TagMutationResult;
  updateTags: TagMutationResult;
  updateTask: TaskMutationResult;
  updateTaskComment: TaskMutationResult;
  updateTaskListDailyDigestSubscription: TaskListDailyDigestSubscriptionMutationResult;
  updateTrainingResource: TrainingResourceMutationResult;
  updateTranslationSet: TranslationSetMutationResult;
  updateUser: UserMutationResult;
  updateUserActionPermissionOverrides: BaseMutationResult;
  /** @deprecated Field no longer supported */
  updateUserActionPermissions: BaseMutationResult;
  updateUserSharingPermission: UserSharingPermissionMutationResult;
  updateWeeklyReachEngagementEmailPreference: UserMutationResult;
  uploadFile: FileUploadMutationResult;
  uploadFileList: FileListUploadMutationResult;
  validateAndExtractScormPackage: ValidateAndExtractScormPackageMutationResult;
  verifySkillV2: SkillInstanceMutationResult;
};


export type MutationAiAddEmojisToTextArgs = {
  text: Scalars['String']['input'];
};


export type MutationAiSuggestReadingLevelChangesToTextArgs = {
  text: Scalars['String']['input'];
};


export type MutationAiSuggestSpellingAndGrammarChangesToTextArgs = {
  text: Scalars['String']['input'];
};


export type MutationDeleteContractArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationEnrichCrmContactArgs = {
  crmContactId: Scalars['UUID']['input'];
  provider: ProviderSource;
};


export type MutationEnrichCandidatesViaProviderArgs = {
  candidateIds: Array<Scalars['ID']['input']>;
  companyId: Scalars['UUID']['input'];
  provider: ProviderSource;
};


export type MutationEnrichCustomContactArgs = {
  companyId: Scalars['UUID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderSource;
};


export type MutationExtractContractFromPdfArgs = {
  pdfData: Scalars['String']['input'];
};


export type MutationKillAgentCommandArgs = {
  commandId: Scalars['UUID']['input'];
};


export type MutationMergeCompanyContactCandidatesArgs = {
  candidateIds: Array<Scalars['ID']['input']>;
  companyId: Scalars['UUID']['input'];
  displayName: Scalars['String']['input'];
};


export type MutationPollAgentSessionCommandLogsArgs = {
  commandId: Scalars['UUID']['input'];
  startLine: Scalars['Int']['input'];
};


export type MutationPollAgentSessionCommandsArgs = {
  sessionIds: Array<Scalars['UUID']['input']>;
};


export type MutationRecalculateAbxBatchArgs = {
  companyIds: Array<Scalars['UUID']['input']>;
};


export type MutationRecalculateAbxForCompanyArgs = {
  companyId: Scalars['UUID']['input'];
};


export type MutationSaveContractArgs = {
  input: SaveContractInput;
};


export type MutationSearchCompanyContactsArgs = {
  companyId: Scalars['UUID']['input'];
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSendAgentMessageArgs = {
  input: SendAgentMessageInput;
};


export type MutationSeparateCompanyContactCandidateArgs = {
  candidateId: Scalars['ID']['input'];
  companyId: Scalars['UUID']['input'];
};


export type MutationSetIntercomConversationCompanyArgs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationSyncCandidatesToAttioArgs = {
  candidateIds: Array<Scalars['ID']['input']>;
  companyId: Scalars['UUID']['input'];
  mergeChoices?: InputMaybe<Array<CandidateMergeChoiceInput>>;
};


export type MutationAbortOpusAgentTurnArgs = {
  turnId: Scalars['UUID']['input'];
};


export type MutationAcceptGuestFeedbackRecommendationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationAccessContentViaQrCodeArgs = {
  input?: InputMaybe<AccessContentViaQrCodeInput>;
};


export type MutationAddContentToLibraryArgs = {
  input: AddContentToLibraryInput;
};


export type MutationAddCourseToLibraryArgs = {
  catalogCourseId: Scalars['Int']['input'];
};


export type MutationAddCoursesToLibraryArgs = {
  catalogCourseIds: Array<Scalars['Int']['input']>;
};


export type MutationAddPostReactionArgs = {
  input: PostReactionInput;
};


export type MutationAddTaskCommentArgs = {
  body: Scalars['String']['input'];
  mediaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  taskId: Scalars['UUID']['input'];
};


export type MutationAddTaskProofMediaArgs = {
  id: Scalars['UUID']['input'];
  mediaIds: Array<Scalars['Int']['input']>;
};


export type MutationAddUsersToLocationsArgs = {
  input: AddUsersToLocationsInput;
};


export type MutationAddUsersToRolesArgs = {
  input: AddUsersToRolesInput;
};


export type MutationApplyBuilderActionsArgs = {
  actions: Array<BuilderActionInput>;
};


export type MutationApplyCourseProgressArgs = {
  promptAttemptInput: CourseProgressPromptAttemptInput;
};


export type MutationApproveRemediationStepArgs = {
  remediationStepId: Scalars['UUID']['input'];
};


export type MutationArchiveContentArgs = {
  inputs: Array<ContentInput>;
};


export type MutationArchiveLibraryItemsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationArchiveModuleArgs = {
  archive: Scalars['Boolean']['input'];
  moduleId: Scalars['Int']['input'];
};


export type MutationArchiveSkillArgs = {
  archive: Scalars['Boolean']['input'];
  skillId: Scalars['Int']['input'];
};


export type MutationArchiveTrainingResourceArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationArchiveWorkflowArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationAssignLibraryItemsArgs = {
  input: AssignLibraryItemsInput;
};


export type MutationAttributeUnsplashImageSelectionArgs = {
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBulkCreateTrainingResourcesArgs = {
  folderId?: InputMaybe<Scalars['UUID']['input']>;
  inputs: Array<BulkCreateTrainingResourceInput>;
};


export type MutationBulkPublishResourcesArgs = {
  trainingResourceIds: Array<Scalars['UUID']['input']>;
};


export type MutationBulkUpdateLibraryItemAutomationsArgs = {
  input: BulkUpdateLibraryItemAutomationsInput;
};


export type MutationCancelWorkflowInstanceArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCompleteKnowledgeCheckArgs = {
  input: CompleteKnowledgeCheckInput;
};


export type MutationCompleteMyTrainingResourceAssignmentArgs = {
  resourceId: Scalars['UUID']['input'];
};


export type MutationCompleteReAuditArgs = {
  input: CompleteReAuditInput;
};


export type MutationCompleteTraineeSignupArgs = {
  input: TraineeSignupInput;
};


export type MutationConvertScormPackageArgs = {
  key: Scalars['String']['input'];
};


export type MutationCopyCourseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCopyModuleArgs = {
  duplicateChildContent?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationCopyResourceArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCopySkillArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCreateAiCourseArgs = {
  input: AiCourseInput;
};


export type MutationCreateAiFeedbackArgs = {
  input: CreateAiFeedbackInput;
};


export type MutationCreateBackfilledAssignmentsArgs = {
  input: CreateBackfilledAssignmentsInput;
};


export type MutationCreateBackfilledCertificatesArgs = {
  input: CreateBackfilledCertificatesInput;
};


export type MutationCreateBlastReadRecordArgs = {
  blastId: Scalars['Int']['input'];
};


export type MutationCreateChatArgs = {
  input: CreateChatInput;
};


export type MutationCreateChatMessageReactionArgs = {
  input: CreateChatMessageReactionInput;
};


export type MutationCreateCheckoutSessionArgs = {
  billingAccountId: Scalars['UUID']['input'];
};


export type MutationCreateCoachingTemplateArgs = {
  input: CreateCoachingTemplateInput;
};


export type MutationCreateCommentArgs = {
  comment: CommentInput;
  threadId: Scalars['String']['input'];
};


export type MutationCreateComplianceAttemptImportsArgs = {
  input: ComplianceAttemptImportsInput;
};


export type MutationCreateContentTagMembershipArgs = {
  libraryItemId: Scalars['UUID']['input'];
  tagId: Scalars['UUID']['input'];
};


export type MutationCreateContentTagMembershipsArgs = {
  inputs?: InputMaybe<Array<InputMaybe<ContentTagMembershipInput>>>;
};


export type MutationCreateCourseArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateCourseFeedbackArgs = {
  courseInstanceId: Scalars['Int']['input'];
  input: CourseFeedbackInput;
};


export type MutationCreateDashboardFeedbackArgs = {
  input: DashboardFeedbackInput;
};


export type MutationCreateExpoPushTokenArgs = {
  platform?: InputMaybe<MobilePlatform>;
  token: Scalars['String']['input'];
};


export type MutationCreateFeedbackArgs = {
  input: FeedbackInput;
};


export type MutationCreateFolderArgs = {
  input: FolderInput;
};


export type MutationCreateGoogleBusinessGuestFeedbackIntegrationArgs = {
  googleBusinessAccountId: Scalars['String']['input'];
  googleBusinessAccountName: Scalars['String']['input'];
  oAuthId: Scalars['UUID']['input'];
};


export type MutationCreateHrisCsvUploadArgs = {
  csvUrl: Scalars['String']['input'];
};


export type MutationCreateHrisEmployeeLinkArgs = {
  hrisEmployeeId: Scalars['Int']['input'];
  traineeId: Scalars['Int']['input'];
};


export type MutationCreateHrisLocationLinkArgs = {
  groupId: Scalars['Int']['input'];
  hrisLocationId: Scalars['Int']['input'];
};


export type MutationCreateHrisTeamLinkArgs = {
  groupId: Scalars['Int']['input'];
  hrisTeamId: Scalars['Int']['input'];
};


export type MutationCreateLibraryItemFolderMembershipsArgs = {
  inputs: Array<LibraryItemFolderMembershipInput>;
};


export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};


export type MutationCreateLocationGroupArgs = {
  input: LocationGroupInput;
};


export type MutationCreateMediaArgs = {
  input: MediaInput;
};


export type MutationCreateMessageBlastArgs = {
  input: MessageBlastInput;
};


export type MutationCreateModuleArgs = {
  input: ModuleInput;
};


export type MutationCreateOneOffCheckInDelegationsArgs = {
  facilitatorIds: Array<Scalars['Int']['input']>;
  skillInstanceId: Scalars['UUID']['input'];
};


export type MutationCreateOngoingCheckInDelegationsArgs = {
  facilitatorIds: Array<Scalars['Int']['input']>;
  skillId: Scalars['Int']['input'];
};


export type MutationCreateOrUpdateCompletionScheduleArgs = {
  input: CompletionScheduleInput;
};


export type MutationCreateOrUpdateDataTransformArgs = {
  input: DataTransformInput;
};


export type MutationCreateOrgArgs = {
  input?: InputMaybe<OrgInput>;
};


export type MutationCreateOrgGuestFeedbackCsvUploadArgs = {
  input: CreateOrgGuestFeedbackCsvUploadInput;
};


export type MutationCreatePostCommentArgs = {
  input: CreatePostCommentInput;
};


export type MutationCreatePromptCommentThreadArgs = {
  comment: CommentInput;
  promptUuid: Scalars['String']['input'];
};


export type MutationCreateRemediationInstanceArgs = {
  input: CreateRemediationInstanceInput;
};


export type MutationCreateReportViewArgs = {
  input: ReportViewInput;
};


export type MutationCreateReportedContentArgs = {
  input: CreateReportedContentInput;
};


export type MutationCreateResourceFromScormPackageArgs = {
  key: Scalars['String']['input'];
};


export type MutationCreateRichTextDocumentCommentThreadArgs = {
  comment: CommentInput;
  quotedText: Scalars['String']['input'];
  richTextDocumentId: Scalars['UUID']['input'];
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateRoleGroupArgs = {
  input: RoleGroupInput;
};


export type MutationCreateScormCourseLibraryItemArgs = {
  packageName: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
};


export type MutationCreateScormCoursePreviewLaunchLinkArgs = {
  scormCourseVersionId: Scalars['UUID']['input'];
};


export type MutationCreateScheduledReportEmailArgs = {
  input: ScheduledReportInput;
};


export type MutationCreateScheduledUserInvitesArgs = {
  input: CreateScheduledUserInvitesInput;
};


export type MutationCreateSearchDocumentArgs = {
  input: CreateSearchDocumentInput;
};


export type MutationCreateSevenShiftsIntegrationArgs = {
  input: CreateSevenShiftsIntegrationInput;
};


export type MutationCreateSkillArgs = {
  input: SkillInput;
};


export type MutationCreateStillEmployedConfirmationArgs = {
  input?: InputMaybe<StillEmployedConfirmationInput>;
};


export type MutationCreateTagArgs = {
  id: Scalars['String']['input'];
  input: TagInput;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTrainingResourceArgs = {
  input: CreateTrainingResourceInput;
};


export type MutationCreateTrainingResourceV2Args = {
  input: CreateTrainingResourceInput;
};


export type MutationCreateTrainingSessionEventArgs = {
  input: TrainingSessionEventInput;
};


export type MutationCreateUserArgs = {
  input: UserInput;
};


export type MutationCreateUserSharingPermissionsArgs = {
  input: CreateUserSharingPermissionsInput;
};


export type MutationCreateWorkflowArgs = {
  name: Scalars['String']['input'];
  type?: InputMaybe<WorkflowType>;
};


export type MutationDeleteBackfilledAssignmentsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteBackfilledCertificatesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteChatArgs = {
  input: DeleteChatInput;
};


export type MutationDeleteChatMessageArgs = {
  input: DeleteChatMessageInput;
};


export type MutationDeleteChatMessageReactionArgs = {
  input: DeleteChatMessageReactionInput;
};


export type MutationDeleteCommentArgs = {
  commentId: Scalars['String']['input'];
};


export type MutationDeleteCommentThreadArgs = {
  threadId: Scalars['String']['input'];
};


export type MutationDeleteComplianceAttemptsArgs = {
  input: DeleteComplianceAttemptsInput;
};


export type MutationDeleteContentTagMembershipArgs = {
  libraryItemId: Scalars['UUID']['input'];
  tagId: Scalars['UUID']['input'];
};


export type MutationDeleteContentTagMembershipsArgs = {
  inputs?: InputMaybe<Array<InputMaybe<ContentTagMembershipInput>>>;
};


export type MutationDeleteFolderArgs = {
  folderId: Scalars['UUID']['input'];
};


export type MutationDeleteHrisEmployeesArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationDeleteHrisIntegrationArgs = {
  input: DeleteHrisIntegrationInput;
};


export type MutationDeleteHrisLocationsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationDeleteHrisTeamsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationDeleteLibraryItemFolderMembershipsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteLocationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteLocationGroupsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteLocationsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationDeleteMessageBlastArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteMessageBlastNotificationScheduleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteModuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteOnCompletionAssignmentRulesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteOneOffCheckInDelegationsArgs = {
  facilitatorIds: Array<Scalars['Int']['input']>;
  skillInstanceId: Scalars['UUID']['input'];
};


export type MutationDeleteOngoingCheckInDelegationsArgs = {
  facilitatorIds: Array<Scalars['Int']['input']>;
  skillId: Scalars['Int']['input'];
};


export type MutationDeleteOrgGuestFeedbackCsvUploadArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteOrgGuestFeedbackIntegrationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteOrgPremiumContentConfigsArgs = {
  input: DeleteOrgPremiumContentConfigsInput;
};


export type MutationDeletePostCommentArgs = {
  input: DeletePostCommentInput;
};


export type MutationDeleteReportArgs = {
  reportId: Scalars['String']['input'];
};


export type MutationDeleteReportViewArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteRoleGroupsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteRolesArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationDeleteScheduledReportEmailArgs = {
  reportId: Scalars['UUID']['input'];
};


export type MutationDeleteScheduledUserInvitesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteTagArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTagsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteTaskArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteTaskCommentArgs = {
  commentId: Scalars['UUID']['input'];
};


export type MutationDeleteUserPushNotificationSettingChatOverrideArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteUserPushNotificationSettingPostActivityOverrideArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDiffAssignmentRulesChangeArgs = {
  input: DiffAssignmentRulesChangeInput;
};


export type MutationDiffAutomationRulesChangeArgs = {
  input: DiffAutomationRulesChangeInput;
};


export type MutationDiscardTaskFormDraftArgs = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  skillInstanceId: Scalars['UUID']['input'];
};


export type MutationEditChatMessageArgs = {
  input: EditChatMessageInput;
};


export type MutationEditCommentArgs = {
  comment?: InputMaybe<CommentInput>;
  commentId: Scalars['String']['input'];
};


export type MutationEditOpusAgentMessageArgs = {
  newMessage: Scalars['String']['input'];
  turnId: Scalars['UUID']['input'];
};


export type MutationEditPostCommentArgs = {
  input: EditPostCommentInput;
};


export type MutationEditPromptWithAiArgs = {
  input: EditPromptWithAiInput;
};


export type MutationEmployeeUpdateEmployeeArgs = {
  input: UpdateEmployee;
};


export type MutationGenCourseFromOutlineChatArgs = {
  input: GenCourseFromOutlineChatInput;
};


export type MutationGenerateBackfilledAssignmentCreationPreviewSummaryArgs = {
  csvContent: Scalars['String']['input'];
  matchingStrategy: BackfilledAssignmentUserMatchingStrategy;
};


export type MutationGenerateBackfilledCertificateCreationPreviewSummaryArgs = {
  complianceType: ComplianceType;
  csvContent: Scalars['String']['input'];
  matchingStrategy: BackfilledAssignmentUserMatchingStrategy;
};


export type MutationGenerateBuilderActionsFromSuggestionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationGenerateCoursePromptsResponsesCsvArgs = {
  input?: InputMaybe<PromptResponsesCsvInput>;
};


export type MutationGenerateFollowUpTaskTitleArgs = {
  skillInstanceId: Scalars['UUID']['input'];
  verificationStepId: Scalars['UUID']['input'];
};


export type MutationGenerateImageArgs = {
  input: GenerateImageInput;
};


export type MutationGenerateMergeAccountTokenArgs = {
  hrisIntegrationId?: InputMaybe<Scalars['String']['input']>;
  publicToken: Scalars['String']['input'];
};


export type MutationGenerateMergeLinkTokenArgs = {
  integrationId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationGeneratePresignedS3PostDataArgs = {
  bucket?: InputMaybe<PresignedS3PostDataBucket>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};


export type MutationGenerateScheduledUserInviteCreationPreviewSummaryArgs = {
  csvContent: Scalars['String']['input'];
  userType: UserType;
};


export type MutationGetAiFeedbackOnGradedFreeResponseAttemptArgs = {
  input: GradedFreeResponseInput;
};


export type MutationGetCsvColumnNumberRangeArgs = {
  columnName: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationGetCsvColumnsArgs = {
  url: Scalars['String']['input'];
};


export type MutationGetOrCreateAssignmentArgs = {
  libraryItemId: Scalars['UUID']['input'];
};


export type MutationGetOrCreateAuditInstanceDraftArgs = {
  input: GetOrCreateAuditInstanceDraftInput;
};


export type MutationGetOrCreateCheckInInstanceDraftArgs = {
  input: GetOrCreateCheckinInstanceDraftInput;
};


export type MutationGetOrCreateTaskListInstanceDraftArgs = {
  input: GetOrCreateTaskListInstanceDraftInput;
};


export type MutationGetReportFieldFrequenciesArgs = {
  fieldId: Scalars['UUID']['input'];
  input: ReportInput;
};


export type MutationGetScormPackageUploadDataArgs = {
  key: Scalars['String']['input'];
};


export type MutationGiveAccessToLibraryItemsArgs = {
  input?: InputMaybe<GiveAccessToLibraryItemsInput>;
};


export type MutationGradeCourseVersionArgs = {
  input: GradeCourseVersionInput;
};


export type MutationInitializeBillingArgs = {
  input: InitializeBillingInput;
};


export type MutationInitializeCourseInstanceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationLinkUserToHrisEmployeeByDateOfBirthArgs = {
  input: LinkUserToHrisEmployeeByDateOfBirthInput;
};


export type MutationMarkAssignmentsCompleteArgs = {
  assignmentIds: Array<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
};


export type MutationMarkChatReadArgs = {
  input: MarkChatReadInput;
};


export type MutationMarkInProductNotificationsAsReadArgs = {
  inProductNotificationIds: Array<Scalars['String']['input']>;
};


export type MutationMarkMessagingActivityItemsReadArgs = {
  input: MarkMessagingActivityItemsReadInput;
};


export type MutationMarkPushNotificationClickedArgs = {
  pushNotificationId: Scalars['Int']['input'];
};


export type MutationMatchOrgGuestFeedbackCsvUploadLocationsArgs = {
  input: MatchOrgGuestFeedbackCsvUploadLocationsInput;
};


export type MutationMergeUsersArgs = {
  input?: InputMaybe<MergeUsersInput>;
};


export type MutationModifyImageArgs = {
  input: ModifyImageInput;
};


export type MutationOpenedCourseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationOpenedLocationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationOpenedLocationGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationOpenedModuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationOpenedRoleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationOpenedRoleGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationOpenedScormCourseArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationOpenedSkillArgs = {
  id: Scalars['Int']['input'];
};


export type MutationOpenedTrainingResourceArgs = {
  id: Scalars['String']['input'];
};


export type MutationOpenedUserArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPauseTrainingArgs = {
  employeeId: Scalars['Int']['input'];
};


export type MutationPersistCoachingAnalysisArgs = {
  input: PersistCoachingAnalysisInput;
};


export type MutationPersistDealScopeAnalysisArgs = {
  input: PersistDealScopeAnalysisInput;
};


export type MutationPersistGuestFeedbackAnalysisRunArgs = {
  input: PersistGuestFeedbackAnalysisRunInput;
};


export type MutationPublishCoachingTemplateVersionArgs = {
  templateId: Scalars['UUID']['input'];
};


export type MutationPublishCourseArgs = {
  courseId: Scalars['Int']['input'];
  input?: InputMaybe<PublishCourseInput>;
};


export type MutationPublishModuleArgs = {
  moduleId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPublishScormCourseArgs = {
  scormCourseId: Scalars['UUID']['input'];
};


export type MutationPublishSkillArgs = {
  skillId: Scalars['Int']['input'];
};


export type MutationPublishTrainingResourceArgs = {
  trainingResourceId: Scalars['UUID']['input'];
};


export type MutationPublishWorkflowArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationPurchaseCreditsArgs = {
  input: PurchaseCreditsInput;
};


export type MutationReactivateEmployeeArgs = {
  employeeId: Scalars['Int']['input'];
};


export type MutationReactivateEmployeesArgs = {
  employeeIds: Array<Scalars['Int']['input']>;
};


export type MutationRecoachRunWithTemplateArgs = {
  input: RecoachRunWithTemplateInput;
};


export type MutationRejectGuestFeedbackRecommendationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRejectRemediationStepArgs = {
  remediationStepId: Scalars['UUID']['input'];
};


export type MutationRemoveActiveClientArgs = {
  clientId: Scalars['String']['input'];
};


export type MutationRemoveAssignmentsArgs = {
  input?: InputMaybe<RemoveAssignmentsInput>;
};


export type MutationRemoveEmployeeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveEmployeesArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveExternalComplianceAttemptsArgs = {
  input: RemoveExternalComplianceAttemptsInput;
};


export type MutationRemoveLibraryAccessArgs = {
  input?: InputMaybe<RemoveLibraryAccessInput>;
};


export type MutationRemovePostReactionArgs = {
  input: PostReactionInput;
};


export type MutationRemoveReportDestinationChannelArgs = {
  channel: ReportDestinationChannel;
};


export type MutationRemoveTaskProofMediaArgs = {
  id: Scalars['UUID']['input'];
  mediaId: Scalars['Int']['input'];
};


export type MutationRemoveUserSharingPermissionArgs = {
  input: RemoveUserSharingPermissionInput;
};


export type MutationRemoveUsersFromLocationsArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIds: Array<Scalars['Int']['input']>;
};


export type MutationRemoveUsersFromRolesArgs = {
  roleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIds: Array<Scalars['Int']['input']>;
};


export type MutationRenameOpusAgentChatArgs = {
  id: Scalars['UUID']['input'];
  title: Scalars['String']['input'];
};


export type MutationReplaceOnCompletionAssignmentRuleSetsArgs = {
  input: ReplaceOnCompletionAssignmentRuleSetsInput;
};


export type MutationResendBlastNotificationArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<BlastNotificationScheduleInput>;
};


export type MutationResolveAiRequestArgs = {
  input: ResolveAiRequestInput;
};


export type MutationRestoreReportedContentArgs = {
  input: RestoreReportedContentInput;
};


export type MutationResyncHrisIntegrationArgs = {
  input: ResyncHrisIntegrationInput;
};


export type MutationRevertCourseToPriorVersionArgs = {
  courseId: Scalars['Int']['input'];
  courseVersionId: Scalars['Int']['input'];
};


export type MutationRevertScormCourseToPublishedVersionArgs = {
  scormCourseId: Scalars['UUID']['input'];
};


export type MutationRevertSkillToPriorVersionArgs = {
  skillId: Scalars['Int']['input'];
  skillVersionId: Scalars['UUID']['input'];
};


export type MutationReviewTaskArgs = {
  decision: TaskReviewDecision;
  id: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRunReportArgs = {
  input: ReportInput;
};


export type MutationSaveReportArgs = {
  input?: InputMaybe<SaveReportInput>;
};


export type MutationScrapeAiBrandContextFoundingStoryArgs = {
  brandDetailsId: Scalars['UUID']['input'];
};


export type MutationScrapeAiBrandContextMissionStatementArgs = {
  brandDetailsId: Scalars['UUID']['input'];
};


export type MutationScrapeAiBrandContextSellsArgs = {
  brandDetailsId: Scalars['UUID']['input'];
};


export type MutationSearchUnsplashImagesArgs = {
  orientation?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  searchText: Scalars['String']['input'];
};


export type MutationSendChatMessagesArgs = {
  input: SendChatMessageInput;
};


export type MutationSendCoursePreviewToPhoneArgs = {
  courseId: Scalars['Int']['input'];
};


export type MutationSendOpusAgentMessageArgs = {
  input: SendOpusAgentMessageInput;
};


export type MutationSendSeparateChatMessagesArgs = {
  input: SendSeparateChatMessagesInput;
};


export type MutationSetActiveClientArgs = {
  input: SetActiveClientInput;
};


export type MutationSetCoachingTemplateArchivedArgs = {
  input: SetCoachingTemplateArchivedInput;
};


export type MutationSetCommentThreadResolvedArgs = {
  resolved: Scalars['Boolean']['input'];
  threadId: Scalars['UUID']['input'];
};


export type MutationSetDealScopeReadyArgs = {
  input: SetDealScopeReadyInput;
};


export type MutationSetEmployeeGroupsArgs = {
  employeeId: Scalars['Int']['input'];
  groupIds: Array<Scalars['Int']['input']>;
  groupType?: InputMaybe<GroupType>;
};


export type MutationSetEmployeeLocationGroupsArgs = {
  employeeId: Scalars['Int']['input'];
  locationGroupIds: Array<Scalars['UUID']['input']>;
};


export type MutationSetEmployeeLocationsArgs = {
  employeeId: Scalars['Int']['input'];
  locationIds: Array<Scalars['Int']['input']>;
};


export type MutationSetEmployeeRolesArgs = {
  employeeId: Scalars['Int']['input'];
  roleIds: Array<Scalars['Int']['input']>;
};


export type MutationSetGoogleDriveReportDestinationArgs = {
  input: SetGoogleDriveReportDestinationInput;
};


export type MutationSetLocationManagerReportedUserCountArgs = {
  count: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
};


export type MutationSetPostCommentsEnabledArgs = {
  input: SetPostCommentsEnabledInput;
};


export type MutationSetS3ReportDestinationArgs = {
  input: SetS3ReportDestinationInput;
};


export type MutationSetSftpReportDestinationArgs = {
  input: SetSftpReportDestinationInput;
};


export type MutationSetTaskProofTextArgs = {
  id: Scalars['UUID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartAiUpdateLibraryItemArgs = {
  input: AiUpdateLibraryItemInput;
};


export type MutationStartGenAuditFromOutlineChatWorkflowArgs = {
  input: GenAuditFromOutlineChatInput;
};


export type MutationStartGenCheckInFromOutlineChatWorkflowArgs = {
  input: GenCheckInFromOutlineChatInput;
};


export type MutationStartGenCourseFromOutlineChatWorkflowArgs = {
  input: GenCourseFromOutlineChatInput;
};


export type MutationStartGenModuleFromOutlineChatWorkflowArgs = {
  input: GenModuleFromOutlineChatInput;
};


export type MutationStartGenTaskListFromOutlineChatWorkflowArgs = {
  input: GenTaskListFromOutlineChatInput;
};


export type MutationStartRemediationArgs = {
  remediationInstanceId: Scalars['UUID']['input'];
};


export type MutationStartScormCourseInstanceArgs = {
  scormCourseInstanceId: Scalars['UUID']['input'];
};


export type MutationStartTaskArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationStartTrainingResourceMediaToRichTextDocumentConversionArgs = {
  input: StartTrainingResourceMediaToRichTextDocumentConversionInput;
};


export type MutationStartUpdateLibraryItemFromRecommendationArgs = {
  input: UpdateLibraryItemFromRecommendationInput;
};


export type MutationSubmitAuditFormArgs = {
  input: SubmitAuditFormInput;
};


export type MutationSubmitCheckinFormArgs = {
  input: SubmitCheckinFormInput;
};


export type MutationSubmitRemediationArgs = {
  remediationInstanceId: Scalars['UUID']['input'];
};


export type MutationSubmitTaskForReviewArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationSubmitTaskFormArgs = {
  input: SubmitTaskFormInput;
};


export type MutationSubmitTaskFormV2Args = {
  input: SubmitTaskFormV2Input;
};


export type MutationSuggestAiBlocksArgs = {
  input: SuggestAiBlocksInput;
};


export type MutationSwitchCoachingRunTeamArgs = {
  input: SwitchCoachingRunTeamInput;
};


export type MutationSwitchToUserArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationTextToSpeechArgs = {
  input: TextToSpeechInput;
};


export type MutationTrackEventArgs = {
  app: Scalars['String']['input'];
  label: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['JSON']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationTranslateTextArgs = {
  dontUseGlossary?: InputMaybe<Scalars['Boolean']['input']>;
  targetLanguage: Scalars['Language']['input'];
  text: Array<Scalars['String']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationTriggerCoachingTestRunArgs = {
  input: TriggerCoachingTestRunInput;
};


export type MutationUnarchiveLibraryItemsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationUnpauseTrainingArgs = {
  employeeIds: Array<Scalars['Int']['input']>;
};


export type MutationUpdateAiOrgContextArgs = {
  updateAIOrgContextInput: UpdateAiOrgContextInput;
};


export type MutationUpdateAdminEmailPreferencesArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationUpdateAssignmentDueDatesArgs = {
  input: UpdateAssignmentDueDatesInput;
};


export type MutationUpdateAutomationArgs = {
  id: Scalars['Int']['input'];
  input: AutomationInput;
};


export type MutationUpdateBillingEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateBlastNotificationScheduleArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<BlastNotificationScheduleInput>;
};


export type MutationUpdateBlastSentRecordArgs = {
  input: BlastSentRecordInput;
};


export type MutationUpdateCertificateEndorserArgs = {
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationUpdateChatMemberPermissionsArgs = {
  input: UpdateChatMemberPermissionsInput;
};


export type MutationUpdateChatMemberStateArgs = {
  input: UpdateChatMemberStateInput;
};


export type MutationUpdateChatMembersArgs = {
  input: UpdateChatMembersInput;
};


export type MutationUpdateChatOwnersArgs = {
  input: UpdateChatOwnersInput;
};


export type MutationUpdateChatSettingsArgs = {
  input: UpdateChatSettingsInput;
};


export type MutationUpdateChatTitleArgs = {
  input: UpdateChatTitleInput;
};


export type MutationUpdateClockInConfirmationSettingsArgs = {
  isEnabled: Scalars['Boolean']['input'];
  setting: ClockInConfirmationAction;
};


export type MutationUpdateCoachingTemplateDraftArgs = {
  input: UpdateCoachingTemplateDraftInput;
};


export type MutationUpdateCoachingTemplateMetadataArgs = {
  input: UpdateCoachingTemplateMetadataInput;
};


export type MutationUpdateContentSharingPermissionArgs = {
  input: UpdateContentSharingPermissionInput;
};


export type MutationUpdateCourseArgs = {
  courseId: Scalars['Int']['input'];
  input: UpdateCourseInput;
};


export type MutationUpdateCustomerFacingAccountPlanArgs = {
  embedUrl?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['Int']['input'];
};


export type MutationUpdateDcOhrReminderPreferenceArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationUpdateDealScopeAnswerArgs = {
  input: UpdateDealScopeAnswerInput;
};


export type MutationUpdateEmployeeCountSettingsArgs = {
  input: UpdateEmployeeCountSettingsInput;
};


export type MutationUpdateEmployeeFeatureFlagsArgs = {
  input: UpdateEmployeeFeatureFlagsInput;
};


export type MutationUpdateExpectedUsersConfigsArgs = {
  inputs: Array<UpdateExpectedUsersConfigInput>;
};


export type MutationUpdateFolderArgs = {
  folderId: Scalars['UUID']['input'];
  input: FolderInput;
};


export type MutationUpdateFolderPositionArgs = {
  folderId: Scalars['UUID']['input'];
  position: Scalars['String']['input'];
};


export type MutationUpdateGlossarySetArgs = {
  input: GlossarySetInput;
};


export type MutationUpdateGuestFeedbackCorrectiveActionArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateGuestFeedbackCorrectiveActionInput;
};


export type MutationUpdateGuestFeedbackCorrectiveActionsArgs = {
  input: UpdateGuestFeedbackCorrectiveActionsInput;
};


export type MutationUpdateHrisCsvUploadArgs = {
  input: UpdateHrisCsvUploadInput;
};


export type MutationUpdateLocationArgs = {
  id: Scalars['Int']['input'];
  input: UpdateLocationInput;
};


export type MutationUpdateLocationGroupArgs = {
  id: Scalars['String']['input'];
  input: LocationGroupInput;
};


export type MutationUpdateMessageBlastArgs = {
  id: Scalars['Int']['input'];
  input: MessageBlastInput;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateModuleSettingsArgs = {
  input: ModuleSettingsInput;
  moduleId: Scalars['Int']['input'];
};


export type MutationUpdateMyOrgArgs = {
  orgId: Scalars['Int']['input'];
};


export type MutationUpdateOrCreateUserGlobalPushNotificationSettingsArgs = {
  input: UpdateOrCreateUserGlobalPushNotificationSettingsInput;
};


export type MutationUpdateOrCreateUserPushNotificationSettingArgs = {
  input: UpdateOrCreateUserPushNotificationSettingInput;
};


export type MutationUpdateOrCreateUserPushNotificationSettingChatOverrideArgs = {
  input: UpdateOrCreateUserPushNotificationSettingChatOverrideInput;
};


export type MutationUpdateOrCreateUserPushNotificationSettingPostActivityOverrideArgs = {
  input: UpdateOrCreateUserPushNotificationSettingPostActivityOverrideInput;
};


export type MutationUpdateOrbCustomerArgs = {
  input: UpdateOrbCustomerInput;
};


export type MutationUpdateOrgArgs = {
  input: OrgInput;
  orgId: Scalars['Int']['input'];
};


export type MutationUpdateOrgBrandColorArgs = {
  brandColor: Scalars['String']['input'];
};


export type MutationUpdateOrgFeatureFlagsArgs = {
  input: UpdateOrgFeatureFlagsInput;
};


export type MutationUpdateOrgGuestFeedbackIntegrationArgs = {
  input: UpdateOrgGuestFeedbackIntegrationInput;
};


export type MutationUpdateOrgGuestFeedbackIntegrationLocationArgs = {
  input: UpdateOrgGuestFeedbackIntegrationLocationInput;
};


export type MutationUpdateOrgHrisConfigArgs = {
  input: OrgHrisConfigInput;
};


export type MutationUpdateOrgLogoArgs = {
  logoUrl: Scalars['String']['input'];
};


export type MutationUpdateOrgPremiumContentConfigArgs = {
  input: UpdateOrgPremiumContentConfigInput;
};


export type MutationUpdateOrgSharpConfigArgs = {
  input: UpdateOrgSharpConfigInput;
};


export type MutationUpdateRemediationStepResponseArgs = {
  input: UpdateRemediationStepResponseInput;
};


export type MutationUpdateReportViewArgs = {
  id: Scalars['UUID']['input'];
  input: ReportViewInput;
};


export type MutationUpdateReportingTargetsArgs = {
  input: UpdateReportingTargetsInput;
};


export type MutationUpdateRoleArgs = {
  id: Scalars['Int']['input'];
  input: UpdateRoleInput;
};


export type MutationUpdateRoleGroupArgs = {
  id: Scalars['String']['input'];
  input: RoleGroupInput;
};


export type MutationUpdateRoleLevelsArgs = {
  input: UpdateRoleLevelsInput;
};


export type MutationUpdateScormCourseArgs = {
  input: UpdateScormCourseInput;
  scormCourseId: Scalars['UUID']['input'];
};


export type MutationUpdateScormCourseDraftVersionArgs = {
  packageName: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  scormCourseId: Scalars['UUID']['input'];
};


export type MutationUpdateSkillArgs = {
  input: UpdateSkillInput;
  skillId: Scalars['Int']['input'];
};


export type MutationUpdateStoreOpeningArgs = {
  input: UpdateStoreOpeningInput;
};


export type MutationUpdateSubtitlesArgs = {
  input: UpdateSubtitlesInput;
};


export type MutationUpdateTagArgs = {
  id: Scalars['String']['input'];
  input: TagInput;
};


export type MutationUpdateTagsArgs = {
  input: UpdateTagsInput;
};


export type MutationUpdateTaskArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateTaskInput;
};


export type MutationUpdateTaskCommentArgs = {
  body: Scalars['String']['input'];
  commentId: Scalars['UUID']['input'];
  mediaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationUpdateTaskListDailyDigestSubscriptionArgs = {
  input: TaskListDailyDigestSubscriptionInput;
};


export type MutationUpdateTrainingResourceArgs = {
  input: UpdateTrainingResourceInput;
  trainingResourceId: Scalars['String']['input'];
};


export type MutationUpdateTranslationSetArgs = {
  input: TranslationSetInput;
  uuid: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  id: Scalars['Int']['input'];
  input: UpdateUserInput;
};


export type MutationUpdateUserActionPermissionOverridesArgs = {
  input: UserActionPermissionsInput;
  userId: Scalars['Int']['input'];
};


export type MutationUpdateUserActionPermissionsArgs = {
  input: UserActionPermissionsInput;
};


export type MutationUpdateUserSharingPermissionArgs = {
  input: UpdateUserSharingPermissionInput;
};


export type MutationUpdateWeeklyReachEngagementEmailPreferenceArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationUploadFileArgs = {
  mediaFile: Scalars['Upload']['input'];
};


export type MutationUploadFileListArgs = {
  mediaFiles: Array<Scalars['Upload']['input']>;
};


export type MutationValidateAndExtractScormPackageArgs = {
  key: Scalars['String']['input'];
};


export type MutationVerifySkillV2Args = {
  assignmentId: Scalars['UUID']['input'];
  input: VerifySkillInput;
};

export type MutationResult = {
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type MyAiChatsInput = {
  type: AiChatType;
};

export type MyCheckinsFiltersInput = {
  locationIds?: InputMaybe<IntArrayInput>;
  skillIds?: InputMaybe<IntArrayInput>;
};

export type MyCheckinsInput = {
  filters?: InputMaybe<MyCheckinsFiltersInput>;
  search?: InputMaybe<StringValue>;
};

export type MyRemediationInstances = PaginatedList & {
  __typename?: 'MyRemediationInstances';
  objects: Array<RemediationInstance>;
  totalCount: Scalars['Int']['output'];
};

export type MyRemediationInstancesInput = {
  sort?: InputMaybe<SortInput>;
};

export type MyTodoAssignmentsInput = {
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export enum NoneOptionalOrRequired {
  None = 'NONE',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  notificationsEnabled: Scalars['Boolean']['output'];
};

export enum NotificationType {
  CommentMention = 'COMMENT_MENTION',
  CommentReply = 'COMMENT_REPLY',
  GuestFeedbackRecommendationsAvailable = 'GUEST_FEEDBACK_RECOMMENDATIONS_AVAILABLE',
  LowCreditBalance = 'LOW_CREDIT_BALANCE',
  NewComment = 'NEW_COMMENT',
  NewCommentPermission = 'NEW_COMMENT_PERMISSION',
  NewEditPermission = 'NEW_EDIT_PERMISSION',
  NewSharingPermission = 'NEW_SHARING_PERMISSION',
  NewViewPermission = 'NEW_VIEW_PERMISSION',
  SharpReassignment = 'SHARP_REASSIGNMENT',
  TaskComment = 'TASK_COMMENT',
  TaskCommentMention = 'TASK_COMMENT_MENTION'
}

export enum NumberTriggerCondition {
  EqualTo = 'EQUAL_TO',
  GreaterThan = 'GREATER_THAN',
  LowerThan = 'LOWER_THAN',
  NotEqual = 'NOT_EQUAL',
  OutsideRange = 'OUTSIDE_RANGE'
}

export type OnCompletionAssignmentRule = {
  __typename?: 'OnCompletionAssignmentRule';
  id: Scalars['UUID']['output'];
  libraryItem: LibraryItem;
  nextLibraryItem: LibraryItem;
  /** @deprecated Field no longer supported */
  roleMemberships: Array<OnCompletionAssignmentRuleRoleMembership>;
  unlockDays?: Maybe<Scalars['Int']['output']>;
  userSelectionSet?: Maybe<UserSelectionSet>;
};

export type OnCompletionAssignmentRuleInput = {
  libraryItemId: Scalars['UUID']['input'];
  nextLibraryItemId: Scalars['UUID']['input'];
  roleIds?: InputMaybe<IntArrayInput>;
  unlockDays?: InputMaybe<Scalars['Int']['input']>;
  userSelectionSet?: InputMaybe<UserSelectionSetInput>;
};

export type OnCompletionAssignmentRuleMutationResult = MutationResult & {
  __typename?: 'OnCompletionAssignmentRuleMutationResult';
  error?: Maybe<Error>;
  onCompletionAssignmentRule?: Maybe<OnCompletionAssignmentRule>;
  success: Scalars['Boolean']['output'];
};

export type OnCompletionAssignmentRuleRoleMembership = {
  __typename?: 'OnCompletionAssignmentRuleRoleMembership';
  id: Scalars['UUID']['output'];
  role: Role;
};

export type OnCompletionAssignmentRuleSet = {
  __typename?: 'OnCompletionAssignmentRuleSet';
  endingModules: Array<LibraryItem>;
  moduleCount: Scalars['Int']['output'];
  rulesTree: Array<OnCompletionAssignmentRule>;
  startingModules: Array<LibraryItem>;
};

export type OnCompletionAssignmentRuleSetsInput = {
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type OnCompletionAssignmentRuleTree = {
  __typename?: 'OnCompletionAssignmentRuleTree';
  rules: Array<OnCompletionAssignmentRule>;
};

export type OnCompletionAssignmentRuleTreeInput = {
  memberLibraryItemId: Scalars['UUID']['input'];
};

export type OneOffCheckInDelegation = {
  __typename?: 'OneOffCheckInDelegation';
  createdBy: Employee;
  delegatedTo: Employee;
  id: Scalars['UUID']['output'];
  skillInstance: SkillInstance;
};

export type OngoingCheckInDelegation = {
  __typename?: 'OngoingCheckInDelegation';
  createdBy: Employee;
  delegatedTo: Employee;
  id: Scalars['UUID']['output'];
  skill: Skill;
};

export enum OpenAiVectorStoreFileStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Unknown = 'UNKNOWN'
}

export enum OpenAiVectorStoreType {
  IntercomData = 'INTERCOM_DATA',
  OrgData = 'ORG_DATA'
}

export type OpenAi_VectorStoreSearchResponse = {
  __typename?: 'OpenAi_VectorStoreSearchResponse';
  attributes?: Maybe<Scalars['JSON']['output']>;
  content: Array<OpenAi_VectorStoreSearchResponseContent>;
  fileId: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type OpenAi_VectorStoreSearchResponseContent = {
  __typename?: 'OpenAi_VectorStoreSearchResponseContent';
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum Operator {
  Contains = 'CONTAINS',
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  In = 'IN',
  Lt = 'LT',
  Lte = 'LTE',
  Neq = 'NEQ',
  Nin = 'NIN'
}

export type OptionalAutoReassignIntervalSourceDateTypeValue = {
  value?: InputMaybe<AutoReassignIntervalSourceDateType>;
};

export type OptionalAutoReassignIntervalUnitValue = {
  value?: InputMaybe<AutoReassignIntervalUnit>;
};

export type OptionalBooleanValue = {
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OptionalDateTimeValue = {
  value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OptionalDateValue = {
  value?: InputMaybe<Scalars['Date']['input']>;
};

export type OptionalIntInput = {
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type OptionalIntValue = {
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type OptionalStringInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OptionalStringValue = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OptionalTaskProofOfCompletionRequirementValue = {
  value?: InputMaybe<TaskProofOfCompletionRequirement>;
};

export type OptionalUuidValue = {
  value?: InputMaybe<Scalars['UUID']['input']>;
};

export type OpusAgentAssistantText = {
  __typename?: 'OpusAgentAssistantText';
  text: Scalars['String']['output'];
};

export type OpusAgentChat = {
  __typename?: 'OpusAgentChat';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastActivity?: Maybe<Scalars['DateTime']['output']>;
  model?: Maybe<OpusAgentModel>;
  title?: Maybe<Scalars['String']['output']>;
  titleSource?: Maybe<OpusAgentChatTitleSource>;
  turns: Array<OpusAgentChatTurn>;
};

export enum OpusAgentChatTitleSource {
  Ai = 'AI',
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type OpusAgentChatTurn = {
  __typename?: 'OpusAgentChatTurn';
  chatId: Scalars['UUID']['output'];
  citations: Array<OpusAgentCitation>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  events: Array<OpusAgentChatTurnEvent>;
  id: Scalars['UUID']['output'];
  model?: Maybe<OpusAgentModel>;
  status: OpusAgentChatTurnStatus;
  supersededByEditAt?: Maybe<Scalars['DateTime']['output']>;
  userMessage: Scalars['String']['output'];
};

export type OpusAgentChatTurnEvent = {
  __typename?: 'OpusAgentChatTurnEvent';
  createdAt: Scalars['DateTime']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  index: Scalars['Int']['output'];
  payload: OpusAgentEventPayload;
};

export enum OpusAgentChatTurnStatus {
  Aborted = 'ABORTED',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

export type OpusAgentChats = PaginatedList & {
  __typename?: 'OpusAgentChats';
  objects: Array<OpusAgentChat>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OpusAgentChatsInput = {
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type OpusAgentCitation = {
  __typename?: 'OpusAgentCitation';
  libraryItemId?: Maybe<Scalars['UUID']['output']>;
  quote?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type OpusAgentContextCompacted = {
  __typename?: 'OpusAgentContextCompacted';
  summaryChars: Scalars['Int']['output'];
};

export type OpusAgentError = {
  __typename?: 'OpusAgentError';
  message: Scalars['String']['output'];
};

export type OpusAgentEventPayload = {
  __typename?: 'OpusAgentEventPayload';
  assistantText?: Maybe<OpusAgentAssistantText>;
  contextCompacted?: Maybe<OpusAgentContextCompacted>;
  error?: Maybe<OpusAgentError>;
  fallbackText?: Maybe<Scalars['String']['output']>;
  planUpdate?: Maybe<OpusAgentPlanUpdate>;
  thinking?: Maybe<OpusAgentThinking>;
  toolCall?: Maybe<OpusAgentToolCall>;
};

export enum OpusAgentModel {
  ClaudeFable_5_1 = 'CLAUDE_FABLE_5_1',
  ClaudeHaiku_4_5 = 'CLAUDE_HAIKU_4_5',
  ClaudeOpus_5 = 'CLAUDE_OPUS_5',
  ClaudeSonnet_5 = 'CLAUDE_SONNET_5',
  Gpt_5_6Luna = 'GPT_5_6_LUNA',
  Gpt_5_6Sol = 'GPT_5_6_SOL',
  Gpt_5_6Terra = 'GPT_5_6_TERRA',
  Gpt_6Astra = 'GPT_6_ASTRA'
}

export type OpusAgentPlanItem = {
  __typename?: 'OpusAgentPlanItem';
  status: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type OpusAgentPlanUpdate = {
  __typename?: 'OpusAgentPlanUpdate';
  activeStep?: Maybe<Scalars['String']['output']>;
  done: Scalars['Int']['output'];
  items: Array<OpusAgentPlanItem>;
  total: Scalars['Int']['output'];
};

export type OpusAgentThinking = {
  __typename?: 'OpusAgentThinking';
  text: Scalars['String']['output'];
};

export type OpusAgentToolCall = {
  __typename?: 'OpusAgentToolCall';
  callId?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  status: Scalars['String']['output'];
  toolName: Scalars['String']['output'];
};

export type OpusAgentTurnEvents = PaginatedList & {
  __typename?: 'OpusAgentTurnEvents';
  objects: Array<OpusAgentChatTurnEvent>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OpusAgentTurnEventsFiltersInput = {
  afterIndex?: InputMaybe<Scalars['Int']['input']>;
  turnId: Scalars['UUID']['input'];
};

export type OpusAgentTurnEventsInput = {
  filters: OpusAgentTurnEventsFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type OpusAgentTurns = PaginatedList & {
  __typename?: 'OpusAgentTurns';
  objects: Array<OpusAgentChatTurn>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OpusAgentTurnsFiltersInput = {
  chatId: Scalars['UUID']['input'];
};

export type OpusAgentTurnsInput = {
  filters: OpusAgentTurnsFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type Org = {
  __typename?: 'Org';
  /** @deprecated Field no longer supported */
  brandColor?: Maybe<Scalars['String']['output']>;
  brandDetails?: Maybe<BrandDetails>;
  certificateEndorser?: Maybe<CertificateEndorser>;
  clockInConfirmationSettings: ClockInConfirmationSettings;
  collectEmployeeCountFromManagers: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  customReportDestination?: Maybe<OrgCustomReportDestination>;
  customerFacingAccountPlan?: Maybe<CustomerFacingAccountPlan>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  defaultLocationTotalEmployees?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Field no longer supported */
  eslTheme?: Maybe<EslTheme>;
  glossarySet?: Maybe<GlossarySet>;
  hasAllLanguages: Scalars['Boolean']['output'];
  hasAppliedHrisCsvUpload: Scalars['Boolean']['output'];
  hasLegacySignupCodes: Scalars['Boolean']['output'];
  hasMergeIntegration: Scalars['Boolean']['output'];
  hrisConfig: HrisConfig;
  hrisIntegrations: Array<HrisIntegration>;
  hrisProvider?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isComplianceOnly?: Maybe<Scalars['Boolean']['output']>;
  isDemoOrg: Scalars['Boolean']['output'];
  languagesInUse: Array<Scalars['Language']['output']>;
  locationGroupTypeConfigs: Array<OrgLocationGroupTypeConfig>;
  /** @deprecated Field no longer supported */
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  paysManually: Scalars['Boolean']['output'];
  seatsExpected?: Maybe<Scalars['Int']['output']>;
  sharpConfig?: Maybe<OrgSharpConfig>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Field no longer supported */
  supportedLanguages: Array<Scalars['Language']['output']>;
  taskListDailyDigestSubscription?: Maybe<TaskListDailyDigestSubscription>;
  timezone: Timezone;
  verifyOverWhatsapp?: Maybe<Scalars['Boolean']['output']>;
};

export type OrgCustomReportDestination = {
  __typename?: 'OrgCustomReportDestination';
  googleDrive?: Maybe<OrgCustomReportDestinationGoogleDrive>;
  id: Scalars['UUID']['output'];
  s3Bucket?: Maybe<OrgCustomReportDestinationS3>;
  sftp?: Maybe<OrgCustomReportDestinationSftp>;
};

export type OrgCustomReportDestinationGoogleDrive = {
  __typename?: 'OrgCustomReportDestinationGoogleDrive';
  folderId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type OrgCustomReportDestinationMutationResult = MutationResult & {
  __typename?: 'OrgCustomReportDestinationMutationResult';
  customReportDestination?: Maybe<OrgCustomReportDestination>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type OrgCustomReportDestinationS3 = {
  __typename?: 'OrgCustomReportDestinationS3';
  bucketName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type OrgCustomReportDestinationSftp = {
  __typename?: 'OrgCustomReportDestinationSftp';
  folder: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  url: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type OrgGuestFeedbackCsvUpload = {
  __typename?: 'OrgGuestFeedbackCsvUpload';
  feedbackDateColumn: Scalars['String']['output'];
  feedbackSource?: Maybe<Scalars['String']['output']>;
  feedbackTextColumn: Scalars['String']['output'];
  feedbacks: Array<GuestFeedback>;
  fileUrl: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  locationColumn: Scalars['String']['output'];
  locations: Array<OrgGuestFeedbackCsvUploadLocation>;
  ratingColumn: Scalars['String']['output'];
};

export type OrgGuestFeedbackCsvUploadLocation = {
  __typename?: 'OrgGuestFeedbackCsvUploadLocation';
  feedbacks: Array<GuestFeedback>;
  id: Scalars['UUID']['output'];
  location: Location;
  locationName: Scalars['String']['output'];
};

export type OrgGuestFeedbackCsvUploadMutationResult = MutationResult & {
  __typename?: 'OrgGuestFeedbackCsvUploadMutationResult';
  error?: Maybe<Error>;
  orgGuestFeedbackCsvUpload?: Maybe<OrgGuestFeedbackCsvUpload>;
  success: Scalars['Boolean']['output'];
};

export type OrgGuestFeedbackCsvUploads = PaginatedList & {
  __typename?: 'OrgGuestFeedbackCsvUploads';
  objects: Array<OrgGuestFeedbackCsvUpload>;
  totalCount: Scalars['Int']['output'];
};

export type OrgGuestFeedbackGoogleBusinessConfig = {
  __typename?: 'OrgGuestFeedbackGoogleBusinessConfig';
  accountId: Scalars['String']['output'];
  accountName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type OrgGuestFeedbackGoogleBusinessMutationResult = MutationResult & {
  __typename?: 'OrgGuestFeedbackGoogleBusinessMutationResult';
  error?: Maybe<Error>;
  orgGuestFeedbackIntegration?: Maybe<OrgGuestFeedbackIntegration>;
  success: Scalars['Boolean']['output'];
};

export type OrgGuestFeedbackIntegration = {
  __typename?: 'OrgGuestFeedbackIntegration';
  enabled: Scalars['Boolean']['output'];
  googleBusinessConfig?: Maybe<OrgGuestFeedbackGoogleBusinessConfig>;
  id: Scalars['UUID']['output'];
  locationGroup?: Maybe<LocationGroup>;
  locations: Array<OrgGuestFeedbackIntegrationLocation>;
  ovationIntegrationConfig?: Maybe<OrgGuestFeedbackOvationIntegrationConfig>;
  tattleIntegrationConfig?: Maybe<OrgGuestFeedbackTattleIntegrationConfig>;
};

export type OrgGuestFeedbackIntegrationLocation = {
  __typename?: 'OrgGuestFeedbackIntegrationLocation';
  feedbacks: Array<GuestFeedback>;
  id: Scalars['UUID']['output'];
  location?: Maybe<Location>;
  sourceAddress?: Maybe<Address>;
  sourceLocationId: Scalars['String']['output'];
  sourceName?: Maybe<Scalars['String']['output']>;
};

export type OrgGuestFeedbackIntegrationLocationMutationResult = MutationResult & {
  __typename?: 'OrgGuestFeedbackIntegrationLocationMutationResult';
  error?: Maybe<Error>;
  orgGuestFeedbackIntegrationLocation?: Maybe<OrgGuestFeedbackIntegrationLocation>;
  success: Scalars['Boolean']['output'];
};

export type OrgGuestFeedbackIntegrationMutationResult = MutationResult & {
  __typename?: 'OrgGuestFeedbackIntegrationMutationResult';
  error?: Maybe<Error>;
  orgGuestFeedbackIntegration?: Maybe<OrgGuestFeedbackIntegration>;
  success: Scalars['Boolean']['output'];
};

export type OrgGuestFeedbackOvationIntegrationConfig = {
  __typename?: 'OrgGuestFeedbackOvationIntegrationConfig';
  companyId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type OrgGuestFeedbackSync = {
  __typename?: 'OrgGuestFeedbackSync';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  feedbacks: Array<GuestFeedback>;
  id: Scalars['UUID']['output'];
  orgGuestFeedbackIntegration: OrgGuestFeedbackIntegration;
  startedAt: Scalars['DateTime']['output'];
};

export type OrgGuestFeedbackSyncs = PaginatedList & {
  __typename?: 'OrgGuestFeedbackSyncs';
  objects: Array<OrgGuestFeedbackSync>;
  totalCount: Scalars['Int']['output'];
};

export type OrgGuestFeedbackTattleIntegrationConfig = {
  __typename?: 'OrgGuestFeedbackTattleIntegrationConfig';
  id: Scalars['UUID']['output'];
  merchantId: Scalars['String']['output'];
};

export type OrgHierarchyInput = {
  allBrands?: InputMaybe<BooleanValue>;
  allFranchises?: InputMaybe<BooleanValue>;
  allRegions?: InputMaybe<BooleanValue>;
  brandIds?: InputMaybe<UuidArrayInput>;
  franchiseIds?: InputMaybe<UuidArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
  regionIds?: InputMaybe<UuidArrayInput>;
};

export type OrgHrisConfigInput = {
  activatedAt?: InputMaybe<DateTimeInput>;
  dataVerifiedAt?: InputMaybe<DateTimeInput>;
  finishedConnectingAt?: InputMaybe<DateTimeInput>;
  finishedLoadingAt?: InputMaybe<DateTimeInput>;
};

export type OrgInput = {
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isTrial?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  seatsExpected: Scalars['Int']['input'];
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  timezone: Scalars['String']['input'];
};

export type OrgLocationGroupTypeConfig = {
  __typename?: 'OrgLocationGroupTypeConfig';
  id: Scalars['UUID']['output'];
  type: LocationGroupType;
};

export type OrgMutationResult = MutationResult & {
  __typename?: 'OrgMutationResult';
  error?: Maybe<Error>;
  org?: Maybe<Org>;
  success: Scalars['Boolean']['output'];
};

export type OrgNode = {
  __typename?: 'OrgNode';
  brand?: Maybe<LocationGroup>;
  children: Array<OrgNode>;
  franchise?: Maybe<LocationGroup>;
  id: Scalars['String']['output'];
  location?: Maybe<Location>;
  region?: Maybe<LocationGroup>;
};

export type OrgPremiumContentConfig = {
  __typename?: 'OrgPremiumContentConfig';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated use premiumContentConfig */
  catalogConfig: PremiumContentConfig;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Employee>;
  creditCost: Scalars['Int']['output'];
  dueDateDays: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEditedBy?: Maybe<Employee>;
  libraryItem: LibraryItem;
  org: Org;
  premiumContentConfig: PremiumContentConfig;
  setupStep: PremiumContentSetupStep;
};

export type OrgPremiumContentConfigInput = {
  catalogModuleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  complianceTypes?: InputMaybe<Array<ComplianceType>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type OrgPremiumContentConfigs = PaginatedList & {
  __typename?: 'OrgPremiumContentConfigs';
  objects: Array<OrgPremiumContentConfig>;
  totalCount: Scalars['Int']['output'];
};

export type OrgSftpIntegration = {
  __typename?: 'OrgSftpIntegration';
  bucketName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  employeeIdField: Scalars['String']['output'];
  filePath?: Maybe<Scalars['String']['output']>;
  firstNameFallbackField?: Maybe<Scalars['String']['output']>;
  firstNameField: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isRemotePull: Scalars['Boolean']['output'];
  lastNameFallbackField?: Maybe<Scalars['String']['output']>;
  lastNameField: Scalars['String']['output'];
  locationField?: Maybe<Scalars['String']['output']>;
  locationGroup?: Maybe<LocationGroup>;
  org: Org;
  phoneFallbackField?: Maybe<Scalars['String']['output']>;
  phoneField?: Maybe<Scalars['String']['output']>;
  remoteFolder?: Maybe<Scalars['String']['output']>;
  remoteHost?: Maybe<Scalars['String']['output']>;
  remotePort?: Maybe<Scalars['Int']['output']>;
  remoteSftpCsvFiles: Array<RemoteSftpCsvFileMetadata>;
  remoteUsername?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  startDateField: Scalars['String']['output'];
  syncTimes: Array<Scalars['String']['output']>;
  teamField?: Maybe<Scalars['String']['output']>;
  terminationDateField?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrgSftpIntegrations = PaginatedList & {
  __typename?: 'OrgSftpIntegrations';
  objects: Array<OrgSftpIntegration>;
  totalCount: Scalars['Int']['output'];
};

export type OrgSftpIntegrationsFiltersInput = {
  locationGroupId?: InputMaybe<UuidValue>;
  orgId?: InputMaybe<UuidValue>;
};

export type OrgSftpIntegrationsInput = {
  filters?: InputMaybe<OrgSftpIntegrationsFiltersInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type OrgSharpConfig = {
  __typename?: 'OrgSharpConfig';
  assignedCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Employee>;
  dueDateDays: Scalars['Int']['output'];
  hotlinePhoneNumber?: Maybe<Scalars['String']['output']>;
  hrEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lastEditedAt: Scalars['DateTime']['output'];
  lastEditedBy?: Maybe<Employee>;
  org: Org;
  realWorldComplaintFormLocation?: Maybe<TranslationSet>;
  sharpPolicy?: Maybe<Media>;
};

export type OrgSharpConfigMutationResult = MutationResult & {
  __typename?: 'OrgSharpConfigMutationResult';
  error?: Maybe<Error>;
  orgSharpConfig?: Maybe<OrgSharpConfig>;
  success: Scalars['Boolean']['output'];
};

export type Orgs = PaginatedList & {
  __typename?: 'Orgs';
  objects: Array<Org>;
  totalCount: Scalars['Int']['output'];
};

export enum OutlineGenerationType {
  Direct = 'DIRECT',
  Rewrite = 'REWRITE'
}

export type PaginatedList = {
  objects?: Maybe<Array<Maybe<PaginatedListObjects>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedListObjects = AbxIntentEvent | AiChat | AskOpusQuestionAnswer | Assignment | Automation | BackfilledAssignment | BackfilledCertificate | BlastSentRecord | CrmabxAssignment | CrmAccountStatusUpdate | CrmCompany | CrmContact | CrmDeal | CrmEmail | CrmMeeting | CrmNote | CrmUser | CsTicket | Chat | ChatMessage | ChatSearchResult | CoachingRun | CompletedTaskCount | CompletionScheduleInstance | CompletionScheduleWindow | ComplianceRecord | Contract | CourseFeedback | CustomerProblem | DealScopeListRow | Employee | EmployeeActionPermission | GuestFeedback | HrisCsvUpload | HrisEmployee | HrisEmployeeEvent | HrisLocation | HrisTeam | InProductNotification | IntercomConversation | KnowledgeCheckInstance | KnowledgeCheckLocationLeaderboard | LibraryItem | Location | LocationGroup | LocationLeaderboardItem | ManagerLeaderboardItem | MergeBackfillRun | MessageBlast | MessagingActivityItem | OnCompletionAssignmentRuleSet | OpusAgentChat | OpusAgentChatTurn | OpusAgentChatTurnEvent | Org | OrgGuestFeedbackCsvUpload | OrgGuestFeedbackSync | OrgPremiumContentConfig | OrgSftpIntegration | PostComment | PostReaction | PremiumContentConfig | PromptInstance | RemediationInstance | Role | RoleGroup | ScheduledUserInvite | Skill | SkillInstance | SubmittedRequest | SuggestedQuestion | Task | TaskScheduleCompletionPercent | TraineeLeaderboardItem | UserAuditItem | VerificationStepInstance | Workflow | WorkflowInstance;

export type PaginatedOnCompletionAssignmentRuleSets = PaginatedList & {
  __typename?: 'PaginatedOnCompletionAssignmentRuleSets';
  objects: Array<OnCompletionAssignmentRuleSet>;
  totalCount: Scalars['Int']['output'];
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PauseTrainingResult = MutationResult & {
  __typename?: 'PauseTrainingResult';
  /** @deprecated Field no longer supported */
  employee?: Maybe<Employee>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<Employee>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  card?: Maybe<CreditCard>;
  id: Scalars['UUID']['output'];
  nextAction?: Maybe<Scalars['String']['output']>;
  usBankAccount?: Maybe<UsBankAccount>;
};

export enum Permission {
  AssignContent = 'assignContent',
  ChangeOrgSettings = 'changeOrgSettings',
  CreateChat = 'createChat',
  CreateContent = 'createContent',
  DeactivateTrainees = 'deactivateTrainees',
  EditTrainees = 'editTrainees',
  InviteOthers = 'inviteOthers',
  ManageBilling = 'manageBilling',
  ManageGuestFeedbackRecommendations = 'manageGuestFeedbackRecommendations',
  ManageLibrary = 'manageLibrary',
  ManageOrgIntegrations = 'manageOrgIntegrations',
  ManagePremiumContent = 'managePremiumContent',
  MarkAsComplete = 'markAsComplete',
  PromoteTrainees = 'promoteTrainees',
  SendMessages = 'sendMessages',
  SendPosts = 'sendPosts',
  UnassignContent = 'unassignContent',
  UpdateAutomations = 'updateAutomations',
  VerifySkills = 'verifySkills',
  ViewAllSubmittedTaskLists = 'viewAllSubmittedTaskLists',
  ViewReporting = 'viewReporting'
}

export enum PermissionReason {
  RoleBasedPermission = 'ROLE_BASED_PERMISSION',
  StaffPermissionOverride = 'STAFF_PERMISSION_OVERRIDE',
  UserHasOverride = 'USER_HAS_OVERRIDE',
  UserTypeDefault = 'USER_TYPE_DEFAULT'
}

export type PersistCoachingAnalysisInput = {
  coachingRunId: Scalars['UUID']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  failed?: InputMaybe<Scalars['Boolean']['input']>;
  overallSummary?: InputMaybe<Scalars['String']['input']>;
  results?: InputMaybe<Array<CoachingCriterionResultInput>>;
  selectionReason?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PersistCoachingAnalysisResult = MutationResult & {
  __typename?: 'PersistCoachingAnalysisResult';
  error?: Maybe<Error>;
  resultsWritten?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PersistDealScopeAnalysisInput = {
  answers: Array<DealScopeAnswerInput>;
  dealRecordId: Scalars['String']['input'];
  meetingId?: InputMaybe<Scalars['String']['input']>;
};

export type PersistDealScopeAnalysisResult = MutationResult & {
  __typename?: 'PersistDealScopeAnalysisResult';
  answersWritten?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type PersistGuestFeedbackAnalysisRunInput = {
  /**
   * The run row created when the agent was dispatched (passed to the agent as
   * analysis_run_id). Persisting completes that row instead of creating a new
   * one. When omitted, the org's newest still-open run is completed, or a new
   * run is created if there is none.
   */
  analysisRunId?: InputMaybe<Scalars['UUID']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['Int']['input'];
  recommendations: Array<PersistGuestFeedbackRecommendationInput>;
  /**
   * Client-minted idempotency key, one per persist attempt. A repeat submit
   * with the same key writes nothing and returns the original run. Optional
   * until all agent callers mint one.
   */
  submissionKey?: InputMaybe<Scalars['UUID']['input']>;
  themeMemberships: Array<PersistGuestFeedbackThemeMembershipInput>;
  themes: Array<PersistGuestFeedbackThemeInput>;
};

export type PersistGuestFeedbackAnalysisRunMutationResult = MutationResult & {
  __typename?: 'PersistGuestFeedbackAnalysisRunMutationResult';
  analysisRunId?: Maybe<Scalars['UUID']['output']>;
  correctiveActionsCreated: Scalars['Int']['output'];
  correctiveActionsSkippedDuplicate: Scalars['Int']['output'];
  error?: Maybe<Error>;
  membershipsCreated: Scalars['Int']['output'];
  membershipsSkippedMissingFeedback: Scalars['Int']['output'];
  sampleReviewsCreated: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  themesCreated: Scalars['Int']['output'];
  themesReused: Scalars['Int']['output'];
};

export type PersistGuestFeedbackRecommendationInput = {
  actionType?: InputMaybe<GuestFeedbackRecommendationActionType>;
  affectedLocationNames: Array<Scalars['String']['input']>;
  audience: GuestFeedbackCorrectiveActionAudience;
  contentType?: InputMaybe<LibraryItemContentType>;
  correctiveActionGroupId: Scalars['UUID']['input'];
  issueDescription: Scalars['String']['input'];
  libraryItemId?: InputMaybe<Scalars['UUID']['input']>;
  locationGroupId?: InputMaybe<Scalars['UUID']['input']>;
  locationIds: Array<Scalars['Int']['input']>;
  primaryThemeName: Scalars['String']['input'];
  priority: ActionItemPriority;
  remediation: Scalars['String']['input'];
  sampleReviews: Array<Scalars['String']['input']>;
  targetRoleIds: Array<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type PersistGuestFeedbackThemeInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PersistGuestFeedbackThemeMembershipInput = {
  feedbackId: Scalars['UUID']['input'];
  relevanceScore: Scalars['Float']['input'];
  themeName: Scalars['String']['input'];
};

export type Person = {
  __typename?: 'Person';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum PexelsOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square'
}

export type PexelsPhoto = {
  __typename?: 'PexelsPhoto';
  alt: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  photographer: Scalars['String']['output'];
  photographerUrl: Scalars['String']['output'];
  src: PexelsSrc;
  width: Scalars['Int']['output'];
};

export type PexelsSrc = {
  __typename?: 'PexelsSrc';
  landscape: Scalars['String']['output'];
  large: Scalars['String']['output'];
  large2x: Scalars['String']['output'];
  medium: Scalars['String']['output'];
  original: Scalars['String']['output'];
  portrait: Scalars['String']['output'];
  small: Scalars['String']['output'];
  tiny: Scalars['String']['output'];
};

export type PexelsVideo = {
  __typename?: 'PexelsVideo';
  height: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  videoFiles: Array<PexelsVideoFile>;
  videoPictures: Array<PexelsVideoPicture>;
  videographer: Scalars['String']['output'];
  videographerUrl: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type PexelsVideoFile = {
  __typename?: 'PexelsVideoFile';
  fileType: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  link: Scalars['String']['output'];
  quality?: Maybe<PexelsVideoQuality>;
  width: Scalars['Int']['output'];
};

export type PexelsVideoPicture = {
  __typename?: 'PexelsVideoPicture';
  id: Scalars['Int']['output'];
  picture: Scalars['String']['output'];
};

export enum PexelsVideoQuality {
  Fhd = 'fhd',
  Hd = 'hd',
  Sd = 'sd',
  Uhd = 'uhd'
}

export type PghistoryContext = {
  __typename?: 'PghistoryContext';
  actorId?: Maybe<Scalars['String']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  correlationId?: Maybe<Scalars['String']['output']>;
  isHris?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export enum PghistoryModelName {
  EmployeeGroupMembership = 'EMPLOYEE_GROUP_MEMBERSHIP',
  Person = 'PERSON',
  User = 'USER'
}

export type Plan = {
  __typename?: 'Plan';
  id: Scalars['UUID']['output'];
  licenseType: LicenseType;
  planType: PlanType;
};

export enum PlanType {
  Custom = 'CUSTOM',
  Growth = 'GROWTH',
  Starter = 'STARTER'
}

export type PollAgentSessionCommandLogsResult = {
  __typename?: 'PollAgentSessionCommandLogsResult';
  asyncLogs?: Maybe<Scalars['String']['output']>;
  asyncLogsLineCount?: Maybe<Scalars['Int']['output']>;
  asyncStatus?: Maybe<CommandStatus>;
  commandId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type PollAgentSessionCommandsResult = {
  __typename?: 'PollAgentSessionCommandsResult';
  sessions: Array<AgentSessionGql>;
  success: Scalars['Boolean']['output'];
};

export type PostComment = {
  __typename?: 'PostComment';
  author: Employee;
  authorSearchHeadline?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  hasUnresolvedReport: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  mentions: Array<PostCommentMention>;
  messageBlast: MessageBlast;
  reportedText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  textSearchHeadline?: Maybe<Scalars['String']['output']>;
};

export type PostCommentMention = {
  __typename?: 'PostCommentMention';
  id: Scalars['UUID']['output'];
  mentionedUser: Employee;
};

export type PostCommentMutationResult = MutationResult & {
  __typename?: 'PostCommentMutationResult';
  error?: Maybe<Error>;
  postComment?: Maybe<PostComment>;
  success: Scalars['Boolean']['output'];
};

export type PostComments = PaginatedList & {
  __typename?: 'PostComments';
  objects: Array<PostComment>;
  totalCount: Scalars['Int']['output'];
};

export type PostCommentsInput = {
  messageBlastId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type PostMention = {
  __typename?: 'PostMention';
  id: Scalars['UUID']['output'];
  mentionedUser: Employee;
};

export type PostReaction = {
  __typename?: 'PostReaction';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  user: Employee;
};

export type PostReactionInput = {
  messageBlastId: Scalars['Int']['input'];
};

export type PostReactionMutationResult = MutationResult & {
  __typename?: 'PostReactionMutationResult';
  error?: Maybe<Error>;
  messageBlast?: Maybe<MessageBlast>;
  success: Scalars['Boolean']['output'];
};

export type PostReactions = PaginatedList & {
  __typename?: 'PostReactions';
  objects: Array<PostReaction>;
  totalCount: Scalars['Int']['output'];
};

export type PremiumContentConfig = {
  __typename?: 'PremiumContentConfig';
  assignedUserType?: Maybe<AssignedUserType>;
  catalogModule?: Maybe<CatalogModule>;
  complianceDurationYears: Scalars['Int']['output'];
  complianceType?: Maybe<ComplianceType>;
  creditCost: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  usState?: Maybe<Scalars['USState']['output']>;
};

export type PremiumContentConfigInput = {
  complianceTypes?: InputMaybe<Array<ComplianceType>>;
};

export type PremiumContentConfigs = PaginatedList & {
  __typename?: 'PremiumContentConfigs';
  objects: Array<PremiumContentConfig>;
  totalCount: Scalars['Int']['output'];
};

export enum PremiumContentSetupStep {
  AssignmentSettings = 'ASSIGNMENT_SETTINGS',
  BuyCredits = 'BUY_CREDITS',
  Completed = 'COMPLETED',
  Review = 'REVIEW',
  StartSetup = 'START_SETUP'
}

export type PremiumContentSetupStepValue = {
  value: PremiumContentSetupStep;
};

export type PresignedS3PostData = {
  __typename?: 'PresignedS3PostData';
  fields: PresignedS3PostDataFields;
  mediaDomain: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum PresignedS3PostDataBucket {
  Media = 'MEDIA',
  Scorm = 'SCORM'
}

export type PresignedS3PostDataFields = {
  __typename?: 'PresignedS3PostDataFields';
  key: Scalars['String']['output'];
  policy: Scalars['String']['output'];
  xAmzAlgorithm: Scalars['String']['output'];
  xAmzCredential: Scalars['String']['output'];
  xAmzDate: Scalars['String']['output'];
  xAmzSecurityToken: Scalars['String']['output'];
  xAmzSignature: Scalars['String']['output'];
};

export type PresignedS3PostDataMutationResult = MutationResult & {
  __typename?: 'PresignedS3PostDataMutationResult';
  data?: Maybe<PresignedS3PostData>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type ProductEngagementInput = {
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Prompt = {
  __typename?: 'Prompt';
  accuracy?: Maybe<Scalars['Float']['output']>;
  aiGenerationInProgress: Scalars['Boolean']['output'];
  allowFreeResponseTypos?: Maybe<Scalars['Boolean']['output']>;
  assignMedia: Scalars['Boolean']['output'];
  correctAudioResponseAnswer?: Maybe<Scalars['String']['output']>;
  correctFreeResponseAnswer?: Maybe<TranslationSet>;
  correctTfAnswer?: Maybe<Scalars['Boolean']['output']>;
  drill: Lesson;
  hideMediaSuggestions: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  imageOnlyMatchItems?: Maybe<Scalars['Boolean']['output']>;
  index: Scalars['Float']['output'];
  libraryItemLink?: Maybe<LibraryItem>;
  libraryItemLinkId?: Maybe<Scalars['UUID']['output']>;
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['Int']['output']>;
  mediaSuggestions?: Maybe<Array<MediaSuggestion>>;
  numResponses: Scalars['Int']['output'];
  randomizeOptionOrder: Scalars['Boolean']['output'];
  requireFullVideoPlayback: Scalars['Boolean']['output'];
  responseOptions: Array<ResponseOption>;
  selectAllThatApply: Scalars['Boolean']['output'];
  text?: Maybe<TranslationSet>;
  type: PromptType;
  uuid: Scalars['UUID']['output'];
};

export type PromptAttempt = {
  __typename?: 'PromptAttempt';
  id: Scalars['Int']['output'];
  response: Scalars['String']['output'];
  responseLanguage?: Maybe<Scalars['Language']['output']>;
  responseOptionInstances: Array<ResponseOptionInstance>;
  responseTranslation?: Maybe<Scalars['String']['output']>;
  submittedAt: Scalars['DateTime']['output'];
  trueFalseResponse?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type PromptAttemptInput = {
  response: Scalars['String']['input'];
  submittedAt: Scalars['DateTime']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type PromptInput = {
  id: Scalars['Int']['input'];
};

export type PromptInstance = {
  __typename?: 'PromptInstance';
  answeredCorrectly?: Maybe<Scalars['Boolean']['output']>;
  attempts: Array<PromptAttempt>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  lessonInstance?: Maybe<LessonInstance>;
  numFailures: Scalars['Int']['output'];
  prompt: Prompt;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type PromptInstanceInput = {
  answeredCorrectly?: InputMaybe<Scalars['Boolean']['input']>;
  attempts: Array<PromptAttemptInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  numFailures: Scalars['Int']['input'];
  prompt?: InputMaybe<PromptInput>;
  promptId?: InputMaybe<Scalars['Int']['input']>;
  promptSlug?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type PromptInstances = PaginatedList & {
  __typename?: 'PromptInstances';
  objects: Array<PromptInstance>;
  totalCount: Scalars['Int']['output'];
};

export type PromptInstancesFiltersInput = {
  peopleFilters?: InputMaybe<GetPeopleInput>;
  promptUuids?: InputMaybe<UuidArrayInput>;
};

export type PromptInstancesInput = {
  filters: PromptInstancesFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type PromptObjectInput = {
  aiGenerationInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  allowFreeResponseTypos?: InputMaybe<Scalars['Boolean']['input']>;
  assignMedia: Scalars['Boolean']['input'];
  correctFreeResponseAnswer?: InputMaybe<TranslationSetObjectInput>;
  correctTfAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  imageOnlyMatchItems?: InputMaybe<Scalars['Boolean']['input']>;
  mediaId?: InputMaybe<Scalars['Int']['input']>;
  randomizeOptionOrder?: Scalars['Boolean']['input'];
  requireFullVideoPlayback?: InputMaybe<Scalars['Boolean']['input']>;
  responseOptions: Array<ResponseOptionObjectInput>;
  selectAllThatApply: Scalars['Boolean']['input'];
  text?: InputMaybe<TranslationSetObjectInput>;
  type: PromptType;
  uuid: Scalars['UUID']['input'];
};

export type PromptResponsesCsvInput = {
  courseId: Scalars['Int']['input'];
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum PromptType {
  AudioResponse = 'AUDIO_RESPONSE',
  GradedFreeResponse = 'GRADED_FREE_RESPONSE',
  ImageChoice = 'IMAGE_CHOICE',
  Matching = 'MATCHING',
  Message = 'MESSAGE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  NongradedFreeResponse = 'NONGRADED_FREE_RESPONSE',
  Ordering = 'ORDERING',
  TitleScreen = 'TITLE_SCREEN',
  TrueFalse = 'TRUE_FALSE'
}

export type ProviderEnrichment = {
  __typename?: 'ProviderEnrichment';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastAttemptedAt?: Maybe<Scalars['DateTime']['output']>;
  provider: ProviderSource;
  status: ProviderEnrichmentStatus;
};

export enum ProviderEnrichmentStatus {
  Enriching = 'ENRICHING',
  Error = 'ERROR',
  NotTried = 'NOT_TRIED',
  SuccessEmpty = 'SUCCESS_EMPTY',
  SuccessWithData = 'SUCCESS_WITH_DATA'
}

export enum ProviderSource {
  Apollo = 'APOLLO',
  Fullenrich = 'FULLENRICH',
  Zoominfo = 'ZOOMINFO'
}

export type PublishCourseInput = {
  allAdmins?: InputMaybe<SharingPermission>;
  allManagers?: InputMaybe<SharingPermission>;
  description?: InputMaybe<TranslationSetInputValue>;
  dueDate?: InputMaybe<DueDateInput>;
  enableCertificate?: InputMaybe<OptionalBooleanValue>;
  enablePromptRetries?: InputMaybe<OptionalBooleanValue>;
  excludeFromKnowledgeCheck?: InputMaybe<OptionalBooleanValue>;
  passingAccuracyThreshold?: InputMaybe<OptionalIntValue>;
};

export type PublishFormActionInput = {
  failed?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};

export enum PublishState {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  UnpublishedChanges = 'UNPUBLISHED_CHANGES'
}

export type PublishStateArrayInput = {
  value: Array<PublishState>;
};

export type PublishStateValue = {
  value: PublishState;
};

export type PublishWorkflowMutationResult = MutationResult & {
  __typename?: 'PublishWorkflowMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  validationErrors?: Maybe<Array<WorkflowValidationError>>;
  workflow?: Maybe<Workflow>;
};

export type PurchaseCreditsInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  billingAccountId?: InputMaybe<Scalars['String']['input']>;
  creditPurchaseOptionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QrCodeSettingsInput = {
  includeLogo?: InputMaybe<Scalars['Boolean']['input']>;
  includeTitle?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  __typename?: 'Query';
  ABXCompanies: AbxCompanies;
  ABXCompanyBreakdown: AbxBreakdown;
  ABXCompanyTimeline: AbxCompanyTimeline;
  ABXIntentContext?: Maybe<AbxIntentContext>;
  ABXIntentEvents: AbxIntentEvents;
  ABXSummary: AbxSummary;
  AdminActiveClients: Array<ActiveClient>;
  AdminCatalogCategories: Array<CatalogCategory>;
  AdminCommentThreads: Array<CommentThread>;
  AdminContentPermissions?: Maybe<ContentPermissions>;
  AdminCourse?: Maybe<Course>;
  AdminCourseBuildingInProgress?: Maybe<Course>;
  AdminCourseFeedback: Array<CourseFeedback>;
  AdminCourseInstance?: Maybe<CourseInstance>;
  AdminCourseLibrary: Array<Course>;
  AdminCourseVersion?: Maybe<CourseVersion>;
  AdminEmployee?: Maybe<Employee>;
  AdminEmployeeEngagement: EmployeeEngagement;
  AdminEmployees: Employees;
  AdminEmployeesWithIncompleteAssignments: Employees;
  AdminEmployeesWithPastDueAssignments: Employees;
  AdminHrisEmployees: HrisEmployees;
  AdminInProductNotifications: Array<InProductNotification>;
  AdminLibrary: LibraryItems;
  AdminMedia?: Maybe<Media>;
  AdminMessageBlast?: Maybe<MessageBlast>;
  AdminModule?: Maybe<Module>;
  /** @deprecated Use ModuleInstance */
  AdminModuleInstance?: Maybe<ModuleInstance>;
  AdminModuleVersion?: Maybe<ModuleVersion>;
  AdminOrgSharpConfig?: Maybe<OrgSharpConfig>;
  AdminProductAdoption: Array<AdoptionDay>;
  AdminReportedContent: Array<ReportedContent>;
  AdminSkill?: Maybe<Skill>;
  AdminSkillVersion?: Maybe<SkillVersion>;
  /** @deprecated Field no longer supported */
  AdminSkills: Array<Skill>;
  /** @deprecated use Tags */
  AdminTags: Array<Tag>;
  /** @deprecated Field no longer supported */
  AdminTrainingResource?: Maybe<TrainingResource>;
  AdminTrainingResourceVersion?: Maybe<TrainingResourceVersion>;
  AdminTrainingResources: Array<TrainingResource>;
  AdminWeeklyRecap: WeeklyRecap;
  AgentSession?: Maybe<AgentSessionGql>;
  AgentSessions: AgentSessionsGql;
  AskOpusQuestionAnswers: AskOpusQuestionAnswers;
  AskOpusThemeAnalysis?: Maybe<AskOpusThemeAnalysis>;
  Assignment?: Maybe<Assignment>;
  AssignmentCompletion: Array<AssignmentCompletionDay>;
  AssignmentHistoryItems: Array<AssignmentHistoryItem>;
  AssignmentStatusCounts: Array<AssignmentStatusCount>;
  Assignments: Assignments;
  AuditFollowUpTaskSetup: AuditFollowUpTaskSetup;
  AuditLocationStatuses: Array<AuditLocationStatus>;
  AutomationOverrides: Array<AutomationOverride>;
  Automations: Array<Automation>;
  AutomationsV2: Automations;
  AverageCourseFeedback?: Maybe<Scalars['Float']['output']>;
  AverageTimeToCompletes: Array<AverageTimeToComplete>;
  AvgTrainingFeedback: Array<AvgTrainingFeedbackWeek>;
  BackfilledAssignments: BackfilledAssignments;
  BackfilledCertificates: BackfilledCertificates;
  BillingAccounts: Array<BillingAccount>;
  BuilderActions: Array<BuilderAction>;
  CRMABXAssignments: CrmabxAssignments;
  CRMAccountStatusUpdates: CrmAccountStatusUpdates;
  CRMCompanies: CrmCompanies;
  CRMCompany?: Maybe<CrmCompany>;
  CRMCompanyOwners: Array<CrmUser>;
  CRMContact?: Maybe<CrmContact>;
  CRMContacts: CrmContacts;
  CRMDeals: CrmDealsResult;
  CRMDealsSummary: CrmDealsSummary;
  CRMEmails: CrmEmails;
  CRMMeetings: CrmMeetings;
  CRMNotes: CrmNotes;
  CRMUsers: CrmUsers;
  CSReps: Array<CsRep>;
  CSTicketStats: CsTicketStats;
  CSTicketsFeed: CsTicketsList;
  CatalogModule?: Maybe<CatalogModule>;
  Chat?: Maybe<Chat>;
  ChatMessageMentionableUsers: Employees;
  ChatMessages: ChatMessages;
  CheckinDelegationsCreatedByMe: Assignments;
  ClientFacingWorkflow?: Maybe<ClientFacingWorkflow>;
  CoachingRun?: Maybe<CoachingRun>;
  CoachingRunCandidates: Array<CoachingTemplateCandidate>;
  CoachingRunList: CoachingRunList;
  CoachingRunPinnedRubric?: Maybe<CoachingPinnedRubric>;
  CoachingTemplates: Array<CoachingPromptTemplate>;
  CoachingTestMeetings: Array<CoachingTestMeeting>;
  CompanyContactCandidates: Array<CompanyContactCandidate>;
  CompletedCheckinsFacilitatedByMe: Assignments;
  CompletedTaskCounts: CompletedTaskCounts;
  CompletedTaskSkillInstances: SkillInstances;
  CompletionReportsV2: Scalars['JSON']['output'];
  CompletionScheduleInstances: CompletionScheduleInstances;
  CompletionScheduleWindows: CompletionScheduleWindows;
  ComplianceRecords: ComplianceRecords;
  ComplianceReports: Array<ComplianceReport>;
  Contract?: Maybe<Contract>;
  Contracts: ContractsResult;
  CourseFeedbackRatingDistribution: CourseFeedbackRatingDistribution;
  CourseFeedbacks: CourseFeedbacks;
  CreditPurchaseOptions: Array<CreditPurchaseOption>;
  CustomerProblem?: Maybe<CustomerProblem>;
  CustomerProblemsHeatmap: CustomerProblemsHeatmap;
  CustomerProblemsList: CustomerProblemsList;
  CustomerProblemsSummary: CustomerProblemsSummary;
  CustomerProblemsTrends: CustomerProblemsTrends;
  DealScopeCard?: Maybe<DealScopeCard>;
  DealScopeEditHistory: Array<DealScopeAnswerEvent>;
  DealScopeList: DealScopeList;
  DealScopeQuestions: Array<DealScopeQuestion>;
  DealScopeSummary: DealScopeSummary;
  EmployeeBlastSentRecord?: Maybe<BlastSentRecord>;
  EmployeeBlastSentRecords: Array<BlastSentRecord>;
  EmployeeBlastSentRecordsPaginated: BlastSentRecords;
  EmployeeCourseInstance?: Maybe<CourseInstance>;
  FeatureFlags: Array<FeatureFlag>;
  GetAIRequests: Array<AiRequest>;
  GetHrisCsvUpload?: Maybe<HrisCsvUpload>;
  GetSavedReports?: Maybe<Array<CustomReport>>;
  GetSupportedImagesMIMETypes: Array<MimeType>;
  GetUsersForUserSelection: Array<Employee>;
  GetUsersForUserSelectionSet: Array<Employee>;
  GuestFeedbackAnalysisRuns: Array<GuestFeedbackAnalysisRun>;
  GuestFeedbackCorrectiveActions: Array<GuestFeedbackCorrectiveAction>;
  GuestFeedbackRatingTrend: Array<GuestFeedbackRatingTrendPoint>;
  GuestFeedbackRecommendations: Array<GuestFeedbackCorrectiveAction>;
  GuestFeedbackThemeSummary: Array<GuestFeedbackTheme>;
  GuestFeedbackThemes: Array<GuestFeedbackTheme>;
  GuestFeedbacks: GuestFeedbacks;
  HomeScreenTaskWidgetLibraryItems: LibraryItems;
  HrisActivationData: HrisActivationData;
  HrisCsvUpload?: Maybe<HrisCsvUpload>;
  HrisCsvUploads: HrisCsvUploads;
  HrisEmployee?: Maybe<HrisEmployee>;
  HrisEmployeeEvent?: Maybe<HrisEmployeeEvent>;
  HrisEmployeeEvents: HrisEmployeeEvents;
  HrisEmployees: HrisEmployees;
  HrisIntegration?: Maybe<HrisIntegration>;
  HrisLocation?: Maybe<HrisLocation>;
  HrisLocations: HrisLocations;
  HrisTeam?: Maybe<HrisTeam>;
  HrisTeams: HrisTeams;
  ImpactReportingAdoption: ImpactReportingAdoption;
  ImpactReportingAssignmentCompletion: ImpactReportingAssignmentCompletion;
  ImpactReportingBrandAndProductKnowledgeCompletion: ImpactReportingBrandAndProductKnowledgeCompletion;
  ImpactReportingCompliance: ImpactReportingCompliance;
  ImpactReportingConsistentOperations: ImpactReportingConsistentOperations;
  ImpactReportingCourseFeedback: ImpactReportingCourseFeedback;
  ImpactReportingCustomSegmentEngagement: ImpactReportingCustomSegmentEngagement;
  ImpactReportingEmployeeRetention: ImpactReportingEmployeeRetention;
  ImpactReportingEngagement: ImpactReportingEngagement;
  ImpactReportingNewStoreOpenings: Array<ImpactReportingStoreOpening>;
  ImpactReportingOnboarding: ImpactReportingOnboarding;
  ImpactReportingReengagement: ImpactReportingReengagement;
  InProductNotificationUnreadCount: Scalars['Int']['output'];
  InProductNotifications: InProductNotifications;
  IntercomConversation?: Maybe<IntercomConversation>;
  IntercomConversationsList: IntercomConversationsList;
  Invoices: Array<Invoice>;
  KnowledgeCheck?: Maybe<KnowledgeCheck>;
  KnowledgeCheckInstances: KnowledgeCheckInstances;
  KnowledgeCheckLeaderboard: Array<Employee>;
  KnowledgeCheckLocationLeaderboards: KnowledgeCheckLocationLeaderboards;
  KnowledgeCheckStreak: KnowledgeCheckStreak;
  LibraryItem?: Maybe<LibraryItem>;
  Location?: Maybe<Location>;
  LocationGroup?: Maybe<LocationGroup>;
  LocationGroups: LocationGroups;
  LocationLeaderboard: LocationLeaderboard;
  Locations: Locations;
  ManagerLeaderboard: Array<ManagerLeaderboardItem>;
  ManagerLeaderboardPaginated: ManagerLeaderboard;
  Me?: Maybe<Me>;
  Media?: Maybe<Media>;
  MergeBackfillRun?: Maybe<MergeBackfillRun>;
  MergeBackfillRuns: MergeBackfillRuns;
  MessageBlasts: MessageBlasts;
  MessageReadsGrid: Scalars['JSON']['output'];
  MessagingActivityItems: MessagingActivityItems;
  MinimumSupportedAppVersion?: Maybe<Scalars['String']['output']>;
  ModuleInstance?: Maybe<ModuleInstance>;
  MostRecentAuditCompletionReports: Array<SkillInstance>;
  MyAiChats: AiChats;
  MyChats: Chats;
  MyEng?: Maybe<EngSlug>;
  MyIncompleteCheckinsToFacilitate: Assignments;
  MyPendingCheckinsToFacilitate: Assignments;
  MyRemediationInstances: MyRemediationInstances;
  MyTasks: Array<Task>;
  MyTeamIncompleteAssignments: Assignments;
  MyTodoAssignments: Assignments;
  NumUsersEligibleForAutomation: Scalars['Int']['output'];
  OnCompletionAssignmentRuleSets: Array<OnCompletionAssignmentRuleSet>;
  OnCompletionAssignmentRuleTree: OnCompletionAssignmentRuleTree;
  OpenGraphData: Scalars['JSON']['output'];
  OpusAgentChat?: Maybe<OpusAgentChat>;
  OpusAgentChats: OpusAgentChats;
  OpusAgentDefaultModel: OpusAgentModel;
  OpusAgentTurnEvents: OpusAgentTurnEvents;
  OpusAgentTurns: OpusAgentTurns;
  OrgFeatureFlags: Array<FeatureFlag>;
  OrgGuestFeedbackCsvUploads: OrgGuestFeedbackCsvUploads;
  OrgGuestFeedbackIntegration?: Maybe<OrgGuestFeedbackIntegration>;
  OrgGuestFeedbackIntegrations: Array<OrgGuestFeedbackIntegration>;
  OrgGuestFeedbackSyncs: OrgGuestFeedbackSyncs;
  OrgHierarchy: Array<OrgNode>;
  OrgPremiumContentConfigs: OrgPremiumContentConfigs;
  OrgSftpIntegration?: Maybe<OrgSftpIntegration>;
  OrgSftpIntegrations: OrgSftpIntegrations;
  PaginatedOnCompletionAssignmentRuleSets: PaginatedOnCompletionAssignmentRuleSets;
  People: Employees;
  PeopleActionPermission: EmployeeActionPermissions;
  PostCommentMentionableUsers: Employees;
  PostComments: PostComments;
  PostMentionableUsers: Employees;
  PostReactions: PostReactions;
  PremiumContentConfigs: PremiumContentConfigs;
  PromptInstances?: Maybe<PromptInstances>;
  ReassignmentCohortDetails: ReassignmentCohortDetails;
  RecentActivity: Array<RecentActivityItem>;
  RecentlyAssignedLibraryItems: Array<RecentlyAssignedLibraryItem>;
  RecentlyViewedLibraryItems: Array<LibraryItem>;
  RemediationInstance: RemediationInstance;
  RemoteHrisSftpCsv?: Maybe<RemoteHrisSftpCsv>;
  RepAccountsByProspectStatus: RepAccountsByProspectStatus;
  RepDashboardSummary: RepDashboardSummary;
  RepDealsByStage: RepDealsByStage;
  RepIntentEvents: RepIntentEvents;
  RepSequenceActivity: RepSequenceActivity;
  RepSignals: RepSignals;
  RepWebActivity: RepWebActivity;
  ReportTopics: Array<ReportTopic>;
  ReportViews: Array<ReportView>;
  ReportingTargetSet: ReportingTargetSet;
  ResponseOptionReportingInstances: Array<ResponseOptionReportingInstance>;
  RichTextDocumentCommentThreads: Array<CommentThread>;
  Role?: Maybe<Role>;
  RoleGroup?: Maybe<RoleGroup>;
  RoleGroups: RoleGroups;
  Roles: Roles;
  SCORMCourseInstance?: Maybe<ScormCourseInstance>;
  SCORMUpload?: Maybe<ScormUpload>;
  ScheduledUserInvites: ScheduledUserInvites;
  SearchChatContents: ChatSearchResults;
  SearchPexelsPhotos?: Maybe<Array<PexelsPhoto>>;
  SearchPexelsVideos?: Maybe<Array<PexelsVideo>>;
  SearchUnsplashImages?: Maybe<Array<UnsplashImage>>;
  SignupCode?: Maybe<SignupCode>;
  SkillInstance?: Maybe<SkillInstance>;
  SkillInstances: SkillInstances;
  Skills: Skills;
  SubmittedRequest?: Maybe<SubmittedRequest>;
  SubmittedRequestsList: SubmittedRequestsList;
  SuggestedQuestions: SuggestedQuestions;
  Tags: Array<Tag>;
  Task?: Maybe<Task>;
  TaskCommentMentionableUsers: Employees;
  TaskScheduleCompletionPercents: TaskScheduleCompletionPercents;
  Tasks: Tasks;
  TopTaskListsBySubmission: Array<TopTaskListBySubmission>;
  TopTrainingsByAssignment: Array<TopTrainingByAssignment>;
  TraineeLeaderboard: TraineeLeaderboard;
  TraineeLibrary: LibraryItems;
  TrainingResource?: Maybe<TrainingResource>;
  TrainingResourceViews: Array<TrainingResourceViews>;
  TrainingSessions: Array<TrainingSession>;
  TranslationSet?: Maybe<TranslationSet>;
  UnreadChatsCount: Scalars['Int']['output'];
  UserActionPermissions: UserActionPermissions;
  UserActivity: Array<UserActivityWeek>;
  UserAuditItems: UserAuditItems;
  UserPushNotificationSettingChatOverrides: Array<UserPushNotificationSettingChatOverride>;
  UserPushNotificationSettingPostActivityOverrides: Array<UserPushNotificationSettingPostActivityOverride>;
  UserPushNotificationSettings: Array<UserPushNotificationSetting>;
  VerificationStepInstances: VerificationStepInstances;
  Workflow?: Maybe<Workflow>;
  WorkflowInstance?: Maybe<WorkflowInstance>;
  WorkflowInstances: WorkflowInstances;
  Workflows: Workflows;
  getGoogleBusinessAccounts: Array<GoogleBusinessAccount>;
};


export type QueryAbxCompaniesArgs = {
  input?: InputMaybe<AbxCompaniesInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAbxCompanyBreakdownArgs = {
  companyId: Scalars['UUID']['input'];
};


export type QueryAbxCompanyTimelineArgs = {
  companyId: Scalars['UUID']['input'];
};


export type QueryAbxIntentContextArgs = {
  companyId: Scalars['UUID']['input'];
};


export type QueryAbxIntentEventsArgs = {
  companyId: Scalars['UUID']['input'];
  input?: InputMaybe<AbxIntentEventsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAdminActiveClientsArgs = {
  input: ActiveClientsInput;
};


export type QueryAdminCommentThreadsArgs = {
  courseId?: InputMaybe<Scalars['Int']['input']>;
  courseVersionId?: InputMaybe<Scalars['Int']['input']>;
  courseVersionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryAdminContentPermissionsArgs = {
  courseId?: InputMaybe<Scalars['Int']['input']>;
  moduleId?: InputMaybe<Scalars['Int']['input']>;
  skillId?: InputMaybe<Scalars['Int']['input']>;
  trainingResourceId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryAdminCourseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdminCourseFeedbackArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAdminCourseInstanceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdminCourseLibraryArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  courseIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasOpened?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  publishState?: InputMaybe<PublishState>;
  publishStates?: InputMaybe<Array<InputMaybe<PublishState>>>;
  userCreatedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAdminCourseVersionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdminEmployeeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdminEmployeeEngagementArgs = {
  input?: InputMaybe<ProductEngagementInput>;
};


export type QueryAdminEmployeesArgs = {
  activeSince?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  doingEsl?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  groupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasHrisEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  hasUsedApp?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  roleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userTypes?: InputMaybe<Array<UserType>>;
};


export type QueryAdminEmployeesWithIncompleteAssignmentsArgs = {
  input?: InputMaybe<AdminEmployeesInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAdminEmployeesWithPastDueAssignmentsArgs = {
  input?: InputMaybe<AdminEmployeesInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAdminHrisEmployeesArgs = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminLibraryArgs = {
  input: AdminLibraryInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAdminMediaArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdminMessageBlastArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdminModuleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdminModuleInstanceArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminModuleVersionArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminSkillArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdminSkillVersionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAdminSkillsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  hasOpened?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  skillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryAdminTrainingResourceArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminTrainingResourceVersionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAdminTrainingResourcesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  hasOpened?: InputMaybe<Scalars['Boolean']['input']>;
  openedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminWeeklyRecapArgs = {
  input?: InputMaybe<WeeklyRecapInput>;
};


export type QueryAgentSessionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAgentSessionsArgs = {
  input?: InputMaybe<AgentSessionsInput>;
  mySessions?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAskOpusQuestionAnswersArgs = {
  input?: InputMaybe<AskOpusQuestionAnswersInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAssignmentArgs = {
  id: Scalars['String']['input'];
};


export type QueryAssignmentCompletionArgs = {
  input?: InputMaybe<AssignmentCompletionInput>;
  libraryItemId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryAssignmentHistoryItemsArgs = {
  assignmentId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAssignmentStatusCountsArgs = {
  input: AssignmentsInput;
};


export type QueryAssignmentsArgs = {
  input: AssignmentsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAuditLocationStatusesArgs = {
  libraryItemId: Scalars['UUID']['input'];
};


export type QueryAutomationOverridesArgs = {
  automationId: Scalars['Int']['input'];
  automationOverrideReasons?: InputMaybe<Array<AutomationOverrideReason>>;
};


export type QueryAutomationsArgs = {
  allLocations?: InputMaybe<Scalars['Boolean']['input']>;
  allUserType?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAutomationsV2Args = {
  input: AutomationsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAverageCourseFeedbackArgs = {
  input: CourseFeedbacksInput;
};


export type QueryAverageTimeToCompletesArgs = {
  input: AverageTimetoCompleteInput;
};


export type QueryAvgTrainingFeedbackArgs = {
  input?: InputMaybe<AvgTrainingFeedbackInput>;
};


export type QueryBackfilledAssignmentsArgs = {
  input: BackfilledAssignmentsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryBackfilledCertificatesArgs = {
  input: BackfilledCertificatesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryBillingAccountsArgs = {
  input: GetBillingAccountsInput;
};


export type QueryBuilderActionsArgs = {
  inputs: Array<GetBuilderActionsInput>;
};


export type QueryCrmabxAssignmentsArgs = {
  input?: InputMaybe<CrmabxAssignmentsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCrmAccountStatusUpdatesArgs = {
  input?: InputMaybe<CrmAccountStatusUpdatesInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCrmCompaniesArgs = {
  input?: InputMaybe<CrmCompaniesInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCrmCompanyArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCrmContactArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCrmContactsArgs = {
  input?: InputMaybe<CrmContactsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCrmDealsArgs = {
  input: CrmDealsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCrmDealsSummaryArgs = {
  filters: CrmDealsFiltersInput;
};


export type QueryCrmEmailsArgs = {
  input?: InputMaybe<CrmEmailsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCrmMeetingsArgs = {
  input?: InputMaybe<CrmMeetingsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCrmNotesArgs = {
  input?: InputMaybe<CrmNotesInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCrmUsersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCsTicketStatsArgs = {
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<CsTicketSource>;
};


export type QueryCsTicketsFeedArgs = {
  input?: InputMaybe<CsTicketsFeedInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCatalogModuleArgs = {
  id: Scalars['String']['input'];
};


export type QueryChatArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryChatMessageMentionableUsersArgs = {
  chatId: Scalars['UUID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatMessagesArgs = {
  chatId?: InputMaybe<Scalars['UUID']['input']>;
  input?: InputMaybe<ChatMessagesInput>;
  pagination?: InputMaybe<PaginationInput>;
  updatedAfter?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryCheckinDelegationsCreatedByMeArgs = {
  input?: InputMaybe<MyCheckinsInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientFacingWorkflowArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCoachingRunArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCoachingRunCandidatesArgs = {
  runId: Scalars['UUID']['input'];
};


export type QueryCoachingRunListArgs = {
  input: CoachingRunsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCoachingRunPinnedRubricArgs = {
  runId: Scalars['UUID']['input'];
};


export type QueryCoachingTemplatesArgs = {
  input: CoachingTemplatesInput;
};


export type QueryCoachingTestMeetingsArgs = {
  search?: InputMaybe<StringValue>;
};


export type QueryCompanyContactCandidatesArgs = {
  companyId: Scalars['UUID']['input'];
};


export type QueryCompletedCheckinsFacilitatedByMeArgs = {
  input?: InputMaybe<MyCheckinsInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompletedTaskCountsArgs = {
  input?: InputMaybe<CompletedTaskCountsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCompletedTaskSkillInstancesArgs = {
  input: CompletedTaskSkillInstancesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCompletionReportsV2Args = {
  input: CompletionReportsInput;
};


export type QueryCompletionScheduleInstancesArgs = {
  input?: InputMaybe<CompletionScheduleInstancesInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCompletionScheduleWindowsArgs = {
  input?: InputMaybe<CompletionScheduleWindowsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryComplianceRecordsArgs = {
  input: ComplianceRecordsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryComplianceReportsArgs = {
  input: ComplianceReportsInput;
};


export type QueryContractArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryContractsArgs = {
  input: ContractsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCourseFeedbackRatingDistributionArgs = {
  input: CourseFeedbacksInput;
};


export type QueryCourseFeedbacksArgs = {
  input: CourseFeedbacksInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCustomerProblemArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerProblemsListArgs = {
  input?: InputMaybe<CustomerProblemsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCustomerProblemsSummaryArgs = {
  filters?: InputMaybe<CustomerProblemsFiltersInput>;
};


export type QueryCustomerProblemsTrendsArgs = {
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryDealScopeCardArgs = {
  dealId: Scalars['UUID']['input'];
};


export type QueryDealScopeEditHistoryArgs = {
  actor?: InputMaybe<DealScopeActorFilter>;
  dealId: Scalars['UUID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryDealScopeListArgs = {
  input: DealScopesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryDealScopeSummaryArgs = {
  filters: DealScopesFiltersInput;
};


export type QueryEmployeeBlastSentRecordArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEmployeeBlastSentRecordsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryEmployeeBlastSentRecordsPaginatedArgs = {
  input?: InputMaybe<EmployeeBlastSentRecordsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryEmployeeCourseInstanceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetAiRequestsArgs = {
  input: GetAiRequestsInput;
};


export type QueryGetHrisCsvUploadArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetUsersForUserSelectionArgs = {
  input?: InputMaybe<UserSelectionInput>;
};


export type QueryGetUsersForUserSelectionSetArgs = {
  input?: InputMaybe<UserSelectionSetInput>;
};


export type QueryGuestFeedbackAnalysisRunsArgs = {
  input?: InputMaybe<GuestFeedbackAnalysisRunsInput>;
};


export type QueryGuestFeedbackCorrectiveActionsArgs = {
  input?: InputMaybe<GuestFeedbackCorrectiveActionsInput>;
};


export type QueryGuestFeedbackRatingTrendArgs = {
  input?: InputMaybe<GuestFeedbackRatingTrendInput>;
};


export type QueryGuestFeedbackRecommendationsArgs = {
  input?: InputMaybe<GuestFeedbackRecommendationsInput>;
};


export type QueryGuestFeedbackThemeSummaryArgs = {
  input?: InputMaybe<GuestFeedbackThemeSummaryInput>;
};


export type QueryGuestFeedbackThemesArgs = {
  input?: InputMaybe<GuestFeedbackThemesInput>;
};


export type QueryGuestFeedbacksArgs = {
  input: GuestFeedbacksInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryHomeScreenTaskWidgetLibraryItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryHrisActivationDataArgs = {
  hrisCsvUploadId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHrisCsvUploadArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryHrisCsvUploadsArgs = {
  input: HrisCsvUploadsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryHrisEmployeeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryHrisEmployeeEventArgs = {
  pghId: Scalars['Int']['input'];
};


export type QueryHrisEmployeeEventsArgs = {
  input: HrisEmployeeEventsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryHrisEmployeesArgs = {
  input: HrisEmployeesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryHrisIntegrationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryHrisLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryHrisLocationsArgs = {
  input: HrisLocationsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryHrisTeamArgs = {
  id: Scalars['Int']['input'];
};


export type QueryHrisTeamsArgs = {
  input: HrisTeamsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryImpactReportingCustomSegmentEngagementArgs = {
  userSelectionId: Scalars['Int']['input'];
};


export type QueryInProductNotificationsArgs = {
  input?: InputMaybe<InProductNotificationsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryIntercomConversationArgs = {
  id: Scalars['String']['input'];
};


export type QueryIntercomConversationsListArgs = {
  input?: InputMaybe<IntercomConversationsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryKnowledgeCheckInstancesArgs = {
  input: KnowledgeCheckInstancesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryKnowledgeCheckLocationLeaderboardsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryLibraryItemArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryLocationGroupsArgs = {
  input?: InputMaybe<LocationGroupsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryLocationLeaderboardArgs = {
  input: LocationLeaderboardInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryLocationsArgs = {
  input?: InputMaybe<LocationsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryManagerLeaderboardArgs = {
  input: ManagerLeaderboardInput;
};


export type QueryManagerLeaderboardPaginatedArgs = {
  input: ManagerLeaderboardInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMediaArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMergeBackfillRunArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMergeBackfillRunsArgs = {
  input: MergeBackfillRunsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMessageBlastsArgs = {
  input?: InputMaybe<MessageBlastsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMessageReadsGridArgs = {
  input: MessageReadsGridInput;
};


export type QueryMessagingActivityItemsArgs = {
  filters?: InputMaybe<MessagingActivityItemFiltersInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryModuleInstanceArgs = {
  id: Scalars['String']['input'];
};


export type QueryMostRecentAuditCompletionReportsArgs = {
  input: MostRecentAuditCompletionReportsInput;
};


export type QueryMyAiChatsArgs = {
  input: MyAiChatsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMyChatsArgs = {
  input?: InputMaybe<ChatsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMyIncompleteCheckinsToFacilitateArgs = {
  input?: InputMaybe<MyCheckinsInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyPendingCheckinsToFacilitateArgs = {
  input?: InputMaybe<MyCheckinsInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyRemediationInstancesArgs = {
  input?: InputMaybe<MyRemediationInstancesInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMyTodoAssignmentsArgs = {
  input?: InputMaybe<MyTodoAssignmentsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNumUsersEligibleForAutomationArgs = {
  automationId: Scalars['Int']['input'];
};


export type QueryOnCompletionAssignmentRuleTreeArgs = {
  input: OnCompletionAssignmentRuleTreeInput;
};


export type QueryOpenGraphDataArgs = {
  url: Scalars['String']['input'];
};


export type QueryOpusAgentChatArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryOpusAgentChatsArgs = {
  input: OpusAgentChatsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOpusAgentTurnEventsArgs = {
  input: OpusAgentTurnEventsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOpusAgentTurnsArgs = {
  input: OpusAgentTurnsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOrgGuestFeedbackCsvUploadsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOrgGuestFeedbackIntegrationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrgGuestFeedbackSyncsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOrgHierarchyArgs = {
  input?: InputMaybe<OrgHierarchyInput>;
};


export type QueryOrgPremiumContentConfigsArgs = {
  input: OrgPremiumContentConfigInput;
};


export type QueryOrgSftpIntegrationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrgSftpIntegrationsArgs = {
  input: OrgSftpIntegrationsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPaginatedOnCompletionAssignmentRuleSetsArgs = {
  input: OnCompletionAssignmentRuleSetsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPeopleArgs = {
  input: GetPeopleInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPeopleActionPermissionArgs = {
  hasPermission?: InputMaybe<BooleanValue>;
  input: GetPeopleInput;
  pagination?: InputMaybe<PaginationInput>;
  permission: Permission;
};


export type QueryPostCommentMentionableUsersArgs = {
  messageBlastId: Scalars['Int']['input'];
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPostCommentsArgs = {
  input?: InputMaybe<PostCommentsInput>;
  messageBlastId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPostMentionableUsersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPostReactionsArgs = {
  messageBlastId: Scalars['Int']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPremiumContentConfigsArgs = {
  input: PremiumContentConfigInput;
};


export type QueryPromptInstancesArgs = {
  input: PromptInstancesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReassignmentCohortDetailsArgs = {
  automationId: Scalars['Int']['input'];
};


export type QueryRecentlyAssignedLibraryItemsArgs = {
  input: RecentlyAssignedLibraryItemsInput;
};


export type QueryRecentlyViewedLibraryItemsArgs = {
  n?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRemediationInstanceArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryRemoteHrisSftpCsvArgs = {
  fileName: Scalars['String']['input'];
  orgSftpIntegrationId: Scalars['UUID']['input'];
};


export type QueryRepAccountsByProspectStatusArgs = {
  input: RepDashboardInput;
};


export type QueryRepDashboardSummaryArgs = {
  input: RepDashboardInput;
};


export type QueryRepDealsByStageArgs = {
  input: RepDashboardInput;
};


export type QueryRepIntentEventsArgs = {
  input: RepDashboardInput;
};


export type QueryRepSequenceActivityArgs = {
  input: RepDashboardInput;
};


export type QueryRepSignalsArgs = {
  input: RepDashboardInput;
};


export type QueryRepWebActivityArgs = {
  input: RepDashboardInput;
};


export type QueryReportViewsArgs = {
  input: GetReportViewsInput;
};


export type QueryResponseOptionReportingInstancesArgs = {
  input: ResponseOptionReportingInstanceInput;
};


export type QueryRichTextDocumentCommentThreadsArgs = {
  richTextDocumentId: Scalars['UUID']['input'];
};


export type QueryRoleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRoleGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryRoleGroupsArgs = {
  input?: InputMaybe<RoleGroupsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryRolesArgs = {
  input?: InputMaybe<RolesInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryScormCourseInstanceArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryScormUploadArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryScheduledUserInvitesArgs = {
  input: ScheduledUserInvitesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySearchChatContentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  query: Scalars['String']['input'];
};


export type QuerySearchPexelsPhotosArgs = {
  orientation?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchText: Scalars['String']['input'];
};


export type QuerySearchPexelsVideosArgs = {
  orientation?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchText: Scalars['String']['input'];
};


export type QuerySearchUnsplashImagesArgs = {
  orientation?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchText: Scalars['String']['input'];
};


export type QuerySignupCodeArgs = {
  code: Scalars['String']['input'];
};


export type QuerySkillInstanceArgs = {
  id: Scalars['String']['input'];
};


export type QuerySkillInstancesArgs = {
  input: SkillInstancesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySkillsArgs = {
  input: SkillsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySubmittedRequestArgs = {
  id: Scalars['String']['input'];
};


export type QuerySubmittedRequestsListArgs = {
  input?: InputMaybe<SubmittedRequestsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySuggestedQuestionsArgs = {
  input?: InputMaybe<SuggestedQuestionsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryTagsArgs = {
  input?: InputMaybe<TagsInput>;
};


export type QueryTaskArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryTaskCommentMentionableUsersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['UUID']['input'];
};


export type QueryTaskScheduleCompletionPercentsArgs = {
  input?: InputMaybe<TaskScheduleCompletionPercentsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryTasksArgs = {
  input: TasksInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryTopTaskListsBySubmissionArgs = {
  input: TopTaskListsBySubmissionInput;
};


export type QueryTopTrainingsByAssignmentArgs = {
  input: TopTrainingsByAssignmentInput;
};


export type QueryTraineeLeaderboardArgs = {
  input: TraineeLeaderboardInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryTraineeLibraryArgs = {
  input: TraineeLibraryInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryTrainingResourceArgs = {
  id: Scalars['String']['input'];
};


export type QueryTrainingResourceViewsArgs = {
  locationGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  roleGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  trainingResourceId: Scalars['UUID']['input'];
};


export type QueryTrainingSessionsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['Int']['input'];
};


export type QueryTranslationSetArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryUserActionPermissionsArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryUserActivityArgs = {
  input?: InputMaybe<UserActivityInput>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserAuditItemsArgs = {
  input: UserAuditItemsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryVerificationStepInstancesArgs = {
  input: VerificationStepInstancesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryWorkflowArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryWorkflowInstanceArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryWorkflowInstancesArgs = {
  input: WorkflowInstancesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryWorkflowsArgs = {
  input?: InputMaybe<WorkflowsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetGoogleBusinessAccountsArgs = {
  oauthId: Scalars['UUID']['input'];
};

export type ReassignmentCohortDetails = {
  __typename?: 'ReassignmentCohortDetails';
  reassignmentDate: Scalars['DateTime']['output'];
  users: Array<Employee>;
};

export type RecentActivityItem = {
  __typename?: 'RecentActivityItem';
  datetime: Scalars['DateTime']['output'];
  libraryItem: LibraryItem;
  type: RecentActivityItemType;
  user: Employee;
};

export enum RecentActivityItemType {
  Completed = 'COMPLETED',
  Started = 'STARTED'
}

export type RecentlyAssignedLibraryItem = {
  __typename?: 'RecentlyAssignedLibraryItem';
  id: Scalars['UUID']['output'];
  libraryItem: LibraryItem;
  numAssignedSince: Scalars['Int']['output'];
  numAssignedTotal: Scalars['Int']['output'];
  numCompletedTotal: Scalars['Int']['output'];
};

export type RecentlyAssignedLibraryItemsInput = {
  since: DateTimeValue;
};

export type RecoachRunWithTemplateInput = {
  runId: Scalars['UUID']['input'];
  templateId: Scalars['UUID']['input'];
};

export type RegionFilters = {
  __typename?: 'RegionFilters';
  regions: Array<LocationGroup>;
};

export type RemediationInstance = {
  __typename?: 'RemediationInstance';
  assignee: Employee;
  assigneeDueDate: Scalars['Date']['output'];
  assigneeStartedAt?: Maybe<Scalars['DateTime']['output']>;
  assigneeSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  auditor: Employee;
  auditorCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  auditorMedias: Array<Media>;
  auditorNotes?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  cycleNumber: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  skillInstance: SkillInstance;
  status: RemediationInstanceStatus;
  steps: Array<RemediationStepInstance>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RemediationInstanceBuilderActionInput = {
  addMediaAction?: InputMaybe<AddMediaActionInput>;
  remediationInstanceId: Scalars['UUID']['input'];
  remediationStepId?: InputMaybe<Scalars['UUID']['input']>;
  removeAllMediaAction?: InputMaybe<RemoveAllRemediationMediaActionInput>;
  setResponseTextAction?: InputMaybe<SetRemediationResponseTextActionInput>;
  submitAction?: InputMaybe<SubmitRemediationActionInput>;
};

export type RemediationInstanceMutationResult = MutationResult & {
  __typename?: 'RemediationInstanceMutationResult';
  error?: Maybe<Error>;
  remediationInstance?: Maybe<RemediationInstance>;
  success: Scalars['Boolean']['output'];
};

export enum RemediationInstanceStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Submitted = 'SUBMITTED'
}

export type RemediationStepInstance = {
  __typename?: 'RemediationStepInstance';
  auditedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  reApproved?: Maybe<Scalars['Boolean']['output']>;
  remediationInstance: RemediationInstance;
  remediationResponseMedias: Array<Media>;
  remediationResponseText?: Maybe<Scalars['String']['output']>;
  sourceRemediationStepInstance?: Maybe<RemediationStepInstance>;
  sourceVerificationStepInstance?: Maybe<VerificationStepInstance>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RemediationStepInstanceMutationResult = MutationResult & {
  __typename?: 'RemediationStepInstanceMutationResult';
  error?: Maybe<Error>;
  remediationStepInstance?: Maybe<RemediationStepInstance>;
  success: Scalars['Boolean']['output'];
};

export type RemoteHrisSftpCsv = {
  __typename?: 'RemoteHrisSftpCsv';
  csvContent: Array<Scalars['JSON']['output']>;
  fileName: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  uploadedAt: Scalars['DateTime']['output'];
};

export type RemoteSftpCsvFileMetadata = {
  __typename?: 'RemoteSftpCsvFileMetadata';
  fileName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  uploadedAt: Scalars['DateTime']['output'];
};

export type RemoveAllRemediationMediaActionInput = {
  removeAll: Scalars['Boolean']['input'];
};

export type RemoveAssignmentsInput = {
  assignmentIds: Array<Scalars['UUID']['input']>;
};

export type RemoveConditionalStepGroupActionInput = {
  conditionalStepGroupId: Scalars['UUID']['input'];
  deleteDescendantSteps?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveEmployeeResult = MutationResult & {
  __typename?: 'RemoveEmployeeResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type RemoveExternalComplianceAttemptsInput = {
  complianceRecordIds: Array<Scalars['UUID']['input']>;
};

export type RemoveLessonActionInput = {
  lessonUuid: Scalars['UUID']['input'];
};

export type RemoveLibraryAccessInput = {
  assignmentIds: Array<Scalars['UUID']['input']>;
};

export type RemoveMcOptionActionInput = {
  option: McOption;
  promptUuid: Scalars['UUID']['input'];
};

export type RemoveMediaActionInput = {
  mediaId: Scalars['Int']['input'];
};

export type RemoveModuleContentMembershipActionInput = {
  moduleContentMembershipUuid: Scalars['UUID']['input'];
};

export type RemovePromptActionInput = {
  promptUuid: Scalars['UUID']['input'];
};

export type RemoveResponseOptionActionInput = {
  promptUuid: Scalars['UUID']['input'];
  responseOptionId: Scalars['UUID']['input'];
};

export type RemoveStepActionInput = {
  id: Scalars['UUID']['input'];
};

export type RemoveStepResponseOptionActionInput = {
  stepResponseOptionId: Scalars['UUID']['input'];
};

export type RemoveStepResponseOptionInstanceActionInput = {
  stepResponseOptionId: Scalars['UUID']['input'];
};

export type RemoveTranslationSetOverridesActionInput = {
  language: Scalars['Language']['input'];
  translationSetUuids: Array<RemoveTranslationSetOverridesActionTranslationSetUuidInput>;
};

export type RemoveTranslationSetOverridesActionTranslationSetUuidInput = {
  translationSetUuid: Scalars['UUID']['input'];
};

export type RemoveUserSharingPermissionInput = {
  courseId?: InputMaybe<Scalars['Int']['input']>;
  moduleId?: InputMaybe<Scalars['Int']['input']>;
  skillId?: InputMaybe<Scalars['Int']['input']>;
  trainingResourceId?: InputMaybe<Scalars['UUID']['input']>;
  userId: Scalars['Int']['input'];
};

export type RenameOpusAgentChatResult = MutationResult & {
  __typename?: 'RenameOpusAgentChatResult';
  chat?: Maybe<OpusAgentChat>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type RepAccountsByProspectStatus = {
  __typename?: 'RepAccountsByProspectStatus';
  groups: Array<GroupedCount>;
  total: Scalars['Int']['output'];
};

export type RepDashboardInput = {
  crmUserId: Scalars['UUID']['input'];
  dealType?: InputMaybe<Scalars['String']['input']>;
};

export type RepDashboardSummary = {
  __typename?: 'RepDashboardSummary';
  inboundsLast90Days: Scalars['Int']['output'];
  pastDueOutreachTasks: Scalars['Int']['output'];
  wtdCalls: Scalars['Int']['output'];
  wtdEmails: Scalars['Int']['output'];
  wtdMeetings: Scalars['Int']['output'];
};

export type RepDealsByStage = {
  __typename?: 'RepDealsByStage';
  groups: Array<GroupedCount>;
  totalActive: Scalars['Int']['output'];
};

export type RepIntentEvents = {
  __typename?: 'RepIntentEvents';
  events: Array<IntentEvent>;
  totalCount: Scalars['Int']['output'];
};

export type RepSequenceActivity = {
  __typename?: 'RepSequenceActivity';
  weeks: Array<WeeklySequenceActivity>;
};

export type RepSignals = {
  __typename?: 'RepSignals';
  accounts: Array<SignalAccount>;
  totalSignals: Scalars['Int']['output'];
};

export type RepWebActivity = {
  __typename?: 'RepWebActivity';
  daily: Array<WebActivity>;
  totalClicks: Scalars['Int']['output'];
  totalVisits: Scalars['Int']['output'];
};

export type ReplaceOnCompletionAssignmentRuleSetsInput = {
  rules: Array<OnCompletionAssignmentRuleInput>;
};

export type ReplaceOnCompletionAssignmentRuleSetsMutationResult = MutationResult & {
  __typename?: 'ReplaceOnCompletionAssignmentRuleSetsMutationResult';
  error?: Maybe<Error>;
  ruleSets: Array<OnCompletionAssignmentRuleSet>;
  success: Scalars['Boolean']['output'];
};

export enum ReportDestinationChannel {
  GoogleDrive = 'GOOGLE_DRIVE',
  S3 = 'S3',
  Sftp = 'SFTP'
}

export type ReportField = {
  __typename?: 'ReportField';
  disableFiltering: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  index: Scalars['Int']['output'];
  type: FieldType;
};

export type ReportFilter = {
  __typename?: 'ReportFilter';
  id: Scalars['UUID']['output'];
  operator: Operator;
  reportField: ReportField;
  value: ReportFilterValue;
};

export type ReportFilterInput = {
  fieldId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
  operator: Operator;
  value: ReportFilterValueInput;
};

export type ReportFilterLocationInput = {
  locationGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ReportFilterRegionInput = {
  regionIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type ReportFilterRoleInput = {
  roleIds: Array<Scalars['Int']['input']>;
};

export type ReportFilterValue = {
  __typename?: 'ReportFilterValue';
  listInput?: Maybe<Array<Scalars['String']['output']>>;
  locationFilters?: Maybe<LocationFilters>;
  regionFilters?: Maybe<RegionFilters>;
  roleFilters?: Maybe<RoleFilters>;
  stringInput?: Maybe<Scalars['String']['output']>;
};

export type ReportFilterValueInput = {
  listInput?: InputMaybe<Array<Scalars['String']['input']>>;
  locationInput?: InputMaybe<ReportFilterLocationInput>;
  regionInput?: InputMaybe<ReportFilterRegionInput>;
  roleInput?: InputMaybe<ReportFilterRoleInput>;
  stringInput?: InputMaybe<Scalars['String']['input']>;
};

export type ReportInput = {
  fieldIds: Array<Scalars['UUID']['input']>;
  filters: Array<ReportFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['UUID']['input']>;
  topicId: Scalars['UUID']['input'];
};

export type ReportMutationResult = {
  __typename?: 'ReportMutationResult';
  objects: Array<Scalars['JSON']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type ReportTopic = {
  __typename?: 'ReportTopic';
  displayName: Scalars['String']['output'];
  fields: Array<ReportField>;
  id: Scalars['UUID']['output'];
};

export type ReportView = {
  __typename?: 'ReportView';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  params: Scalars['JSON']['output'];
  reportViewType: ReportViewType;
};

export type ReportViewInput = {
  name: Scalars['String']['input'];
  params: Scalars['JSON']['input'];
  reportViewType: ReportViewType;
};

export type ReportViewMutationResult = MutationResult & {
  __typename?: 'ReportViewMutationResult';
  error?: Maybe<Error>;
  reportView?: Maybe<ReportView>;
  success: Scalars['Boolean']['output'];
};

export enum ReportViewType {
  LocationCompletionGrid = 'LOCATION_COMPLETION_GRID',
  MessageReadsGrid = 'MESSAGE_READS_GRID',
  MostRecentAuditCompletionGrid = 'MOST_RECENT_AUDIT_COMPLETION_GRID',
  TaskCompletionGrid = 'TASK_COMPLETION_GRID',
  UserCompletionGrid = 'USER_COMPLETION_GRID'
}

export type ReportViewTypeValueInput = {
  value: ReportViewType;
};

export type ReportedContent = {
  __typename?: 'ReportedContent';
  chatMessage?: Maybe<ChatMessage>;
  /** @deprecated Reports cover the whole chat message; always null. Use chatMessage */
  chatMessageAttachment?: Maybe<ChatMessageAttachment>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  postComment?: Maybe<PostComment>;
  reportedBy: Employee;
  restoredAt?: Maybe<Scalars['DateTime']['output']>;
  restoredBy?: Maybe<Employee>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReportedContentMutationResult = MutationResult & {
  __typename?: 'ReportedContentMutationResult';
  error?: Maybe<Error>;
  reportedContent?: Maybe<ReportedContent>;
  success: Scalars['Boolean']['output'];
};

export type ReportingTargetSet = {
  __typename?: 'ReportingTargetSet';
  assignmentCompletionRate: Scalars['Int']['output'];
  assignmentPastDueRate: Scalars['Int']['output'];
  collectEmployeeCountFromManagers: Scalars['Boolean']['output'];
  courseAccuracy?: Maybe<Scalars['Int']['output']>;
  courseFeedback?: Maybe<Scalars['Float']['output']>;
  id: Scalars['UUID']['output'];
  managerEngagementRate: Scalars['Int']['output'];
  newHireOnboardingDays: Scalars['Int']['output'];
  onboardingRate: Scalars['Int']['output'];
  taskListCompletionRate: Scalars['Int']['output'];
  traineeEngagementRate: Scalars['Int']['output'];
};

export type ReportingTargetSetMutationResult = MutationResult & {
  __typename?: 'ReportingTargetSetMutationResult';
  error?: Maybe<Error>;
  reportingTargetSet?: Maybe<ReportingTargetSet>;
  success: Scalars['Boolean']['output'];
};

export type ResolveAiRequestInput = {
  accepted: Scalars['Boolean']['input'];
  aiRequestId: Scalars['UUID']['input'];
  regenerateMessage?: InputMaybe<Scalars['String']['input']>;
};

export type ResponseOption = {
  __typename?: 'ResponseOption';
  answer: TranslationSet;
  id: Scalars['UUID']['output'];
  index: Scalars['Float']['output'];
  isCorrect: Scalars['Boolean']['output'];
  matchItem?: Maybe<MatchItem>;
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['Int']['output']>;
  prompt: Prompt;
};

export type ResponseOptionInstance = {
  __typename?: 'ResponseOptionInstance';
  id: Scalars['UUID']['output'];
  matchItemId?: Maybe<Scalars['UUID']['output']>;
  responseOption: ResponseOption;
  responseOptionId: Scalars['UUID']['output'];
};

export type ResponseOptionObjectInput = {
  answer: TranslationSetObjectInput;
  id: Scalars['UUID']['input'];
  isCorrect: Scalars['Boolean']['input'];
  matchItem?: InputMaybe<MatchItemObjectInput>;
  mediaId?: InputMaybe<Scalars['Int']['input']>;
};

export type ResponseOptionReportingInstance = {
  __typename?: 'ResponseOptionReportingInstance';
  id: Scalars['String']['output'];
  isCorrectOption: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  media?: Maybe<Media>;
  percentOfTraineesSelectedOption: Scalars['Float']['output'];
};

export type ResponseOptionReportingInstanceInput = {
  promptUuid?: InputMaybe<Scalars['UUID']['input']>;
  verificationStepId?: InputMaybe<Scalars['UUID']['input']>;
};

export type RestoreReportedContentInput = {
  id: Scalars['UUID']['input'];
};

export type ResyncHrisIntegrationInput = {
  hrisIntegrationId: Scalars['UUID']['input'];
};

export type ResyncHrisIntegrationMutationResult = MutationResult & {
  __typename?: 'ResyncHrisIntegrationMutationResult';
  error?: Maybe<Error>;
  hrisIntegration?: Maybe<HrisIntegration>;
  success: Scalars['Boolean']['output'];
};

export type RichTextDocument = {
  __typename?: 'RichTextDocument';
  content: TranslationSet;
  id: Scalars['UUID']['output'];
  trainingResourceVersion?: Maybe<TrainingResourceVersion>;
};

export type Role = {
  __typename?: 'Role';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Employee>;
  directReports: Array<Role>;
  employees: Array<Employee>;
  id: Scalars['Int']['output'];
  lastUpdatedBy?: Maybe<Employee>;
  name: Scalars['String']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  org: Org;
  reportsTo: Array<Role>;
  roleActionPermissions?: Maybe<RoleActionPermissions>;
  roleGroupMemberships: Array<RoleGroupMembership>;
  roleLevel?: Maybe<Scalars['Int']['output']>;
  roleLevelV2?: Maybe<Scalars['Int']['output']>;
  userCount: Scalars['Int']['output'];
};


export type RoleUserCountArgs = {
  roleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RoleActionPermissions = {
  __typename?: 'RoleActionPermissions';
  actionPermissions: ActionPermissionSet;
  id: Scalars['UUID']['output'];
  requireClockInConfirmation: Scalars['Boolean']['output'];
  role: Role;
  roleUserType: UserType;
};

export type RoleFilters = {
  __typename?: 'RoleFilters';
  roles: Array<Role>;
};

export type RoleGroup = {
  __typename?: 'RoleGroup';
  childRoleGroups: Array<RoleGroup>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  parentRoleGroup?: Maybe<RoleGroup>;
  roleCount: Scalars['Int']['output'];
  roleMemberships: Array<RoleGroupMembership>;
  userCount: Scalars['Int']['output'];
};

export type RoleGroupInput = {
  childRoleGroupIds?: Array<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  parentRoleGroupId?: InputMaybe<Scalars['UUID']['input']>;
  roleIds: Array<Scalars['Int']['input']>;
};

export type RoleGroupMembership = {
  __typename?: 'RoleGroupMembership';
  id: Scalars['UUID']['output'];
  role: Role;
  roleGroup: RoleGroup;
};

export type RoleGroupMutationResult = MutationResult & {
  __typename?: 'RoleGroupMutationResult';
  error?: Maybe<Error>;
  roleGroup?: Maybe<RoleGroup>;
  success: Scalars['Boolean']['output'];
};

export type RoleGroups = PaginatedList & {
  __typename?: 'RoleGroups';
  objects: Array<RoleGroup>;
  totalCount: Scalars['Int']['output'];
};

export type RoleGroupsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  openedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  roleGroupsChildOf?: InputMaybe<Array<Scalars['UUID']['input']>>;
  roleGroupsDirectChildOf?: InputMaybe<Array<Scalars['UUID']['input']>>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type RoleLevelInput = {
  level: Scalars['Int']['input'];
  roleId: Scalars['Int']['input'];
};

export type RoleMutationResult = MutationResult & {
  __typename?: 'RoleMutationResult';
  error?: Maybe<Error>;
  role?: Maybe<Role>;
  success: Scalars['Boolean']['output'];
};

export type Roles = PaginatedList & {
  __typename?: 'Roles';
  objects: Array<Role>;
  totalCount: Scalars['Int']['output'];
};

export type RolesInput = {
  hasHrisLink?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  openedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  roleGroupsChildOf?: InputMaybe<Array<Scalars['UUID']['input']>>;
  roleGroupsDirectChildOf?: InputMaybe<Array<Scalars['UUID']['input']>>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type RolesMutationResult = MutationResult & {
  __typename?: 'RolesMutationResult';
  error?: Maybe<Error>;
  roles?: Maybe<Array<Role>>;
  success: Scalars['Boolean']['output'];
};

export type ScormCourse = {
  __typename?: 'SCORMCourse';
  assignedCount: Scalars['Int']['output'];
  draftVersion: ScormCourseVersion;
  id: Scalars['UUID']['output'];
  lastPublishedBy?: Maybe<Employee>;
  libraryItem: LibraryItem;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedVersion?: Maybe<ScormCourseVersion>;
  scormCourseVersions: Array<ScormCourseVersion>;
};

export type ScormCourseInstance = {
  __typename?: 'SCORMCourseInstance';
  assignment: Assignment;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['UUID']['output'];
  markedCompletedBy?: Maybe<Employee>;
  markedCompletedReason?: Maybe<Scalars['String']['output']>;
  scormCloudLaunchLink?: Maybe<Scalars['String']['output']>;
  scormCloudRegistrationId?: Maybe<Scalars['String']['output']>;
  scormCourseVersion: ScormCourseVersion;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  user: Employee;
};

export type ScormCourseInstanceMutationResult = MutationResult & {
  __typename?: 'SCORMCourseInstanceMutationResult';
  error?: Maybe<Error>;
  scormCourseInstance?: Maybe<ScormCourseInstance>;
  success: Scalars['Boolean']['output'];
};

export type ScormCourseLaunchLinkMutationResult = MutationResult & {
  __typename?: 'SCORMCourseLaunchLinkMutationResult';
  error?: Maybe<Error>;
  launchLink?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ScormCourseMutationResult = MutationResult & {
  __typename?: 'SCORMCourseMutationResult';
  error?: Maybe<Error>;
  scormCourse?: Maybe<ScormCourse>;
  success: Scalars['Boolean']['output'];
};

export type ScormCourseVersion = {
  __typename?: 'SCORMCourseVersion';
  createdAt: Scalars['DateTime']['output'];
  externalSCORMCloudCourse?: Maybe<ExternalScormCloudCourse>;
  id: Scalars['UUID']['output'];
  metadata: VersionMetadata;
  scormCourse?: Maybe<ScormCourse>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ScormPackageConversionMutationResult = MutationResult & {
  __typename?: 'SCORMPackageConversionMutationResult';
  error?: Maybe<Error>;
  scormUpload?: Maybe<ScormUpload>;
  success: Scalars['Boolean']['output'];
};

export type ScormPackageUploadDataMutationResult = MutationResult & {
  __typename?: 'SCORMPackageUploadDataMutationResult';
  data?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type ScormUpload = {
  __typename?: 'SCORMUpload';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Employee>;
  id: Scalars['UUID']['output'];
  moduleVersion?: Maybe<ModuleVersion>;
  trainingResourceVersion?: Maybe<TrainingResourceVersion>;
};

export type SaveContractDiscountInput = {
  appliesTo: ContractDiscountBasis;
  description: Scalars['String']['input'];
  kind: ContractDiscountKind;
  phaseOrder?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['Float']['input'];
};

export type SaveContractInput = {
  annualIncreaseAppliesTo?: InputMaybe<ContractDiscountBasis>;
  annualIncreasePercent?: InputMaybe<Scalars['Float']['input']>;
  billingCadence?: InputMaybe<ContractBillingCadence>;
  contractId: Scalars['String']['input'];
  customer: Scalars['String']['input'];
  dealId: Scalars['UUID']['input'];
  discounts: Array<SaveContractDiscountInput>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  extractionNotes: Scalars['String']['input'];
  hasOptInPilotTerm: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  isAddendum: Scalars['Boolean']['input'];
  lineItems: Array<SaveContractLineItemInput>;
  marketingTerms: Array<SaveContractMarketingTermInput>;
  payments: Array<SaveContractPaymentInput>;
  phases: Array<SaveContractPhaseInput>;
  planTier?: InputMaybe<ContractPlanTier>;
  primaryContractId?: InputMaybe<Scalars['UUID']['input']>;
  renewalIncreaseCapPercent?: InputMaybe<Scalars['Float']['input']>;
  renewalNoticeDays?: InputMaybe<Scalars['Int']['input']>;
  renewalTermsNote: Scalars['String']['input'];
  salesRep: Scalars['String']['input'];
  satisfactionGuaranteeDays?: InputMaybe<Scalars['Int']['input']>;
  satisfactionGuaranteeNote: Scalars['String']['input'];
  statedTotal?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<ContractStatus>;
  termMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveContractLineItemInput = {
  category: ContractLineCategory;
  datesOverridden: Scalars['Boolean']['input'];
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  feeTreatment: ContractFeeTreatment;
  listRate?: InputMaybe<Scalars['Float']['input']>;
  netRate: Scalars['Float']['input'];
  notes: Scalars['String']['input'];
  origin: ContractLineOrigin;
  phaseOrder?: InputMaybe<Scalars['Int']['input']>;
  product: Scalars['String']['input'];
  qty: Scalars['Float']['input'];
  serviceEnd?: InputMaybe<Scalars['Date']['input']>;
  serviceStart?: InputMaybe<Scalars['Date']['input']>;
  unitType: ContractUnitType;
};

export type SaveContractMarketingTermInput = {
  conditionsDiscount: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  kind: ContractMarketingTermKind;
  order: Scalars['Int']['input'];
};

export type SaveContractPaymentInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  note: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type SaveContractPhaseInput = {
  description: Scalars['String']['input'];
  discountNote: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  durationUnit?: InputMaybe<ContractDurationUnit>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  increasePercent?: InputMaybe<Scalars['Float']['input']>;
  kind: ContractPhaseKind;
  openEnded: Scalars['Boolean']['input'];
  order: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type SaveReportInput = {
  id: Scalars['UUID']['input'];
  reportInput: ReportInput;
  title: Scalars['String']['input'];
};

export type SavedReportMutationResult = MutationResult & {
  __typename?: 'SavedReportMutationResult';
  error?: Maybe<Error>;
  savedReport?: Maybe<CustomReport>;
  success: Scalars['Boolean']['output'];
};

export type Schedule = {
  __typename?: 'Schedule';
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  rrule: Scalars['RRuleNaive']['output'];
  scheduleSet: ScheduleSet;
};

export type ScheduleInput = {
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  rrule: Scalars['RRule']['input'];
};

export type ScheduleSet = {
  __typename?: 'ScheduleSet';
  id: Scalars['UUID']['output'];
  schedules: Array<Schedule>;
};

export type ScheduleSetInput = {
  schedules: Array<ScheduleInput>;
};

export type ScheduledReport = {
  __typename?: 'ScheduledReport';
  recipients: Array<ScheduledReportRecipient>;
  sendAt: Scalars['Time']['output'];
  sendOn: Scalars['String']['output'];
};

export type ScheduledReportInput = {
  recipientEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientIds: Array<InputMaybe<Scalars['Int']['input']>>;
  reportId: Scalars['UUID']['input'];
  sendAt: Scalars['Time']['input'];
  sendOn: DayOfTheWeek;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReportRecipient = {
  __typename?: 'ScheduledReportRecipient';
  /** Set when the recipient is an arbitrary email address. Null for user recipients. */
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** Set when the recipient is a user in the org. Null for external email recipients. */
  user?: Maybe<Employee>;
};

export type ScheduledUserInvite = {
  __typename?: 'ScheduledUserInvite';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Employee>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  inviteUserAt: Scalars['DateTime']['output'];
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  invitedUser?: Maybe<Employee>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  locationMemberships: Array<ScheduledUserInviteLocationMembership>;
  org?: Maybe<Org>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  roleMemberships: Array<ScheduledUserInviteRoleMembership>;
  status: ScheduledUserInviteStatus;
  userType: UserType;
};

export type ScheduledUserInviteImportPreview = {
  __typename?: 'ScheduledUserInviteImportPreview';
  clean: Array<ScheduledUserInvitePreviewRow>;
  csvErrors: Array<CsvSchemaError>;
  duplicateEmailInCsv: Array<ScheduledUserInvitePreviewRow>;
  duplicatePhoneInCsv: Array<ScheduledUserInvitePreviewRow>;
  emailAlreadyScheduled: Array<ScheduledUserInvitePreviewRow>;
  emailAlreadyUser: Array<ScheduledUserInvitePreviewRow>;
  identityConflict: Array<ScheduledUserInvitePreviewRow>;
  locationNotFound: Array<ScheduledUserInvitePreviewRow>;
  phoneAlreadyScheduled: Array<ScheduledUserInvitePreviewRow>;
  phoneAlreadyUser: Array<ScheduledUserInvitePreviewRow>;
  roleNotFound: Array<ScheduledUserInvitePreviewRow>;
  willReactivate: Array<ScheduledUserInvitePreviewRow>;
};

export type ScheduledUserInviteLocationMembership = {
  __typename?: 'ScheduledUserInviteLocationMembership';
  id: Scalars['UUID']['output'];
  location: Location;
};

export type ScheduledUserInvitePreviewRow = {
  __typename?: 'ScheduledUserInvitePreviewRow';
  email: Scalars['String']['output'];
  existingUser?: Maybe<Employee>;
  name: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  unknownNames: Array<Scalars['String']['output']>;
};

export type ScheduledUserInviteRoleMembership = {
  __typename?: 'ScheduledUserInviteRoleMembership';
  id: Scalars['UUID']['output'];
  role: Role;
};

export enum ScheduledUserInviteStatus {
  Invited = 'INVITED',
  Scheduled = 'SCHEDULED'
}

export type ScheduledUserInvites = PaginatedList & {
  __typename?: 'ScheduledUserInvites';
  objects: Array<ScheduledUserInvite>;
  totalCount: Scalars['Int']['output'];
};

export type ScheduledUserInvitesFiltersInput = {
  statuses?: InputMaybe<Array<ScheduledUserInviteStatus>>;
  userTypes?: InputMaybe<Array<UserType>>;
};

export type ScheduledUserInvitesInput = {
  filters?: InputMaybe<ScheduledUserInvitesFiltersInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type ScopeActor = {
  __typename?: 'ScopeActor';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum ScormValidationErrorType {
  InvalidArticulateExport = 'INVALID_ARTICULATE_EXPORT',
  InvalidZipFile = 'INVALID_ZIP_FILE'
}

export type SearchCompanyContactsResult = MutationResult & {
  __typename?: 'SearchCompanyContactsResult';
  clientFacingWorkflow?: Maybe<ClientFacingWorkflow>;
  error?: Maybe<Error>;
  queued: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type SearchDocument = {
  __typename?: 'SearchDocument';
  content: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  language: Scalars['Language']['output'];
  libraryItem?: Maybe<LibraryItem>;
  media?: Maybe<Media>;
};

export type SearchDocumentMutationResult = MutationResult & {
  __typename?: 'SearchDocumentMutationResult';
  error?: Maybe<Error>;
  searchDocument?: Maybe<SearchDocument>;
  success: Scalars['Boolean']['output'];
};

export type SearchUnsplashMutationResult = MutationResult & {
  __typename?: 'SearchUnsplashMutationResult';
  error?: Maybe<Error>;
  images: Array<UnsplashImage>;
  success: Scalars['Boolean']['output'];
};

export type SectionBreak = {
  __typename?: 'SectionBreak';
  id: Scalars['Int']['output'];
  lockBetweenSectionDays: Scalars['Int']['output'];
  title: TranslationSet;
  uuid: Scalars['UUID']['output'];
};

export type SectionBreakInput = {
  title: TranslationSetObjectInput;
  uuid: Scalars['UUID']['input'];
};

export type SectionBreakInstance = {
  __typename?: 'SectionBreakInstance';
  id: Scalars['UUID']['output'];
  sectionBreak: SectionBreak;
};

export type SectionGrade = {
  __typename?: 'SectionGrade';
  actionItems: Array<GradeActionItem>;
  courseVersionGrade: CourseVersionGrade;
  feedback: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  maxScore: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  subsections: Array<SubsectionGrade>;
};

export type SendAgentMessageInput = {
  customerProblemId?: InputMaybe<Scalars['String']['input']>;
  killFirst?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  sessionId: Scalars['UUID']['input'];
};

export type SendAgentMessageResult = {
  __typename?: 'SendAgentMessageResult';
  command?: Maybe<AgentCommandGql>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type SendChatMessageInput = {
  attachments?: InputMaybe<Array<ChatMessageAttachmentInput>>;
  chatId: Scalars['UUID']['input'];
  text: Scalars['String']['input'];
};

export type SendOpusAgentMessageInput = {
  chatId?: InputMaybe<Scalars['UUID']['input']>;
  liveContext?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  model?: InputMaybe<OpusAgentModel>;
};

export type SendOpusAgentMessageResult = MutationResult & {
  __typename?: 'SendOpusAgentMessageResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  turn?: Maybe<OpusAgentChatTurn>;
};

export type SendSeparateChatMessagesInput = {
  recipientUserIds: Array<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};

export type SeparateCompanyContactCandidateResult = MutationResult & {
  __typename?: 'SeparateCompanyContactCandidateResult';
  candidates?: Maybe<Array<CompanyContactCandidate>>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type SetActiveClientInput = {
  activeWorkflowNodeId?: InputMaybe<Scalars['UUID']['input']>;
  clientId: Scalars['UUID']['input'];
  courseVersionId?: InputMaybe<Scalars['Int']['input']>;
  moduleContentMembershipUuid?: InputMaybe<Scalars['UUID']['input']>;
  moduleVersionId?: InputMaybe<Scalars['UUID']['input']>;
  promptUuid?: InputMaybe<Scalars['UUID']['input']>;
  richTextDocumentId?: InputMaybe<Scalars['UUID']['input']>;
  skillVersionId?: InputMaybe<Scalars['UUID']['input']>;
  verificationStepId?: InputMaybe<Scalars['UUID']['input']>;
  workflowVersionId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SetAllowGradedFreeResponseTyposActionInput = {
  allowTypos: Scalars['Boolean']['input'];
  promptUuid: Scalars['UUID']['input'];
};

export type SetCheckboxAnswerActionInput = {
  checkboxAnswer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetCoachingTemplateArchivedInput = {
  archived: Scalars['Boolean']['input'];
  templateId: Scalars['UUID']['input'];
};

export type SetCourseCoverImageActionInput = {
  coverImage: CoverImageInput;
};

export type SetCourseDescriptionActionInput = {
  description: TranslationSetObjectInput;
};

export type SetCourseNameActionInput = {
  name: TranslationSetObjectInput;
};

export type SetCourseOutlineBodyTextActionInput = {
  body: Scalars['String']['input'];
  courseOutlineUuid: Scalars['UUID']['input'];
};

export type SetCourseOutlineTitleTextActionInput = {
  courseOutlineUuid: Scalars['UUID']['input'];
  title: Scalars['String']['input'];
};

export type SetCourseSettingsActionInput = {
  adminAccess: SharingPermission;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDateDays?: InputMaybe<Scalars['Int']['input']>;
  enableCertificate: Scalars['Boolean']['input'];
  enablePromptRetries: Scalars['Boolean']['input'];
  excludeFromKnowledgeCheck?: InputMaybe<Scalars['Boolean']['input']>;
  managerAccess: SharingPermission;
  passingAccuracyThreshold?: InputMaybe<Scalars['Int']['input']>;
};

export type SetDealScopeReadyInput = {
  dealId: Scalars['UUID']['input'];
  ready: Scalars['Boolean']['input'];
};

export type SetDealScopeReadyResult = MutationResult & {
  __typename?: 'SetDealScopeReadyResult';
  card?: Maybe<DealScopeCard>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type SetFollowUpTaskDraftConfigActionInput = {
  approvalRequired?: InputMaybe<BooleanValue>;
  assigneeId?: InputMaybe<OptionalIntValue>;
  dueDate?: InputMaybe<OptionalDateValue>;
  notes?: InputMaybe<OptionalStringValue>;
  proofOfCompletionRequirement?: InputMaybe<OptionalTaskProofOfCompletionRequirementValue>;
  title?: InputMaybe<StringValue>;
};

export type SetGoogleDriveReportDestinationInput = {
  folderId: Scalars['String']['input'];
  gcpCredentialsJson: Scalars['String']['input'];
};

export type SetGradedFreeResponseCorrectAnswerActionInput = {
  lang?: InputMaybe<Scalars['Language']['input']>;
  promptUuid: Scalars['UUID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  translationSet: TranslationSetObjectInput;
};

export type SetLessonNameActionInput = {
  lessonUuid: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type SetMcCorrectOptionActionInput = {
  correctMcOption: McOption;
  promptUuid: Scalars['UUID']['input'];
};

export type SetMcOptionActionInput = {
  lang?: InputMaybe<Scalars['Language']['input']>;
  option: McOption;
  promptUuid: Scalars['UUID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  translationSet?: InputMaybe<TranslationSetObjectInput>;
};

export type SetModuleContentMembershipRequireFullVideoPlaybackActionInput = {
  moduleContentMembershipUuid: Scalars['UUID']['input'];
  requireFullVideoPlayback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetModuleCoverImageActionInput = {
  coverImage: CoverImageInput;
};

export type SetModuleDescriptionActionInput = {
  description: TranslationSetObjectInput;
};

export type SetModuleNameActionInput = {
  name: TranslationSetObjectInput;
};

export type SetModuleSettingsActionInput = {
  adminAccess: SharingPermission;
  completeInOrder?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDateDays?: InputMaybe<Scalars['Int']['input']>;
  enableCertificate?: InputMaybe<BooleanValue>;
  managerAccess: SharingPermission;
};

export type SetModuleVersionSettingsActionInput = {
  completeInOrder: CompleteModuleInOrder;
};

export type SetNotesActionInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type SetNumberAnswerActionInput = {
  numberAnswer?: InputMaybe<Scalars['Float']['input']>;
};

export type SetPostCommentsEnabledInput = {
  enabled: Scalars['Boolean']['input'];
  messageBlastId: Scalars['Int']['input'];
};

export type SetPromptAssignMediaActionInput = {
  assignMedia: Scalars['Boolean']['input'];
  promptUuid: Scalars['UUID']['input'];
};

export type SetPromptImageOnlyMatchItemsActionInput = {
  imageOnlyMatchItems: Scalars['Boolean']['input'];
  promptUuid: Scalars['UUID']['input'];
};

export type SetPromptMediaActionInput = {
  libraryItemId?: InputMaybe<Scalars['UUID']['input']>;
  mediaId?: InputMaybe<Scalars['Int']['input']>;
  promptUuid: Scalars['UUID']['input'];
};

export type SetPromptRandomizeOptionOrderActionInput = {
  promptUuid: Scalars['UUID']['input'];
  randomizeOptionOrder: Scalars['Boolean']['input'];
};

export type SetPromptRequireFullVideoPlaybackActionInput = {
  promptUuid: Scalars['UUID']['input'];
  requireFullVideoPlayback: Scalars['Boolean']['input'];
};

export type SetPromptSelectAllThatApplyActionInput = {
  promptUuid: Scalars['UUID']['input'];
  selectAllThatApply: Scalars['Boolean']['input'];
};

export type SetPromptTextActionInput = {
  lang?: InputMaybe<Scalars['Language']['input']>;
  promptUuid: Scalars['UUID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  translationSet: TranslationSetObjectInput;
};

export type SetPromptTypeActionInput = {
  promptUuid: Scalars['UUID']['input'];
  type: PromptType;
};

export type SetRatingActionInput = {
  rating?: InputMaybe<Scalars['Int']['input']>;
};

export type SetRemediationResponseTextActionInput = {
  responseText?: InputMaybe<Scalars['String']['input']>;
};

export type SetResponseOptionAnswerActionInput = {
  answer: TranslationSetObjectInput;
  promptUuid: Scalars['UUID']['input'];
  responseOptionId: Scalars['UUID']['input'];
};

export type SetResponseOptionIsCorrectActionInput = {
  isCorrect: Scalars['Boolean']['input'];
  promptUuid: Scalars['UUID']['input'];
  responseOptionId: Scalars['UUID']['input'];
};

export type SetResponseOptionMatchItemActionInput = {
  matchItem: MatchItemObjectInput;
  promptUuid: Scalars['UUID']['input'];
  responseOptionId: Scalars['UUID']['input'];
};

export type SetResponseOptionMediaActionInput = {
  mediaId?: InputMaybe<Scalars['Int']['input']>;
  promptUuid: Scalars['UUID']['input'];
  responseOptionId: Scalars['UUID']['input'];
};

export type SetRichTextDocumentContentActionInput = {
  content: TranslationSetObjectInput;
  richTextDocumentId: Scalars['UUID']['input'];
};

export type SetS3ReportDestinationInput = {
  bucketName: Scalars['String']['input'];
};

export type SetSectionBreakLockBetweenSectionDaysActionInput = {
  lockBetweenSectionDays: Scalars['Int']['input'];
  sectionBreakUuid: Scalars['UUID']['input'];
};

export type SetSectionBreakTitleActionInput = {
  sectionBreakUuid: Scalars['UUID']['input'];
  title: TranslationSetObjectInput;
};

export type SetSftpReportDestinationInput = {
  folder: Scalars['String']['input'];
  password: Scalars['String']['input'];
  url: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SetSkillCoverImageActionInput = {
  coverImage?: InputMaybe<CoverImageInput>;
};

export type SetSkillDescriptionActionInput = {
  description: TranslationSetObjectInput;
};

export type SetSkillNameActionInput = {
  name: TranslationSetObjectInput;
};

export type SetSkillSettingsActionInput = {
  admin_access: SharingPermission;
  manager_access: SharingPermission;
};

export type SetSkillVersionFollowUpTaskDefaultsActionInput = {
  defaultApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  defaultDueDateOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  defaultProofOfCompletionRequirement?: InputMaybe<TaskProofOfCompletionRequirement>;
  skillVersionId: Scalars['UUID']['input'];
};

export type SetSkillVersionHeaderLibraryItemLinkActionInput = {
  libraryItemId?: InputMaybe<Scalars['UUID']['input']>;
  skillVersionId: Scalars['UUID']['input'];
};

export type SetSkillVersionHeaderMediaInput = {
  mediaId?: InputMaybe<Scalars['Int']['input']>;
  skillVersionId: Scalars['UUID']['input'];
};

export type SetSkillVersionPassingThresholdPercentageActionInput = {
  passingThresholdPercentage?: InputMaybe<Scalars['Int']['input']>;
  skillVersionId: Scalars['UUID']['input'];
};

export type SetStepDescriptionActionInput = {
  description: TranslationSetObjectInput;
  stepId: Scalars['UUID']['input'];
};

export type SetStepDisableCameraRollActionInput = {
  disableCameraRoll: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
};

export type SetStepFailedSuggestionTextActionInput = {
  id: Scalars['UUID']['input'];
  text: TranslationSetObjectInput;
};

export type SetStepIsRequiredActionInput = {
  isRequired: Scalars['Boolean']['input'];
  stepId: Scalars['UUID']['input'];
};

export type SetStepLibraryItemLinkActionInput = {
  libraryItemId?: InputMaybe<Scalars['UUID']['input']>;
  stepId: Scalars['UUID']['input'];
};

export type SetStepMediaActionInput = {
  id: Scalars['UUID']['input'];
  media: MediaInput;
};

export type SetStepMediaInput = {
  mediaId?: InputMaybe<Scalars['Int']['input']>;
  stepId: Scalars['UUID']['input'];
};

export type SetStepNoteRequiredActionInput = {
  id: Scalars['UUID']['input'];
  noteRequired: NoneOptionalOrRequired;
};

export type SetStepPhotoRequiredActionInput = {
  id: Scalars['UUID']['input'];
  photoRequired: NoneOptionalOrRequired;
};

export type SetStepResponseOptionIsCorrectActionInput = {
  isCorrect: Scalars['Boolean']['input'];
  stepResponseOptionId: Scalars['UUID']['input'];
};

export type SetStepResponseOptionPointsActionInput = {
  points: Scalars['Int']['input'];
  stepResponseOptionId: Scalars['UUID']['input'];
};

export type SetStepResponseOptionTextActionInput = {
  stepResponseOptionId: Scalars['UUID']['input'];
  text: TranslationSetObjectInput;
};

export type SetStepTemperatureUnitActionInput = {
  stepId: Scalars['UUID']['input'];
  temperatureUnit: TemperatureUnit;
};

export type SetStepTextActionInput = {
  id: Scalars['UUID']['input'];
  text: TranslationSetObjectInput;
};

export type SetStepTypeActionInput = {
  id: Scalars['UUID']['input'];
  type: VerificationStepType;
};

export type SetStepVideoRequiredActionInput = {
  id: Scalars['UUID']['input'];
  videoRequired: NoneOptionalOrRequired;
};

export type SetTemperatureAnswerActionInput = {
  temperatureAnswer?: InputMaybe<Scalars['Float']['input']>;
};

export type SetTextAnswerActionInput = {
  textAnswer?: InputMaybe<Scalars['String']['input']>;
};

export type SetTrainingResourceNameActionInput = {
  name: TranslationSetObjectInput;
};

export type SetTrainingResourceVersionTypeActionInput = {
  versionType: TrainingResourceVersionType;
};

export type SetTrueFalseCorrectOptionActionInput = {
  correctTfOption: Scalars['Boolean']['input'];
  promptUuid: Scalars['UUID']['input'];
};

export type SetVerificationStepTriggerActionInput = {
  trigger?: InputMaybe<TriggerInput>;
  verificationStepId: Scalars['UUID']['input'];
};

export type SetWorkflowActivationWindowActionInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetWorkflowNameActionInput = {
  name: Scalars['String']['input'];
};

export type SetWorkflowNodeLibraryItemActionInput = {
  libraryItemId?: InputMaybe<Scalars['UUID']['input']>;
  nodeId: Scalars['UUID']['input'];
};

export type SetWorkflowNodeTimeDelayActionInput = {
  nodeId: Scalars['UUID']['input'];
  timeDelayDays?: InputMaybe<Scalars['Int']['input']>;
};

export type SetWorkflowNodeUserSelectionSetActionInput = {
  nodeId: Scalars['UUID']['input'];
  userSelectionSet?: InputMaybe<UserSelectionSetInput>;
};

export type SetYesNoAnswerActionInput = {
  yesNoAnswer?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SharingPermission {
  Comment = 'COMMENT',
  Edit = 'EDIT',
  None = 'NONE',
  ViewInLibrary = 'VIEW_IN_LIBRARY'
}

export type SharpCatalogExperience = {
  __typename?: 'SharpCatalogExperience';
  coverImage?: Maybe<CoverImage>;
  creditCost: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type SignalAccount = {
  __typename?: 'SignalAccount';
  company: CrmCompany;
  latestSignalDate?: Maybe<Scalars['DateTime']['output']>;
  signalCount: Scalars['Int']['output'];
  signalTypes: Array<Scalars['String']['output']>;
};

export type SignupCode = {
  __typename?: 'SignupCode';
  code: Scalars['String']['output'];
  group: Location;
  id: Scalars['Int']['output'];
  signupLink: Scalars['String']['output'];
  signupQrcodeLink: Scalars['String']['output'];
};

export type Skill = {
  __typename?: 'Skill';
  aiGenerationFailed: Scalars['Boolean']['output'];
  aiGenerationInProgress: Scalars['Boolean']['output'];
  aiGenerationRequested: Scalars['Boolean']['output'];
  assignedCount: Scalars['Int']['output'];
  collaborativeCompletionEnabled?: Maybe<Scalars['Boolean']['output']>;
  draftVersion?: Maybe<SkillVersion>;
  id: Scalars['Int']['output'];
  isSelfDirected: Scalars['Boolean']['output'];
  lastBuilderActionId?: Maybe<Scalars['Int']['output']>;
  libraryItem: LibraryItem;
  moduleContentMemberships: Array<ModuleContentMembership>;
  /** @deprecated Field no longer supported */
  ongoingCheckInDelegations: Array<OngoingCheckInDelegation>;
  publishedVersion?: Maybe<SkillVersion>;
  verificationCount: Scalars['Int']['output'];
  versions: Array<SkillVersion>;
};

export type SkillBuilderActionInput = {
  addConditionalStepGroupAction?: InputMaybe<AddConditionalStepGroupActionInput>;
  addStepAction?: InputMaybe<AddStepActionInput>;
  addStepResponseOptionAction?: InputMaybe<AddStepResponseOptionActionInput>;
  moveStepAction?: InputMaybe<MoveStepActionInput>;
  moveStepResponseOptionAction?: InputMaybe<MoveStepResponseOptionActionInput>;
  removeConditionalStepGroupAction?: InputMaybe<RemoveConditionalStepGroupActionInput>;
  removeStepAction?: InputMaybe<RemoveStepActionInput>;
  removeStepResponseOptionAction?: InputMaybe<RemoveStepResponseOptionActionInput>;
  setSkillCoverImageAction?: InputMaybe<SetSkillCoverImageActionInput>;
  setSkillDescriptionAction?: InputMaybe<SetSkillDescriptionActionInput>;
  setSkillNameAction?: InputMaybe<SetSkillNameActionInput>;
  setSkillSettingsAction?: InputMaybe<SetSkillSettingsActionInput>;
  setSkillVersionFollowUpTaskDefaultsAction?: InputMaybe<SetSkillVersionFollowUpTaskDefaultsActionInput>;
  setSkillVersionHeaderLibraryItemLinkAction?: InputMaybe<SetSkillVersionHeaderLibraryItemLinkActionInput>;
  setSkillVersionHeaderMediaAction?: InputMaybe<SetSkillVersionHeaderMediaInput>;
  setSkillVersionPassingThresholdPercentageAction?: InputMaybe<SetSkillVersionPassingThresholdPercentageActionInput>;
  setStepDescriptionAction?: InputMaybe<SetStepDescriptionActionInput>;
  setStepDisableCameraRollAction?: InputMaybe<SetStepDisableCameraRollActionInput>;
  setStepFailedSuggestionTextAction?: InputMaybe<SetStepFailedSuggestionTextActionInput>;
  setStepIsRequiredAction?: InputMaybe<SetStepIsRequiredActionInput>;
  setStepLibraryItemLinkAction?: InputMaybe<SetStepLibraryItemLinkActionInput>;
  setStepMediaAction?: InputMaybe<SetStepMediaInput>;
  setStepNoteRequiredAction?: InputMaybe<SetStepNoteRequiredActionInput>;
  setStepPhotoRequiredAction?: InputMaybe<SetStepPhotoRequiredActionInput>;
  setStepResponseOptionIsCorrectAction?: InputMaybe<SetStepResponseOptionIsCorrectActionInput>;
  setStepResponseOptionPointsAction?: InputMaybe<SetStepResponseOptionPointsActionInput>;
  setStepResponseOptionTextAction?: InputMaybe<SetStepResponseOptionTextActionInput>;
  setStepTemperatureUnitAction?: InputMaybe<SetStepTemperatureUnitActionInput>;
  setStepTextAction?: InputMaybe<SetStepTextActionInput>;
  setStepTypeAction?: InputMaybe<SetStepTypeActionInput>;
  setStepVideoRequiredAction?: InputMaybe<SetStepVideoRequiredActionInput>;
  setVerificationStepTriggerAction?: InputMaybe<SetVerificationStepTriggerActionInput>;
  skillId: Scalars['Int']['input'];
};

export type SkillFormDataInput = {
  failed?: InputMaybe<Scalars['Boolean']['input']>;
  skillVersionId: Scalars['UUID']['input'];
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationStepsInput: Array<VerificationStepInput>;
};

export type SkillInput = {
  description?: InputMaybe<TranslationSetInput>;
  name: TranslationSetInput;
  selfDirected?: InputMaybe<BooleanValue>;
  type?: InputMaybe<LibraryItemType>;
};

export type SkillInstance = {
  __typename?: 'SkillInstance';
  assignedByAccessSources: Array<AccessSource>;
  assignedByList: Array<Scalars['String']['output']>;
  assignment?: Maybe<Assignment>;
  createdAt: Scalars['DateTime']['output'];
  discardedAt?: Maybe<Scalars['DateTime']['output']>;
  draftVersion?: Maybe<SkillInstanceVersion>;
  /** @deprecated Field no longer supported */
  employee: Employee;
  failed?: Maybe<Scalars['Boolean']['output']>;
  firstAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  firstAssignedByStr?: Maybe<Scalars['String']['output']>;
  followUpTaskCount: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  isAssignedThroughModule: Scalars['Boolean']['output'];
  isReadyForVerification: Scalars['Boolean']['output'];
  lastAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  lastAssignedByStr?: Maybe<Scalars['String']['output']>;
  lastBuilderActionId?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Location>;
  moduleContentMembershipInstances: Array<ModuleContentMembershipInstance>;
  oneOffCheckInDelegations: Array<OneOffCheckInDelegation>;
  percentComplete: Scalars['Float']['output'];
  percentCompleted: Scalars['Float']['output'];
  pointsPossible?: Maybe<Scalars['Int']['output']>;
  pointsScored?: Maybe<Scalars['Int']['output']>;
  publishedVersion?: Maybe<SkillInstanceVersion>;
  remediationInstances: Array<RemediationInstance>;
  scoreThresholdPassed?: Maybe<Scalars['Boolean']['output']>;
  skill: Skill;
  skillVersion?: Maybe<SkillVersion>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  tasks: Array<Task>;
  triggerFlags: Scalars['Int']['output'];
  user: Employee;
  verifiableAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedBy?: Maybe<Employee>;
};

export type SkillInstanceBuilderActionInput = {
  addMediaAction?: InputMaybe<AddMediaActionInput>;
  addStepResponseOptionAction?: InputMaybe<AddStepResponseOptionInstanceActionInput>;
  clearFormAction?: InputMaybe<ClearFormActionInput>;
  discardFormAction?: InputMaybe<DiscardFormActionInput>;
  publishFormAction?: InputMaybe<PublishFormActionInput>;
  removeMediaAction?: InputMaybe<RemoveMediaActionInput>;
  removeStepResponseOptionAction?: InputMaybe<RemoveStepResponseOptionInstanceActionInput>;
  setCheckboxAnswerAction?: InputMaybe<SetCheckboxAnswerActionInput>;
  setFollowUpTaskDraftConfigAction?: InputMaybe<SetFollowUpTaskDraftConfigActionInput>;
  setNotesAction?: InputMaybe<SetNotesActionInput>;
  setNumberAnswerAction?: InputMaybe<SetNumberAnswerActionInput>;
  setRatingAction?: InputMaybe<SetRatingActionInput>;
  setTemperatureAnswerAction?: InputMaybe<SetTemperatureAnswerActionInput>;
  setTextAnswerAction?: InputMaybe<SetTextAnswerActionInput>;
  setYesNoAnswerAction?: InputMaybe<SetYesNoAnswerActionInput>;
  skillInstanceId: Scalars['UUID']['input'];
  verificationStepId?: InputMaybe<Scalars['UUID']['input']>;
  verificationStepInstanceId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SkillInstanceMutationResult = MutationResult & {
  __typename?: 'SkillInstanceMutationResult';
  error?: Maybe<Error>;
  skillInstance?: Maybe<SkillInstance>;
  success: Scalars['Boolean']['output'];
};

export type SkillInstanceVersion = {
  __typename?: 'SkillInstanceVersion';
  failed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  metadata: VersionMetadata;
  percentComplete: Scalars['Float']['output'];
  pointsPossible?: Maybe<Scalars['Int']['output']>;
  pointsScored?: Maybe<Scalars['Int']['output']>;
  skillInstance: SkillInstance;
  skillVersion?: Maybe<SkillVersion>;
  submissionNotes?: Maybe<Scalars['String']['output']>;
  verificationStepInstances: Array<VerificationStepInstance>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedBy?: Maybe<Employee>;
};

export type SkillInstances = PaginatedList & {
  __typename?: 'SkillInstances';
  objects: Array<SkillInstance>;
  totalCount: Scalars['Int']['output'];
};

export type SkillInstancesFiltersInput = {
  locationGroupIds?: InputMaybe<UuidArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
  ratings?: InputMaybe<IntArrayInput>;
  userIds?: InputMaybe<IntArrayInput>;
  verifiable?: InputMaybe<BooleanValue>;
  verified?: InputMaybe<BooleanValue>;
};

export type SkillInstancesInput = {
  filters: SkillInstancesSearchSortPaginateFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type SkillInstancesSearchSortPaginateFiltersInput = {
  accessTypes?: InputMaybe<AccessTypeListInput>;
  assignmentStatuses?: InputMaybe<AssignmentStatusArrayInput>;
  libraryItemIds?: InputMaybe<UuidArrayInput>;
  locationGroupIds?: InputMaybe<UuidArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
  roleIds?: InputMaybe<IntArrayInput>;
  skillInstanceLocationIds?: InputMaybe<IntArrayInput>;
  skillInstanceStatuses?: InputMaybe<AttemptStatusArrayInput>;
  tasksOnly?: InputMaybe<BooleanValue>;
  verifiedAtEndDate?: InputMaybe<DateTimeValue>;
  verifiedAtStartDate?: InputMaybe<DateTimeValue>;
};

export type SkillMutationResult = MutationResult & {
  __typename?: 'SkillMutationResult';
  error?: Maybe<Error>;
  skill?: Maybe<Skill>;
  success: Scalars['Boolean']['output'];
};

export type SkillVersion = {
  __typename?: 'SkillVersion';
  createdAt: Scalars['DateTime']['output'];
  followUpTaskDefaultApprovalRequired: Scalars['Boolean']['output'];
  followUpTaskDefaultDueDateOffsetDays?: Maybe<Scalars['Int']['output']>;
  followUpTaskDefaultProofOfCompletionRequirement: TaskProofOfCompletionRequirement;
  hasPassFailEvaluation: Scalars['Boolean']['output'];
  headerLibraryItemLink?: Maybe<LibraryItem>;
  headerMedia?: Maybe<Media>;
  id: Scalars['UUID']['output'];
  metadata: VersionMetadata;
  passingThresholdPercentage?: Maybe<Scalars['Int']['output']>;
  skill: Skill;
  verificationSteps: Array<VerificationStep>;
};

export type Skills = PaginatedList & {
  __typename?: 'Skills';
  objects: Array<Skill>;
  totalCount: Scalars['Int']['output'];
};

export type SkillsFiltersInput = {
  archived?: InputMaybe<BooleanValue>;
  hasOpened?: InputMaybe<BooleanValue>;
  hasVerifiableSkills?: InputMaybe<BooleanValue>;
  ids?: InputMaybe<IntArrayInput>;
  openedStartDate?: InputMaybe<DateTimeValue>;
};

export type SkillsInput = {
  filters?: InputMaybe<SkillsFiltersInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type SortInput = {
  column: Scalars['String']['input'];
  descending: Scalars['Boolean']['input'];
  explicit?: InputMaybe<Scalars['Boolean']['input']>;
  nullsLast?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SourcedValue = {
  __typename?: 'SourcedValue';
  sources: Array<ProviderSource>;
  value: Scalars['String']['output'];
};

export enum StakeholderRole {
  Champion = 'CHAMPION',
  DecisionMaker = 'DECISION_MAKER',
  EndUser = 'END_USER',
  Influencer = 'INFLUENCER',
  Other = 'OTHER',
  PrimaryContact = 'PRIMARY_CONTACT'
}

export type StartCourseOutlineGenerationActionInput = {
  courseOutlineUuid: Scalars['UUID']['input'];
  generationType?: InputMaybe<OutlineGenerationType>;
  interactivity: Scalars['Int']['input'];
  toneFormality: Scalars['Int']['input'];
  toneSeriousness: Scalars['Int']['input'];
};

export type StartTrainingResourceMediaToRichTextDocumentConversionInput = {
  sourceMediaId: Scalars['Int']['input'];
  trainingResourceId: Scalars['UUID']['input'];
};

export type StepResponseOption = {
  __typename?: 'StepResponseOption';
  id: Scalars['UUID']['output'];
  isCorrect: Scalars['Boolean']['output'];
  points?: Maybe<Scalars['Int']['output']>;
  text: TranslationSet;
};

export type StepResponseOptionInstance = {
  __typename?: 'StepResponseOptionInstance';
  id: Scalars['UUID']['output'];
  stepResponseOption: StepResponseOption;
  verificationStepInstance: VerificationStepInstance;
};

export type StepResponseOptionObjectInput = {
  id: Scalars['UUID']['input'];
  isCorrect: Scalars['Boolean']['input'];
  points?: InputMaybe<Scalars['Int']['input']>;
  text: TranslationSetObjectInput;
};

export type StillEmployedConfirmationInput = {
  userIds: Array<Scalars['Int']['input']>;
};

export enum StoreOpeningEvaluationStatus {
  Good = 'GOOD',
  Ok = 'OK',
  Poor = 'POOR'
}

export type StringArrayInput = {
  value: Array<Scalars['String']['input']>;
};

export type StringInput = {
  value: Scalars['String']['input'];
};

export type StringMutationResult = MutationResult & {
  __typename?: 'StringMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type StringValue = {
  value: Scalars['String']['input'];
};

export type SubmitAuditFormInput = {
  locationId: Scalars['Int']['input'];
  skillInstanceId: Scalars['UUID']['input'];
};

export type SubmitCheckinFormInput = {
  failed: Scalars['Boolean']['input'];
  skillInstanceId: Scalars['UUID']['input'];
};

export type SubmitRemediationActionInput = {
  submit: Scalars['Boolean']['input'];
};

export type SubmitTaskFormInput = {
  formData: SkillFormDataInput;
  locationId: Scalars['Int']['input'];
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  taskLibraryItemId: Scalars['UUID']['input'];
};

export type SubmitTaskFormV2Input = {
  locationId: Scalars['Int']['input'];
  skillInstanceId: Scalars['UUID']['input'];
};

export type SubmittedRequest = {
  __typename?: 'SubmittedRequest';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  linearAssigneeEmail?: Maybe<Scalars['String']['output']>;
  linearAssigneeName?: Maybe<Scalars['String']['output']>;
  linearCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  linearDescription?: Maybe<Scalars['String']['output']>;
  linearIssueId: Scalars['String']['output'];
  linearLabels?: Maybe<Scalars['String']['output']>;
  linearPriority?: Maybe<Scalars['String']['output']>;
  linearProblemArea?: Maybe<Scalars['String']['output']>;
  linearState?: Maybe<Scalars['String']['output']>;
  linearStateName?: Maybe<Scalars['String']['output']>;
  linearStateType?: Maybe<Scalars['String']['output']>;
  linearTitle?: Maybe<Scalars['String']['output']>;
  linearUrgency?: Maybe<Scalars['String']['output']>;
  linearUrl?: Maybe<Scalars['String']['output']>;
  orgNames: Array<Scalars['String']['output']>;
  productAreas: Array<Scalars['String']['output']>;
  slackChannel?: Maybe<Scalars['String']['output']>;
  slackThreadTs?: Maybe<Scalars['String']['output']>;
  submitterEmail: Scalars['String']['output'];
  submitterName?: Maybe<Scalars['String']['output']>;
  submitterSlackId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SubmittedRequestsFiltersInput = {
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  newThisWeek?: InputMaybe<Scalars['Boolean']['input']>;
  orgs?: InputMaybe<Array<Scalars['String']['input']>>;
  priorities?: InputMaybe<Array<Scalars['String']['input']>>;
  problemAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  productAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  resolvedThisWeek?: InputMaybe<Scalars['Boolean']['input']>;
  stateTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  submitters?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  urgencies?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubmittedRequestsInput = {
  filters: SubmittedRequestsFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type SubmittedRequestsList = PaginatedList & {
  __typename?: 'SubmittedRequestsList';
  objects: Array<SubmittedRequest>;
  totalCount: Scalars['Int']['output'];
};

export type SubscriptionInput = {
  planId: Scalars['UUID']['input'];
};

export type SubsectionGrade = {
  __typename?: 'SubsectionGrade';
  feedback: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  maxScore: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  section: SectionGrade;
};

export type SubtitleSegment = {
  __typename?: 'SubtitleSegment';
  endTime: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  index: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type SubtitleSegmentInput = {
  id: Scalars['UUID']['input'];
  text: Scalars['String']['input'];
};

export type SubtitleTrack = {
  __typename?: 'SubtitleTrack';
  id: Scalars['UUID']['output'];
  language: Scalars['Language']['output'];
  subtitleSegments: Array<SubtitleSegment>;
  webvttLink?: Maybe<Scalars['String']['output']>;
};

export type SuggestAiBlocksInput = {
  promptUuids: Array<Scalars['String']['input']>;
  type: SuggestAiBlocksType;
};

export type SuggestAiBlocksMutationResult = MutationResult & {
  __typename?: 'SuggestAIBlocksMutationResult';
  aiPrompts?: Maybe<Array<AiPrompt>>;
  error?: Maybe<Error>;
  /** @deprecated Field no longer supported */
  prompts?: Maybe<Array<Prompt>>;
  success: Scalars['Boolean']['output'];
};

export enum SuggestAiBlocksType {
  Any = 'ANY',
  Questions = 'QUESTIONS'
}

export type SuggestedQuestion = {
  __typename?: 'SuggestedQuestion';
  generatedByAiExchange: AiChatExchange;
  id: Scalars['UUID']['output'];
  questionText: TranslationSet;
  searchDocument: SearchDocument;
};

export type SuggestedQuestions = PaginatedList & {
  __typename?: 'SuggestedQuestions';
  objects: Array<SuggestedQuestion>;
  totalCount: Scalars['Int']['output'];
};

export type SuggestedQuestionsInput = {
  randomize?: InputMaybe<BooleanValue>;
};

/**
 * Re-open a mis-triggered call on the other team. The target team is the one this
 * run is not on, so the client cannot ask for a third.
 */
export type SwitchCoachingRunTeamInput = {
  runId: Scalars['UUID']['input'];
};

export type SwitchToUserMutationResult = MutationResult & {
  __typename?: 'SwitchToUserMutationResult';
  error?: Maybe<Error>;
  sessionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SyncCandidatesToAttioResult = MutationResult & {
  __typename?: 'SyncCandidatesToAttioResult';
  clientFacingWorkflow?: Maybe<ClientFacingWorkflow>;
  error?: Maybe<Error>;
  queued: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  availableInApp: Scalars['Boolean']['output'];
  checkInsCount?: Maybe<Scalars['Int']['output']>;
  contentTagMemberships: Array<ContentTagMembership>;
  coursesCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  isVisibleToTrainees?: Maybe<Scalars['Boolean']['output']>;
  libraryItemCount: Scalars['Int']['output'];
  modulesCount?: Maybe<Scalars['Int']['output']>;
  nameTranslations: TranslationSet;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  resourcesCount?: Maybe<Scalars['Int']['output']>;
};

export type TagInput = {
  availableInApp: Scalars['Boolean']['input'];
  nameTranslations: TranslationSetInput;
  pinned?: InputMaybe<BooleanValue>;
};

export type TagMutationResult = MutationResult & {
  __typename?: 'TagMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  tag?: Maybe<Tag>;
};

export type TagsInput = {
  libraryItemFilters?: InputMaybe<AdminLibraryFiltersInput>;
  traineeLibraryFilters?: InputMaybe<TraineeLibraryFiltersInput>;
};

export type Task = {
  __typename?: 'Task';
  activity: Array<TaskActivityEvent>;
  approvalRequired: Scalars['Boolean']['output'];
  assignee?: Maybe<Employee>;
  comments: Array<TaskComment>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['UUID']['output'];
  isPastDue: Scalars['Boolean']['output'];
  location: Location;
  observers: Array<Employee>;
  proofMedias: Array<TaskProofMedia>;
  proofOfCompletionRequirement?: Maybe<TaskProofOfCompletionRequirement>;
  proofText?: Maybe<Scalars['String']['output']>;
  reviewer?: Maybe<Employee>;
  sourceSkillInstance?: Maybe<SkillInstance>;
  sourceVerificationStepInstance?: Maybe<VerificationStepInstance>;
  status: TaskStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TaskActivityEvent = {
  __typename?: 'TaskActivityEvent';
  actor?: Maybe<Employee>;
  comment?: Maybe<TaskComment>;
  id: Scalars['String']['output'];
  kind: TaskActivityEventKind;
  media?: Maybe<Media>;
  newAssignee?: Maybe<Employee>;
  newStatus?: Maybe<TaskStatus>;
  note?: Maybe<Scalars['String']['output']>;
  oldAssignee?: Maybe<Employee>;
  oldStatus?: Maybe<TaskStatus>;
  sourceSkillInstance?: Maybe<SkillInstance>;
  timestamp: Scalars['DateTime']['output'];
};

export enum TaskActivityEventKind {
  AssigneeChanged = 'ASSIGNEE_CHANGED',
  Comment = 'COMMENT',
  Created = 'CREATED',
  ProofMediaAdded = 'PROOF_MEDIA_ADDED',
  ProofMediaRemoved = 'PROOF_MEDIA_REMOVED',
  ProofTextUpdated = 'PROOF_TEXT_UPDATED',
  ReviewChangesRequested = 'REVIEW_CHANGES_REQUESTED',
  ReviewCompleted = 'REVIEW_COMPLETED',
  StatusChanged = 'STATUS_CHANGED',
  SubmittedForReview = 'SUBMITTED_FOR_REVIEW'
}

export type TaskComment = {
  __typename?: 'TaskComment';
  author?: Maybe<Employee>;
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isEdited: Scalars['Boolean']['output'];
  media: Array<TaskCommentMedia>;
  mentions: Array<TaskCommentMention>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TaskCommentMedia = {
  __typename?: 'TaskCommentMedia';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  media: Media;
  order: Scalars['Int']['output'];
};

export type TaskCommentMention = {
  __typename?: 'TaskCommentMention';
  id: Scalars['UUID']['output'];
  mentionedUser: Employee;
};

export type TaskFiltersInput = {
  assigneeId?: InputMaybe<Scalars['Int']['input']>;
  locationGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  reviewerId?: InputMaybe<Scalars['Int']['input']>;
  sourceSkillInstanceId?: InputMaybe<Scalars['UUID']['input']>;
  statuses?: InputMaybe<Array<TaskStatus>>;
};

export type TaskFormMutationResult = MutationResult & {
  __typename?: 'TaskFormMutationResult';
  error?: Maybe<Error>;
  skillInstance?: Maybe<SkillInstance>;
  success: Scalars['Boolean']['output'];
};

export type TaskListDailyDigestSubscription = {
  __typename?: 'TaskListDailyDigestSubscription';
  id: Scalars['UUID']['output'];
  userSelection: UserSelection;
};

export type TaskListDailyDigestSubscriptionInput = {
  userSelectionInput: UserSelectionInput;
};

export type TaskListDailyDigestSubscriptionMutationResult = MutationResult & {
  __typename?: 'TaskListDailyDigestSubscriptionMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  taskListDailyDigestSubscription?: Maybe<TaskListDailyDigestSubscription>;
};

export type TaskMutationResult = MutationResult & {
  __typename?: 'TaskMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  task?: Maybe<Task>;
};

export type TaskProofMedia = {
  __typename?: 'TaskProofMedia';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Employee>;
  id: Scalars['UUID']['output'];
  media: Media;
  order: Scalars['Int']['output'];
};

export enum TaskProofOfCompletionRequirement {
  None = 'NONE',
  Photo = 'PHOTO',
  PhotoOrVideo = 'PHOTO_OR_VIDEO',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export enum TaskReviewDecision {
  MarkComplete = 'MARK_COMPLETE',
  RequestChanges = 'REQUEST_CHANGES'
}

export type TaskScheduleCompletionPercent = {
  __typename?: 'TaskScheduleCompletionPercent';
  completedCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  libraryItemId: Scalars['UUID']['output'];
  locationId: Scalars['Int']['output'];
  percent: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
};

export type TaskScheduleCompletionPercents = PaginatedList & {
  __typename?: 'TaskScheduleCompletionPercents';
  objects: Array<TaskScheduleCompletionPercent>;
  totalCount: Scalars['Int']['output'];
};

export type TaskScheduleCompletionPercentsInput = {
  endDate?: InputMaybe<DateTimeValue>;
  libraryItemIds?: InputMaybe<UuidArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
  startDate?: InputMaybe<DateTimeValue>;
};

export enum TaskStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  ReadyForReview = 'READY_FOR_REVIEW'
}

export type Tasks = PaginatedList & {
  __typename?: 'Tasks';
  objects: Array<Task>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TasksInput = {
  filters?: InputMaybe<TaskFiltersInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export enum TemperatureUnit {
  Celsius = 'CELSIUS',
  Fahrenheit = 'FAHRENHEIT'
}

export enum TestEnum {
  A = 'A',
  B = 'B',
  C = 'C'
}

export type TextToSpeechInput = {
  text: Scalars['String']['input'];
};

export enum Timezone {
  UsArizona = 'US_ARIZONA',
  UsCentral = 'US_CENTRAL',
  UsEastern = 'US_EASTERN',
  UsMountain = 'US_MOUNTAIN',
  UsPacific = 'US_PACIFIC'
}

export type TopTaskListBySubmission = {
  __typename?: 'TopTaskListBySubmission';
  libraryItem: LibraryItem;
  totalLocations: Scalars['Int']['output'];
  totalSubmissions: Scalars['Int']['output'];
};

export type TopTaskListsBySubmissionInput = {
  endDate?: InputMaybe<DateTimeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<DateTimeInput>;
};

export type TopTrainingByAssignment = {
  __typename?: 'TopTrainingByAssignment';
  completedAssignments: Scalars['Int']['output'];
  libraryItem: LibraryItem;
  pastDueAssignments: Scalars['Int']['output'];
  totalAssignments: Scalars['Int']['output'];
};

export type TopTrainingsByAssignmentInput = {
  endDate?: InputMaybe<DateTimeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<DateTimeInput>;
};

export type Topic = {
  __typename?: 'Topic';
  color?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export enum TotalEmployeesType {
  Hris = 'HRIS',
  Org = 'ORG'
}

export type TraineeLeaderboard = PaginatedList & {
  __typename?: 'TraineeLeaderboard';
  objects: Array<TraineeLeaderboardItem>;
  totalCount: Scalars['Int']['output'];
};

export type TraineeLeaderboardInput = {
  sort?: InputMaybe<SortInput>;
  window?: InputMaybe<LeaderboardWindow>;
};

export type TraineeLeaderboardItem = {
  __typename?: 'TraineeLeaderboardItem';
  assignmentCompletionPercentage?: Maybe<Scalars['Float']['output']>;
  assignmentPastDuePercentage?: Maybe<Scalars['Float']['output']>;
  assignmentsCompleted: Scalars['Int']['output'];
  averageAccuracy?: Maybe<Scalars['Float']['output']>;
  id: Scalars['UUID']['output'];
  pastDueAssignments: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  userFirstName: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
  userLastName: Scalars['String']['output'];
  userLocations?: Maybe<Array<Scalars['String']['output']>>;
  userName: Scalars['String']['output'];
  userRoles?: Maybe<Array<Scalars['String']['output']>>;
  verifiedSkills: Scalars['Int']['output'];
};

export type TraineeLibraryFiltersInput = {
  folderId?: InputMaybe<OptionalUuidValue>;
  ids?: InputMaybe<UuidArrayInput>;
  libraryItemTypes?: InputMaybe<LibraryItemTypeListInput>;
  tagIds?: InputMaybe<UuidArrayInput>;
  userId: Scalars['Int']['input'];
};

export type TraineeLibraryInput = {
  filters: TraineeLibraryFiltersInput;
  search?: InputMaybe<StringValue>;
  searchMode?: InputMaybe<LibrarySearchMode>;
  sort?: InputMaybe<SortInput>;
};

export type TraineeSignupInput = {
  email?: InputMaybe<StringValue>;
  firstName?: InputMaybe<StringValue>;
  language: LanguageValue;
  lastName?: InputMaybe<StringValue>;
  name?: InputMaybe<StringValue>;
  password?: InputMaybe<StringValue>;
  phoneNumber?: InputMaybe<StringValue>;
  signupCode: StringValue;
};

export type TrainingResource = {
  __typename?: 'TrainingResource';
  assignedCount: Scalars['Int']['output'];
  assignedThroughCourses: Array<Course>;
  draftVersion: TrainingResourceVersion;
  id: Scalars['UUID']['output'];
  lastBuilderActionId?: Maybe<Scalars['Int']['output']>;
  libraryItem: LibraryItem;
  moduleContentMemberships: Array<ModuleContentMembership>;
  publishedVersion?: Maybe<TrainingResourceVersion>;
};

export type TrainingResourceBuilderActionInput = {
  setRichTextDocumentContentAction?: InputMaybe<SetRichTextDocumentContentActionInput>;
  setTrainingResourceNameAction?: InputMaybe<SetTrainingResourceNameActionInput>;
  setTrainingResourceVersionTypeAction?: InputMaybe<SetTrainingResourceVersionTypeActionInput>;
  trainingResourceId: Scalars['UUID']['input'];
};

export type TrainingResourceInput = {
  mediaId: Scalars['Int']['input'];
};

export type TrainingResourceInstance = {
  __typename?: 'TrainingResourceInstance';
  assignedByList: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  firstAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  firstAssignedByStr?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isAssignedThroughModule: Scalars['Boolean']['output'];
  lastAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  lastAssignedByStr?: Maybe<Scalars['String']['output']>;
  moduleContentMembershipInstances: Array<ModuleContentMembershipInstance>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  trainingResource: TrainingResource;
  user: Employee;
};

export type TrainingResourceInstanceMutationResult = MutationResult & {
  __typename?: 'TrainingResourceInstanceMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  trainingResourceInstance?: Maybe<TrainingResourceInstance>;
};

export type TrainingResourceMutationResult = MutationResult & {
  __typename?: 'TrainingResourceMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  trainingResource?: Maybe<TrainingResource>;
};

/**
 * Classification of a training resource for display and filtering. Derived from
 * the resource's version type and media URL, preferring the draft version (see
 * LibraryItemAnnotations.resource_type). Mirrors the frontend getLinkType
 * classification so this is the single source of truth.
 */
export enum TrainingResourceType {
  Audio = 'AUDIO',
  ContactCard = 'CONTACT_CARD',
  Gif = 'GIF',
  Image = 'IMAGE',
  Link = 'LINK',
  OpusDoc = 'OPUS_DOC',
  Pdf = 'PDF',
  Video = 'VIDEO',
  Website = 'WEBSITE'
}

export type TrainingResourceTypeListInput = {
  value: Array<TrainingResourceType>;
};

export type TrainingResourceVersion = {
  __typename?: 'TrainingResourceVersion';
  id: Scalars['UUID']['output'];
  media?: Maybe<Media>;
  richTextDocument?: Maybe<RichTextDocument>;
  trainingResource: TrainingResource;
  type: TrainingResourceVersionType;
};

export enum TrainingResourceVersionType {
  Media = 'MEDIA',
  RichTextDocument = 'RICH_TEXT_DOCUMENT'
}

export type TrainingResourceViews = {
  __typename?: 'TrainingResourceViews';
  count: Scalars['Int']['output'];
  day: Scalars['Date']['output'];
  locationIds?: Maybe<Array<Scalars['Int']['output']>>;
  roleIds?: Maybe<Array<Scalars['Int']['output']>>;
  trainingResourceId: Scalars['UUID']['output'];
};

export type TrainingResourcesMutationResult = MutationResult & {
  __typename?: 'TrainingResourcesMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  trainingResources?: Maybe<Array<TrainingResource>>;
};

export type TrainingSession = {
  __typename?: 'TrainingSession';
  courseId?: Maybe<Scalars['Int']['output']>;
  courseName?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  messageBlastId?: Maybe<Scalars['Int']['output']>;
  messageBlastSenderName?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  trainingResourceId?: Maybe<Scalars['UUID']['output']>;
  trainingResourceName?: Maybe<Scalars['String']['output']>;
};

export type TrainingSessionEventInput = {
  courseId?: InputMaybe<Scalars['Int']['input']>;
  knowledgeCheckId?: InputMaybe<Scalars['UUID']['input']>;
  messageBlastId?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  moduleId?: InputMaybe<Scalars['Int']['input']>;
  skillId?: InputMaybe<Scalars['Int']['input']>;
  timestamp: Scalars['DateTime']['input'];
  trainingResourceId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum TrainingStatus {
  InvitePending = 'INVITE_PENDING',
  NotStarted = 'NOT_STARTED',
  NoCourse = 'NO_COURSE',
  OnTrack = 'ON_TRACK',
  OptedOut = 'OPTED_OUT',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  StoppedResponding = 'STOPPED_RESPONDING'
}

export type TranslatedTextMutationResult = MutationResult & {
  __typename?: 'TranslatedTextMutationResult';
  error: Error;
  language: Scalars['Language']['output'];
  success: Scalars['Boolean']['output'];
  text: Array<Scalars['String']['output']>;
};

export type TranslationOverride = {
  __typename?: 'TranslationOverride';
  id: Scalars['UUID']['output'];
  language: Scalars['Language']['output'];
  sourceText: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type TranslationOverrideInput = {
  language: Scalars['Language']['input'];
  sourceText: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type TranslationOverrideObjectInput = {
  id: Scalars['UUID']['input'];
  language: Scalars['Language']['input'];
  sourceText: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type TranslationSet = {
  __typename?: 'TranslationSet';
  en: Scalars['String']['output'];
  myTranslation: Scalars['String']['output'];
  translationOverrides: Array<TranslationOverride>;
  translationsDisabled?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type TranslationSetInput = {
  en: Scalars['String']['input'];
  translationOverrides?: InputMaybe<Array<TranslationOverrideInput>>;
  translationsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TranslationSetInputValue = {
  value: TranslationSetInput;
};

export type TranslationSetMutationResult = MutationResult & {
  __typename?: 'TranslationSetMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  translationSet?: Maybe<TranslationSet>;
};

export type TranslationSetObjectInput = {
  en: Scalars['String']['input'];
  translationOverrides: Array<TranslationOverrideObjectInput>;
  translationsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['UUID']['input'];
};

export type Trigger = {
  __typename?: 'Trigger';
  actions: Array<TriggerAction>;
  checkedCondition?: Maybe<TriggerCheckedCondition>;
  id: Scalars['UUID']['output'];
  numberCondition?: Maybe<TriggerNumberCondition>;
  verificationStepMultipleChoiceAnyCondition?: Maybe<TriggerVerificationStepMultipleChoiceAnyCondition>;
  verificationStepMultipleChoiceCondition?: Maybe<TriggerVerificationStepMultipleChoiceCondition>;
  yesNoCondition?: Maybe<TriggerYesNoCondition>;
};

export type TriggerAction = {
  __typename?: 'TriggerAction';
  correctiveAction?: Maybe<TriggerCorrectiveAction>;
  flagAction?: Maybe<TriggerFlagAction>;
  id: Scalars['UUID']['output'];
  index: Scalars['Int']['output'];
  messageAction?: Maybe<TriggerMessageAction>;
  remediateAction?: Maybe<TriggerRemediateAction>;
  trigger: Trigger;
};

export type TriggerActionInput = {
  correctiveAction?: InputMaybe<TranslationSetInputValue>;
  flagAction?: InputMaybe<BooleanValue>;
  followUpTaskAction?: InputMaybe<TriggerFollowUpTaskActionInput>;
  messageAction?: InputMaybe<TriggerMessageActionInput>;
  /**
   * Legacy on/off follow-up task trigger; true creates the action with
   * all-inherit config. Deprecated in favor of followUpTaskAction.
   */
  remediateAction?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TriggerCheckedCondition = {
  __typename?: 'TriggerCheckedCondition';
  checked: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
};

export type TriggerCoachingTestRunInput = {
  meetingId: Scalars['UUID']['input'];
  templateId: Scalars['UUID']['input'];
};

export type TriggerCorrectiveAction = {
  __typename?: 'TriggerCorrectiveAction';
  action: TranslationSet;
  id: Scalars['UUID']['output'];
};

export type TriggerFlagAction = {
  __typename?: 'TriggerFlagAction';
  flag: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
};

export type TriggerFollowUpTaskActionInput = {
  approvalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  dueDateOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  proofOfCompletionRequirement?: InputMaybe<TaskProofOfCompletionRequirement>;
};

export type TriggerInput = {
  actions: Array<TriggerActionInput>;
  checkedCondition?: InputMaybe<BooleanValue>;
  numberCondition?: InputMaybe<TriggerNumberConditionInput>;
  verificationStepMultipleChoiceAnyCondition?: InputMaybe<VerificationStepTriggerMultipleChoiceAnyConditionInput>;
  verificationStepMultipleChoiceCondition?: InputMaybe<VerificationStepTriggerMultipleChoiceConditionInput>;
  yesNoCondition?: InputMaybe<BooleanValue>;
};

export type TriggerMessageAction = {
  __typename?: 'TriggerMessageAction';
  id: Scalars['UUID']['output'];
  note?: Maybe<TranslationSet>;
  userSelection: UserSelection;
};

export type TriggerMessageActionInput = {
  note?: InputMaybe<TranslationSetInputValue>;
  userSelection: UserSelectionInput;
};

export type TriggerMultipleChoiceAnyConditionOption = {
  __typename?: 'TriggerMultipleChoiceAnyConditionOption';
  id: Scalars['UUID']['output'];
  stepResponseOption: StepResponseOption;
};

export type TriggerNumberCondition = {
  __typename?: 'TriggerNumberCondition';
  condition: NumberTriggerCondition;
  id: Scalars['UUID']['output'];
  number: Scalars['Float']['output'];
  numberRangeTop?: Maybe<Scalars['Float']['output']>;
};

export type TriggerNumberConditionInput = {
  condition: NumberTriggerCondition;
  number: FloatValue;
  numberRangeTop?: InputMaybe<FloatValue>;
};

export type TriggerRemediateAction = {
  __typename?: 'TriggerRemediateAction';
  approvalRequired?: Maybe<Scalars['Boolean']['output']>;
  dueDateOffsetDays?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  proofOfCompletionRequirement?: Maybe<TaskProofOfCompletionRequirement>;
};

export type TriggerVerificationStepMultipleChoiceAnyCondition = {
  __typename?: 'TriggerVerificationStepMultipleChoiceAnyCondition';
  id: Scalars['UUID']['output'];
  options: Array<TriggerMultipleChoiceAnyConditionOption>;
};

export type TriggerVerificationStepMultipleChoiceCondition = {
  __typename?: 'TriggerVerificationStepMultipleChoiceCondition';
  condition: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  stepResponseOption: StepResponseOption;
};

export type TriggerYesNoCondition = {
  __typename?: 'TriggerYesNoCondition';
  id: Scalars['UUID']['output'];
  yesNo: Scalars['Boolean']['output'];
};

export type UnsplashImage = {
  __typename?: 'UnsplashImage';
  altDescription?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  links: UnsplashLinks;
  urls: UnsplashUrls;
  user: UnsplashUser;
};

export type UnsplashLinks = {
  __typename?: 'UnsplashLinks';
  downloadLocation: Scalars['String']['output'];
};

export type UnsplashUrls = {
  __typename?: 'UnsplashUrls';
  full: Scalars['String']['output'];
  regular: Scalars['String']['output'];
  small: Scalars['String']['output'];
  thumb: Scalars['String']['output'];
};

export type UnsplashUser = {
  __typename?: 'UnsplashUser';
  id: Scalars['UUID']['output'];
  links: UnsplashUserLinks;
  name: Scalars['String']['output'];
};

export type UnsplashUserLinks = {
  __typename?: 'UnsplashUserLinks';
  html: Scalars['String']['output'];
  portfolio?: Maybe<Scalars['String']['output']>;
};

export type UpdateAiOrgContextInput = {
  businessType?: InputMaybe<StringValue>;
  foundingStory?: InputMaybe<StringValue>;
  id: Scalars['UUID']['input'];
  isApproved?: InputMaybe<BooleanValue>;
  missionStatement?: InputMaybe<StringValue>;
  rulesForAi?: InputMaybe<StringValue>;
  sells?: InputMaybe<StringValue>;
};

export type UpdateAssignmentDueDatesInput = {
  assignmentIds: Array<Scalars['UUID']['input']>;
  dueDate: Scalars['Date']['input'];
};

export type UpdateChatMemberPermissionsInput = {
  chatId: Scalars['UUID']['input'];
  membersCanEditMembers: Scalars['Boolean']['input'];
  membersCanEditTitle: Scalars['Boolean']['input'];
};

export type UpdateChatMemberStateInput = {
  archived?: InputMaybe<OptionalBooleanValue>;
  chatId: Scalars['UUID']['input'];
};

export type UpdateChatMembersInput = {
  chatId: Scalars['UUID']['input'];
  userSelectionSet: UserSelectionSetInput;
};

export type UpdateChatOwnersInput = {
  chatId: Scalars['UUID']['input'];
  ownerUserIds: Array<Scalars['Int']['input']>;
};

export type UpdateChatSettingsInput = {
  chatId: Scalars['UUID']['input'];
  membersCanEditMembers?: InputMaybe<Scalars['Boolean']['input']>;
  membersCanEditTitle?: InputMaybe<Scalars['Boolean']['input']>;
  ownerUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<TranslationSetInput>;
  userSelectionSet?: InputMaybe<UserSelectionSetInput>;
};

export type UpdateChatTitleInput = {
  chatId: Scalars['UUID']['input'];
  title: TranslationSetInput;
};

export type UpdateCoachingTemplateDraftInput = {
  criteria: Array<CoachingCriterionInput>;
  promptBody: Scalars['String']['input'];
  templateId: Scalars['UUID']['input'];
};

export type UpdateCoachingTemplateMetadataInput = {
  identificationGuidance?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['UUID']['input'];
};

export type UpdateContentSharingPermissionInput = {
  allAdmins?: InputMaybe<SharingPermission>;
  allManagers?: InputMaybe<SharingPermission>;
  courseId?: InputMaybe<Scalars['Int']['input']>;
  moduleId?: InputMaybe<Scalars['Int']['input']>;
  skillId?: InputMaybe<Scalars['Int']['input']>;
  trainingResourceId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateCourseInput = {
  archived?: InputMaybe<BooleanValue>;
  description?: InputMaybe<TranslationSetInputValue>;
  dueDate?: InputMaybe<DueDateInputValue>;
  enableCertificate?: InputMaybe<BooleanValue>;
  enablePromptRetries?: InputMaybe<BooleanValue>;
  excludeFromKnowledgeCheck?: InputMaybe<BooleanValue>;
  name?: InputMaybe<StringValue>;
  passingAccuracyThreshold?: InputMaybe<OptionalIntValue>;
  qrCodeSettings?: InputMaybe<QrCodeSettingsInput>;
};

export type UpdateCoverImageMutationResult = MutationResult & {
  __typename?: 'UpdateCoverImageMutationResult';
  coverImage?: Maybe<CoverImage>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type UpdateDealScopeAnswerInput = {
  confident: Scalars['Boolean']['input'];
  dealId: Scalars['UUID']['input'];
  questionKey: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UpdateDealScopeAnswerResult = MutationResult & {
  __typename?: 'UpdateDealScopeAnswerResult';
  answer?: Maybe<DealScopeAnswer>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type UpdateEmployee = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  language?: InputMaybe<Scalars['Language']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profileImageId?: InputMaybe<OptionalIntInput>;
};

export type UpdateEmployeeCountSettingsInput = {
  collectEmployeeCountFromManagers: Scalars['Boolean']['input'];
  defaultLocationTotalEmployees: Scalars['Int']['input'];
  locationOverrides: Array<LocationEmployeeCountOverrideInput>;
};

export type UpdateEmployeeFeatureFlagsInput = {
  featureFlags: Array<FeatureFlagInput>;
};

export type UpdateEmployeeResult = MutationResult & {
  __typename?: 'UpdateEmployeeResult';
  /** @deprecated Field no longer supported */
  employee?: Maybe<Employee>;
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<Employee>;
};

export type UpdateExpectedUsersConfigInput = {
  config: ExpectedUsersConfigInput;
  locationId: Scalars['Int']['input'];
};

export type UpdateFolderPositionInput = {
  position: Scalars['String']['input'];
};

export type UpdateGuestFeedbackCorrectiveActionInput = {
  comment?: InputMaybe<CommentInput>;
  libraryItemId?: InputMaybe<Scalars['UUID']['input']>;
  measuringImpactStartedOn?: InputMaybe<Scalars['Date']['input']>;
  status: GuestFeedbackCorrectiveActionStatus;
};

export type UpdateGuestFeedbackCorrectiveActionsInput = {
  guestFeedbackCorrectiveActions: Array<GuestFeedbackCorrectiveActionInput>;
};

export type UpdateHrisCsvUploadInput = {
  appliedAt?: InputMaybe<DateTimeInput>;
  dataVerifiedAt?: InputMaybe<DateTimeInput>;
  id: Scalars['UUID']['input'];
  idField?: InputMaybe<StringValue>;
  locationField?: InputMaybe<OptionalStringValue>;
  nameField?: InputMaybe<StringValue>;
  phoneField?: InputMaybe<StringValue>;
  selectedColumnsAt?: InputMaybe<DateTimeInput>;
  teamField?: InputMaybe<OptionalStringValue>;
  terminationDateField?: InputMaybe<StringValue>;
};

export type UpdateLibraryItemCourseInput = {
  enableCertificate?: InputMaybe<BooleanValue>;
  enablePromptRetries?: InputMaybe<BooleanValue>;
  passingAccuracyThreshold?: InputMaybe<OptionalIntValue>;
};

export type UpdateLibraryItemFromRecommendationInput = {
  recommendationId: Scalars['UUID']['input'];
};

export type UpdateLibraryItemTrainingResourceInput = {
  mediaUrls?: InputMaybe<TranslationSetObjectInput>;
};

export type UpdateLocationInput = {
  addressInput?: InputMaybe<AddressInput>;
  locationGroupIds?: InputMaybe<UuidArrayInput>;
  name: Scalars['String']['input'];
};

export type UpdateMediaInputV2 = {
  mediaUrls?: InputMaybe<TranslationSetObjectInput>;
};

export type UpdateOnCompletionAssignmentRuleInput = {
  roleIds?: InputMaybe<IntArrayInput>;
  unlockDays?: InputMaybe<IntValue>;
};

export type UpdateOrCreateUserGlobalPushNotificationSettingsInput = {
  textFallback: Scalars['Boolean']['input'];
};

export type UpdateOrCreateUserPushNotificationSettingChatOverrideInput = {
  chatId: Scalars['UUID']['input'];
  chatSetting: UserPushNotificationChatSetting;
};

export type UpdateOrCreateUserPushNotificationSettingInput = {
  chatSetting?: InputMaybe<UserPushNotificationChatSetting>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  newPostsSetting?: InputMaybe<UserPushNotificationNewPostsSetting>;
  postActivitySetting?: InputMaybe<UserPushNotificationPostActivitySetting>;
  taskSetting?: InputMaybe<UserPushNotificationTaskSetting>;
  type: UserPushNotificationSettingType;
};

export type UpdateOrCreateUserPushNotificationSettingPostActivityOverrideInput = {
  postActivitySetting: UserPushNotificationPostActivitySetting;
  postId: Scalars['Int']['input'];
};

export type UpdateOrbCustomerInput = {
  additionalEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<AddressInput>;
  autoCollection?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrgFeatureFlagsInput = {
  featureFlags: Array<FeatureFlagInput>;
};

export type UpdateOrgGuestFeedbackIntegrationInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
  locationGroupId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateOrgGuestFeedbackIntegrationLocationInput = {
  id: Scalars['UUID']['input'];
  locationId: Scalars['Int']['input'];
};

export type UpdateOrgPremiumContentConfigInput = {
  dueDateDays?: InputMaybe<IntValue>;
  id: Scalars['Int']['input'];
  setupStep?: InputMaybe<PremiumContentSetupStepValue>;
};

export type UpdateOrgSharpConfigInput = {
  dueDateDays?: InputMaybe<IntValue>;
  hotlinePhoneNumber?: InputMaybe<StringValue>;
  hrEmail?: InputMaybe<StringValue>;
  realWorldComplaintFormLocation?: InputMaybe<TranslationSetInputValue>;
  sharpPolicyId?: InputMaybe<IntValue>;
};

export type UpdateRemediationStepResponseInput = {
  remediationStepId: Scalars['UUID']['input'];
  responseMediaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  responseText?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReportingTargetsInput = {
  assignmentCompletionRate?: InputMaybe<Scalars['Int']['input']>;
  assignmentPastDueRate?: InputMaybe<Scalars['Int']['input']>;
  courseAccuracy?: InputMaybe<Scalars['Int']['input']>;
  courseFeedback?: InputMaybe<Scalars['Float']['input']>;
  managerEngagementRate?: InputMaybe<Scalars['Int']['input']>;
  newHireOnboardingDays?: InputMaybe<Scalars['Int']['input']>;
  onboardingRate?: InputMaybe<Scalars['Int']['input']>;
  taskListCompletionRate?: InputMaybe<Scalars['Int']['input']>;
  traineeEngagementRate?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRoleInput = {
  directReportRoleIds?: InputMaybe<IntArrayInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<ActionPermissionSetInput>;
  requireClockInConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  roleGroupIds?: InputMaybe<UuidArrayInput>;
  roleLevelV2?: InputMaybe<Scalars['Int']['input']>;
  roleUserType?: InputMaybe<UserType>;
};

export type UpdateRoleLevelsInput = {
  roleLevels: Array<RoleLevelInput>;
};

export type UpdateScormCourseInput = {
  archived?: InputMaybe<BooleanValue>;
  coverImage?: InputMaybe<CoverImageInput>;
  description?: InputMaybe<TranslationSetInputValue>;
  dueDate?: InputMaybe<DueDateInputValue>;
  name?: InputMaybe<StringValue>;
};

export type UpdateSkillInput = {
  collaborativeCompletionEnabled?: InputMaybe<BooleanValue>;
  name?: InputMaybe<StringValue>;
  qrCodeSettings?: InputMaybe<QrCodeSettingsInput>;
  selfDirected?: InputMaybe<BooleanValue>;
  type?: InputMaybe<LibraryItemType>;
};

export type UpdateStoreOpeningInput = {
  evaluationNotes?: InputMaybe<Scalars['String']['input']>;
  evaluationStatus?: InputMaybe<StoreOpeningEvaluationStatus>;
  locationId: Scalars['Int']['input'];
  openingDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateSubtitlesInput = {
  language: Scalars['Language']['input'];
  mediaId: Scalars['Int']['input'];
  subtitleSegments: Array<SubtitleSegmentInput>;
};

export type UpdateTagsInput = {
  availableInApp: Scalars['Boolean']['input'];
  ids: Array<Scalars['UUID']['input']>;
};

export type UpdateTaskInput = {
  approvalRequired?: InputMaybe<BooleanValue>;
  assigneeId?: InputMaybe<OptionalIntValue>;
  description?: InputMaybe<OptionalStringValue>;
  dueDate?: InputMaybe<OptionalDateValue>;
  observerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  proofOfCompletionRequirement?: InputMaybe<OptionalTaskProofOfCompletionRequirementValue>;
  reviewerId?: InputMaybe<OptionalIntValue>;
  title?: InputMaybe<StringValue>;
};

export type UpdateTrainingResourceInput = {
  description?: InputMaybe<TranslationSetObjectInput>;
  mediaInput?: InputMaybe<UpdateMediaInputV2>;
  name?: InputMaybe<TranslationSetObjectInput>;
  qrCodeSettings?: InputMaybe<QrCodeSettingsInput>;
};

export type UpdateTranslationSetActionInput = {
  lang?: InputMaybe<Scalars['Language']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translationSet?: InputMaybe<TranslationSetObjectInput>;
  translationSetUuid: Scalars['UUID']['input'];
};

export type UpdateUser = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  language: Scalars['Language']['input'];
  locationIds: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  roleIds: Array<Scalars['Int']['input']>;
  userType: UserType;
};

export type UpdateUserInput = {
  email?: InputMaybe<OptionalStringInput>;
  firstName?: InputMaybe<StringInput>;
  jobTitle?: InputMaybe<StringInput>;
  language?: InputMaybe<LanguageInput>;
  lastName?: InputMaybe<StringInput>;
  locationGroupIds?: InputMaybe<UuidArrayInput>;
  locationIds?: InputMaybe<IntArrayInput>;
  name?: InputMaybe<StringInput>;
  phoneNumber?: InputMaybe<StringInput>;
  roleIds?: InputMaybe<IntArrayInput>;
  userType?: InputMaybe<UserTypeInput>;
};

export type UpdateUserSharingPermissionInput = {
  courseId?: InputMaybe<Scalars['Int']['input']>;
  moduleId?: InputMaybe<Scalars['Int']['input']>;
  permission: SharingPermission;
  skillId?: InputMaybe<Scalars['Int']['input']>;
  trainingResourceId?: InputMaybe<Scalars['UUID']['input']>;
  userId: Scalars['Int']['input'];
};

export type UpdateWorkflowNodePositionActionInput = {
  nodeId: Scalars['UUID']['input'];
  positionX: Scalars['Float']['input'];
  positionY: Scalars['Float']['input'];
};

export enum UrlType {
  Audio = 'AUDIO',
  Document = 'DOCUMENT',
  Gif = 'GIF',
  Image = 'IMAGE',
  Other = 'OTHER',
  Video = 'VIDEO'
}

export type UsBankAccount = {
  __typename?: 'UsBankAccount';
  bankName: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

export type UserActionPermissionOverrides = {
  __typename?: 'UserActionPermissionOverrides';
  actionPermissions: ActionPermissionSet;
  id: Scalars['UUID']['output'];
  lastEditedBy?: Maybe<Employee>;
  updatedAt: Scalars['DateTime']['output'];
  user: Employee;
};

export type UserActionPermissionValue = {
  __typename?: 'UserActionPermissionValue';
  hasPermission: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
  reasonEnum: PermissionReason;
};

export type UserActionPermissions = {
  __typename?: 'UserActionPermissions';
  assignContent: UserActionPermissionValue;
  changeOrgSettings: UserActionPermissionValue;
  createChat: UserActionPermissionValue;
  createContent: UserActionPermissionValue;
  deactivateTrainees: UserActionPermissionValue;
  editTrainees: UserActionPermissionValue;
  inviteOthers: UserActionPermissionValue;
  manageBilling: UserActionPermissionValue;
  manageGuestFeedbackRecommendations: UserActionPermissionValue;
  manageLibrary: UserActionPermissionValue;
  manageOrgIntegrations: UserActionPermissionValue;
  managePremiumContent: UserActionPermissionValue;
  markAsComplete: UserActionPermissionValue;
  promoteTrainees: UserActionPermissionValue;
  sendMessages: UserActionPermissionValue;
  sendPosts: UserActionPermissionValue;
  unassignContent: UserActionPermissionValue;
  updateAutomations: UserActionPermissionValue;
  verifySkills: UserActionPermissionValue;
  viewAllSubmittedTaskLists: UserActionPermissionValue;
  viewReporting: UserActionPermissionValue;
};

export type UserActionPermissionsInput = {
  assignContent?: InputMaybe<OptionalBooleanValue>;
  changeOrgSettings?: InputMaybe<OptionalBooleanValue>;
  createChat?: InputMaybe<OptionalBooleanValue>;
  createContent?: InputMaybe<OptionalBooleanValue>;
  deactivateTrainees?: InputMaybe<OptionalBooleanValue>;
  editTrainees?: InputMaybe<OptionalBooleanValue>;
  inviteOthers?: InputMaybe<OptionalBooleanValue>;
  manageBilling?: InputMaybe<OptionalBooleanValue>;
  manageGuestFeedbackRecommendations?: InputMaybe<OptionalBooleanValue>;
  manageLibrary?: InputMaybe<OptionalBooleanValue>;
  manageOrgIntegrations?: InputMaybe<OptionalBooleanValue>;
  managePremiumContent?: InputMaybe<OptionalBooleanValue>;
  markAsComplete?: InputMaybe<OptionalBooleanValue>;
  promoteTrainees?: InputMaybe<OptionalBooleanValue>;
  sendMessages?: InputMaybe<OptionalBooleanValue>;
  sendPosts?: InputMaybe<OptionalBooleanValue>;
  unassignContent?: InputMaybe<OptionalBooleanValue>;
  updateAutomations?: InputMaybe<OptionalBooleanValue>;
  verifySkills?: InputMaybe<OptionalBooleanValue>;
  viewAllSubmittedTaskLists?: InputMaybe<OptionalBooleanValue>;
  viewReporting?: InputMaybe<OptionalBooleanValue>;
};

export type UserActivityInput = {
  since?: InputMaybe<DateTimeValue>;
};

export type UserActivityWeek = {
  __typename?: 'UserActivityWeek';
  activeUsers?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  totalUsers?: Maybe<Scalars['Int']['output']>;
  week?: Maybe<Scalars['Date']['output']>;
};

export enum UserAuditEventLabel {
  DeactivatedFromUpdated = 'DEACTIVATED_FROM_UPDATED',
  EmailUpdated = 'EMAIL_UPDATED',
  EmployeeGroupMembershipCreated = 'EMPLOYEE_GROUP_MEMBERSHIP_CREATED',
  EmployeeGroupMembershipDeleted = 'EMPLOYEE_GROUP_MEMBERSHIP_DELETED',
  JobTitleUpdated = 'JOB_TITLE_UPDATED',
  PersonCreated = 'PERSON_CREATED',
  PhoneNumberUpdated = 'PHONE_NUMBER_UPDATED',
  UserCreated = 'USER_CREATED',
  UserTypeUpdated = 'USER_TYPE_UPDATED'
}

export enum UserAuditField {
  DeactivatedFromId = 'DEACTIVATED_FROM_ID',
  Email = 'EMAIL',
  GroupId = 'GROUP_ID',
  JobTitle = 'JOB_TITLE',
  PhoneNumber = 'PHONE_NUMBER',
  UserType = 'USER_TYPE'
}

export type UserAuditItem = {
  __typename?: 'UserAuditItem';
  actorType?: Maybe<ActorType>;
  actorUser?: Maybe<Employee>;
  affectedUser: Employee;
  eventLabel: UserAuditEventLabel;
  field?: Maybe<UserAuditField>;
  id: Scalars['Int']['output'];
  location?: Maybe<Location>;
  oldLocation?: Maybe<Location>;
  oldRole?: Maybe<Role>;
  oldValue?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  timestamp: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type UserAuditItems = {
  __typename?: 'UserAuditItems';
  objects: Array<UserAuditItem>;
  totalCount: Scalars['Int']['output'];
};

export type UserAuditItemsInput = {
  affectedUserIds: Array<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type UserGlobalPushNotificationSettings = {
  __typename?: 'UserGlobalPushNotificationSettings';
  id: Scalars['UUID']['output'];
  textFallback: Scalars['Boolean']['output'];
  user: Employee;
};

export type UserGlobalPushNotificationSettingsMutationResult = MutationResult & {
  __typename?: 'UserGlobalPushNotificationSettingsMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  userGlobalPushNotificationSettings?: Maybe<UserGlobalPushNotificationSettings>;
};

export type UserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['Language']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  locationGroupIds?: InputMaybe<UuidArrayInput>;
  locationIds: Array<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  roleIds: Array<Scalars['Int']['input']>;
  userType: UserType;
};

export type UserLocationGroupMembership = {
  __typename?: 'UserLocationGroupMembership';
  id: Scalars['UUID']['output'];
  locationGroup: LocationGroup;
  user: Employee;
};

export type UserMutationResult = MutationResult & {
  __typename?: 'UserMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<Employee>;
};

export enum UserPushNotificationChatSetting {
  AtMentions = 'AT_MENTIONS',
  Muted = 'MUTED',
  NewMessages = 'NEW_MESSAGES'
}

export enum UserPushNotificationNewPostsSetting {
  AtMentions = 'AT_MENTIONS',
  Muted = 'MUTED',
  NewPosts = 'NEW_POSTS'
}

export enum UserPushNotificationPostActivitySetting {
  AtMentions = 'AT_MENTIONS',
  Muted = 'MUTED',
  NewComments = 'NEW_COMMENTS'
}

export enum UserPushNotificationPostSetting {
  AtMentions = 'AT_MENTIONS',
  Muted = 'MUTED',
  NewPosts = 'NEW_POSTS',
  NewPostsAndComments = 'NEW_POSTS_AND_COMMENTS'
}

export type UserPushNotificationSetting = {
  __typename?: 'UserPushNotificationSetting';
  chatSetting?: Maybe<UserPushNotificationChatSetting>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  newPostsSetting?: Maybe<UserPushNotificationNewPostsSetting>;
  postActivitySetting?: Maybe<UserPushNotificationPostActivitySetting>;
  taskSetting?: Maybe<UserPushNotificationTaskSetting>;
  type: UserPushNotificationSettingType;
  user: Employee;
};

export type UserPushNotificationSettingChatOverride = {
  __typename?: 'UserPushNotificationSettingChatOverride';
  chat: Chat;
  chatSetting: UserPushNotificationChatSetting;
  id: Scalars['UUID']['output'];
  user: Employee;
};

export type UserPushNotificationSettingChatOverrideMutationResult = MutationResult & {
  __typename?: 'UserPushNotificationSettingChatOverrideMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  userPushNotificationSettingChatOverride?: Maybe<UserPushNotificationSettingChatOverride>;
};

export type UserPushNotificationSettingMutationResult = MutationResult & {
  __typename?: 'UserPushNotificationSettingMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  userPushNotificationSetting?: Maybe<UserPushNotificationSetting>;
};

export type UserPushNotificationSettingPostActivityOverride = {
  __typename?: 'UserPushNotificationSettingPostActivityOverride';
  id: Scalars['UUID']['output'];
  post: MessageBlast;
  postActivitySetting: UserPushNotificationPostActivitySetting;
  user: Employee;
};

export type UserPushNotificationSettingPostActivityOverrideMutationResult = MutationResult & {
  __typename?: 'UserPushNotificationSettingPostActivityOverrideMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  userPushNotificationSettingPostActivityOverride?: Maybe<UserPushNotificationSettingPostActivityOverride>;
};

export enum UserPushNotificationSettingType {
  Assignments = 'ASSIGNMENTS',
  Chats = 'CHATS',
  Checkins = 'CHECKINS',
  CoursePreviews = 'COURSE_PREVIEWS',
  NewPosts = 'NEW_POSTS',
  OneOnOneChats = 'ONE_ON_ONE_CHATS',
  PostActivity = 'POST_ACTIVITY',
  Tasks = 'TASKS'
}

export enum UserPushNotificationTaskSetting {
  AtMentions = 'AT_MENTIONS',
  Muted = 'MUTED',
  NewTasks = 'NEW_TASKS'
}

export type UserSelection = {
  __typename?: 'UserSelection';
  allAdmins: Scalars['Boolean']['output'];
  allLocations: Scalars['Boolean']['output'];
  allManagers: Scalars['Boolean']['output'];
  allTrainees: Scalars['Boolean']['output'];
  daysAfterHire?: Maybe<Scalars['Int']['output']>;
  everyoneAtOrgOrBrand: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  locationGroupMemberships: Array<UserSelectionLocationGroup>;
  locationMemberships: Array<UserSelectionLocation>;
  roleGroupMemberships: Array<UserSelectionRoleGroup>;
  roleMemberships: Array<UserSelectionRole>;
  userMemberships: Array<UserSelectionUser>;
};

export type UserSelectionFiltersInput = {
  allAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  allManagers?: InputMaybe<Scalars['Boolean']['input']>;
  allTrainees?: InputMaybe<Scalars['Boolean']['input']>;
  locationGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  roleGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UserSelectionInput = {
  allAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  allLocations: Scalars['Boolean']['input'];
  allManagers: Scalars['Boolean']['input'];
  allTrainees: Scalars['Boolean']['input'];
  daysAfterHire?: InputMaybe<Scalars['Int']['input']>;
  everyoneAtOrgOrBrand?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locationGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  roleGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UserSelectionLocation = {
  __typename?: 'UserSelectionLocation';
  id: Scalars['Int']['output'];
  location: Location;
};

export type UserSelectionLocationGroup = {
  __typename?: 'UserSelectionLocationGroup';
  id: Scalars['UUID']['output'];
  locationGroup: LocationGroup;
};

export type UserSelectionRole = {
  __typename?: 'UserSelectionRole';
  id: Scalars['Int']['output'];
  role: Role;
};

export type UserSelectionRoleGroup = {
  __typename?: 'UserSelectionRoleGroup';
  id: Scalars['UUID']['output'];
  roleGroup: RoleGroup;
};

export type UserSelectionSet = {
  __typename?: 'UserSelectionSet';
  id: Scalars['UUID']['output'];
  userSelections: Array<UserSelection>;
};

export type UserSelectionSetInput = {
  userSelections: Array<UserSelectionInput>;
};

export type UserSelectionUser = {
  __typename?: 'UserSelectionUser';
  id: Scalars['Int']['output'];
  user: Employee;
};

export type UserSharingPermission = {
  __typename?: 'UserSharingPermission';
  id: Scalars['UUID']['output'];
  permission: SharingPermission;
  user: Employee;
};

export type UserSharingPermissionMutationResult = MutationResult & {
  __typename?: 'UserSharingPermissionMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  userSharingPermission?: Maybe<UserSharingPermission>;
  userSharingPermissions?: Maybe<Array<UserSharingPermission>>;
};

export enum UserType {
  Admin = 'ADMIN',
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER'
}

export type UserTypeInput = {
  value: UserType;
};

export type UserTypeListInput = {
  value: Array<UserType>;
};

export type UuidArrayInput = {
  value: Array<Scalars['UUID']['input']>;
};

export type UuidValue = {
  value: Scalars['UUID']['input'];
};

export type ValidateAndExtractScormPackageMutationResult = MutationResult & {
  __typename?: 'ValidateAndExtractScormPackageMutationResult';
  error?: Maybe<Error>;
  scormUpload?: Maybe<ScormUpload>;
  scormValidationError?: Maybe<ScormValidationErrorType>;
  success: Scalars['Boolean']['output'];
};

export type VectorSearchResult = {
  __typename?: 'VectorSearchResult';
  chunkId: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  intercomArticleId?: Maybe<Scalars['UUID']['output']>;
  intercomArticleTitle?: Maybe<Scalars['String']['output']>;
  intercomArticleUrl?: Maybe<Scalars['String']['output']>;
  libraryItemId?: Maybe<Scalars['UUID']['output']>;
  libraryItemName?: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  sourceType?: Maybe<ChunkSourceType>;
};

export type VercelAiChatAnnotation = {
  __typename?: 'VercelAiChatAnnotation';
  file_id?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  quote?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type VercelAiChatMessage = {
  __typename?: 'VercelAiChatMessage';
  annotations?: Maybe<Array<VercelAiChatAnnotation>>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  role: VercelAiChatMessageRole;
};

export enum VercelAiChatMessageRole {
  Assistant = 'assistant',
  System = 'system',
  User = 'user'
}

export type VerificationMedia = {
  __typename?: 'VerificationMedia';
  id: Scalars['UUID']['output'];
  media: Media;
};

export type VerificationStep = {
  __typename?: 'VerificationStep';
  averageNumber?: Maybe<Scalars['Float']['output']>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  averageTemperature?: Maybe<Scalars['Float']['output']>;
  childConditionalStepGroups: Array<ConditionalStepGroup>;
  description?: Maybe<TranslationSet>;
  disableCameraRoll: Scalars['Boolean']['output'];
  failedSuggestionText?: Maybe<TranslationSet>;
  familyId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  index: Scalars['Float']['output'];
  /** @deprecated Field no longer supported */
  isNoteRequired?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Field no longer supported */
  isPhotoRequired?: Maybe<Scalars['Boolean']['output']>;
  isRequired: Scalars['Boolean']['output'];
  libraryItemLink?: Maybe<LibraryItem>;
  media?: Maybe<Media>;
  noteRequired: NoneOptionalOrRequired;
  numResponses: Scalars['Int']['output'];
  parentConditionalStepGroup?: Maybe<ConditionalStepGroup>;
  percentAnsweredYes?: Maybe<Scalars['Float']['output']>;
  percentChecked?: Maybe<Scalars['Float']['output']>;
  percentPassedEvaluation?: Maybe<Scalars['Float']['output']>;
  photoRequired: NoneOptionalOrRequired;
  responseOptions: Array<StepResponseOption>;
  temperatureUnit?: Maybe<TemperatureUnit>;
  text?: Maybe<TranslationSet>;
  trigger?: Maybe<Trigger>;
  triggerFlags: Scalars['Int']['output'];
  type: VerificationStepType;
  videoRequired: NoneOptionalOrRequired;
};

export type VerificationStepInput = {
  checkboxAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberAnswer?: InputMaybe<Scalars['Float']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  stepResponseOptionIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  temperatureAnswer?: InputMaybe<Scalars['Float']['input']>;
  textAnswer?: InputMaybe<Scalars['String']['input']>;
  verificationStepId: Scalars['UUID']['input'];
  yesNoAnswer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerificationStepInstance = {
  __typename?: 'VerificationStepInstance';
  answerLastEditedBy?: Maybe<Employee>;
  checkboxAnswer?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  draftTaskConfig?: Maybe<DraftTaskConfig>;
  id: Scalars['UUID']['output'];
  isRespondedTo: Scalars['Boolean']['output'];
  mediaLastEditedBy?: Maybe<Employee>;
  notes?: Maybe<Scalars['String']['output']>;
  notesLanguage?: Maybe<Scalars['Language']['output']>;
  notesLastEditedBy?: Maybe<Employee>;
  notesTranslation?: Maybe<Scalars['String']['output']>;
  numberAnswer?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  skillInstanceVersion: SkillInstanceVersion;
  stepResponseOptionInstances: Array<StepResponseOptionInstance>;
  temperatureAnswer?: Maybe<Scalars['Float']['output']>;
  textAnswer?: Maybe<Scalars['String']['output']>;
  textAnswerLanguage?: Maybe<Scalars['Language']['output']>;
  textAnswerTranslation?: Maybe<Scalars['String']['output']>;
  triggerConditionMet?: Maybe<Scalars['Boolean']['output']>;
  verificationMedias: Array<VerificationMedia>;
  verificationStep: VerificationStep;
  yesNoAnswer?: Maybe<Scalars['Boolean']['output']>;
};

export type VerificationStepInstances = PaginatedList & {
  __typename?: 'VerificationStepInstances';
  objects: Array<VerificationStepInstance>;
  totalCount: Scalars['Int']['output'];
};

export type VerificationStepInstancesFiltersInput = {
  createdAtEndDate?: InputMaybe<DateTimeValue>;
  createdAtStartDate?: InputMaybe<DateTimeValue>;
  peopleFilters?: InputMaybe<GetPeopleInput>;
  verificationStepIds?: InputMaybe<UuidArrayInput>;
};

export type VerificationStepInstancesInput = {
  filters: VerificationStepInstancesFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type VerificationStepObjectInput = {
  disableCameraRoll?: InputMaybe<Scalars['Boolean']['input']>;
  familyId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
  /** @deprecated Field no longer supported */
  isNoteRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Field no longer supported */
  isPhotoRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  noteRequired?: InputMaybe<NoneOptionalOrRequired>;
  parentConditionalStepGroupId?: InputMaybe<Scalars['UUID']['input']>;
  photoRequired?: InputMaybe<NoneOptionalOrRequired>;
  responseOptions?: InputMaybe<Array<StepResponseOptionObjectInput>>;
  temperatureUnit?: InputMaybe<TemperatureUnit>;
  text?: InputMaybe<TranslationSetObjectInput>;
  type: VerificationStepType;
  videoRequired?: InputMaybe<NoneOptionalOrRequired>;
};

export type VerificationStepTriggerMultipleChoiceAnyConditionInput = {
  options: Array<VerificationStepTriggerMultipleChoiceAnyConditionOptionInput>;
};

export type VerificationStepTriggerMultipleChoiceAnyConditionOptionInput = {
  stepResponseOptionId: Scalars['UUID']['input'];
};

export type VerificationStepTriggerMultipleChoiceConditionInput = {
  condition: Scalars['Boolean']['input'];
  stepResponseOptionId: Scalars['UUID']['input'];
};

export enum VerificationStepType {
  Checkbox = 'CHECKBOX',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Number = 'NUMBER',
  PassFail = 'PASS_FAIL',
  Rating = 'RATING',
  SectionBreak = 'SECTION_BREAK',
  Temperature = 'TEMPERATURE',
  Text = 'TEXT',
  YesNo = 'YES_NO'
}

export type VerifySkillInput = {
  failed?: InputMaybe<Scalars['Boolean']['input']>;
  skillVersionId: Scalars['UUID']['input'];
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationStepsInput: Array<VerificationStepInput>;
};

export type VersionMetadata = {
  __typename?: 'VersionMetadata';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<Employee>;
  id: Scalars['UUID']['output'];
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEditedBy?: Maybe<Employee>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<Employee>;
};

export type WebActivity = {
  __typename?: 'WebActivity';
  clicks: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
  visits: Scalars['Int']['output'];
};

export type WeeklyRecap = {
  __typename?: 'WeeklyRecap';
  /** @deprecated Field no longer supported */
  eslUpLevels?: Maybe<Array<Employee>>;
  numCoursesCreated: Scalars['Int']['output'];
  numCoursesPublished: Scalars['Int']['output'];
  numInvited: Scalars['Int']['output'];
  numTraineesCompletedACourse: Scalars['Int']['output'];
};

export type WeeklyRecapInput = {
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type WeeklySequenceActivity = {
  __typename?: 'WeeklySequenceActivity';
  accountsAdded: Scalars['Int']['output'];
  contactsAdded: Scalars['Int']['output'];
  weekStart: Scalars['Date']['output'];
};

export type Workflow = {
  __typename?: 'Workflow';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeInstanceCount: Scalars['Int']['output'];
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  distinctContent: Array<LibraryItem>;
  distinctSegments: Array<UserSelection>;
  draftVersion?: Maybe<WorkflowVersion>;
  id: Scalars['UUID']['output'];
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  legacyRuleSetStartingModuleId?: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  publishState: WorkflowPublishState;
  publishedVersion?: Maybe<WorkflowVersion>;
  type: WorkflowType;
  updatedAt: Scalars['DateTime']['output'];
  versions: Array<WorkflowVersion>;
};

export type WorkflowBuilderActionInput = {
  connectNodesAction?: InputMaybe<ConnectWorkflowNodesActionInput>;
  createNodeAction?: InputMaybe<CreateWorkflowNodeActionInput>;
  deleteNodeAction?: InputMaybe<DeleteWorkflowNodeActionInput>;
  disconnectNodesAction?: InputMaybe<DisconnectWorkflowNodesActionInput>;
  setActivationWindowAction?: InputMaybe<SetWorkflowActivationWindowActionInput>;
  setNameAction?: InputMaybe<SetWorkflowNameActionInput>;
  setNodeLibraryItemAction?: InputMaybe<SetWorkflowNodeLibraryItemActionInput>;
  setNodeTimeDelayAction?: InputMaybe<SetWorkflowNodeTimeDelayActionInput>;
  setNodeUserSelectionSetAction?: InputMaybe<SetWorkflowNodeUserSelectionSetActionInput>;
  updateNodePositionAction?: InputMaybe<UpdateWorkflowNodePositionActionInput>;
  workflowId: Scalars['UUID']['input'];
};

export enum WorkflowBuilderActionType {
  ConnectNodes = 'CONNECT_NODES',
  CreateNode = 'CREATE_NODE',
  DeleteNode = 'DELETE_NODE',
  DisconnectNodes = 'DISCONNECT_NODES',
  UpdateNodeConfig = 'UPDATE_NODE_CONFIG',
  UpdateNodePosition = 'UPDATE_NODE_POSITION'
}

export type WorkflowEdge = {
  __typename?: 'WorkflowEdge';
  childNodeId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  parentNodeId: Scalars['UUID']['output'];
};

export type WorkflowInstance = {
  __typename?: 'WorkflowInstance';
  canceledBy?: Maybe<Employee>;
  cancellationReason?: Maybe<WorkflowInstanceCancellationReason>;
  createdAt: Scalars['DateTime']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  nodeInstances: Array<WorkflowNodeInstance>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: WorkflowInstanceStatus;
  triggeredByModuleInstanceId?: Maybe<Scalars['UUID']['output']>;
  triggeredBySkillInstanceId?: Maybe<Scalars['UUID']['output']>;
  user?: Maybe<Employee>;
  workflowVersion: WorkflowVersion;
};

export enum WorkflowInstanceCancellationReason {
  AdminCancel = 'ADMIN_CANCEL',
  Archived = 'ARCHIVED',
  ReferenceUnavailable = 'REFERENCE_UNAVAILABLE',
  VersionSuperseded = 'VERSION_SUPERSEDED'
}

export type WorkflowInstanceMutationResult = MutationResult & {
  __typename?: 'WorkflowInstanceMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  workflowInstance?: Maybe<WorkflowInstance>;
};

export enum WorkflowInstanceStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type WorkflowInstances = PaginatedList & {
  __typename?: 'WorkflowInstances';
  objects: Array<WorkflowInstance>;
  totalCount: Scalars['Int']['output'];
};

export type WorkflowInstancesFiltersInput = {
  startedAtEndDate?: InputMaybe<DateTimeValue>;
  startedAtStartDate?: InputMaybe<DateTimeValue>;
  statuses?: InputMaybe<Array<WorkflowInstanceStatus>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  workflowId: Scalars['UUID']['input'];
};

export type WorkflowInstancesInput = {
  filters: WorkflowInstancesFiltersInput;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export type WorkflowMutationResult = MutationResult & {
  __typename?: 'WorkflowMutationResult';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  workflow?: Maybe<Workflow>;
};

export type WorkflowNode = {
  __typename?: 'WorkflowNode';
  id: Scalars['UUID']['output'];
  libraryItem?: Maybe<LibraryItem>;
  positionX: Scalars['Float']['output'];
  positionY: Scalars['Float']['output'];
  timeDelayDays?: Maybe<Scalars['Int']['output']>;
  type: WorkflowNodeType;
  userSelectionSet?: Maybe<UserSelectionSet>;
};

export enum WorkflowNodeCancellationReason {
  /** The step's legacy fire window passed without it ever running — written by the in-flight seeder, never by the live executor. */
  LegacyWindowExpired = 'LEGACY_WINDOW_EXPIRED'
}

export type WorkflowNodeInstance = {
  __typename?: 'WorkflowNodeInstance';
  cancellationReason?: Maybe<WorkflowNodeCancellationReason>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: WorkflowNodeInstanceStatus;
  workflowNode: WorkflowNode;
  workflowNodeId: Scalars['UUID']['output'];
};

export enum WorkflowNodeInstanceStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  FilteredOut = 'FILTERED_OUT',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
  WaitingForCompletion = 'WAITING_FOR_COMPLETION',
  WaitingForDelay = 'WAITING_FOR_DELAY'
}

export enum WorkflowNodeType {
  StepAssignContent = 'STEP_ASSIGN_CONTENT',
  StepFilter = 'STEP_FILTER',
  StepTimeDelay = 'STEP_TIME_DELAY',
  StepWaitForCompletion = 'STEP_WAIT_FOR_COMPLETION',
  TriggerAssignmentCompleted = 'TRIGGER_ASSIGNMENT_COMPLETED',
  TriggerTaskListSubmitted = 'TRIGGER_TASK_LIST_SUBMITTED'
}

export enum WorkflowPublishState {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  UnpublishedChanges = 'UNPUBLISHED_CHANGES'
}

/** Deprecated: superseded by WorkflowInstanceCancellationReason; retained only for frozen migrations. */
export enum WorkflowRunCancellationReason {
  AdminCancel = 'ADMIN_CANCEL',
  Archived = 'ARCHIVED',
  ReferenceUnavailable = 'REFERENCE_UNAVAILABLE',
  VersionSuperseded = 'VERSION_SUPERSEDED'
}

/** Deprecated: superseded by WorkflowInstanceStatus; retained only for frozen migrations. */
export enum WorkflowRunStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  FilteredOut = 'FILTERED_OUT',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

/** Deprecated: superseded by WorkflowNodeInstanceStatus; retained only for frozen migrations. */
export enum WorkflowRunStepStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  FilteredOut = 'FILTERED_OUT',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
  WaitingForCompletion = 'WAITING_FOR_COMPLETION',
  WaitingForDelay = 'WAITING_FOR_DELAY'
}

/** Deprecated: superseded by WorkflowPublishState; retained only for frozen migrations. */
export enum WorkflowStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  UnpublishedChanges = 'UNPUBLISHED_CHANGES'
}

export enum WorkflowType {
  Path = 'PATH',
  Workflow = 'WORKFLOW'
}

export type WorkflowValidationError = {
  __typename?: 'WorkflowValidationError';
  code: WorkflowValidationErrorCode;
  message: Scalars['String']['output'];
  nodeIds: Array<Scalars['UUID']['output']>;
};

export enum WorkflowValidationErrorCode {
  ContentTypeNotAllowed = 'CONTENT_TYPE_NOT_ALLOWED',
  Cycle = 'CYCLE',
  MissingConfig = 'MISSING_CONFIG',
  MultipleTriggers = 'MULTIPLE_TRIGGERS',
  NodeTypeNotAllowed = 'NODE_TYPE_NOT_ALLOWED',
  NoTrigger = 'NO_TRIGGER',
  OrphanSubtree = 'ORPHAN_SUBTREE',
  ReferenceDeleted = 'REFERENCE_DELETED',
  WaitWithoutUpstreamAssign = 'WAIT_WITHOUT_UPSTREAM_ASSIGN'
}

export type WorkflowVersion = {
  __typename?: 'WorkflowVersion';
  edges: Array<WorkflowEdge>;
  id: Scalars['UUID']['output'];
  nodes: Array<WorkflowNode>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Workflows = PaginatedList & {
  __typename?: 'Workflows';
  objects: Array<Workflow>;
  totalCount: Scalars['Int']['output'];
};

export type WorkflowsFiltersInput = {
  contentTypes?: InputMaybe<LibraryItemTypeListInput>;
  libraryItemIds?: InputMaybe<UuidArrayInput>;
  types?: InputMaybe<Array<WorkflowType>>;
  userSelection?: InputMaybe<UserSelectionFiltersInput>;
};

export type WorkflowsInput = {
  filters?: InputMaybe<WorkflowsFiltersInput>;
  search?: InputMaybe<StringValue>;
  sort?: InputMaybe<SortInput>;
};

export const GraphqlOperations = {
  Query: {
    BrandSelector: 'BrandSelector',
    ChatReferences_AdminLibraryItems: 'ChatReferences_AdminLibraryItems',
    ChatReferences_TraineeLibraryItems: 'ChatReferences_TraineeLibraryItems',
    ChatReferences_LegacyAdminLibraryBySearchDocs: 'ChatReferences_LegacyAdminLibraryBySearchDocs',
    ChatReferences_LegacyAssignmentsBySearchDocs: 'ChatReferences_LegacyAssignmentsBySearchDocs',
    BillingBanner: 'BillingBanner',
    LocationsWithoutAddressesBanner: 'LocationsWithoutAddressesBanner',
    AddMediaDialogTrainingResources: 'AddMediaDialogTrainingResources',
    AddMediaResourcesTrainingResources: 'AddMediaResourcesTrainingResources',
    Search_StockPhotos: 'Search_StockPhotos',
    Search_StockVideos: 'Search_StockVideos',
    AIUploadMediaGetSupportedImagesMIMETypes: 'AIUploadMediaGetSupportedImagesMIMETypes',
    AIGenerateUploadTrainingResourceLibraryItems: 'AIGenerateUploadTrainingResourceLibraryItems',
    AssignContentToUserDialog: 'AssignContentToUserDialog',
    InviteQRCodeDialog: 'InviteQRCodeDialog',
    OrgForUpdate: 'OrgForUpdate',
    TranslationSet: 'TranslationSet',
    IsStaff: 'IsStaff',
    MyJointEmployerStatus: 'MyJointEmployerStatus',
    MeUserId: 'MeUserId',
    AvailableOrgCount: 'AvailableOrgCount',
    ClientFacingWorkflow: 'ClientFacingWorkflow',
    Init: 'Init',
    SearchUsersForImpersonation: 'SearchUsersForImpersonation',
    Notifications: 'Notifications',
    GetNotifications: 'GetNotifications',
    OrgSwitcher: 'OrgSwitcher',
    OrgFeatureFlags: 'OrgFeatureFlags',
    SetOrgFeatureFlags_FeatureFlags: 'SetOrgFeatureFlags_FeatureFlags',
    JumpToPeople: 'JumpToPeople',
    JumpToLibraryItems: 'JumpToLibraryItems',
    JumpToLocationGroups: 'JumpToLocationGroups',
    JumpToLocations: 'JumpToLocations',
    JumpToRoleGroups: 'JumpToRoleGroups',
    JumpToRoles: 'JumpToRoles',
    JumpToTags: 'JumpToTags',
    RecentlyViewedEmployees: 'RecentlyViewedEmployees',
    RecentlyViewedLibraryItems: 'RecentlyViewedLibraryItems',
    RecentlyViewedCourses: 'RecentlyViewedCourses',
    RecentlyViewedTrainingResources: 'RecentlyViewedTrainingResources',
    RecentlyViewedLocations: 'RecentlyViewedLocations',
    RecentlyViewedRoles: 'RecentlyViewedRoles',
    RecentlyViewedLocationGroups: 'RecentlyViewedLocationGroups',
    RecentlyViewedRoleGroups: 'RecentlyViewedRoleGroups',
    SuggestedQuestions: 'SuggestedQuestions',
    ChatAttachMenuLibraryItems: 'ChatAttachMenuLibraryItems',
    ChatHistory: 'ChatHistory',
    AutomationList: 'AutomationList',
    AutomationListCount: 'AutomationListCount',
    ActiveClients: 'ActiveClients',
    CourseInstanceResponsesDialog: 'CourseInstanceResponsesDialog',
    CourseFeedbackRatingDistribution: 'CourseFeedbackRatingDistribution',
    CourseFeedbacks: 'CourseFeedbacks',
    AssignmentStatusCounts: 'AssignmentStatusCounts',
    NumUsersEligibleForAutomation: 'NumUsersEligibleForAutomation',
    FoodHandlerDetailAssignmentsTabContainer_Assignments: 'FoodHandlerDetailAssignmentsTabContainer_Assignments',
    PremiumModuleDetailAssignmentsTabContainer_Assignments: 'PremiumModuleDetailAssignmentsTabContainer_Assignments',
    PremiumModuleDetailOverview: 'PremiumModuleDetailOverview',
    PremiumModuleDetailHeader: 'PremiumModuleDetailHeader',
    PremiumModuleDetailCertificatesCount: 'PremiumModuleDetailCertificatesCount',
    UpcomingReassignmentCohortDetails: 'UpcomingReassignmentCohortDetails',
    SkillDetailOverview: 'SkillDetailOverview',
    SkillDetailCounts: 'SkillDetailCounts',
    OpenGraphData: 'OpenGraphData',
    AssignLibraryItemDialog_LibraryItem: 'AssignLibraryItemDialog_LibraryItem',
    AssignLibraryItemDialog_Assignments: 'AssignLibraryItemDialog_Assignments',
    ProgressiveTagFilterTags: 'ProgressiveTagFilterTags',
    SelectFolderDialog: 'SelectFolderDialog',
    AutomationDialog_GetUsersForUserSelectionSet: 'AutomationDialog_GetUsersForUserSelectionSet',
    NewAutomationCourse: 'NewAutomationCourse',
    NewAutomationModule: 'NewAutomationModule',
    NewAutomationTrainingResource: 'NewAutomationTrainingResource',
    AutomationDialog_Query: 'AutomationDialog_Query',
    SelectUsersDialog_Users: 'SelectUsersDialog_Users',
    SelectUsersDialog_LocationGroups: 'SelectUsersDialog_LocationGroups',
    ReassignmentSelectModuleContent_LibraryItem: 'ReassignmentSelectModuleContent_LibraryItem',
    useAssignmentSummaryData_Assignments: 'useAssignmentSummaryData_Assignments',
    GetUsersForUserSelectionSet: 'GetUsersForUserSelectionSet',
    GetUsersForUserSelection: 'GetUsersForUserSelection',
    UserIdsToReassign_Assignments: 'UserIdsToReassign_Assignments',
    GetSelectedUsers: 'GetSelectedUsers',
    ModuleContentSelectionDialog_LibraryItem: 'ModuleContentSelectionDialog_LibraryItem',
    CourseSingleSelectDropdown: 'CourseSingleSelectDropdown',
    CourseAssignmentFilterState: 'CourseAssignmentFilterState',
    FoodHandlerModuleAssignmentFilterState: 'FoodHandlerModuleAssignmentFilterState',
    ModuleAssignmentFilterState: 'ModuleAssignmentFilterState',
    LibraryItemFilterDropdown: 'LibraryItemFilterDropdown',
    LocationGroupFilters: 'LocationGroupFilters',
    AddContentToFolderDialog: 'AddContentToFolderDialog',
    AddContentToFolderDialog_ExistingItems: 'AddContentToFolderDialog_ExistingItems',
    FolderLibraryItem: 'FolderLibraryItem',
    FolderAncestors: 'FolderAncestors',
    GetGoogleBusinessAccounts: 'GetGoogleBusinessAccounts',
    OrgGuestFeedbackCsvUploadsSidebar: 'OrgGuestFeedbackCsvUploadsSidebar',
    OrgGuestFeedbackCsvUploads: 'OrgGuestFeedbackCsvUploads',
    OrgGuestFeedbackIntegrationSidebar: 'OrgGuestFeedbackIntegrationSidebar',
    GuestFeedbackIntegrationOpusLocations: 'GuestFeedbackIntegrationOpusLocations',
    GuestFeedbackIntegrationBrands: 'GuestFeedbackIntegrationBrands',
    OrgGuestFeedbackIntegrations: 'OrgGuestFeedbackIntegrations',
    GuestFeedbackRatingTrend: 'GuestFeedbackRatingTrend',
    GuestFeedbackReviewsTab_GuestFeedbacks: 'GuestFeedbackReviewsTab_GuestFeedbacks',
    OrgGuestFeedbackSyncsSidebar: 'OrgGuestFeedbackSyncsSidebar',
    OrgGuestFeedbackSyncs: 'OrgGuestFeedbackSyncs',
    LocationsForGuestFeedback: 'LocationsForGuestFeedback',
    GuestFeedbackSourceOptions: 'GuestFeedbackSourceOptions',
    GuestFeedbackRecommendations: 'GuestFeedbackRecommendations',
    GuestFeedbackAnalysisRunStatus: 'GuestFeedbackAnalysisRunStatus',
    GuestFeedbackThemes: 'GuestFeedbackThemes',
    GuestFeedbackRecommendationDetail: 'GuestFeedbackRecommendationDetail',
    RecommendationImpactTrend: 'RecommendationImpactTrend',
    RecommendationImpactLocationVolume: 'RecommendationImpactLocationVolume',
    GuestFeedbackThemeSummary: 'GuestFeedbackThemeSummary',
    GuestFeedbackSetupStatus: 'GuestFeedbackSetupStatus',
    ActiveLanguagesWidget: 'ActiveLanguagesWidget',
    ActiveAndTotalManagers: 'ActiveAndTotalManagers',
    ActivityWidget: 'ActivityWidget',
    AssignmentCompletion__HomeWidget: 'AssignmentCompletion__HomeWidget',
    AvgTrainingFeedbackWidget: 'AvgTrainingFeedbackWidget',
    AverageCourseFeedback: 'AverageCourseFeedback',
    IncompleteAssignmentsSheet: 'IncompleteAssignmentsSheet',
    IncompleteAssignmentsWidget: 'IncompleteAssignmentsWidget',
    LocationAssignmentLeaderboardWidget: 'LocationAssignmentLeaderboardWidget',
    LocationGroupDialog_LocationGroup: 'LocationGroupDialog_LocationGroup',
    LocationGroupDialog_Locations: 'LocationGroupDialog_Locations',
    LocationsTable_Locations: 'LocationsTable_Locations',
    NotInvitedUsersSheetHrisEmployees: 'NotInvitedUsersSheetHrisEmployees',
    NotInvitedUsersWidgetHrisEmployees: 'NotInvitedUsersWidgetHrisEmployees',
    NotInvitedUsersWidgetNotInvitedHrisEmployees: 'NotInvitedUsersWidgetNotInvitedHrisEmployees',
    RecentlyAssignedLibraryItems: 'RecentlyAssignedLibraryItems',
    RecentCourseFeedback: 'RecentCourseFeedback',
    RecentSubmissionsWidget: 'RecentSubmissionsWidget',
    AdminRecentlyEditedModules: 'AdminRecentlyEditedModules',
    RoleGroupDialog_RoleGroup: 'RoleGroupDialog_RoleGroup',
    RoleGroupDialog_Roles: 'RoleGroupDialog_Roles',
    TotalActiveUsersWidget: 'TotalActiveUsersWidget',
    TotalLocationsCount: 'TotalLocationsCount',
    AdminEmployeesCount: 'AdminEmployeesCount',
    UsersNoRoleSheet: 'UsersNoRoleSheet',
    UsersNoRoleWidgetCount: 'UsersNoRoleWidgetCount',
    InactiveUsersSheet: 'InactiveUsersSheet',
    InactiveUsersCount: 'InactiveUsersCount',
    LocationGroupParentOptions_LocationGroups: 'LocationGroupParentOptions_LocationGroups',
    LocationGroupChildrenOptions_LocationGroups: 'LocationGroupChildrenOptions_LocationGroups',
    RoleGroupParentOptions_RoleGroups: 'RoleGroupParentOptions_RoleGroups',
    RoleGroupChildrenOptions_RoleGroups: 'RoleGroupChildrenOptions_RoleGroups',
    KnowledgeCheckPaginatedTable_LibraryItem: 'KnowledgeCheckPaginatedTable_LibraryItem',
    LibraryItemAccessAutomation: 'LibraryItemAccessAutomation',
    DeleteFolderDialog_FolderItemCount: 'DeleteFolderDialog_FolderItemCount',
    FoldersGrid_Folders: 'FoldersGrid_Folders',
    LibraryAllContentTable_LibraryItems: 'LibraryAllContentTable_LibraryItems',
    LibrarySummaryBar_Counts: 'LibrarySummaryBar_Counts',
    LibraryContentCount: 'LibraryContentCount',
    ArchiveLibraryPaginatedTable_LibraryItems: 'ArchiveLibraryPaginatedTable_LibraryItems',
    CheckInsPageHeader: 'CheckInsPageHeader',
    CheckinsLibraryPaginatedTable_LibraryItems: 'CheckinsLibraryPaginatedTable_LibraryItems',
    CourseLibraryItemPaginatedTable_LibraryItem: 'CourseLibraryItemPaginatedTable_LibraryItem',
    CoursesPageHeader: 'CoursesPageHeader',
    ModulesLibraryPaginatedTable_LibraryItems: 'ModulesLibraryPaginatedTable_LibraryItems',
    SaveModuleDialog: 'SaveModuleDialog',
    ResourcesLibraryPaginatedTable_LibraryItems: 'ResourcesLibraryPaginatedTable_LibraryItems',
    ResourcesPageHeader: 'ResourcesPageHeader',
    ScormCourseLibraryItemPaginatedTable_LibraryItem: 'ScormCourseLibraryItemPaginatedTable_LibraryItem',
    ScormCoursesPageHeader: 'ScormCoursesPageHeader',
    TasksLibraryPaginatedTable_LibraryItems: 'TasksLibraryPaginatedTable_LibraryItems',
    TaskListDigestSubscription: 'TaskListDigestSubscription',
    AssignmentCompletionGraph: 'AssignmentCompletionGraph',
    LibraryItemDetailPage_LibraryItem: 'LibraryItemDetailPage_LibraryItem',
    FileAssignments: 'FileAssignments',
    CourseAiGenerationStatus: 'CourseAiGenerationStatus',
    CourseDetailPageQuery: 'CourseDetailPageQuery',
    CourseDetailOverview: 'CourseDetailOverview',
    CourseDetailHeader: 'CourseDetailHeader',
    CourseVersions: 'CourseVersions',
    MediaPreviewMedia: 'MediaPreviewMedia',
    CourseVersion: 'CourseVersion',
    CourseContentRedirect: 'CourseContentRedirect',
    getCourseCommentThreads: 'getCourseCommentThreads',
    CommentMentionPeople: 'CommentMentionPeople',
    LinkedLibraryItemPreviewWithSubtitles: 'LinkedLibraryItemPreviewWithSubtitles',
    CourseVersionGrade: 'CourseVersionGrade',
    GetAIRequests: 'GetAIRequests',
    CourseManageTabAssignments: 'CourseManageTabAssignments',
    CourseDetailLibraryAccess: 'CourseDetailLibraryAccess',
    CourseReportingOverview_LibraryItem: 'CourseReportingOverview_LibraryItem',
    CourseReportingOverview_CourseVersion: 'CourseReportingOverview_CourseVersion',
    CourseReportingAverageTimeToComplete_LibraryItem: 'CourseReportingAverageTimeToComplete_LibraryItem',
    CourseReportingOverview_ResponseOptionReportingInstances: 'CourseReportingOverview_ResponseOptionReportingInstances',
    CourseReportingPromptResponsesTable_PromptInstances: 'CourseReportingPromptResponsesTable_PromptInstances',
    CourseReportingVersionSelector_LibraryItem: 'CourseReportingVersionSelector_LibraryItem',
    CourseSharingPermissions: 'CourseSharingPermissions',
    ModuleSharingPermissions: 'ModuleSharingPermissions',
    TrainingResourceSharingPermissions: 'TrainingResourceSharingPermissions',
    ContentPermissions: 'ContentPermissions',
    LibraryItemContentPermissions: 'LibraryItemContentPermissions',
    BuilderActions: 'BuilderActions',
    ValidateModule_Module: 'ValidateModule_Module',
    BuilderModuleVersion: 'BuilderModuleVersion',
    PollModuleItemAiGeneration: 'PollModuleItemAiGeneration',
    RedirectModuleBuilder: 'RedirectModuleBuilder',
    PollAIGenerateModuleRequests: 'PollAIGenerateModuleRequests',
    PollAISCORMUploadRequests: 'PollAISCORMUploadRequests',
    ModuleContentLibraryItems: 'ModuleContentLibraryItems',
    AddModuleContentMembership_Course: 'AddModuleContentMembership_Course',
    AddModuleContentMembership_Courses: 'AddModuleContentMembership_Courses',
    getCommentThreadsInModule: 'getCommentThreadsInModule',
    ModuleManageAssignmentsTab_Assignments: 'ModuleManageAssignmentsTab_Assignments',
    ModuleManageLibraryAccessTab_Assignments: 'ModuleManageLibraryAccessTab_Assignments',
    ModuleManageSettingsTab_Module: 'ModuleManageSettingsTab_Module',
    ModuleReportingContent_LibraryItem: 'ModuleReportingContent_LibraryItem',
    ModuleReportingAvgTimeToComplete_LibraryItem: 'ModuleReportingAvgTimeToComplete_LibraryItem',
    ModuleReportingStepsTable_ModuleVersion: 'ModuleReportingStepsTable_ModuleVersion',
    ModuleReportingStepsTableCourses_AverageTimeToCompletes: 'ModuleReportingStepsTableCourses_AverageTimeToCompletes',
    ModuleReportingVersionSelector_LibraryItem: 'ModuleReportingVersionSelector_LibraryItem',
    LibraryItemOverviewPathMembership: 'LibraryItemOverviewPathMembership',
    LibraryItemOverviewRecentAssignments: 'LibraryItemOverviewRecentAssignments',
    LibraryItemOverviewVersions: 'LibraryItemOverviewVersions',
    ModuleHomescreenCoursePreviews: 'ModuleHomescreenCoursePreviews',
    TrainingResourceViews: 'TrainingResourceViews',
    TrainingResourceDetailPage_TrainingResourceVersion: 'TrainingResourceDetailPage_TrainingResourceVersion',
    TrainingResourceDetailPage_CheckMediaConversionStatus: 'TrainingResourceDetailPage_CheckMediaConversionStatus',
    TrainingResourceBuildRightPane_Media: 'TrainingResourceBuildRightPane_Media',
    TrainingResourcePDFContainer_TrainingResource: 'TrainingResourcePDFContainer_TrainingResource',
    ScormCourseManageAssignmentsTab_Assignments: 'ScormCourseManageAssignmentsTab_Assignments',
    ScormCourseDetailLibraryAccess: 'ScormCourseDetailLibraryAccess',
    CourseModuleMemberships: 'CourseModuleMemberships',
    LinkedLibraryItemPreview: 'LinkedLibraryItemPreview',
    AssignmentTimelineDialog: 'AssignmentTimelineDialog',
    AssignmentTimelineDialog_AssignmentHistoryItems: 'AssignmentTimelineDialog_AssignmentHistoryItems',
    ModuleInstanceScreen: 'ModuleInstanceScreen',
    SkillInstanceDialogV2_SkillInstance: 'SkillInstanceDialogV2_SkillInstance',
    PublishSkillDialog_Skill: 'PublishSkillDialog_Skill',
    ShareSkillDialog_Skill: 'ShareSkillDialog_Skill',
    SkillBuilderLinkedLibraryItem_LibraryItem: 'SkillBuilderLinkedLibraryItem_LibraryItem',
    SkillBuilder_SkillVersion: 'SkillBuilder_SkillVersion',
    SkillVersions: 'SkillVersions',
    AssignmentsTab_Skill: 'AssignmentsTab_Skill',
    AssignmentsTab_Assignments: 'AssignmentsTab_Assignments',
    SkillDetailLibraryAccess: 'SkillDetailLibraryAccess',
    GetLibraryItemCompletionSchedule: 'GetLibraryItemCompletionSchedule',
    CheckinAllAttemptsTab_SkillInstances: 'CheckinAllAttemptsTab_SkillInstances',
    SkillReportingOverview_SkillVersion: 'SkillReportingOverview_SkillVersion',
    SkillReportingOverview_ResponseOptionReportingInstances: 'SkillReportingOverview_ResponseOptionReportingInstances',
    SkillReportingResponsesTable_VerificationStepInstances: 'SkillReportingResponsesTable_VerificationStepInstances',
    SkillReportingVersionSelector_LibraryItem: 'SkillReportingVersionSelector_LibraryItem',
    TaskAllAttemptsTab_SkillInstances: 'TaskAllAttemptsTab_SkillInstances',
    TaskFullSubmissionsTab_SkillInstances: 'TaskFullSubmissionsTab_SkillInstances',
    TaskReportingResponsesTable_VerificationStepInstances: 'TaskReportingResponsesTable_VerificationStepInstances',
    TaskScheduleCompletionTab_CompletionSchedule: 'TaskScheduleCompletionTab_CompletionSchedule',
    TaskScheduleCompletionTab_CompletionScheduleWindows: 'TaskScheduleCompletionTab_CompletionScheduleWindows',
    LocationsPageHeader: 'LocationsPageHeader',
    ActivatedLocations: 'ActivatedLocations',
    locationDialog_Location: 'locationDialog_Location',
    LocationDialog_LocationGroup: 'LocationDialog_LocationGroup',
    GetLocationGroups: 'GetLocationGroups',
    GetLocations: 'GetLocations',
    GetEmployees: 'GetEmployees',
    LocationGroupLocationsTable_Locations: 'LocationGroupLocationsTable_Locations',
    LocationGroupPagePeople: 'LocationGroupPagePeople',
    PaginatedLocationGroupsTable: 'PaginatedLocationGroupsTable',
    SubRegionsList_LocationGroup: 'SubRegionsList_LocationGroup',
    MarketplacePageCatalogCategories: 'MarketplacePageCatalogCategories',
    OrgPremiumContentConfigs: 'OrgPremiumContentConfigs',
    MessageDialogGateUsers: 'MessageDialogGateUsers',
    MessageBlasts: 'MessageBlasts',
    ReceivedMessages: 'ReceivedMessages',
    getReceivedMessage: 'getReceivedMessage',
    getMessageBlast: 'getMessageBlast',
    PostActivityPushNotificationSetting: 'PostActivityPushNotificationSetting',
    PostsPushNotificationSetting: 'PostsPushNotificationSetting',
    MessagingActivityUnreadCount: 'MessagingActivityUnreadCount',
    MessagingActivityItems: 'MessagingActivityItems',
    ChatMessageMentionableUsers: 'ChatMessageMentionableUsers',
    ChatComposerDraftMedia: 'ChatComposerDraftMedia',
    ChatComposerDraftLibraryItem: 'ChatComposerDraftLibraryItem',
    NewMessagingSearchChatMessages: 'NewMessagingSearchChatMessages',
    NewMessagingChat: 'NewMessagingChat',
    NewMessagingChatMessages: 'NewMessagingChatMessages',
    NewMessagingChats: 'NewMessagingChats',
    GroupChatOwnerUsers: 'GroupChatOwnerUsers',
    SendSeparateChatMessagesDialogUsers: 'SendSeparateChatMessagesDialogUsers',
    ChatNotificationOverride: 'ChatNotificationOverride',
    ChatsPushNotificationSetting: 'ChatsPushNotificationSetting',
    AdminReportedContent: 'AdminReportedContent',
    ReportedPostDetailBlast: 'ReportedPostDetailBlast',
    MessagingSearchChatMessages: 'MessagingSearchChatMessages',
    MessagingSearchMessageBlasts: 'MessagingSearchMessageBlasts',
    MessagingSearchPostComments: 'MessagingSearchPostComments',
    UserPushNotificationSettingPostActivityOverrides: 'UserPushNotificationSettingPostActivityOverrides',
    PostDialogBlast: 'PostDialogBlast',
    NewMessagingReceivedPosts: 'NewMessagingReceivedPosts',
    NewMessagingPosts: 'NewMessagingPosts',
    PostDetailFallbackBlast: 'PostDetailFallbackBlast',
    PostCommentMentionableUsers: 'PostCommentMentionableUsers',
    NewMessagingPostComments: 'NewMessagingPostComments',
    NewMessagingPostReactions: 'NewMessagingPostReactions',
    NewMessagingPostReads: 'NewMessagingPostReads',
    PostMentionableUsers: 'PostMentionableUsers',
    AdminPermissionSelectList: 'AdminPermissionSelectList',
    NotificationPreferences: 'NotificationPreferences',
    PermissionCardEnabledCount: 'PermissionCardEnabledCount',
    PermissionUsersDialogList: 'PermissionUsersDialogList',
    MyProfilePageUser: 'MyProfilePageUser',
    MyCompletedTrainingTable: 'MyCompletedTrainingTable',
    MyTrainingAssignmentsTable: 'MyTrainingAssignmentsTable',
    MyTrainingFoodHandlerModules: 'MyTrainingFoodHandlerModules',
    MyTrainingFoodHandlerExams: 'MyTrainingFoodHandlerExams',
    MyTrainingPageMyTodoAssignmentsCount: 'MyTrainingPageMyTodoAssignmentsCount',
    MyTrainingPageMyTodoAssignments: 'MyTrainingPageMyTodoAssignments',
    MyTrainingPageCompletedAssignments: 'MyTrainingPageCompletedAssignments',
    MyTrainingSkillInstancePreview: 'MyTrainingSkillInstancePreview',
    TraineeLibraryItemSidebar: 'TraineeLibraryItemSidebar',
    TraineeLibrary_LibraryItems: 'TraineeLibrary_LibraryItems',
    MyTraining_TrainingResourceInstance: 'MyTraining_TrainingResourceInstance',
    MyTrainingModuleInstanceAssignment: 'MyTrainingModuleInstanceAssignment',
    MyTrainingCurrentModuleAssignment: 'MyTrainingCurrentModuleAssignment',
    MyTrainingModuleInstanceScreen: 'MyTrainingModuleInstanceScreen',
    UserClockInStatus: 'UserClockInStatus',
    CourseInstanceScreen: 'CourseInstanceScreen',
    CourseContentCourse: 'CourseContentCourse',
    CourseContentMembershipInstanceRowAssignment: 'CourseContentMembershipInstanceRowAssignment',
    SCORMCourseInstanceContainer: 'SCORMCourseInstanceContainer',
    OpusAgentChats: 'OpusAgentChats',
    OpusAgentChat: 'OpusAgentChat',
    OpusAgentDefaultModel: 'OpusAgentDefaultModel',
    OpusAgentMostRecentChat: 'OpusAgentMostRecentChat',
    OpusAgentTurns: 'OpusAgentTurns',
    OpusAgentTurnEvents: 'OpusAgentTurnEvents',
    OnCompletionAssignmentRuleSets: 'OnCompletionAssignmentRuleSets',
    PlacholderSidebarLibraryItems: 'PlacholderSidebarLibraryItems',
    PathsPageHeaderCount: 'PathsPageHeaderCount',
    PaginatedOnCompletionAssignmentRuleSets: 'PaginatedOnCompletionAssignmentRuleSets',
    AllAuditSubmissions_SkillInstances: 'AllAuditSubmissions_SkillInstances',
    AllTaskSubmissions_SkillInstances: 'AllTaskSubmissions_SkillInstances',
    AskOpusQuestionAnswers: 'AskOpusQuestionAnswers',
    AskOpusThemeAnalysis: 'AskOpusThemeAnalysis',
    ReportTopics: 'ReportTopics',
    GetSavedReports: 'GetSavedReports',
    LibraryItemFilter: 'LibraryItemFilter',
    LibraryItemHoverCardContent: 'LibraryItemHoverCardContent',
    LocationGroupHoverCard: 'LocationGroupHoverCard',
    LocationHoverCard: 'LocationHoverCard',
    GetReportViews: 'GetReportViews',
    UserHoverCard: 'UserHoverCard',
    CompletionGridLibraryItems: 'CompletionGridLibraryItems',
    CompletionGridLibraryItemsWithModuleMemberships: 'CompletionGridLibraryItemsWithModuleMemberships',
    CompletionGridAllModules: 'CompletionGridAllModules',
    CompletionReports: 'CompletionReports',
    OrgHierarchy: 'OrgHierarchy',
    Locations__locationGroupMemberships: 'Locations__locationGroupMemberships',
    MessageBlastHoverCard: 'MessageBlastHoverCard',
    MessageReadsGrid: 'MessageReadsGrid',
    MessageReadsGridMessages: 'MessageReadsGridMessages',
    TaskListCompletionGridLibraryItems: 'TaskListCompletionGridLibraryItems',
    TaskListCompletionGridLibraryItemsWithModuleMemberships: 'TaskListCompletionGridLibraryItemsWithModuleMemberships',
    TasksListsCompletionGrid_CompletedTaskCounts: 'TasksListsCompletionGrid_CompletedTaskCounts',
    TasksListsCompletionGrid_ScheduleCompletionPercent: 'TasksListsCompletionGrid_ScheduleCompletionPercent',
    UserCompletionGrid__Assignments: 'UserCompletionGrid__Assignments',
    UserCompletionGrid__Users: 'UserCompletionGrid__Users',
    ComplianceAttemptImportRow_People: 'ComplianceAttemptImportRow_People',
    ComplianceRecords: 'ComplianceRecords',
    ComplianceSummary: 'ComplianceSummary',
    ComplianceGridComplianceRecords: 'ComplianceGridComplianceRecords',
    CompletionReportingLocationGroups: 'CompletionReportingLocationGroups',
    UserCount: 'UserCount',
    CompletionReportingLocations: 'CompletionReportingLocations',
    ReportingOrgPremiumConfigs: 'ReportingOrgPremiumConfigs',
    ReportingCourseFeedbacks: 'ReportingCourseFeedbacks',
    KnowledgeCheckReportingGraph: 'KnowledgeCheckReportingGraph',
    KnowledgeCheckReportingLibraryItemPage_LibraryItem: 'KnowledgeCheckReportingLibraryItemPage_LibraryItem',
    KnowledgeCheckReportingLibraryItemPage_KnowledgeCheckInstances: 'KnowledgeCheckReportingLibraryItemPage_KnowledgeCheckInstances',
    KnowledgeCheckReportingTable_LibraryItems: 'KnowledgeCheckReportingTable_LibraryItems',
    KnowledgeCheckLeaderboardPeople: 'KnowledgeCheckLeaderboardPeople',
    LocationLeaderboard: 'LocationLeaderboard',
    ManagerLeaderboard: 'ManagerLeaderboard',
    TraineeLeaderboard: 'TraineeLeaderboard',
    MostRecentAuditCompletionReports: 'MostRecentAuditCompletionReports',
    LocationOverview_LocationDayMetrics: 'LocationOverview_LocationDayMetrics',
    ReportingOverviewLocations: 'ReportingOverviewLocations',
    GetReportingTargetSet: 'GetReportingTargetSet',
    GetEmployeeCountSettings: 'GetEmployeeCountSettings',
    TopTaskListsBySubmission: 'TopTaskListsBySubmission',
    TopTrainingsByAssignment: 'TopTrainingsByAssignment',
    AskOpusThemeNames: 'AskOpusThemeNames',
    impactReportingEngagement: 'impactReportingEngagement',
    impactReportingReengagement: 'impactReportingReengagement',
    impactReportingAssignmentCompletion: 'impactReportingAssignmentCompletion',
    impactReportingBrandAndProductKnowledgeCompletion: 'impactReportingBrandAndProductKnowledgeCompletion',
    impactReportingCourseFeedback: 'impactReportingCourseFeedback',
    impactReportingAdoption: 'impactReportingAdoption',
    impactReportingOnboarding: 'impactReportingOnboarding',
    impactReportingEmployeeRetention: 'impactReportingEmployeeRetention',
    impactReportingCompliance: 'impactReportingCompliance',
    impactReportingConsistentOperations: 'impactReportingConsistentOperations',
    impactReportingNewStoreOpenings: 'impactReportingNewStoreOpenings',
    GetRoles: 'GetRoles',
    GetRolesPageLazy: 'GetRolesPageLazy',
    DepartmentsPageContentRoleGroups: 'DepartmentsPageContentRoleGroups',
    DepartmentsPageHeader: 'DepartmentsPageHeader',
    RoleDialogBody_Roles: 'RoleDialogBody_Roles',
    GetRoleGroups: 'GetRoleGroups',
    GetRolesForSelect: 'GetRolesForSelect',
    RoleDetail: 'RoleDetail',
    RoleGroupDetailTabCounts: 'RoleGroupDetailTabCounts',
    RoleGroupHeader_PeopleCount: 'RoleGroupHeader_PeopleCount',
    RoleGroupHeader_RolesCount: 'RoleGroupHeader_RolesCount',
    RoleGroupHeaderAllLocations_RolesCount: 'RoleGroupHeaderAllLocations_RolesCount',
    RoleGroupRolesTable_Roles: 'RoleGroupRolesTable_Roles',
    SubRoleGroupsList_RoleGroup: 'SubRoleGroupsList_RoleGroup',
    CustomerFacingAccountPlan: 'CustomerFacingAccountPlan',
    CustomerFacingAccountPlanNav: 'CustomerFacingAccountPlanNav',
    AIOrgContext: 'AIOrgContext',
    ArchivePageHeader: 'ArchivePageHeader',
    GetCreditPurchaseOptions: 'GetCreditPurchaseOptions',
    BillingContainer: 'BillingContainer',
    BillingAccount_Invoices: 'BillingAccount_Invoices',
    BillingViewBillingAccount: 'BillingViewBillingAccount',
    BillingAccount_CreditSpendByLocation: 'BillingAccount_CreditSpendByLocation',
    CertificateEndorser: 'CertificateEndorser',
    BackfilledCertificates: 'BackfilledCertificates',
    GetTraineesWithoutHrisEmployee: 'GetTraineesWithoutHrisEmployee',
    BillingInitializedBillingAccounts: 'BillingInitializedBillingAccounts',
    ModuleCount: 'ModuleCount',
    Plan: 'Plan',
    BrandColor: 'BrandColor',
    ClockInConfirmationSettings: 'ClockInConfirmationSettings',
    HrisBase: 'HrisBase',
    HrisProtectedIntegrations: 'HrisProtectedIntegrations',
    useLicenseType_BillingAccounts: 'useLicenseType_BillingAccounts',
    CreditBalance: 'CreditBalance',
    HrisCsvUploadSidebar: 'HrisCsvUploadSidebar',
    HrisCsvUploads: 'HrisCsvUploads',
    HrisEmployeeSidebar: 'HrisEmployeeSidebar',
    HrisEmployeeRemoteHrisData: 'HrisEmployeeRemoteHrisData',
    HrisEmployeeEvents: 'HrisEmployeeEvents',
    HrisEmployeeEventSidebar: 'HrisEmployeeEventSidebar',
    HrisEmployeeEventPrevious: 'HrisEmployeeEventPrevious',
    HrisEmployees: 'HrisEmployees',
    HrisLocationFilterOptions: 'HrisLocationFilterOptions',
    HrisTeamFilterOptions: 'HrisTeamFilterOptions',
    HrisIntegrationSidebar: 'HrisIntegrationSidebar',
    HrisListHrisIntegrations: 'HrisListHrisIntegrations',
    HrisLocationSidebar: 'HrisLocationSidebar',
    HrisLocations: 'HrisLocations',
    HrisRoleSidebar: 'HrisRoleSidebar',
    HrisTeams: 'HrisTeams',
    HrisSyncSidebar: 'HrisSyncSidebar',
    MergeBackfillRuns: 'MergeBackfillRuns',
    OrgSftpIntegrationSidebar: 'OrgSftpIntegrationSidebar',
    OrgSftpIntegrations: 'OrgSftpIntegrations',
    RelinkHrisBanner: 'RelinkHrisBanner',
    RemoteHrisSftpCsvSidebar: 'RemoteHrisSftpCsvSidebar',
    HrisActivationData: 'HrisActivationData',
    HrisIntegrations: 'HrisIntegrations',
    HrisSetupNextButtonDisabled: 'HrisSetupNextButtonDisabled',
    OrgHrisConfig: 'OrgHrisConfig',
    CheckIfCsvCompletedCreatingObjects: 'CheckIfCsvCompletedCreatingObjects',
    GetHrisCsvUpload: 'GetHrisCsvUpload',
    GlossarySetMe: 'GlossarySetMe',
    ScheduledUserInvites: 'ScheduledUserInvites',
    BackfilledAssignments: 'BackfilledAssignments',
    AddSharpVersionDialog: 'AddSharpVersionDialog',
    SharpDetailAssignmentsTable_Assignments: 'SharpDetailAssignmentsTable_Assignments',
    SharpComplianceRecords: 'SharpComplianceRecords',
    SharpVersionCard_Assignments: 'SharpVersionCard_Assignments',
    DcOhrReminderPreference: 'DcOhrReminderPreference',
    TraineeSignupCode: 'TraineeSignupCode',
    GetLocationPoster: 'GetLocationPoster',
    TagDropdownContentTags: 'TagDropdownContentTags',
    TagsPageContentTags: 'TagsPageContentTags',
    TagsPageHeader: 'TagsPageHeader',
    TaskAssigneeSelect_People: 'TaskAssigneeSelect_People',
    TaskDetail_TaskCommentMentionableUsers: 'TaskDetail_TaskCommentMentionableUsers',
    TaskDetail_Task: 'TaskDetail_Task',
    TasksPage_ZeroState: 'TasksPage_ZeroState',
    TasksPage_Tasks: 'TasksPage_Tasks',
    TasksPage_HasBrands: 'TasksPage_HasBrands',
    UsersPageContent: 'UsersPageContent',
    UsersPageHeader: 'UsersPageHeader',
    UserDetailAccessTraineeLibrary: 'UserDetailAccessTraineeLibrary',
    UserDetailAssignments: 'UserDetailAssignments',
    UserDetailCompletedTrainingTabAssignments: 'UserDetailCompletedTrainingTabAssignments',
    UserDetailComplianceCertificatesTabComplianceRecords: 'UserDetailComplianceCertificatesTabComplianceRecords',
    UserActionPermissionOverrides: 'UserActionPermissionOverrides',
    SearchBlastRecipients: 'SearchBlastRecipients',
    RolesList: 'RolesList',
    GetPeople: 'GetPeople',
    UserSelectInput: 'UserSelectInput',
    GetLocationsWithEmployees: 'GetLocationsWithEmployees',
    GetRolesWithEmployees: 'GetRolesWithEmployees',
    GetAllEmployees: 'GetAllEmployees',
    UserDetailAccountHistory_UserAuditItems: 'UserDetailAccountHistory_UserAuditItems',
    TrainingSessions: 'TrainingSessions',
    UserDetailProfileTabAdminEmployee: 'UserDetailProfileTabAdminEmployee',
    UserDetailVerificationsTabAssignments: 'UserDetailVerificationsTabAssignments',
    UserDetailsAdminEmployee: 'UserDetailsAdminEmployee',
    UserPageContentTabCounts: 'UserPageContentTabCounts',
    UserPageContentEmployee: 'UserPageContentEmployee',
    UserPageHeaderEmployee: 'UserPageHeaderEmployee',
    WorkflowInlineLibraryItemPicker: 'WorkflowInlineLibraryItemPicker',
    WorkflowPage: 'WorkflowPage',
    WorkflowsPageHeader: 'WorkflowsPageHeader',
    WorkflowsTable: 'WorkflowsTable',
    WorkflowsContentOptions: 'WorkflowsContentOptions',
    WorkflowBuilderActionsPoll: 'WorkflowBuilderActionsPoll',
    LibraryItemCard: 'LibraryItemCard',
    WorkflowRunDetail: 'WorkflowRunDetail',
    WorkflowRunSiblings: 'WorkflowRunSiblings',
    WorkflowRunsTable: 'WorkflowRunsTable',
    WorkflowRunsCount: 'WorkflowRunsCount',
    WorkflowRunsVersions: 'WorkflowRunsVersions',
    UserActionPermissions: 'UserActionPermissions',
    FeatureFlags: 'FeatureFlags',
    LocationDetail: 'LocationDetail',
    LocationGroupDetail: 'LocationGroupDetail',
    OrgSharpConfig: 'OrgSharpConfig',
    RoleGroupDetail: 'RoleGroupDetail',
    Tags: 'Tags'
  },
  Mutation: {
    AIAddEmojisToText: 'AIAddEmojisToText',
    AISuggestSpellingAndGrammarChangesToText: 'AISuggestSpellingAndGrammarChangesToText',
    AISuggestReadingLevelChangesToText: 'AISuggestReadingLevelChangesToText',
    ModifyImage: 'ModifyImage',
    LibraryItemDataTransform: 'LibraryItemDataTransform',
    UploadFileCreateMedia: 'UploadFileCreateMedia',
    AddMediaDialogCreateMedia: 'AddMediaDialogCreateMedia',
    GenerateImage: 'GenerateImage',
    BulkCreateTrainingResources: 'BulkCreateTrainingResources',
    CreateLocationInQRCodeDialog: 'CreateLocationInQRCodeDialog',
    CreateOrg: 'CreateOrg',
    UpdateOrg: 'UpdateOrg',
    UpdateCustomerFacingAccountPlan: 'UpdateCustomerFacingAccountPlan',
    updateTranslationSet: 'updateTranslationSet',
    GeneratePresignedS3PostData: 'GeneratePresignedS3PostData',
    UpdateMyOrg: 'UpdateMyOrg',
    TrackEvent: 'TrackEvent',
    Logout: 'Logout',
    resetDemoOrg: 'resetDemoOrg',
    createDashboardFeedback: 'createDashboardFeedback',
    InitializeBilling: 'InitializeBilling',
    MarkNotificationsRead: 'MarkNotificationsRead',
    updateStaffActionPermissions: 'updateStaffActionPermissions',
    UpdateEmployeeFeatureFlags: 'UpdateEmployeeFeatureFlags',
    UpdateOrgFeatureFlags: 'UpdateOrgFeatureFlags',
    GenCourseFromOutlineChat: 'GenCourseFromOutlineChat',
    StartGenCourseFromOutlineChatWorkflow: 'StartGenCourseFromOutlineChatWorkflow',
    StartGenModuleFromOutlineChatWorkflow: 'StartGenModuleFromOutlineChatWorkflow',
    StartGenTaskListFromOutlineChatWorkflow: 'StartGenTaskListFromOutlineChatWorkflow',
    StartGenCheckInFromOutlineChatWorkflow: 'StartGenCheckInFromOutlineChatWorkflow',
    StartGenAuditFromOutlineChatWorkflow: 'StartGenAuditFromOutlineChatWorkflow',
    SetActiveClient: 'SetActiveClient',
    RemoveActiveClient: 'RemoveActiveClient',
    GenerateCoursePromptsResponsesCSV: 'GenerateCoursePromptsResponsesCSV',
    UpdateCourse: 'UpdateCourse',
    UpdateAutomation: 'UpdateAutomation',
    DiffAutomationChange: 'DiffAutomationChange',
    updateOrgPremiumContentConfig: 'updateOrgPremiumContentConfig',
    OpenedSkill: 'OpenedSkill',
    UpdateSkill: 'UpdateSkill',
    BulkCreateLibraryItemFolderMemberships: 'BulkCreateLibraryItemFolderMemberships',
    CopyCourse: 'CopyCourse',
    ValidateAndExtractScormPackage: 'ValidateAndExtractScormPackage',
    ConvertSCORMPackage: 'ConvertSCORMPackage',
    BulkDeleteLibraryItemFolderMemberships: 'BulkDeleteLibraryItemFolderMemberships',
    CopySkill: 'CopySkill',
    BulkUpdateLibraryItemAutomations: 'BulkUpdateLibraryItemAutomations',
    createTrainingResource: 'createTrainingResource',
    updateTrainingResource: 'updateTrainingResource',
    UpdateAssignmentDueDates: 'UpdateAssignmentDueDates',
    AssignLibraryItems: 'AssignLibraryItems',
    DeleteContentInstances: 'DeleteContentInstances',
    ScrapeFoundingStory: 'ScrapeFoundingStory',
    ScrapeSells: 'ScrapeSells',
    ScrapeMissionStatement: 'ScrapeMissionStatement',
    CreateGoogleBusinessGuestFeedbackIntegration: 'CreateGoogleBusinessGuestFeedbackIntegration',
    DeleteOrgGuestFeedbackCsvUpload: 'DeleteOrgGuestFeedbackCsvUpload',
    UpdateOrgGuestFeedbackIntegrationBrand: 'UpdateOrgGuestFeedbackIntegrationBrand',
    UpdateOrgGuestFeedbackIntegrationLocation: 'UpdateOrgGuestFeedbackIntegrationLocation',
    UpdateOrgGuestFeedbackIntegration: 'UpdateOrgGuestFeedbackIntegration',
    DeleteOrgGuestFeedbackIntegration: 'DeleteOrgGuestFeedbackIntegration',
    GetCsvColumns: 'GetCsvColumns',
    GetCsvColumnNumberRange: 'GetCsvColumnNumberRange',
    MatchOrgGuestFeedbackCsvUploadLocations: 'MatchOrgGuestFeedbackCsvUploadLocations',
    CreateOrgGuestFeedbackCsvUpload: 'CreateOrgGuestFeedbackCsvUpload',
    StartAIUpdateLibraryItem: 'StartAIUpdateLibraryItem',
    LinkLibraryItemToRecommendation: 'LinkLibraryItemToRecommendation',
    AcceptGuestFeedbackRecommendationDetail: 'AcceptGuestFeedbackRecommendationDetail',
    RejectGuestFeedbackRecommendationDetail: 'RejectGuestFeedbackRecommendationDetail',
    SetGuestFeedbackRecommendationStatus: 'SetGuestFeedbackRecommendationStatus',
    CreateLocationGroup: 'CreateLocationGroup',
    UpdateLocationGroup: 'UpdateLocationGroup',
    CreateRoleGroup: 'CreateRoleGroup',
    UpdateRoleGroup: 'UpdateRoleGroup',
    UpdateInactiveUsersSheet: 'UpdateInactiveUsersSheet',
    translateText: 'translateText',
    ArchiveContent: 'ArchiveContent',
    DeleteFolder: 'DeleteFolder',
    CreateFolder: 'CreateFolder',
    UpdateFolder: 'UpdateFolder',
    UpdateFolderPosition: 'UpdateFolderPosition',
    unarchiveLibraryItems: 'unarchiveLibraryItems',
    CheckInsPageHeaderCreateSkill: 'CheckInsPageHeaderCreateSkill',
    PublishCourse: 'PublishCourse',
    updateModuleSettingsAndPublish: 'updateModuleSettingsAndPublish',
    CopyResource: 'CopyResource',
    BulkPublishResources: 'BulkPublishResources',
    createBlankRichTextDocument: 'createBlankRichTextDocument',
    UpdateTaskListDigest: 'UpdateTaskListDigest',
    ArchiveModule: 'ArchiveModule',
    ArchiveTrainingResource: 'ArchiveTrainingResource',
    ArchiveSkill: 'ArchiveSkill',
    UpdateTrainingResourceQRCode: 'UpdateTrainingResourceQRCode',
    CourseDetailHeader_ArchiveLibraryItems: 'CourseDetailHeader_ArchiveLibraryItems',
    CourseDetailHeader_UnarchiveLibraryItems: 'CourseDetailHeader_UnarchiveLibraryItems',
    UpdateCourseArchived: 'UpdateCourseArchived',
    RevertToPriorVersion: 'RevertToPriorVersion',
    applyBuilderActions: 'applyBuilderActions',
    CreatePromptCommentThread: 'CreatePromptCommentThread',
    ResolvePromptCommentThread: 'ResolvePromptCommentThread',
    AddCommentToThread: 'AddCommentToThread',
    DeleteComment: 'DeleteComment',
    EditComment: 'EditComment',
    CreateAIFeedback: 'CreateAIFeedback',
    GradeCourseVersion: 'GradeCourseVersion',
    GenerateBuilderActionInput: 'GenerateBuilderActionInput',
    SuggestAIBlocks: 'SuggestAIBlocks',
    EditPromptWithAI: 'EditPromptWithAI',
    ResolveAIRequest: 'ResolveAIRequest',
    OpenedCourse: 'OpenedCourse',
    PromptCreateMedia: 'PromptCreateMedia',
    updateContentSharingPermission: 'updateContentSharingPermission',
    createUserSharingPermissions: 'createUserSharingPermissions',
    updateUserSharingPermission: 'updateUserSharingPermission',
    removeUserSharingPermission: 'removeUserSharingPermission',
    sendCoursePreviewToPhone: 'sendCoursePreviewToPhone',
    CopyModule: 'CopyModule',
    CreateBlankRichTextDocument__ModuleContentLibraryPopup: 'CreateBlankRichTextDocument__ModuleContentLibraryPopup',
    ModuleBuilder_CreateSkill: 'ModuleBuilder_CreateSkill',
    createModule: 'createModule',
    OpenedModule: 'OpenedModule',
    PublishTrainingResource: 'PublishTrainingResource',
    UpdateTrainingResourceNameAndDescription: 'UpdateTrainingResourceNameAndDescription',
    StartMediaToRichTextDocumentConversion: 'StartMediaToRichTextDocumentConversion',
    TrainingResourceTitleInput_UpdateTrainingResource: 'TrainingResourceTitleInput_UpdateTrainingResource',
    ScormCourseDetailPageHeader_ArchiveLibraryItem: 'ScormCourseDetailPageHeader_ArchiveLibraryItem',
    ScormCourseDetailPageHeader_UnarchiveLibraryItem: 'ScormCourseDetailPageHeader_UnarchiveLibraryItem',
    ScormCourseDetailPageHeader_PublishScormCourse: 'ScormCourseDetailPageHeader_PublishScormCourse',
    ScormCourseDetailPageHeader_UpdateScormCourse: 'ScormCourseDetailPageHeader_UpdateScormCourse',
    OpenedSCORMCourse: 'OpenedSCORMCourse',
    ScormCourseManageSettings_UpdateSCORMCourse: 'ScormCourseManageSettings_UpdateSCORMCourse',
    ScormCourseManageUpload_CreateSCORMCoursePreviewLaunchLink: 'ScormCourseManageUpload_CreateSCORMCoursePreviewLaunchLink',
    ScormCourseManageUpload_RevertToPublishedFile: 'ScormCourseManageUpload_RevertToPublishedFile',
    ScormCourseSettingsFields_UpdateSCORMCourse: 'ScormCourseSettingsFields_UpdateSCORMCourse',
    UpdateSubtitles: 'UpdateSubtitles',
    MarkAssignmentsComplete: 'MarkAssignmentsComplete',
    NewFollowUpTask_CreateTask: 'NewFollowUpTask_CreateTask',
    PublishSkillAndUpdateSharingPermissions: 'PublishSkillAndUpdateSharingPermissions',
    RevertSkillToPriorVersion: 'RevertSkillToPriorVersion',
    StepMediaSettings_CreateMedia: 'StepMediaSettings_CreateMedia',
    CreateOrUpdateCompletionSchedule: 'CreateOrUpdateCompletionSchedule',
    createLocation: 'createLocation',
    updateLocation: 'updateLocation',
    OpenedLocation: 'OpenedLocation',
    OpenedLocationGroupPage: 'OpenedLocationGroupPage',
    CreateCourse: 'CreateCourse',
    CreateOrgSharpConfig: 'CreateOrgSharpConfig',
    addContentToLibrary: 'addContentToLibrary',
    CreateMessageBlast: 'CreateMessageBlast',
    UpdateMessageBlast: 'UpdateMessageBlast',
    MessageBlastDialogCreateMedia: 'MessageBlastDialogCreateMedia',
    deleteMessageBlastNotificationSchedule: 'deleteMessageBlastNotificationSchedule',
    CreateBlastReadRecord: 'CreateBlastReadRecord',
    DeleteMessageBlast: 'DeleteMessageBlast',
    resendBlastNotification: 'resendBlastNotification',
    updateBlastNotificationSchedule: 'updateBlastNotificationSchedule',
    SetPostsPushNotification: 'SetPostsPushNotification',
    MarkActivityPagePostItemsRead: 'MarkActivityPagePostItemsRead',
    UpdateChatMemberState: 'UpdateChatMemberState',
    SendChatMessages: 'SendChatMessages',
    EditChatMessage: 'EditChatMessage',
    MarkChatRead: 'MarkChatRead',
    MarkChatMessagingActivityItemsRead: 'MarkChatMessagingActivityItemsRead',
    DeleteChatMessage: 'DeleteChatMessage',
    CreateChatMessageReaction: 'CreateChatMessageReaction',
    DeleteChatMessageReaction: 'DeleteChatMessageReaction',
    DeleteChat: 'DeleteChat',
    UpdateChatSettings: 'UpdateChatSettings',
    CreateChat: 'CreateChat',
    SendSeparateChatMessages: 'SendSeparateChatMessages',
    SetChatNotificationOverride: 'SetChatNotificationOverride',
    DeleteChatNotificationOverride: 'DeleteChatNotificationOverride',
    RestoreReportedContent: 'RestoreReportedContent',
    CreateReportedContent: 'CreateReportedContent',
    SetPostCommentsEnabled: 'SetPostCommentsEnabled',
    UpdateOrCreateUserPushNotificationSettingPostActivityOverride: 'UpdateOrCreateUserPushNotificationSettingPostActivityOverride',
    DeleteUserPushNotificationSettingPostActivityOverride: 'DeleteUserPushNotificationSettingPostActivityOverride',
    UpdatePostBlast: 'UpdatePostBlast',
    AddPostReaction: 'AddPostReaction',
    RemovePostReaction: 'RemovePostReaction',
    MarkReceivedPostsMessagingActivityItemsRead: 'MarkReceivedPostsMessagingActivityItemsRead',
    MarkSentPostsMessagingActivityItemsRead: 'MarkSentPostsMessagingActivityItemsRead',
    CreatePostComment: 'CreatePostComment',
    EditPostComment: 'EditPostComment',
    DeletePostComment: 'DeletePostComment',
    MarkPostDetailActivityItemsRead: 'MarkPostDetailActivityItemsRead',
    UpdateNotificationPreferencesSetting: 'UpdateNotificationPreferencesSetting',
    UpdateNotificationPreferencesPostActivityOverride: 'UpdateNotificationPreferencesPostActivityOverride',
    DeleteNotificationPreferencesPostActivityOverride: 'DeleteNotificationPreferencesPostActivityOverride',
    UpdateNotificationPreferencesChatOverride: 'UpdateNotificationPreferencesChatOverride',
    DeleteNotificationPreferencesChatOverride: 'DeleteNotificationPreferencesChatOverride',
    UpdateMessagingRolePermission: 'UpdateMessagingRolePermission',
    MyProfilePageUpdateEmployee: 'MyProfilePageUpdateEmployee',
    CreateCourseFeedback: 'CreateCourseFeedback',
    getAIFeedbackOnGradedFreeResponseAttempt: 'getAIFeedbackOnGradedFreeResponseAttempt',
    applyCourseProgress: 'applyCourseProgress',
    CreateTrainingSessionEvent: 'CreateTrainingSessionEvent',
    CreateClockInConfirmation: 'CreateClockInConfirmation',
    CompleteMyTrainingResourceAssignment: 'CompleteMyTrainingResourceAssignment',
    StartSCORMCourseInstance: 'StartSCORMCourseInstance',
    RenameOpusAgentChat: 'RenameOpusAgentChat',
    SendOpusAgentMessage: 'SendOpusAgentMessage',
    AbortOpusAgentTurn: 'AbortOpusAgentTurn',
    EditOpusAgentMessage: 'EditOpusAgentMessage',
    ReplaceOncompletionAssignmentRuleSets: 'ReplaceOncompletionAssignmentRuleSets',
    DeleteOnCompletionAssignmentRules: 'DeleteOnCompletionAssignmentRules',
    triggerGuestFeedbackRecommendations: 'triggerGuestFeedbackRecommendations',
    DeleteScheduledReportEmail: 'DeleteScheduledReportEmail',
    GetFieldFrequencies: 'GetFieldFrequencies',
    RunReport: 'RunReport',
    SaveReport: 'SaveReport',
    deleteReport: 'deleteReport',
    CreateScheduledReportEmail: 'CreateScheduledReportEmail',
    CreateReportView: 'CreateReportView',
    UpdateReportView: 'UpdateReportView',
    DeleteReportView: 'DeleteReportView',
    CreateComplianceAttemptImports: 'CreateComplianceAttemptImports',
    RemoveComplianceCertificateDialog: 'RemoveComplianceCertificateDialog',
    UpdateEmployeeCountSettings: 'UpdateEmployeeCountSettings',
    UpdateExpectedUsersConfigs: 'UpdateExpectedUsersConfigs',
    UpdateReportingTargetSet: 'UpdateReportingTargetSet',
    updateStoreOpening: 'updateStoreOpening',
    updateRole: 'updateRole',
    createRole: 'createRole',
    updateRoleLevels: 'updateRoleLevels',
    OpenedRole: 'OpenedRole',
    OpenedRoleGroup: 'OpenedRoleGroup',
    UploadSCORMDialog_CreateSCORMCourse: 'UploadSCORMDialog_CreateSCORMCourse',
    UpdateAIOrgContext: 'UpdateAIOrgContext',
    PurchaseCredits: 'PurchaseCredits',
    CreateCheckoutSession: 'CreateCheckoutSession',
    updateOrbCustomer: 'updateOrbCustomer',
    updateOrgLogo: 'updateOrgLogo',
    updateCertificateEndorser: 'updateCertificateEndorser',
    updateOrgBrandColor: 'updateOrgBrandColor',
    DeleteBackfilledCertificates: 'DeleteBackfilledCertificates',
    GenerateBackfilledCertificateCreationPreviewSummary: 'GenerateBackfilledCertificateCreationPreviewSummary',
    CreateBackfilledCertificates: 'CreateBackfilledCertificates',
    UpdateClockInConfirmationSettings: 'UpdateClockInConfirmationSettings',
    LinkHrisEmployeeToOpusUser: 'LinkHrisEmployeeToOpusUser',
    LinkHrisLocationToOpusLocation: 'LinkHrisLocationToOpusLocation',
    LinkHrisTeamToOpusRole: 'LinkHrisTeamToOpusRole',
    DeleteHrisEmployees: 'DeleteHrisEmployees',
    ResyncHrisIntegration: 'ResyncHrisIntegration',
    DeleteHrisIntegration: 'DeleteHrisIntegration',
    DeleteHrisLocations: 'DeleteHrisLocations',
    DeleteHrisTeams: 'DeleteHrisTeams',
    CreateHrisCsvUpload: 'CreateHrisCsvUpload',
    CreateSevenShiftsIntegration: 'CreateSevenShiftsIntegration',
    GenerateAccountToken: 'GenerateAccountToken',
    GenerateLinkToken: 'GenerateLinkToken',
    UpdateOrgHrisConfig: 'UpdateOrgHrisConfig',
    UpdateHrisCsvUpload: 'UpdateHrisCsvUpload',
    UpdateGlossarySet: 'UpdateGlossarySet',
    GenerateScheduledUserInviteCreationPreviewSummary: 'GenerateScheduledUserInviteCreationPreviewSummary',
    CreateScheduledUserInvites: 'CreateScheduledUserInvites',
    DeleteScheduledUserInvites: 'DeleteScheduledUserInvites',
    DeleteBackfilledAssignments: 'DeleteBackfilledAssignments',
    GenerateBackfilledAssignmentCreationPreviewSummary: 'GenerateBackfilledAssignmentCreationPreviewSummary',
    CreateBackfilledAssignments: 'CreateBackfilledAssignments',
    CompanyPolicyCreateMedia: 'CompanyPolicyCreateMedia',
    updateOrgSharpConfig: 'updateOrgSharpConfig',
    UpdateDcOhrReminderPreference: 'UpdateDcOhrReminderPreference',
    GenerateDcOhrReportCsv: 'GenerateDcOhrReportCsv',
    ConvertPdfToOpusDocDialog_CreateTrainingResource: 'ConvertPdfToOpusDocDialog_CreateTrainingResource',
    CompleteTraineeSignup: 'CompleteTraineeSignup',
    UpdateTags: 'UpdateTags',
    DeleteTags: 'DeleteTags',
    DeleteTaskDialog_DeleteTask: 'DeleteTaskDialog_DeleteTask',
    TaskDetail_AddTaskComment: 'TaskDetail_AddTaskComment',
    TaskDetail_UpdateTaskComment: 'TaskDetail_UpdateTaskComment',
    TaskDetail_DeleteTaskComment: 'TaskDetail_DeleteTaskComment',
    TaskDetail_CreateTaskCommentMedia: 'TaskDetail_CreateTaskCommentMedia',
    TaskDetail_StartTask: 'TaskDetail_StartTask',
    TaskDetail_SubmitTaskForReview: 'TaskDetail_SubmitTaskForReview',
    TaskDetail_ReviewTask: 'TaskDetail_ReviewTask',
    TaskDetail_UpdateTask: 'TaskDetail_UpdateTask',
    TaskDetail_AddTaskProofMedia: 'TaskDetail_AddTaskProofMedia',
    TaskDetail_SetTaskProofText: 'TaskDetail_SetTaskProofText',
    TaskDetail_RemoveTaskProofMedia: 'TaskDetail_RemoveTaskProofMedia',
    TaskProofUpload_CreateMedia: 'TaskProofUpload_CreateMedia',
    CreateUser: 'CreateUser',
    RemoveEmployees: 'RemoveEmployees',
    DeactivateUser: 'DeactivateUser',
    DisablePushNotifications: 'DisablePushNotifications',
    EnablePushNotifications: 'EnablePushNotifications',
    MergeUsers: 'MergeUsers',
    ReactivateEmployees: 'ReactivateEmployees',
    ReactivateEmployee: 'ReactivateEmployee',
    updateUserActionPermissionOverrides: 'updateUserActionPermissionOverrides',
    addUsersToLocations: 'addUsersToLocations',
    addUsersToRoles: 'addUsersToRoles',
    removeUsersFromLocations: 'removeUsersFromLocations',
    removeUsersFromRoles: 'removeUsersFromRoles',
    DeleteLocations: 'DeleteLocations',
    DeleteRoles: 'DeleteRoles',
    DeleteLocationGroups: 'DeleteLocationGroups',
    DeleteRoleGroups: 'DeleteRoleGroups',
    DeleteLocation: 'DeleteLocation',
    DeleteRole: 'DeleteRole',
    searchUnsplashImages: 'searchUnsplashImages',
    attributeUnsplashImageSelection: 'attributeUnsplashImageSelection',
    UpdateUserProfileImageCreateMedia: 'UpdateUserProfileImageCreateMedia',
    UpdateUserProfileImageUpdateEmployee: 'UpdateUserProfileImageUpdateEmployee',
    UpdateUser: 'UpdateUser',
    CreateWorkflow: 'CreateWorkflow',
    PublishWorkflow: 'PublishWorkflow',
    ArchiveWorkflow: 'ArchiveWorkflow',
    ApplyWorkflowBuilderActions: 'ApplyWorkflowBuilderActions',
    CancelWorkflowRun: 'CancelWorkflowRun',
    createTag: 'createTag',
    updateTag: 'updateTag',
    deleteTag: 'deleteTag',
    createContentTagMemberships: 'createContentTagMemberships',
    deleteContentTagMemberships: 'deleteContentTagMemberships',
    UpdateModuleSettings: 'UpdateModuleSettings'
  },
  Fragment: {
    LocationGroupObjectFragment: 'LocationGroupObjectFragment',
    LibraryItemForChatReference: 'LibraryItemForChatReference',
    AddMediaResources_TrainingResource: 'AddMediaResources_TrainingResource',
    AddMediaResources_LibraryItem: 'AddMediaResources_LibraryItem',
    UnsplashImage_StockPhotos: 'UnsplashImage_StockPhotos',
    PexelsPhoto_StockPhotos: 'PexelsPhoto_StockPhotos',
    PexelsVideo_StockVideos: 'PexelsVideo_StockVideos',
    TrainingResourceLibraryItem: 'TrainingResourceLibraryItem',
    AssignmentDialogCourse: 'AssignmentDialogCourse',
    AssignmentDialogTrainingResource: 'AssignmentDialogTrainingResource',
    AssignContentToUserDialogLibraryItem: 'AssignContentToUserDialogLibraryItem',
    UploadedTrainingResource: 'UploadedTrainingResource',
    OrgFormState: 'OrgFormState',
    PresignedS3UploadData: 'PresignedS3UploadData',
    ClientFacingWorkflow: 'ClientFacingWorkflow',
    Me: 'Me',
    MeOrg: 'MeOrg',
    AvailableOrg: 'AvailableOrg',
    JumpToOrgPremiumContentConfig: 'JumpToOrgPremiumContentConfig',
    JumpToEmployee: 'JumpToEmployee',
    JumpToCourse: 'JumpToCourse',
    JumpToModule: 'JumpToModule',
    JumpToTrainingResource: 'JumpToTrainingResource',
    JumpToSkill: 'JumpToSkill',
    JumpToLocation: 'JumpToLocation',
    JumpToRole: 'JumpToRole',
    JumpToLocationGroup: 'JumpToLocationGroup',
    JumpToRoleGroup: 'JumpToRoleGroup',
    ChatAttachmentLibraryItem: 'ChatAttachmentLibraryItem',
    ChatAttachment_TrainingResourceVersion: 'ChatAttachment_TrainingResourceVersion',
    ChatAttachmentMedia: 'ChatAttachmentMedia',
    VercelAiChatAnnotation: 'VercelAiChatAnnotation',
    VercelAiChatMessage: 'VercelAiChatMessage',
    AiExchangeAttachment: 'AiExchangeAttachment',
    AiChatExchange: 'AiChatExchange',
    AiChat: 'AiChat',
    AutomationListAutomation: 'AutomationListAutomation',
    InlineEditTagsLibraryItem: 'InlineEditTagsLibraryItem',
    Responses_Prompt: 'Responses_Prompt',
    Responses_PromptInstance: 'Responses_PromptInstance',
    Responses_LessonInstance: 'Responses_LessonInstance',
    Responses_CourseInstance: 'Responses_CourseInstance',
    CourseFeedbackRow: 'CourseFeedbackRow',
    UserCourseStatusCourseInstance: 'UserCourseStatusCourseInstance',
    FoodHandlerDetailAssignmentsTabContainer_Assignment: 'FoodHandlerDetailAssignmentsTabContainer_Assignment',
    AIRequestThin: 'AIRequestThin',
    PremiumModuleDetailLibraryItem: 'PremiumModuleDetailLibraryItem',
    PremiumModuleDetailOverview: 'PremiumModuleDetailOverview',
    AIGenerateCourseFromOutlineRequest: 'AIGenerateCourseFromOutlineRequest',
    CourseOutline: 'CourseOutline',
    PremiumModuleDetailSectionBreak: 'PremiumModuleDetailSectionBreak',
    PremiumModuleDetailModuleContentMembership: 'PremiumModuleDetailModuleContentMembership',
    PremiumModuleDetailFile: 'PremiumModuleDetailFile',
    PremiumModuleDetailSkill: 'PremiumModuleDetailSkill',
    PremiumModuleDetailCourse: 'PremiumModuleDetailCourse',
    PremiumModuleDetailHeader: 'PremiumModuleDetailHeader',
    ReassignmentCohortDetails: 'ReassignmentCohortDetails',
    AssignedByContentMembershipModule: 'AssignedByContentMembershipModule',
    AssignedByModuleContentMembership: 'AssignedByModuleContentMembership',
    AssignedByCourse: 'AssignedByCourse',
    SkillDetailOverview: 'SkillDetailOverview',
    VerificationStepColumnData_VerificationStepInstance: 'VerificationStepColumnData_VerificationStepInstance',
    VerificationStepColumnData_SkillInstance: 'VerificationStepColumnData_SkillInstance',
    CreateAICourseResult: 'CreateAICourseResult',
    CreateAiOutlineResult: 'CreateAiOutlineResult',
    LibraryItemTagCell_LibraryItem: 'LibraryItemTagCell_LibraryItem',
    ProgressiveTagFilterTag: 'ProgressiveTagFilterTag',
    SelectFolderDialogFolder: 'SelectFolderDialogFolder',
    SkillOverflowMenu_LibraryItem: 'SkillOverflowMenu_LibraryItem',
    AutomationDialog_UsersFromUserSelection: 'AutomationDialog_UsersFromUserSelection',
    AutomationDialog_Assignments: 'AutomationDialog_Assignments',
    AutomationDialog_AutomationOverrides: 'AutomationDialog_AutomationOverrides',
    SelectUsersDialog_UserThin: 'SelectUsersDialog_UserThin',
    SelectUsersDialog_LocationGroup: 'SelectUsersDialog_LocationGroup',
    ReassignmentSelectModuleContent_LibraryItem: 'ReassignmentSelectModuleContent_LibraryItem',
    ModuleContentSelectionDialog_LibraryItem2: 'ModuleContentSelectionDialog_LibraryItem2',
    ModuleContentSelectionDialog_ModuleContentMembership: 'ModuleContentSelectionDialog_ModuleContentMembership',
    ModuleContentSelectionDialog_LibraryItem: 'ModuleContentSelectionDialog_LibraryItem',
    TrainingResourceDialog_File: 'TrainingResourceDialog_File',
    PremiumLibraryItemUrl_LibraryItem: 'PremiumLibraryItemUrl_LibraryItem',
    ModuleOrPremiumContentLibraryItemTitle_LibraryItem: 'ModuleOrPremiumContentLibraryItemTitle_LibraryItem',
    HasLibraryItemEditPermission_LibraryItem: 'HasLibraryItemEditPermission_LibraryItem',
    LibraryUserSharingPermission: 'LibraryUserSharingPermission',
    LibraryContentSharingPermission: 'LibraryContentSharingPermission',
    LibraryItemOwner_LibraryItem: 'LibraryItemOwner_LibraryItem',
    LibraryItemUrl: 'LibraryItemUrl',
    LibraryItemTitle: 'LibraryItemTitle',
    LibraryItemAvatar: 'LibraryItemAvatar',
    LibraryItemOwner: 'LibraryItemOwner',
    TrainingResourceVersion__Avatar: 'TrainingResourceVersion__Avatar',
    TrainingResourceAvatar_LibraryItem: 'TrainingResourceAvatar_LibraryItem',
    CourseAssignmentFilterState: 'CourseAssignmentFilterState',
    FoodHandlerModuleAssignmentFilterState: 'FoodHandlerModuleAssignmentFilterState',
    ModuleAssignmentFilterState: 'ModuleAssignmentFilterState',
    AddContentToFolderDialogCourse: 'AddContentToFolderDialogCourse',
    AddContentToFolderDialogTrainingResource: 'AddContentToFolderDialogTrainingResource',
    AddContentToFolderDialogLibraryItem: 'AddContentToFolderDialogLibraryItem',
    FolderLibraryItem_Detail: 'FolderLibraryItem_Detail',
    FolderLibraryItem__Subfolder: 'FolderLibraryItem__Subfolder',
    FolderBreadcrumb: 'FolderBreadcrumb',
    OrgGuestFeedbackCsvUpload: 'OrgGuestFeedbackCsvUpload',
    OrgGuestFeedbackIntegration: 'OrgGuestFeedbackIntegration',
    GuestFeedbackReviewsTab_GuestFeedback: 'GuestFeedbackReviewsTab_GuestFeedback',
    OrgGuestFeedbackSync: 'OrgGuestFeedbackSync',
    GuestFeedbackRecommendationsListItem: 'GuestFeedbackRecommendationsListItem',
    LanguageCount: 'LanguageCount',
    ManagerLeaderboardItem_Widget: 'ManagerLeaderboardItem_Widget',
    IncompleteAssignmentsSheetEmployee: 'IncompleteAssignmentsSheetEmployee',
    LocationAssignmentLeaderboardWidgetItem: 'LocationAssignmentLeaderboardWidgetItem',
    LocationGroupDialog_LocationGroup: 'LocationGroupDialog_LocationGroup',
    LocationsTable_Location: 'LocationsTable_Location',
    NotInvitedUsersSheetHrisEmployee: 'NotInvitedUsersSheetHrisEmployee',
    RecentlyAssignedLibraryItem__Widget: 'RecentlyAssignedLibraryItem__Widget',
    CourseFeedbackFull: 'CourseFeedbackFull',
    RecentFeedbackCourseInstance: 'RecentFeedbackCourseInstance',
    RecentSubmissionsWidget_SkillInstance: 'RecentSubmissionsWidget_SkillInstance',
    RoleGroupDialog_RoleGroup: 'RoleGroupDialog_RoleGroup',
    UsersNoRoleSheetEmployee: 'UsersNoRoleSheetEmployee',
    InactiveUsersSheetEmployee: 'InactiveUsersSheetEmployee',
    KnowledgeCheckPaginatedTable_LibraryItem: 'KnowledgeCheckPaginatedTable_LibraryItem',
    LibraryContainerLibraryItem: 'LibraryContainerLibraryItem',
    LibraryCourse: 'LibraryCourse',
    CourseEditPermissionsCourse: 'CourseEditPermissionsCourse',
    LibraryModule: 'LibraryModule',
    LibrarySkill: 'LibrarySkill',
    LibraryContentTagMembership: 'LibraryContentTagMembership',
    LibraryTrainingResource: 'LibraryTrainingResource',
    LibraryModulePremiumContentConfig: 'LibraryModulePremiumContentConfig',
    LibraryCatalogModule: 'LibraryCatalogModule',
    OrgPremiumContentConfig: 'OrgPremiumContentConfig',
    FolderLibraryItemFolderMembership: 'FolderLibraryItemFolderMembership',
    FolderLibraryItem: 'FolderLibraryItem',
    LibraryAllContentTable_LibraryItem: 'LibraryAllContentTable_LibraryItem',
    ArchiveLibraryItemPaginatedTable_LibraryItem: 'ArchiveLibraryItemPaginatedTable_LibraryItem',
    CreatedTaskList: 'CreatedTaskList',
    CheckinLibraryItemPaginatedTable_LibraryItem: 'CheckinLibraryItemPaginatedTable_LibraryItem',
    CourseLibraryItemPaginatedTable_LibraryItem: 'CourseLibraryItemPaginatedTable_LibraryItem',
    PublishCourseDialog: 'PublishCourseDialog',
    PublishCourseDialog_Automation: 'PublishCourseDialog_Automation',
    ModuleLibraryPaginatedTable_LibraryItem: 'ModuleLibraryPaginatedTable_LibraryItem',
    PublishModuleDialog: 'PublishModuleDialog',
    ValidateModule_LibraryItem: 'ValidateModule_LibraryItem',
    ValidateModule_ModuleVersion: 'ValidateModule_ModuleVersion',
    ResourceLibraryItemPaginatedTable_LibraryItem: 'ResourceLibraryItemPaginatedTable_LibraryItem',
    ScormCourseLibraryItemPaginatedTable_LibraryItem: 'ScormCourseLibraryItemPaginatedTable_LibraryItem',
    TaskLibraryItemPaginatedTable_LibraryItem: 'TaskLibraryItemPaginatedTable_LibraryItem',
    LibraryItemDetailPage_LibraryItem: 'LibraryItemDetailPage_LibraryItem',
    LibraryItemDetailPage_Course: 'LibraryItemDetailPage_Course',
    LibraryItemDetailPage_Module: 'LibraryItemDetailPage_Module',
    LibraryItemDetailPage_Skill: 'LibraryItemDetailPage_Skill',
    TrainingResourceBuilder: 'TrainingResourceBuilder',
    LibraryItemDetailPage_TrainingResource: 'LibraryItemDetailPage_TrainingResource',
    LibraryItemDetailPage_ScormCourse: 'LibraryItemDetailPage_ScormCourse',
    LibraryItemDetailPageCoverImage_CoverImage: 'LibraryItemDetailPageCoverImage_CoverImage',
    FileAssignment: 'FileAssignment',
    FileAssignmentTrainingResourceInstance: 'FileAssignmentTrainingResourceInstance',
    FileDetailEmployee: 'FileDetailEmployee',
    CourseDetailOverview: 'CourseDetailOverview',
    CourseDetailHeader: 'CourseDetailHeader',
    HistoryCourseVersion: 'HistoryCourseVersion',
    SubtitleSegment: 'SubtitleSegment',
    SubtitleTrack: 'SubtitleTrack',
    MediaPreview: 'MediaPreview',
    RightSidebarCourseSettingsContent_Course: 'RightSidebarCourseSettingsContent_Course',
    CourseContentCourse: 'CourseContentCourse',
    CourseContentCourseVersion: 'CourseContentCourseVersion',
    CourseContentLesson: 'CourseContentLesson',
    CourseContentPrompt: 'CourseContentPrompt',
    ResponseOption: 'ResponseOption',
    LibraryItemDetailCourseSettingsRightPane_Course: 'LibraryItemDetailCourseSettingsRightPane_Course',
    CommentThread: 'CommentThread',
    Comment: 'Comment',
    CommentMention: 'CommentMention',
    AtMentionEmployee: 'AtMentionEmployee',
    SubsectionGrade: 'SubsectionGrade',
    GradeActionItem: 'GradeActionItem',
    SectionGrade: 'SectionGrade',
    CourseVersionGrade: 'CourseVersionGrade',
    SuggestedPrompt: 'SuggestedPrompt',
    AITranslationSet: 'AITranslationSet',
    AIQuestionResponseOption: 'AIQuestionResponseOption',
    AIPrompt: 'AIPrompt',
    AIRequest: 'AIRequest',
    AIResponseOption: 'AIResponseOption',
    AIEditPromptRequest: 'AIEditPromptRequest',
    CourseManageTabAssignmentsAssignment: 'CourseManageTabAssignmentsAssignment',
    CourseDetailAccessCourseInstance: 'CourseDetailAccessCourseInstance',
    CourseDetailAccessAssignment: 'CourseDetailAccessAssignment',
    CourseReportingOverview_LibraryItem: 'CourseReportingOverview_LibraryItem',
    CourseReportingOverview_Courseversion: 'CourseReportingOverview_Courseversion',
    ResponseOptionReportingInstance: 'ResponseOptionReportingInstance',
    CourseReportingPromptResponsesTable_CourseInstance: 'CourseReportingPromptResponsesTable_CourseInstance',
    CourseReportingPromptResponsesTable_PromptInstance: 'CourseReportingPromptResponsesTable_PromptInstance',
    CourseReportingPromptResponsesTable_PromptAttempt: 'CourseReportingPromptResponsesTable_PromptAttempt',
    CourseSharingPermissionsCourse: 'CourseSharingPermissionsCourse',
    ModuleSharingPermissionsModule: 'ModuleSharingPermissionsModule',
    TrainingResourceSharingPermissionsTrainingResource: 'TrainingResourceSharingPermissionsTrainingResource',
    LessonUtils_CourseVersion: 'LessonUtils_CourseVersion',
    PromptUtils_CourseVersion: 'PromptUtils_CourseVersion',
    ResponseOptionUtils_CourseVersion: 'ResponseOptionUtils_CourseVersion',
    ContentPermissions: 'ContentPermissions',
    LibraryItemContentPermissions: 'LibraryItemContentPermissions',
    BuilderAction: 'BuilderAction',
    SectionBreak: 'SectionBreak',
    ModuleBuilderLibraryItem: 'ModuleBuilderLibraryItem',
    ModuleBuilderContentMembership: 'ModuleBuilderContentMembership',
    ModuleBuilderModule: 'ModuleBuilderModule',
    ModuleBuilderAIGenerateModuleRequest: 'ModuleBuilderAIGenerateModuleRequest',
    ModuleBuilderAISCORMUploadRequest: 'ModuleBuilderAISCORMUploadRequest',
    ModuleBuilderCourse: 'ModuleBuilderCourse',
    ModuleBuilderModuleVersion: 'ModuleBuilderModuleVersion',
    ModuleBuilderSkill: 'ModuleBuilderSkill',
    ModuleBuilderFile: 'ModuleBuilderFile',
    RightSidebarModuleSettingsContent_Module: 'RightSidebarModuleSettingsContent_Module',
    ModuleContentLibraryItem: 'ModuleContentLibraryItem',
    ModuleContentCourse: 'ModuleContentCourse',
    ModuleDetailActivityFields_Module: 'ModuleDetailActivityFields_Module',
    ModuleManageSettingsTab_Module: 'ModuleManageSettingsTab_Module',
    ModuleReportingStepsTable_ModuleVersion: 'ModuleReportingStepsTable_ModuleVersion',
    ModuleReportingStepsTable_MCM: 'ModuleReportingStepsTable_MCM',
    ModuleStepsTable_LibraryItem: 'ModuleStepsTable_LibraryItem',
    ReportingTabTrainingResourceViews: 'ReportingTabTrainingResourceViews',
    TrainingResourceDetailPage_TrainingResourceVersion: 'TrainingResourceDetailPage_TrainingResourceVersion',
    TrainingResourcePDFContainer_TrainingResource: 'TrainingResourcePDFContainer_TrainingResource',
    ScormCourseManageAssignmentsTab_Assignment: 'ScormCourseManageAssignmentsTab_Assignment',
    ScormCourseDetailAccessSCORMCourseInstance: 'ScormCourseDetailAccessSCORMCourseInstance',
    ScormCourseDetailAccessAssignment: 'ScormCourseDetailAccessAssignment',
    LibraryItemFoldersDetailCard_LibraryItem: 'LibraryItemFoldersDetailCard_LibraryItem',
    LinkedLibraryItemPreview: 'LinkedLibraryItemPreview',
    MarkAssignmentCompleteAssignment: 'MarkAssignmentCompleteAssignment',
    AssignmentTimelineLibraryItem: 'AssignmentTimelineLibraryItem',
    AssignmentTimelineDialogAssignment: 'AssignmentTimelineDialogAssignment',
    AssignmentTimelineCourse: 'AssignmentTimelineCourse',
    UserScormCourseStatusSCORMCourseInstance: 'UserScormCourseStatusSCORMCourseInstance',
    UserSkillStatusSkillInstance: 'UserSkillStatusSkillInstance',
    UserModuleStatusModuleInstance: 'UserModuleStatusModuleInstance',
    AssignmentHistoryItem: 'AssignmentHistoryItem',
    ModuleInstanceTrainingResourceInstance: 'ModuleInstanceTrainingResourceInstance',
    ModuleInstanceSectionBreakInstance: 'ModuleInstanceSectionBreakInstance',
    ModuleInstanceCourseInstance: 'ModuleInstanceCourseInstance',
    ModuleInstanceSkillInstance: 'ModuleInstanceSkillInstance',
    ModuleInstanceModuleContentMembershipInstance: 'ModuleInstanceModuleContentMembershipInstance',
    ModuleInstanceScreen_ModuleInstance: 'ModuleInstanceScreen_ModuleInstance',
    ModuleInstanceScreen_Course: 'ModuleInstanceScreen_Course',
    ModuleInstanceScreen_Skill: 'ModuleInstanceScreen_Skill',
    ModuleInstanceScreen_LibraryItem: 'ModuleInstanceScreen_LibraryItem',
    SkillInstanceDialogV2_SkillInstance: 'SkillInstanceDialogV2_SkillInstance',
    SkillInstanceDialogTask_Task: 'SkillInstanceDialogTask_Task',
    SkillInstanceDialogTaskActivity_TaskActivityEvent: 'SkillInstanceDialogTaskActivity_TaskActivityEvent',
    SkillInstanceDialogV2_VerificationStep: 'SkillInstanceDialogV2_VerificationStep',
    SkillInstanceDialogV2_VerificationStepInstance: 'SkillInstanceDialogV2_VerificationStepInstance',
    SkillInstanceDialogV2_Trigger: 'SkillInstanceDialogV2_Trigger',
    SkillInstanceDialogV2_TriggerAction: 'SkillInstanceDialogV2_TriggerAction',
    PublishSkillDialog_Skill: 'PublishSkillDialog_Skill',
    ShareSkillDialog_Skill: 'ShareSkillDialog_Skill',
    SkillBuilderLinkedLibraryItem_LibraryItem: 'SkillBuilderLinkedLibraryItem_LibraryItem',
    SkillBuilder_Skill: 'SkillBuilder_Skill',
    SkillBuilder_TriggerAction: 'SkillBuilder_TriggerAction',
    SkillBuilder_Trigger: 'SkillBuilder_Trigger',
    SkillBuilder_SkillVersion: 'SkillBuilder_SkillVersion',
    SkillBuilder_VerificationStep: 'SkillBuilder_VerificationStep',
    SkillBuilder_ConditionalStepGroup: 'SkillBuilder_ConditionalStepGroup',
    SkillBuilder_StepResponseOption: 'SkillBuilder_StepResponseOption',
    HistorySkillVersion: 'HistorySkillVersion',
    ScheduleRruleStringFormat_Schedule: 'ScheduleRruleStringFormat_Schedule',
    ScheduleRruleStringFormat_ScheduleSet: 'ScheduleRruleStringFormat_ScheduleSet',
    AssignmentsTab_Assignment: 'AssignmentsTab_Assignment',
    SkillDetailAccessSkillInstance: 'SkillDetailAccessSkillInstance',
    SkillDetailAccessAssignment: 'SkillDetailAccessAssignment',
    SortAndFilter_CompletionSchedule: 'SortAndFilter_CompletionSchedule',
    SkillScheduleDialog_LibraryItem: 'SkillScheduleDialog_LibraryItem',
    SkillScheduleDialog_CompletionSchedule: 'SkillScheduleDialog_CompletionSchedule',
    SkillScheduleDialog_ScheduleSet: 'SkillScheduleDialog_ScheduleSet',
    SkillScheduleDialog_Schedule: 'SkillScheduleDialog_Schedule',
    CheckinAllAttemptsTab_SkillInstance: 'CheckinAllAttemptsTab_SkillInstance',
    SkillReportingOverview_SkillVersion: 'SkillReportingOverview_SkillVersion',
    SkillReportingResponsesTable_VerificationStepInstance: 'SkillReportingResponsesTable_VerificationStepInstance',
    TaskAllAttemptsTab_SkillInstance: 'TaskAllAttemptsTab_SkillInstance',
    TaskFullSubmissionsTab_SkillInstance: 'TaskFullSubmissionsTab_SkillInstance',
    TaskReportingResponsesTable_VerificationStepInstance: 'TaskReportingResponsesTable_VerificationStepInstance',
    TaskScheduleCompletionTab_Location: 'TaskScheduleCompletionTab_Location',
    TaskScheduleCompletionTab_CompletionScheduleInstance: 'TaskScheduleCompletionTab_CompletionScheduleInstance',
    TaskScheduleCompletionTab_CompletionScheduleWindow: 'TaskScheduleCompletionTab_CompletionScheduleWindow',
    DeleteLocationGroupDialog_LocationGroup: 'DeleteLocationGroupDialog_LocationGroup',
    LocationDialog_LocationWithAddress: 'LocationDialog_LocationWithAddress',
    LocationDialog_Location: 'LocationDialog_Location',
    LocationGroupThin: 'LocationGroupThin',
    LocationThin: 'LocationThin',
    LocationGroupLocationsTable_Location: 'LocationGroupLocationsTable_Location',
    SubRegionsList_LocationGroup: 'SubRegionsList_LocationGroup',
    MarketplacePageCatalogCategory: 'MarketplacePageCatalogCategory',
    MarketplacePageCatalogCourseMembership: 'MarketplacePageCatalogCourseMembership',
    MarketplacePageCatalogCourse: 'MarketplacePageCatalogCourse',
    MarketplacePageCatalogModule: 'MarketplacePageCatalogModule',
    MarketplacePagePremiumContentConfig: 'MarketplacePagePremiumContentConfig',
    MarketplacePageCatalogSharpExperience: 'MarketplacePageCatalogSharpExperience',
    CreatedCourse: 'CreatedCourse',
    CourseAddedToLibrary: 'CourseAddedToLibrary',
    ModuleAddedToLibrary: 'ModuleAddedToLibrary',
    ReceivedMessage: 'ReceivedMessage',
    ReceivedMessage_CoverImage: 'ReceivedMessage_CoverImage',
    ReceivedMessage_SkillInstance: 'ReceivedMessage_SkillInstance',
    ReceivedMessageBlast: 'ReceivedMessageBlast',
    MessageBlast: 'MessageBlast',
    UserSelectionSet: 'UserSelectionSet',
    SentMessage_MessageBlastMedia: 'SentMessage_MessageBlastMedia',
    MessagingActivityItem: 'MessagingActivityItem',
    ChatUnreadCount: 'ChatUnreadCount',
    ChatDetail: 'ChatDetail',
    ChatMessageItem: 'ChatMessageItem',
    ChatMessageItemAttachment: 'ChatMessageItemAttachment',
    ChatListItem: 'ChatListItem',
    ReportedContentCardItem: 'ReportedContentCardItem',
    ReportedContentListItem: 'ReportedContentListItem',
    ReportedPostDetailBlast: 'ReportedPostDetailBlast',
    MessagingSearchChatMessage: 'MessagingSearchChatMessage',
    MessagingSearchMessageBlast: 'MessagingSearchMessageBlast',
    MessagingSearchPostComment: 'MessagingSearchPostComment',
    PostDialogBlast: 'PostDialogBlast',
    NewMessagingReceivedPost: 'NewMessagingReceivedPost',
    NewMessagingPost: 'NewMessagingPost',
    PostCommentItem: 'PostCommentItem',
    PostReactor: 'PostReactor',
    MyProfilePageEmployee: 'MyProfilePageEmployee',
    MyCompletedTrainingTable_Assignment: 'MyCompletedTrainingTable_Assignment',
    MyCompletedTrainingTable_LibraryItem: 'MyCompletedTrainingTable_LibraryItem',
    MyCompletedTrainingTable_ModuleInstance: 'MyCompletedTrainingTable_ModuleInstance',
    MyCompletedTrainingTable_CourseInstance: 'MyCompletedTrainingTable_CourseInstance',
    MyCompletedTrainingTable_SCORMCourseInstance: 'MyCompletedTrainingTable_SCORMCourseInstance',
    MyTrainingAssignmentsTable_Assignment: 'MyTrainingAssignmentsTable_Assignment',
    MyTrainingAssignmentsTable_LibraryItem: 'MyTrainingAssignmentsTable_LibraryItem',
    MyTrainingAssignmentsTable_ModuleInstance: 'MyTrainingAssignmentsTable_ModuleInstance',
    MyTrainingAssignmentsTable_CourseInstance: 'MyTrainingAssignmentsTable_CourseInstance',
    MyTrainingAssignmentsTable_SCORMCourseInstance: 'MyTrainingAssignmentsTable_SCORMCourseInstance',
    MyTrainingPageToDoAssignment: 'MyTrainingPageToDoAssignment',
    MyTrainingPageToDoLibraryItem: 'MyTrainingPageToDoLibraryItem',
    MyTrainingPageToDoModuleInstance: 'MyTrainingPageToDoModuleInstance',
    MyTrainingPageToDoCourseInstance: 'MyTrainingPageToDoCourseInstance',
    MyTrainingPageToDoSCORMCourseInstance: 'MyTrainingPageToDoSCORMCourseInstance',
    MyTrainingPageCompletedAssignment: 'MyTrainingPageCompletedAssignment',
    MyTrainingSkillInstancePreview_SkillInstance: 'MyTrainingSkillInstancePreview_SkillInstance',
    MyTrainingSkillInstancePreview_Skill: 'MyTrainingSkillInstancePreview_Skill',
    MyTrainingSkillInstancePreview_PublishedVersion: 'MyTrainingSkillInstancePreview_PublishedVersion',
    MyTrainingSkillInstancePreview_VerificationStep: 'MyTrainingSkillInstancePreview_VerificationStep',
    TraineeLibrary_LibraryItem: 'TraineeLibrary_LibraryItem',
    MyTraining_TrainingResource: 'MyTraining_TrainingResource',
    AssignmentPill: 'AssignmentPill',
    MyTrainingModuleInstance: 'MyTrainingModuleInstance',
    MyTrainingModuleContentMembershipInstance: 'MyTrainingModuleContentMembershipInstance',
    MyTrainingCourseInstance: 'MyTrainingCourseInstance',
    MyTrainingSkillInstance: 'MyTrainingSkillInstance',
    MyTrainingSectionBreakInstance: 'MyTrainingSectionBreakInstance',
    MyTrainingSectionBreak: 'MyTrainingSectionBreak',
    MyTrainingTrainingResourceInstance: 'MyTrainingTrainingResourceInstance',
    MyTrainingTrainingResource: 'MyTrainingTrainingResource',
    CourseInstanceScreenCourseInstance: 'CourseInstanceScreenCourseInstance',
    LessonInstance: 'LessonInstance',
    PromptInstance: 'PromptInstance',
    PromptAttempt: 'PromptAttempt',
    Prompt: 'Prompt',
    PromptMedia: 'PromptMedia',
    LessonTraining: 'LessonTraining',
    ResponseOptionTraining: 'ResponseOptionTraining',
    CourseContentCourseTraining: 'CourseContentCourseTraining',
    CourseContentCourseVersionTraining: 'CourseContentCourseVersionTraining',
    OpusAgentChatListItem: 'OpusAgentChatListItem',
    OpusAgentEvent: 'OpusAgentEvent',
    OpusAgentCitationFields: 'OpusAgentCitationFields',
    OpusAgentTurn: 'OpusAgentTurn',
    OpusAgentChatModelSeed: 'OpusAgentChatModelSeed',
    OnCompletionRuleLibraryItem: 'OnCompletionRuleLibraryItem',
    CompletionRuleTreeOnCompletionRule: 'CompletionRuleTreeOnCompletionRule',
    OnCompletionPaths_OnCompletionAssignmentRuleSet: 'OnCompletionPaths_OnCompletionAssignmentRuleSet',
    OnCompletionPathsContent_LibraryItem: 'OnCompletionPathsContent_LibraryItem',
    OnCompletionPathsContent_RulesTree: 'OnCompletionPathsContent_RulesTree',
    AllAuditSubmissions_SkillInstance: 'AllAuditSubmissions_SkillInstance',
    AllTaskSubmissions_SkillInstance: 'AllTaskSubmissions_SkillInstance',
    AskOpusAnnotationFields: 'AskOpusAnnotationFields',
    AskOpus_AiChatExchangeStep: 'AskOpus_AiChatExchangeStep',
    AskOpus_AiGenerationFeedback: 'AskOpus_AiGenerationFeedback',
    AskOpus_AiChatExchange: 'AskOpus_AiChatExchange',
    AskOpusQuestionAnswer: 'AskOpusQuestionAnswer',
    ReportField: 'ReportField',
    ReportTopic: 'ReportTopic',
    ReportFilter: 'ReportFilter',
    Field: 'Field',
    EmailSchedule: 'EmailSchedule',
    SavedReport: 'SavedReport',
    RunReport: 'RunReport',
    LibraryItemFilter: 'LibraryItemFilter',
    ReportView: 'ReportView',
    CompletionGridLibraryItem: 'CompletionGridLibraryItem',
    CompletionGridLibraryItemWithModuleMemberships: 'CompletionGridLibraryItemWithModuleMemberships',
    HierarchyNode: 'HierarchyNode',
    MessageBlastHoverCard: 'MessageBlastHoverCard',
    MessageGrid__Message: 'MessageGrid__Message',
    TaskListCompletionGridLibraryItem: 'TaskListCompletionGridLibraryItem',
    TaskListCompletionGridLibraryItemWithModuleMemberships: 'TaskListCompletionGridLibraryItemWithModuleMemberships',
    UserCompletionGrid_Assignment: 'UserCompletionGrid_Assignment',
    UserCompletionGrid__User: 'UserCompletionGrid__User',
    PremiumModuleDetailCertificatesTab_ComplianceRecord: 'PremiumModuleDetailCertificatesTab_ComplianceRecord',
    PremiumModuleDetailCertifricatesTab_ComplianceAttempt: 'PremiumModuleDetailCertifricatesTab_ComplianceAttempt',
    ComplianceSummary: 'ComplianceSummary',
    ComplianceRecord: 'ComplianceRecord',
    CompletionReport_LocationGroup: 'CompletionReport_LocationGroup',
    ReportingPremiumConfig: 'ReportingPremiumConfig',
    ReportingCourseFeedbackRow: 'ReportingCourseFeedbackRow',
    KnowledgeCheckReportingLibraryItemPage_KnowledgeCheckInstance: 'KnowledgeCheckReportingLibraryItemPage_KnowledgeCheckInstance',
    KnowledgeCheckReportingTable_LibraryItem: 'KnowledgeCheckReportingTable_LibraryItem',
    KnowledgeCheckLeaderboardEmployee: 'KnowledgeCheckLeaderboardEmployee',
    LocationLeaderboardItem: 'LocationLeaderboardItem',
    ManagerLeaderboardItem: 'ManagerLeaderboardItem',
    TraineeLeaderboardItem: 'TraineeLeaderboardItem',
    MostRecentAuditCompletionSkillInstance: 'MostRecentAuditCompletionSkillInstance',
    DeleteRoleGroupDialog_RoleGroup: 'DeleteRoleGroupDialog_RoleGroup',
    RoleWithPermissions: 'RoleWithPermissions',
    ActionPermissionSet: 'ActionPermissionSet',
    RoleActionPermissions: 'RoleActionPermissions',
    RoleDialogBody_Role: 'RoleDialogBody_Role',
    RoleGroupThin: 'RoleGroupThin',
    RoleThin: 'RoleThin',
    RoleLevel: 'RoleLevel',
    RoleDetailDirectReport: 'RoleDetailDirectReport',
    RoleDetail: 'RoleDetail',
    RoleDetail_RoleGroup: 'RoleDetail_RoleGroup',
    RoleEmployee: 'RoleEmployee',
    RoleAutomation: 'RoleAutomation',
    RoleDetailTrainingResource: 'RoleDetailTrainingResource',
    RoleGroupRolesTable_Role: 'RoleGroupRolesTable_Role',
    SubRoleGroupsList_RoleGroup: 'SubRoleGroupsList_RoleGroup',
    CreditPurchaseOption: 'CreditPurchaseOption',
    Invoice: 'Invoice',
    BillingView_BillingAccount: 'BillingView_BillingAccount',
    BackfilledCertificate: 'BackfilledCertificate',
    Plan: 'Plan',
    AIOrgContext: 'AIOrgContext',
    BrandDetails: 'BrandDetails',
    HrisCsvUploadDetail: 'HrisCsvUploadDetail',
    HrisCsvUploadList: 'HrisCsvUploadList',
    HrisEmployeeEvent: 'HrisEmployeeEvent',
    HrisEmployeeEventSidebar: 'HrisEmployeeEventSidebar',
    EmployeeListHrisLocation: 'EmployeeListHrisLocation',
    EmployeeListHrisTeam: 'EmployeeListHrisTeam',
    HrisEmployee: 'HrisEmployee',
    HrisLocationFilterOption: 'HrisLocationFilterOption',
    HrisTeamFilterOption: 'HrisTeamFilterOption',
    HrisListHrisIntegration: 'HrisListHrisIntegration',
    HrisLocation: 'HrisLocation',
    HrisTeam: 'HrisTeam',
    MergeBackfillRun: 'MergeBackfillRun',
    OrgSftpIntegration: 'OrgSftpIntegration',
    HrisIntegration: 'HrisIntegration',
    HrisConfig: 'HrisConfig',
    HrisCsvUploadFlow: 'HrisCsvUploadFlow',
    GlossarySetOrg: 'GlossarySetOrg',
    ScheduledUserInvitePreviewRow: 'ScheduledUserInvitePreviewRow',
    ScheduledUserInvite: 'ScheduledUserInvite',
    BackfilledAssignment: 'BackfilledAssignment',
    AddSharpVersionDialog_PremiumContentConfig: 'AddSharpVersionDialog_PremiumContentConfig',
    SharpDetailAssignmentsTab_Assignment: 'SharpDetailAssignmentsTab_Assignment',
    SharpDetailAssignmentsTab_ComplianceAttempt: 'SharpDetailAssignmentsTab_ComplianceAttempt',
    IsSharpSetupComplete: 'IsSharpSetupComplete',
    OrgPremiumContentConfigStatus: 'OrgPremiumContentConfigStatus',
    PromptInstanceCard_Prompt: 'PromptInstanceCard_Prompt',
    PromptInstanceCard_PromptInstance: 'PromptInstanceCard_PromptInstance',
    TraineeSignupCode: 'TraineeSignupCode',
    TagDropdownContentTag: 'TagDropdownContentTag',
    TagsPageContentTag: 'TagsPageContentTag',
    TaskDetail_Task: 'TaskDetail_Task',
    TasksPage_Task: 'TasksPage_Task',
    UserDetailAccessTraineeLibraryLibraryItem: 'UserDetailAccessTraineeLibraryLibraryItem',
    UserDetailAssignmentsAssignment: 'UserDetailAssignmentsAssignment',
    UserDetailAssignmentsModuleInstance: 'UserDetailAssignmentsModuleInstance',
    UserDetailAssignmentsCourseInstance: 'UserDetailAssignmentsCourseInstance',
    UserDetailComplianceCertificatesTabComplianceRecord: 'UserDetailComplianceCertificatesTabComplianceRecord',
    UserDetailComplianceCertificatesTabComplianceAttempt: 'UserDetailComplianceCertificatesTabComplianceAttempt',
    UserActionPermissionOverrides: 'UserActionPermissionOverrides',
    LocationGroup: 'LocationGroup',
    UserSelectInputUser: 'UserSelectInputUser',
    MinimalEmployee: 'MinimalEmployee',
    UserDetailAccountHistory_UserAuditItemDetails: 'UserDetailAccountHistory_UserAuditItemDetails',
    TrainingSession: 'TrainingSession',
    UserDetailProfileTabEmployee: 'UserDetailProfileTabEmployee',
    UserDetailProfileTabAssignment: 'UserDetailProfileTabAssignment',
    UserDetailVerificationsTabAssignment: 'UserDetailVerificationsTabAssignment',
    UserDetailsAdminEmployee: 'UserDetailsAdminEmployee',
    UserPageContentEmployee: 'UserPageContentEmployee',
    UserPageHeaderEmployee: 'UserPageHeaderEmployee',
    WorkflowInlineLibraryItemPicker_LibraryItem: 'WorkflowInlineLibraryItemPicker_LibraryItem',
    WorkflowPageVersion: 'WorkflowPageVersion',
    WorkflowPageWorkflow: 'WorkflowPageWorkflow',
    WorkflowsTableWorkflow: 'WorkflowsTableWorkflow',
    WorkflowRunsTableRow: 'WorkflowRunsTableRow',
    TranslationSet: 'TranslationSet',
    MyTranslationSet: 'MyTranslationSet',
    CoverImage: 'CoverImage',
    ImageUrls: 'ImageUrls',
    AvatarProfileImage: 'AvatarProfileImage',
    Media: 'Media',
    EnglishOnlyMedia: 'EnglishOnlyMedia',
    EnglishOnlyTranslationSet: 'EnglishOnlyTranslationSet',
    TranslationOverride: 'TranslationOverride',
    CourseTopic: 'CourseTopic',
    CourseThin: 'CourseThin',
    CourseThinNoJoins: 'CourseThinNoJoins',
    Lesson: 'Lesson',
    Course: 'Course',
    CourseInfo: 'CourseInfo',
    CourseInstance: 'CourseInstance',
    EmployeeListItem: 'EmployeeListItem',
    LocationGroupMember: 'LocationGroupMember',
    EmployeeThin: 'EmployeeThin',
    UserSelection: 'UserSelection',
    BlastSentRecord: 'BlastSentRecord',
    MessageBlastThin: 'MessageBlastThin',
    CourseInstanceComplete: 'CourseInstanceComplete',
    EmployeeEslReporting: 'EmployeeEslReporting',
    UnsplashImage: 'UnsplashImage',
    AutomationLastEditedBy_Employee: 'AutomationLastEditedBy_Employee',
    Automation: 'Automation',
    Module: 'Module',
    SkillThin: 'SkillThin',
    SkillThinnest: 'SkillThinnest',
    Skill: 'Skill',
    RichTextDocument: 'RichTextDocument',
    MediaConversionStatus: 'MediaConversionStatus',
    ConvertMediaToRichTextDocumentWorkflow: 'ConvertMediaToRichTextDocumentWorkflow',
    TrainingResourceVersion: 'TrainingResourceVersion',
    TrainingResource: 'TrainingResource',
    ModuleInstanceThin: 'ModuleInstanceThin',
    TrainingResourceInstance: 'TrainingResourceInstance',
    Notification: 'Notification',
    ContentTagMembership: 'ContentTagMembership',
    LocationMember: 'LocationMember',
    RoleMember: 'RoleMember',
    AutomationLibraryItem: 'AutomationLibraryItem',
    EmployeeShared: 'EmployeeShared',
    UserSharingPermission: 'UserSharingPermission',
    ContentSharingPermission: 'ContentSharingPermission',
    AiGenerateModuleRequest: 'AiGenerateModuleRequest',
    ContentQRCode: 'ContentQRCode',
    ModuleAssignmentTable_Assignment: 'ModuleAssignmentTable_Assignment',
    UserActionPermissionValue: 'UserActionPermissionValue',
    UserActionPermissions: 'UserActionPermissions',
    Address: 'Address',
    LocationDetail: 'LocationDetail',
    LocationDetail_LocationGroup: 'LocationDetail_LocationGroup',
    LocationEmployee: 'LocationEmployee',
    AutomationLoc: 'AutomationLoc',
    LocationDetailTrainingResource: 'LocationDetailTrainingResource',
    LocationGroupDetail: 'LocationGroupDetail',
    AllNestedParents_LocationGroup: 'AllNestedParents_LocationGroup',
    LocationGroupEmployee: 'LocationGroupEmployee',
    AutomationLocGroup: 'AutomationLocGroup',
    LocationGroupDetailTrainingResource: 'LocationGroupDetailTrainingResource',
    OrgSharpConfig: 'OrgSharpConfig',
    RoleGroupDetail: 'RoleGroupDetail',
    AllNestedParents_RoleGroup: 'AllNestedParents_RoleGroup',
    RoleGroupEmployee: 'RoleGroupEmployee',
    AutomationRoleGroup: 'AutomationRoleGroup',
    RoleGroupDetailTrainingResource: 'RoleGroupDetailTrainingResource',
    Tag: 'Tag',
    ActiveClient: 'ActiveClient'
  }
}